import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { parseHostname, Environment } from 'shared';
import QueryString from 'query-string';
import Cookie from 'js-cookie';
import { v4 } from 'uuid';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { schema, normalize as normalize$1 } from 'normalizr';
import { TinyColor } from '@ctrl/tinycolor';
import { camelCase, isObject, noop } from 'lodash';
import styled, { css, keyframes, ThemeContext, useTheme, createGlobalStyle } from 'styled-components';
import _merge from 'lodash/merge';
import * as React from 'react';
import React__default, { useContext, useMemo, useCallback, useState, useEffect, useLayoutEffect, useRef, Fragment, Children, isValidElement } from 'react';
import _copy from 'copy-to-clipboard';
import hljs from 'highlight.js/lib/core';
import plaintext from 'highlight.js/lib/languages/plaintext';
import markdown from 'highlight.js/lib/languages/markdown';
import json from 'highlight.js/lib/languages/json';
import javascript from 'highlight.js/lib/languages/javascript';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';
import cssLang from 'highlight.js/lib/languages/css';
import less from 'highlight.js/lib/languages/less';
import swift from 'highlight.js/lib/languages/swift';
import objectivec from 'highlight.js/lib/languages/objectivec';
import python from 'highlight.js/lib/languages/python';
import php from 'highlight.js/lib/languages/php';
import perl from 'highlight.js/lib/languages/perl';
import java from 'highlight.js/lib/languages/java';
import { Link, useNavigate } from 'react-router-dom';
import { formatDistanceToNow, format, parseISO } from 'date-fns';
import _mergeWith from 'lodash/mergeWith';
import _isArray from 'lodash/isArray';
import _isFinite from 'lodash/isFinite';
import _extends from '@babel/runtime/helpers/extends';
import { createPortal as createPortal$1, flushSync } from 'react-dom';
import { HashLink } from 'react-router-hash-link';
import ReactMarkdown from 'react-markdown';
import { gfmStrikethrough } from 'micromark-extension-gfm-strikethrough';
import { gfmFromMarkdown, gfmToMarkdown } from 'mdast-util-gfm';
import remarkBreaks from 'remark-breaks';
import { useInView } from 'react-intersection-observer';
import AutosizeInput from 'react-input-autosize';
import { useCombobox } from 'downshift';
import lottie from 'lottie-web';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link$1 from '@tiptap/extension-link';
import TurndownService from 'turndown';
import markdownIt from 'markdown-it';
import DOMPurify from 'dompurify';
import { Extension } from '@tiptap/core';
import AutosizeTextarea from 'react-autosize-textarea';
import ReactModal from 'react-modal';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import reboot, { defaultRebootTheme } from 'styled-reboot';

function ownKeys$m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$m(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const mobileBreakpoint = "768px";
const mobileBreakpointRuleDown = "@media screen and (max-width: ".concat(mobileBreakpoint, ")");
const mobileBreakpointRuleUp = "@media screen and (min-width: ".concat(mobileBreakpoint, ")");

/**
 * Color object contains base colors, extend named theme colors below:
 * IE:
 * const color = {
 *  red: "#FF0000",
 * }
 * color.primary = color.red;
 */
const color = {
  success: "#00C851",
  info: "#3769E4",
  infoLight: "#F5F9FF",
  infoDark: "#2A57C8",
  warning: "#FFAC26",
  warningLight: "#FFFCF5",
  warningDark: "#E7AF41",
  error: "#C83434",
  errorLight: "#FFF7F7",
  errorDark: "#B12424",
  neutral: "#757575",
  neutralLight: "#FAFAFA",
  neutralDark: "#616161",
  green: "#6BBC19",
  red: "#DD0000",
  gallerySelection: "#E9EEF4",
  bestValueBackground: "#F8F9FE",
  focus: "#5586FF",
  toolbarBackground: "rgba(255, 255, 255, 0.98)",
  modalOverlay: "rgba(42, 42, 42, 0.9)",
  navbarHoverBackground: "rgba(88, 89, 90, 0.50)",
  // Note background colors
  noteInfo: "#FEF2CD",
  noteWarning: "#F1CCCC",
  noteSuccess: "#DBEAD4",
  // Brand blue
  blue700: "#3534C4",
  blue600: "#3E3FD1",
  blue500: "#4349DC",
  blue400: "#6066E3",
  blue300: "#6066E3",
  blue200: "#C8C9F5",
  blue100: "#E7E7FF",
  // Brand red
  red700: "#BD1759",
  red600: "#D31A5F",
  red500: "#E41D61",
  red400: "#E73F78",
  red300: "#EC6190",
  red200: "#F18EAF",
  red100: "#C8C9F5",
  // Brand yellow
  yellow700: "#3534c4",
  yellow600: "#3e3fd1",
  yellow500: "#4349dc",
  yellow400: "#6066e3",
  yellow300: "#6066e3",
  yellow200: "#a3a6ef",
  yellow100: "#c8c9f5",
  // Brand neutral
  neutral900: "#242425",
  neutral800: "#58595A",
  neutral700: "#767678",
  neutral600: "#A3A4A6",
  neutral500: "#D4D5D7",
  neutral400: "#E1E2E4",
  neutral300: "#EEEFF0",
  neutral200: "#FAFAFA",
  neutral100: "#FFFFFF"
};
color.primaryDarkest = color.blue700;
color.primaryDark = color.blue600;
color.primary = color.blue500;
color.primaryLight = color.blue400;
color.primaryLighter = color.blue300;
color.primaryExtraLight = color.blue200;
color.primaryLightest = color.blue100;
color.secondaryDarkest = color.red700;
color.secondaryDark = color.red600;
color.secondary = color.red500;
color.secondaryLight = color.red400;
color.secondaryLighter = color.red300;
color.secondaryExtraLight = color.red200;
color.secondaryLightest = color.red100;
color.tertiaryDarkest = color.yellow700;
color.tertiaryDark = color.yellow600;
color.tertiary = color.yellow500;
color.tertiaryLight = color.yellow400;
color.tertiaryLighter = color.yellow300;
color.tertiaryExtraLight = color.yellow200;
color.tertiaryLightest = color.yellow100;
color.black = color.neutral900;
color.grayDarkest = color.neutral800;
color.grayDarker = color.neutral700;
color.grayDark = color.neutral600;
color.gray = color.neutral500;
color.grayLight = color.neutral400;
color.grayLighter = color.neutral300;
color.grayLightest = color.neutral200;
color.white = color.neutral100;
color.neutralLoader = color.neutral600;
color.border = color.neutral400;
color.panelBackground = color.neutral200;

// Asset background colors
color.assetLight = color.neutral300;
color.assetDark = color.neutral600;
const boxShadow = {
  panel: "0 10px 20px rgba(0, 0, 0, 0.2)",
  component: "0px 1px 1px rgba(42, 42, 42, 0.05)",
  card: "0px 4px 16px rgba(42, 42, 42, 0.12);",
  image: "0px 2px 6px rgba(42, 42, 42, 0.14), 0px 6px 20px rgba(0, 0, 0, 0.08);",
  button: "0px 1px 2px rgba(42, 42, 42, 0.12), 0px 2px 8px rgba(42, 42, 42, 0.08);"
};
const borderRadius = {
  small: "4px",
  medium: "8px",
  large: "12px",
  // This is aiming for 40% on button sized elements
  // Some elements like expanding inpyts though may get larger
  // and look very funny if this is set to a large number or 50%.
  // 20 is meanted to pillify most components fine.
  pill: "20px",
  //Keeping old "default" for compatibility
  default: "4px"
};
const border = {
  default: "1px solid ".concat(color.grayLight),
  grayDashed: "1px dashed ".concat(color.grayLight),
  warning: "1px solid rgba(255, 172, 38, 0.6)"
};
const zIndex = {
  inspectorView: 900,
  assetOverlay: 1000,
  modalWrapper: 20000,
  modal: 999,
  tooltip: 51001,
  popupMenu: 51000
};
const fontStyles = {
  s76: {
    fontSize: "76px",
    lineHeight: "96px",
    [mobileBreakpointRuleDown]: {
      fontSize: "48px",
      lineHeight: "64px"
    }
  },
  s48: {
    fontSize: "48px",
    lineHeight: "64px",
    [mobileBreakpointRuleDown]: {
      fontSize: "28px",
      lineHeight: "40px"
    }
  },
  s36: {
    fontSize: "36px",
    lineHeight: "56px"
  },
  s28: {
    fontSize: "28px",
    lineHeight: "40px",
    [mobileBreakpointRuleDown]: {
      fontSize: "24px",
      lineHeight: "32px"
    }
  },
  s22: {
    fontSize: "22px",
    lineHeight: "32px",
    [mobileBreakpointRuleDown]: {
      fontSize: "20px",
      lineHeight: "32px"
    }
  },
  s20: {
    fontSize: "20px",
    lineHeight: "24px"
  },
  s18: {
    fontSize: "18px",
    lineHeight: "24px"
  },
  s16: {
    fontSize: "16px",
    lineHeight: "24px"
  },
  s14: {
    fontSize: "14px",
    lineHeight: "24px"
  },
  s12: {
    fontSize: "12px",
    lineHeight: "16px"
  },
  s11: {
    fontSize: "11px",
    lineHeight: "16px"
  },
  italic: {
    fontStyle: "italic"
  }
};
const fontWeight = {
  light: {
    fontWeight: 300
  },
  regular: {
    fontWeight: "normal"
  },
  medium: {
    fontWeight: 500
  },
  semibold: {
    fontWeight: 600
  },
  bold: {
    fontWeight: 700
  },
  extraBold: {
    fontWeight: 800
  },
  black: {
    fontWeight: 900
  }
};
const fontFamily = {
  inter: {
    fontFamily: "'Inter', sans-serif"
  },
  mono: {
    fontFamily: "'Source Code Pro', monospace"
  },
  texta: {
    fontFamily: "'Texta Alt', serif"
  }
};

/**
 * The font object contains all styles both as nested groups for access in code
 * as well as dot seperated strings for access via component props
 *
 * Access via code
 * ```
 * import { font } from './styles'
 * const myStyle = css`
 *  ${font.ui.title}
 * `
 * ```
 *
 * Access via props
 * ```
 * <MyComponent font="ui.title" />
 * ```
 */
const font = {};
font.ui = {
  /** Marketing and 404 */
  mediumTitle: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s48), fontWeight.bold), fontFamily.inter),
  pageTitle: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s28), fontWeight.extraBold), fontFamily.inter),
  title: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s20), fontWeight.extraBold), fontFamily.inter),
  subtitle: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s18), fontWeight.light), fontFamily.inter),
  mediumSubtitle: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s28), fontWeight.medium), fontFamily.inter),
  regular: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s14), fontWeight.regular), fontFamily.inter),
  regularSemiBold: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s14), fontWeight.semibold), fontFamily.inter),
  regularBold: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s14), fontWeight.bold), fontFamily.inter),
  small: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s12), fontWeight.regular), fontFamily.inter),
  smallBold: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s12), fontWeight.semibold), fontFamily.inter),
  tiny: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s11), fontWeight.regular), fontFamily.inter)
};
font.themeOverrides = {
  scher: {
    "ui.mediumTitle": {
      fontSize: "76px",
      letterSpacing: "-.03em",
      [mobileBreakpointRuleDown]: {
        fontSize: "40px"
      }
    },
    "ui.mediumSubtitle": {
      fontSize: "48px",
      letterSpacing: "-.02em",
      [mobileBreakpointRuleDown]: {
        fontSize: "32px"
      }
    },
    "ui.pageTitle": {
      fontSize: "28px",
      letterSpacing: "-.02em",
      [mobileBreakpointRuleDown]: {
        fontSize: "28px"
      }
    },
    "ui.title": {
      fontSize: "24px",
      lineHeight: "28px"
    },
    "ui.subtitle": {
      fontSize: "24px",
      [mobileBreakpointRuleDown]: {
        fontSize: "20px"
      }
    },
    "gallery.title": {
      fontSize: "48px",
      fontWeight: 600,
      letterSpacing: "-0.021em",
      lineHeight: 1
    }
  },
  wyman: {
    "ui.mediumTitle": {
      fontSize: "52px",
      fontWeight: 700,
      letterSpacing: "-.015em",
      [mobileBreakpointRuleDown]: {
        fontSize: "36px"
      }
    },
    "ui.mediumSubtitle": {
      letterSpacing: "-.015em"
    },
    "ui.pageTitle": {
      fontSize: "24px",
      fontWeight: 600,
      letterSpacing: "-.015em",
      [mobileBreakpointRuleDown]: {
        fontSize: "24px"
      }
    },
    "ui.title": {
      fontWeight: 500,
      letterSpacing: "-.015em"
    },
    "ui.subtitle": {
      fontWeight: 400,
      letterSpacing: "-.015em"
    }
  }
};
font.classic = {
  title: _objectSpread$m(_objectSpread$m({}, font.ui.title), {}, {
    fontWeight: 600,
    letterSpacing: "-.0125em",
    lineHeight: 1.5
  })
};
font.gallery = {
  /** Main gallery tites (e.g. section name) */
  title: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s36), fontWeight.black), fontFamily.inter),
  /** Heading items */
  heading: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s28), fontWeight.semibold), fontFamily.inter),
  /** Markdown h1 */
  h1: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s22), fontWeight.semibold), fontFamily.inter),
  /** Markdown h2 */
  h2: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s16), fontWeight.semibold), fontFamily.inter),
  /** Markdown body */
  regular: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, fontStyles.s14), fontWeight.regular), fontFamily.inter),
  /** Code */
  code: _objectSpread$m(_objectSpread$m({}, fontStyles.s14), fontFamily.mono)
};

/**
 * Marketing fonts
 */
font.marketing = {
  /** H1 Text */
  h1: _objectSpread$m(_objectSpread$m({
    fontSize: "64px",
    lineHeight: "64px",
    letterSpacing: "-1.5px",
    [mobileBreakpointRuleDown]: {
      fontSize: "48px",
      lineHeight: "48px",
      letterSpacing: "-1.25px"
    }
  }, fontWeight.black), fontFamily.texta),
  /** H2 Text */
  h2: _objectSpread$m(_objectSpread$m({
    fontSize: "48px",
    lineHeight: "48px",
    letterSpacing: "-1.25px"
  }, fontWeight.black), fontFamily.texta),
  /** H3 Text */
  h3: _objectSpread$m(_objectSpread$m({
    fontSize: "36px",
    lineHeight: "36px",
    letterSpacing: "-0.5px"
  }, fontWeight.black), fontFamily.texta),
  /** H4 Text */
  h4: _objectSpread$m(_objectSpread$m({
    fontSize: "28px",
    lineHeight: "28px",
    letterSpacing: "0"
  }, fontWeight.black), fontFamily.texta),
  /** H5 Text */
  h5: _objectSpread$m(_objectSpread$m({
    fontSize: "24px",
    lineHeight: "24px",
    letterSpacing: "1px"
  }, fontWeight.medium), fontFamily.texta),
  /** Subtitle 1 */
  subtitle1: _objectSpread$m(_objectSpread$m({
    fontSize: "20px",
    lineHeight: "24px",
    letterSpacing: "0"
  }, fontWeight.black), fontFamily.texta),
  /** Subtitle 2 */
  subtitle2: _objectSpread$m(_objectSpread$m({
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  }, fontWeight.black), fontFamily.texta),
  /** Body Large */
  bodyLarge: _objectSpread$m(_objectSpread$m({
    fontSize: "20px",
    lineHeight: "32px",
    letterSpacing: "-0.25px"
  }, fontWeight.light), fontFamily.inter),
  /** Body Regular */
  regular: _objectSpread$m(_objectSpread$m({
    fontSize: "16px",
    lineHeight: "28px",
    letterSpacing: "0px"
  }, fontWeight.regular), fontFamily.inter),
  /** Body Regular Bold */
  regularBold: _objectSpread$m(_objectSpread$m({
    fontSize: "16px",
    lineHeight: "28px",
    letterSpacing: "0px"
  }, fontWeight.bold), fontFamily.inter),
  /** Nav Link */
  navLink: _objectSpread$m(_objectSpread$m({
    fontSize: "14px",
    lineHeight: "16px"
  }, fontWeight.medium), fontFamily.inter),
  /** Nav Link */
  textLink: _objectSpread$m(_objectSpread$m({
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: ".5px"
  }, fontWeight.semibold), fontFamily.inter),
  /** Caption */
  caption: _objectSpread$m(_objectSpread$m({
    fontSize: "11px",
    lineHeight: "16px"
  }, fontWeight.regular), fontFamily.inter)
};
font.blog = {
  h1: _objectSpread$m(_objectSpread$m({
    fontSize: "32px",
    lineHeight: "48px",
    letterSpacing: ".25px",
    [mobileBreakpointRuleDown]: {
      fontSize: "28px",
      lineHeight: "42px",
      letterSpacing: ".25px"
    }
  }, fontWeight.bold), fontFamily.texta),
  h2: _objectSpread$m(_objectSpread$m({
    fontSize: "24px",
    lineHeight: "36px",
    letterSpacing: "0.25px",
    [mobileBreakpointRuleDown]: {
      fontSize: "20px",
      lineHeight: "30px",
      letterSpacing: "0.25px"
    }
  }, fontWeight.bold), fontFamily.texta),
  h3: _objectSpread$m(_objectSpread$m({
    fontSize: "20px",
    lineHeight: 1.5,
    letterSpacing: "0.25px",
    [mobileBreakpointRuleDown]: {
      fontSize: "20px",
      lineHeight: 1.5,
      letterSpacing: "0.25px"
    }
  }, fontWeight.bold), fontFamily.texta),
  figcaption: _objectSpread$m(_objectSpread$m({
    fontSize: "11px",
    lineHeight: 1.2,
    letterSpacing: "0.08px"
  }, fontWeight.regular), fontFamily.inter)
};
Object.keys(font).forEach(groupKey => {
  const g = font[groupKey];
  Object.keys(g).forEach(styleKey => {
    font["".concat(groupKey, ".").concat(styleKey)] = font[groupKey][styleKey];
  });
});
const space$1 = {
  none: "0",
  xxs: "2px",
  xs: "4px",
  s: "8px",
  m: "16px",
  l: "24px",
  xl: "40px",
  xxl: "80px",
  xxxl: "120px"
};
const Devices = {
  mobile: 0,
  tablet: 1,
  desktop: 2,
  mediaQueryForDevice: device => {
    switch (device) {
      case Devices.mobile:
      case Devices.tablet:
        return mobileBreakpointRuleDown;
      default:
        return "@media(min-width: ".concat(mobileBreakpoint, ")");
    }
  }
};

/**
 * Spacing values for responsive layouts
 *
 * [<768, 769-1280, >1280]
 */
const spacing = {
  none: [0, 0, 0],
  xxs: [2, 2, 2],
  xs: [4, 4, 4],
  s: [4, 4, 8],
  m: [8, 8, 16],
  l: [16, 24, 24],
  xl: [24, 32, 40],
  xxl: [40, 60, 80],
  xxxl: [80, 100, 120]
};
Object.keys(spacing).forEach(k => {
  const negValues = spacing[k].map(v => -Math.abs(v));
  spacing["-".concat(k)] = negValues;
});
const properties = {
  a: [""],
  t: ["Top"],
  b: ["Bottom"],
  r: ["Right"],
  l: ["Left"],
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
const makeSpacingRule = (propertyType, propertyAspects, spacingKey) => {
  const [mobilePx, desktopPx] = spacing[spacingKey];
  return _objectSpread$m(_objectSpread$m({}, propertyAspects.reduce((obj, asp) => {
    obj["".concat(propertyType).concat(asp)] = "".concat(mobilePx, "px");
    return obj;
  }, {})), {}, {
    [mobileBreakpointRuleUp]: _objectSpread$m({}, propertyAspects.reduce((obj, asp) => {
      obj["".concat(propertyType).concat(asp)] = "".concat(desktopPx, "px");
      return obj;
    }, {}))
  });
};

/**
 * These are populated as
 * {
 *  a: {
 *    none: { margin: 0, @media(...) }
 *    xxs: { margin: 2, @media(...) }
 *  },
 *  t: {
 *    none: { margin-top: 0, @media(...) }
 *    xxs: { margin: 2, @media(...) }
 *  },
 * }
 */
const padding = {};
const margin = {};
Object.entries(properties).forEach(p => {
  const pKey = p[0],
    pVal = p[1];
  padding[pKey] = {};
  margin[pKey] = {};
  Object.keys(spacing).forEach(spacingKey => {
    padding[pKey][spacingKey] = makeSpacingRule("padding", pVal, spacingKey);
    margin[pKey][spacingKey] = makeSpacingRule("margin", pVal, spacingKey);
  });
});

/**
 * Defined breakpoints to use for styled-component media query helper
 */
const bp = {
  xs: 500,
  s: 768,
  m: 1024,
  l: 1200,
  xl: 1400
};

var styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Devices: Devices,
  border: border,
  borderRadius: borderRadius,
  boxShadow: boxShadow,
  bp: bp,
  color: color,
  font: font,
  fontFamily: fontFamily,
  fontStyles: fontStyles,
  margin: margin,
  padding: padding,
  space: space$1,
  spacing: spacing,
  zIndex: zIndex
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any

// MARK : Custom Fields
// -------------------------------------------------------------------------------
let CustomFieldTypes = /*#__PURE__*/function (CustomFieldTypes) {
  CustomFieldTypes["text"] = "text";
  CustomFieldTypes["number"] = "number";
  CustomFieldTypes["date"] = "date";
  CustomFieldTypes["checklist"] = "checklist";
  CustomFieldTypes["select"] = "select";
  return CustomFieldTypes;
}({});
let CustomFieldOperation = /*#__PURE__*/function (CustomFieldOperation) {
  CustomFieldOperation["add"] = "add";
  CustomFieldOperation["remove"] = "remove";
  CustomFieldOperation["set"] = "set";
  return CustomFieldOperation;
}({});

// MARK : Tags
// -------------------------------------------------------------------------------

// MARK : User
// -------------------------------------------------------------------------------

// MARK : Download Requests
// -------------------------------------------------------------------------------

// MARK : Theming
// -------------------------------------------------------------------------------
let SpaceThemeNames = /*#__PURE__*/function (SpaceThemeNames) {
  SpaceThemeNames["classic"] = "classic";
  SpaceThemeNames["scher"] = "scher";
  SpaceThemeNames["wyman"] = "wyman";
  return SpaceThemeNames;
}({});
let ThemeHeaderTitleOptions = /*#__PURE__*/function (ThemeHeaderTitleOptions) {
  ThemeHeaderTitleOptions["name"] = "name";
  ThemeHeaderTitleOptions["logo"] = "logo_only";
  ThemeHeaderTitleOptions["none"] = "no_title";
  return ThemeHeaderTitleOptions;
}({});

// MARK : Space
// -------------------------------------------------------------------------------

let SpacePermission = /*#__PURE__*/function (SpacePermission) {
  SpacePermission["view"] = "view";
  SpacePermission["searchAssets"] = "search_assets";
  SpacePermission["viewDashboard"] = "view_dashboard";
  SpacePermission["viewMembers"] = "view_members";
  SpacePermission["delete"] = "delete";
  SpacePermission["manageBilling"] = "manage_billing";
  SpacePermission["manageResources"] = "manage_resources";
  SpacePermission["revokeInvitation"] = "revoke_invitation";
  SpacePermission["removeUser"] = "remove_user";
  SpacePermission["removeSelf"] = "remove_self";
  SpacePermission["edit"] = "edit";
  SpacePermission["createKit"] = "create_kit";
  SpacePermission["inviteUser"] = "invite_user";
  SpacePermission["changeUserRole"] = "change_user_role";
  SpacePermission["viewAnalytics"] = "view_analytics";
  SpacePermission["viewAdvancedAnalytics"] = "view_advanced_analytics";
  SpacePermission["manageExports"] = "manage_exports";
  SpacePermission["managePortals"] = "manage_portals";
  SpacePermission["manageBrandPortal"] = "manage_brand_portal";
  SpacePermission["manageApiTokens"] = "manage_api_tokens";
  SpacePermission["managePasswordAccess"] = "manage_password_access";
  SpacePermission["managePublicAccess"] = "manage_public_access";
  SpacePermission["manageSEO"] = "manage_seo";
  SpacePermission["manageViews"] = "manage_views";
  SpacePermission["manageMembers"] = "manage_members";
  SpacePermission["createKitCollection"] = "create_kit_collection";
  SpacePermission["editKitCollection"] = "edit_kit_collection";
  SpacePermission["viewAssetLibrary"] = "view_asset_library";
  SpacePermission["createAsset"] = "create_asset";
  SpacePermission["manageTags"] = "manage_tags";
  SpacePermission["viewFields"] = "view_fields";
  SpacePermission["editFields"] = "edit_fields";
  SpacePermission["manageCustomTheme"] = "manage_custom_theme";
  SpacePermission["manageCustomThemeFont"] = "manage_custom_theme_font";
  SpacePermission["manageCustomThemeAppearance"] = "manage_custom_theme_appearance";
  SpacePermission["manageCustomDomain"] = "manage_custom_domain";
  SpacePermission["configureSSO"] = "configure_sso";
  SpacePermission["downloadRequirements"] = "download_requirements";
  SpacePermission["manageDownloadRequirements"] = "manage_download_requirements";
  SpacePermission["createDynamicGalleryItems"] = "create_dynamic_gallery_items";
  SpacePermission["manageDirectLinks"] = "manage_direct_links";
  SpacePermission["viewDirectLinks"] = "view_direct_links";
  return SpacePermission;
}({});
let KitPermission = /*#__PURE__*/function (KitPermission) {
  KitPermission["view"] = "view";
  KitPermission["searchAssets"] = "search_assets";
  KitPermission["favorite"] = "favorite";
  KitPermission["changeOwnStatus"] = "change_own_status";
  KitPermission["viewAllContent"] = "view_all_content";
  KitPermission["edit"] = "edit";
  KitPermission["delete"] = "delete";
  KitPermission["changeMemberRole"] = "change_member_role";
  KitPermission["editContent"] = "edit_content";
  KitPermission["manage"] = "manage";
  KitPermission["manageExports"] = "manage_exports";
  KitPermission["manageCustomTheme"] = "manage_custom_theme";
  KitPermission["manageCustomThemeFont"] = "manage_custom_theme_font";
  KitPermission["manageCustomThemeAppearance"] = "manage_custom_theme_appearance";
  KitPermission["manageSharelinks"] = "manage_sharelinks";
  KitPermission["managePublicAccess"] = "manage_public_access";
  KitPermission["managePasswordAccess"] = "manage_password_access";
  KitPermission["manageSEO"] = "manage_seo";
  KitPermission["managePortalAccess"] = "manage_portal_access";
  return KitPermission;
}({});

// MARK : Kit Collections
// -------------------------------------------------------------------------------

// MARK : Portals
// -------------------------------------------------------------------------------

let PortalPermission = /*#__PURE__*/function (PortalPermission) {
  PortalPermission["view"] = "view";
  PortalPermission["searchAssets"] = "search_assets";
  PortalPermission["edit"] = "edit";
  PortalPermission["delete"] = "delete";
  PortalPermission["editContent"] = "edit_content";
  PortalPermission["manageCustomDomain"] = "manage_custom_domain";
  PortalPermission["manageCustomTheme"] = "manage_custom_theme";
  PortalPermission["manageCustomThemeFont"] = "manage_custom_theme_font";
  PortalPermission["manageCustomThemeAppearance"] = "manage_custom_theme_appearance";
  PortalPermission["managePublicAccess"] = "manage_public_access";
  PortalPermission["managePasswordAccess"] = "manage_password_access";
  PortalPermission["managePortalAccess"] = "manage_portal_access";
  PortalPermission["manageDownloadRequirements"] = "manage_download_requirements";
  PortalPermission["manageSEO"] = "manage_seo";
  PortalPermission["viewMembers"] = "view_members";
  return PortalPermission;
}({});

// MARK : Kit Content
// -------------------------------------------------------------------------------

// MARK : API Responses
// -------------------------------------------------------------------------------

/**
 * Typically used for sync or batch endpoints where the result is a list of change results
 *
 * For example, batch updating assets could look like
 * ```
 * APIResultList<"assets">
 * {
 *  entities: {},
 *  result: {
 *    assets: [ // <- the key provided
 *      // The asset is normalized in entities
 *      { "success": true, "result": "asset-uuid" },
 *      { "success": false, "error": {
 *         "code": 400, "message": "Invalid asset" }
 *      }
 *   ]
 *  }
 * }
 * ```
 */

// MARK : Search
// -------------------------------------------------------------------------------
let SearchFilterTypes = /*#__PURE__*/function (SearchFilterTypes) {
  SearchFilterTypes["kit"] = "kit";
  SearchFilterTypes["type"] = "type";
  SearchFilterTypes["orientation"] = "orientation";
  SearchFilterTypes["tag"] = "tag";
  SearchFilterTypes["after"] = "after";
  SearchFilterTypes["before"] = "before";
  SearchFilterTypes["name"] = "name";
  SearchFilterTypes["uploader"] = "uploader";
  SearchFilterTypes["date"] = "date";
  SearchFilterTypes["text"] = "text";
  SearchFilterTypes["token"] = "token";
  SearchFilterTypes["keyword"] = "keyword";
  SearchFilterTypes["suggestion"] = "suggestion";
  SearchFilterTypes["field-text"] = "field-text";
  SearchFilterTypes["field-date"] = "field-date";
  SearchFilterTypes["field-number"] = "field-number";
  SearchFilterTypes["field-checklist"] = "field-checklist";
  SearchFilterTypes["field-select"] = "field-select";
  return SearchFilterTypes;
}({});
let SearchOperators = /*#__PURE__*/function (SearchOperators) {
  SearchOperators["eq"] = "eq";
  SearchOperators["lt"] = "lt";
  SearchOperators["gt"] = "gt";
  SearchOperators["lte"] = "lte";
  SearchOperators["gte"] = "gte";
  return SearchOperators;
}({});

// MARK : Uploads
// -------------------------------------------------------------------------------

function ownKeys$l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$l(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// MARK : Themes
// -------------------------------------------------------------------------------
function getThemeName(props) {
  var _props$theme;
  return (props === null || props === void 0 || (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.themeName) || SpaceThemeNames.classic;
}

// MARK : Colors
/*-------------------------------------------------------------------------------*/

function getColor(propValue) {
  let fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (propValue) {
    if (color[propValue]) {
      return color[propValue];
    }
    return propValue;
  }
  return fallback ? getColor(fallback) : null;
}
function getPrimaryColor(props) {
  if (props.theme.primaryColor) return props.theme.primaryColor;
  return color.primary;
}
function getPrimaryColorTint(props) {
  if (props.theme.primaryColorTint) return props.theme.primaryColorTint;
  return "#fff";
}
function replaceColors(str) {
  if (!str) return str;
  return str.split(" ").map(comp => {
    return color[comp] || comp;
  }).join(" ");
}
function getShadow(propValue, def) {
  return propValue && (boxShadow[propValue] || replaceColors(propValue)) || (def ? getShadow(def) : null);
}
function getColorBasedOnLightness(hex, lightReturn, darkReturn) {
  const lightness = new TinyColor(hex).toHsl().l;
  return lightness > 0.6 || lightness === 0 ? lightReturn : darkReturn;
}
function getTextColor(hex) {
  return getColorBasedOnLightness(hex, "#2a2a2a", "#ffffff");
}
function getBlockquoteTextColor(hex) {
  return getColorBasedOnLightness(hex, "#58595a", "#ffffff");
}
function getIconFill(hex) {
  return getColorBasedOnLightness(hex, "black", "white");
}

// MARK : Fonts
/*-------------------------------------------------------------------------------*/

function getFont(propValue, def, props) {
  if (propValue) {
    if (font[propValue]) {
      /**
       * Get the default font object based on the prop value passed.
       * If there is an override or theme font accessible in props, replace font family.
       * NOTE: We may need some font style map if we support multiple fonts in the future.
       */
      const fontObject = _objectSpread$l({}, font[propValue]);
      const customFontFamily = getCustomFontFamily(props);
      const themeOverrides = getThemeFontOverrides(propValue, def, props);
      if (customFontFamily) fontObject.fontFamily = customFontFamily;
      return _merge(fontObject, themeOverrides);
    }
    if (typeof propValue === "string") {
      console.error("Invalid font name ".concat(propValue));
    }
    return propValue;
  }
  return def ? getFont(def, null, props) : null;
}
function getThemeFontOverrides(propValue, def, props) {
  var _props$theme2, _font$themeOverrides$;
  const key = propValue || def;
  const themeName = props === null || props === void 0 || (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.themeName;
  if (themeName && (_font$themeOverrides$ = font.themeOverrides[themeName]) !== null && _font$themeOverrides$ !== void 0 && _font$themeOverrides$[key]) return font.themeOverrides[props.theme.themeName][key];
  return {};
}
function getCustomFontFamily(props) {
  var _props$font, _props$theme3;
  if ((props === null || props === void 0 ? void 0 : props.as) === "code" || props !== null && props !== void 0 && (_props$font = props.font) !== null && _props$font !== void 0 && _props$font.includes("code")) return fontFamily.mono.fontFamily;
  if (props !== null && props !== void 0 && (_props$theme3 = props.theme) !== null && _props$theme3 !== void 0 && (_props$theme3 = _props$theme3.fonts) !== null && _props$theme3 !== void 0 && (_props$theme3 = _props$theme3.system) !== null && _props$theme3 !== void 0 && _props$theme3.family) {
    return "\"".concat(props.theme.fonts.system.family, "\", sans-serif");
  }
  return undefined;
}

// MARK : Borders
/*-------------------------------------------------------------------------------*/

const themeVals = {
  [SpaceThemeNames.classic]: {
    borderRadius: "small"
  },
  [SpaceThemeNames.scher]: {
    borderRadius: "pill"
  },
  [SpaceThemeNames.wyman]: {
    borderRadius: "medium"
  }
};
function getBorderRadius(propValue) {
  let def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return themeVals[propValue] && borderRadius[themeVals[propValue].borderRadius] || propValue && (borderRadius[propValue] || cssVal(propValue)) || (def ? getBorderRadius(def) : null);
}

/**
 *
 * @param propValue the desired border value
 * @param def a default border value if propValue is not defined (optional)
 *
 * Attampts to replace any values in the border definition with a color value
 * This allows for values like `1px solid grayLight` where grayLight will be replaced with
 * the predefined color vlaue.
 */
function getBorder(propValue) {
  let def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (propValue) {
    if (border[propValue]) {
      return border[propValue];
    }
    return replaceColors(propValue);
  }
  return def ? getBorder(def) : null;
}

// MARK : Spacing
/*-------------------------------------------------------------------------------*/

function getZIndex(propValue) {
  let def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return propValue && zIndex[propValue] || propValue || (def ? getZIndex(def) : null);
}
function getResponsiveSpacing(device, val) {
  let fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  function getValue(value) {
    const values = spacing[value];
    if (spacing[value]) {
      return cssVal(values[device === null ? Devices.desktop : device]);
    }
    return cssVal(value);
  }
  return getValue(val) || getValue(fallback);
}
function cssVal(val) {
  if (val === "") return null;
  if (val === null) return null;
  const num = Number(val);
  return Number.isNaN(num) ? val : "".concat(val, "px");
}
function flexCSS(props) {
  return css(["flex:", ";flex-basis:", ";flex-grow:", ";flex-shrink:", ";", ""], props.flex, props.flexBasis, props.flexGrow, props.flexShrink, getVariations(props, flexCSS));
}
function positioningCSS(props) {
  function getPositionSpacing(device) {
    return css(["padding:", ";padding-left:", ";padding-right:", ";padding-bottom:", ";padding-top:", ";margin:", ";margin-left:", ";margin-right:", ";margin-bottom:", ";margin-top:", ";top:", ";left:", ";right:", ";bottom:", ";"], getResponsiveSpacing(device, props.p), getResponsiveSpacing(device, props.pl, props.px), getResponsiveSpacing(device, props.pr, props.px), getResponsiveSpacing(device, props.pb, props.py), getResponsiveSpacing(device, props.pt, props.py), getResponsiveSpacing(device, props.m), getResponsiveSpacing(device, props.ml, props.mx), getResponsiveSpacing(device, props.mr, props.mx), getResponsiveSpacing(device, props.mb, props.my), getResponsiveSpacing(device, props.mt, props.my), getResponsiveSpacing(device, props.top), getResponsiveSpacing(device, props.left), getResponsiveSpacing(device, props.right), getResponsiveSpacing(device, props.bottom));
  }
  return css(["", " width:", ";height:", ";max-width:", ";max-height:", ";min-width:", ";min-height:", ";text-align:", ";justify-self:", ";align-self:", ";z-index:", ";transform:", ";order:", ";position:", ";display:", ";overflow:", ";", "{", "}", "{", "}", ""], getPositionSpacing(Devices.desktop), props.width && cssVal(props.width), props.height && cssVal(props.height), props.maxWidth && cssVal(props.maxWidth), props.maxHeight && cssVal(props.maxHeight), props.minWidth && cssVal(props.minWidth), props.minHeight && cssVal(props.minHeight), props.textAlign, props.justifySelf, props.alignSelf, getZIndex(props.zIndex), props.transform, props.order, props.position, props.display, props.overflow, Devices.mediaQueryForDevice(Devices.tablet), getPositionSpacing(Devices.tablet), Devices.mediaQueryForDevice(Devices.mobile), getPositionSpacing(Devices.mobile), getVariations(props, positioningCSS));
}
function borderCSS(props) {
  return css(["border-radius:", ";border:", ";border-top:", ";border-left:", ";border-right:", ";border-bottom:", ";", ""], getBorderRadius(props.borderRadius), getBorder(props.border), getBorder(props.borderTop), getBorder(props.borderLeft), getBorder(props.borderRight), getBorder(props.borderBottom), getVariations(props, borderCSS));
}
function transitionCSS(props) {
  return css(["transition:", ";transition-property:", ";transition-duration:", ";transition-timing-function:", ";transition-delay:", ";", ""], props.transition, props.transitionProperty, props.transitionDuration, props.transitionTimingFunction, props.transitionDelay, getVariations(props, transitionCSS));
}
function getVariations(props, render) {
  const keys = Object.keys(props.variations || {});
  return keys.reduce((res, key) => {
    const val = render(props.variations[key]);
    if (key.startsWith("mq")) {
      const size = key.split(".")[1];
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      res.push(mq[size](val));
    } else {
      res.push(css(["", "{", "}"], key, val));
    }
    return res;
  }, []);
}
const mq = Object.keys(bp).reduce((acc, label) => {
  acc[label] = style => css(["@media screen and (max-width:", "px){", ";}"], bp[label], style);
  acc["".concat(label, "_up")] = style => css(["@media screen and (min-width:", "px){", ";}"], bp[label], style);
  return acc;
}, {});
const centered = css(["position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%);"]);
const ellipsis = css(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);

// export const transition = ".5s ease";

const Sticky = styled.div.withConfig({
  displayName: "utils__Sticky"
})(["position:sticky;top:0;"]);

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Sticky: Sticky,
  borderCSS: borderCSS,
  centered: centered,
  cssVal: cssVal,
  ellipsis: ellipsis,
  flexCSS: flexCSS,
  getBlockquoteTextColor: getBlockquoteTextColor,
  getBorder: getBorder,
  getBorderRadius: getBorderRadius,
  getColor: getColor,
  getCustomFontFamily: getCustomFontFamily,
  getFont: getFont,
  getIconFill: getIconFill,
  getPrimaryColor: getPrimaryColor,
  getPrimaryColorTint: getPrimaryColorTint,
  getResponsiveSpacing: getResponsiveSpacing,
  getShadow: getShadow,
  getTextColor: getTextColor,
  getThemeName: getThemeName,
  getVariations: getVariations,
  mq: mq,
  positioningCSS: positioningCSS,
  transitionCSS: transitionCSS
});

function variableStyle$2(props) {
  if (!props.position) {
    props.position = "relative";
  }
  return css(["background:", ";background-color:", ";background-image:", ";background-size:", ";background-position:", ";overflow:", ";box-shadow:", ";", ";", ""], getColor(props.background), p => getColor(p.theme[props.backgroundColor], props.backgroundColor), props.backgroundImage, props.backgroundSize, props.backgroundPosition, props.overflow, getShadow(props.boxShadow), props.aspectRatio && "&:before {\n      content: \"\";\n      display: block;\n      padding-top: ".concat(props.aspectRatio, "%;\n    }"), getVariations(props, variableStyle$2));
}
const Box = styled.div.withConfig({
  displayName: "Box"
})(["box-sizing:border-box;", " ", " ", " ", " ", ""], variableStyle$2, positioningCSS, flexCSS, borderCSS, transitionCSS);
var Box$1 = Box;

const _excluded$B = ["id"];
function ownKeys$k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$k(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const elementFonts = {
  h1: "ui.mediumTitle",
  h2: "ui.title",
  h3: "ui.regularBold",
  h4: "ui.regularBold",
  label: "ui.smallBold",
  code: "gallery.code"
};
function getFontName(props) {
  return props.font || elementFonts[props.as] || "ui.regular";
}
var Text = styled.p.attrs(_ref => {
  var _props$theme$props$co;
  let {
      id
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$B);
  const ellipsisStyles = props.truncate ? {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  } : {};
  return {
    "data-testid": id || props["data-testid"],
    as: props.as,
    style: _objectSpread$k(_objectSpread$k({}, ellipsisStyles), {}, {
      // display: props.display,
      boxSizing: "border-box",
      backgroundColor: getColor(props.background),
      textAlign: props.textAlign,
      fontStyle: props.fontStyle,
      letterSpacing: props.letterSpacing,
      lineHeight: props.lineHeight,
      textDecoration: props.textDecoration,
      textTransform: props.textTransform,
      color: getColor((_props$theme$props$co = props.theme[props.color]) !== null && _props$theme$props$co !== void 0 ? _props$theme$props$co : props.color, "black")
    })
  };
}).withConfig({
  displayName: "Text"
})(["", ";", " ", " ", " ", ""], props => getFont(getFontName(props), "ui.regular", props), props => positioningCSS(_objectSpread$k({
  m: "none"
}, props)), borderCSS, flexCSS, transitionCSS);

function variableStyle$1(props) {
  return css(["flex-wrap:", ";flex-direction:", ";align-items:", ";justify-content:", ";gap:", ";", ""], props.flexWrap, props.flexDirection, props.alignItems, props.justifyContent, props.gap, getVariations(props, variableStyle$1));
}
const Flex = styled(Box$1).withConfig({
  displayName: "Flex"
})(["display:flex;", ""], variableStyle$1);
var Flex$1 = Flex;

var iconIndex = {
  "action.add": "24x24",
  "action.add-circle": "24x24",
  "action.checkbox-checked": "24x24",
  "action.checkbox-unchecked": "24x24",
  "action.clear": "24x24",
  "action.close": "24x24",
  "action.copy": "24x24",
  "action.download": "24x24",
  "action.dropper": "24x24",
  "action.edit": "24x24",
  "action.expand": "24x24",
  "action.external-link": "24x24",
  "action.filter": "24x24",
  "action.link": "24x24",
  "action.logout": "24x24",
  "action.maximize": "24x24",
  "action.minimize": "24x24",
  "action.play": "24x24",
  "action.radio-deselected": "24x24",
  "action.radio-selected": "24x24",
  "action.reorder": "24x24",
  "action.table-sort-ascending": "24x24",
  "action.table-sort-descending": "24x24",
  "action.trash": "24x24",
  "action.copy_to": "24x24",
  "action.move_to": "24x24",
  "action.add-to": "24x24",
  "action.drag-handler": "24x24",
  "action.checkbox-indeterminate": "24x24",
  "action.add_16": "16x16",
  "action.add-circle_16": "16x16",
  "action.checkbox-checked_16": "16x16",
  "action.checkbox-unchecked_16": "16x16",
  "action.clear_16": "16x16",
  "action.close_16": "16x16",
  "action.copy_16": "16x16",
  "action.download_16": "16x16",
  "action.dropper_16": "16x16",
  "action.edit_16": "16x16",
  "action.expand_16": "16x16",
  "action.external-link_16": "16x16",
  "action.filter_16": "16x16",
  "action.link_16": "16x16",
  "action.logout_16": "16x16",
  "action.maximize_16": "16x16",
  "action.minimize_16": "16x16",
  "action.play_16": "16x16",
  "action.radio-deselected_16": "16x16",
  "action.radio-selected_16": "16x16",
  "action.reorder_16": "16x16",
  "action.table-sort-ascending_16": "16x16",
  "action.table-sort-descending_16": "16x16",
  "action.trash_16": "16x16",
  "action.copy_to_16": "16x16",
  "action.move_to_16": "16x16",
  "action.add-to_16": "16x16",
  "action.drag-handler_16": "16x16",
  "action.checkbox-indeterminate_16": "16x16",
  "content.audio": "24x24",
  "content.code": "24x24",
  "content.color": "24x24",
  "content.file": "24x24",
  "content.file-document": "24x24",
  "content.file-graphic": "24x24",
  "content.font": "24x24",
  "content.guide": "24x24",
  "content.heading": "24x24",
  "content.kit": "24x24",
  "content.note": "24x24",
  "content.section": "24x24",
  "content.supporting-image": "24x24",
  "content.version": "24x24",
  "content.custom-colors": "24x24",
  "content.grid": "24x24",
  "content.checkered": "24x24",
  "content.portal": "24x24",
  "content.audio_16": "16x16",
  "content.code_16": "16x16",
  "content.color_16": "16x16",
  "content.file_16": "16x16",
  "content.file-document_16": "16x16",
  "content.file-graphic_16": "16x16",
  "content.font_16": "16x16",
  "content.guide_16": "16x16",
  "content.heading_16": "16x16",
  "content.kit_16": "16x16",
  "content.note_16": "16x16",
  "content.section_16": "16x16",
  "content.supporting-image_16": "16x16",
  "content.version_16": "16x16",
  "content.custom-colors_16": "16x16",
  "content.grid_16": "16x16",
  "content.checkered_16": "16x16",
  "content.portal_16": "16x16",
  "empty-state.assets": "24x24",
  "empty-state.supporting": "24x24",
  "info.building": "24x24",
  "info.check-circle": "24x24",
  "info.checkmark": "24x24",
  "info.cloud-download": "24x24",
  "info.code-android": "24x24",
  "info.code-apple": "24x24",
  "info.code-web": "24x24",
  "info.component": "24x24",
  "info.error": "24x24",
  "info.figma": "24x24",
  "info.frame": "24x24",
  "info.globe": "24x24",
  "info.globe-lock": "24x24",
  "info.group": "24x24",
  "info.history": "24x24",
  "info.info": "24x24",
  "info.lock-closed": "24x24",
  "info.lock-open": "24x24",
  "info.sketch": "24x24",
  "info.spinner": "24x24",
  "info.star": "24x24",
  "info.star-filled": "24x24",
  "info.upload": "24x24",
  "info.warning": "24x24",
  "info.help": "24x24",
  "info.building_16": "16x16",
  "info.check-circle_16": "16x16",
  "info.checkmark_16": "16x16",
  "info.cloud-download_16": "16x16",
  "info.code-android_16": "16x16",
  "info.code-apple_16": "16x16",
  "info.code-web_16": "16x16",
  "info.component_16": "16x16",
  "info.error_16": "16x16",
  "info.figma_16": "16x16",
  "info.frame_16": "16x16",
  "info.globe_16": "16x16",
  "info.globe-lock_16": "16x16",
  "info.group_16": "16x16",
  "info.history_16": "16x16",
  "info.info_16": "16x16",
  "info.lock-closed_16": "16x16",
  "info.lock-open_16": "16x16",
  "info.sketch_16": "16x16",
  "info.spinner_16": "16x16",
  "info.star_16": "16x16",
  "info.star-filled_16": "16x16",
  "info.upload_16": "16x16",
  "info.warning_16": "16x16",
  "info.help_16": "16x16",
  "logo.full": "75x35",
  "logo.mark": "24x24",
  "logo.mark_16": "16x16",
  "marketing.asset-library": "24x24",
  "marketing.design-system": "24x24",
  "marketing.distribution": "24x24",
  "marketing.security": "24x24",
  "marketing.storage": "24x24",
  "marketing.style-guide": "24x24",
  "marketing.support": "24x24",
  "marketing.terms": "24x24",
  "marketing.usage": "24x24",
  "marketing.asset-library_16": "16x16",
  "marketing.design-system_16": "16x16",
  "marketing.distribution_16": "16x16",
  "marketing.security_16": "16x16",
  "marketing.storage_16": "16x16",
  "marketing.style-guide_16": "16x16",
  "marketing.support_16": "16x16",
  "marketing.terms_16": "16x16",
  "marketing.usage_16": "16x16",
  "navigation.chart": "24x24",
  "navigation.chevron-down": "24x24",
  "navigation.chevron-left": "24x24",
  "navigation.chevron-right": "24x24",
  "navigation.chevron-up": "24x24",
  "navigation.credit-card": "24x24",
  "navigation.kit-menu": "24x24",
  "navigation.layout-detailed": "24x24",
  "navigation.layout-simple": "24x24",
  "navigation.mail": "24x24",
  "navigation.menu": "24x24",
  "navigation.overflow": "24x24",
  "navigation.privacy": "24x24",
  "navigation.search": "24x24",
  "navigation.settings": "24x24",
  "navigation.user": "24x24",
  "navigation.user-group": "24x24",
  "navigation.chart_16": "16x16",
  "navigation.chevron-down_16": "16x16",
  "navigation.chevron-left_16": "16x16",
  "navigation.chevron-right_16": "16x16",
  "navigation.chevron-up_16": "16x16",
  "navigation.credit-card_16": "16x16",
  "navigation.kit-menu_16": "16x16",
  "navigation.layout-detailed_16": "16x16",
  "navigation.layout-simple_16": "16x16",
  "navigation.mail_16": "16x16",
  "navigation.menu_16": "16x16",
  "navigation.overflow_16": "16x16",
  "navigation.privacy_16": "16x16",
  "navigation.search_16": "16x16",
  "navigation.settings_16": "16x16",
  "navigation.user_16": "16x16",
  "navigation.user-group_16": "16x16",
  "social.facebook": "24x24",
  "social.twitter": "24x24",
  "social.facebook_16": "16x16",
  "social.twitter_16": "16x16",
  "integrations.google-drive": "24x24",
  "integrations.dropbox": "24x24",
  "integrations.google-signin": "24x24",
  "integrations.figma": "24x24",
  "integrations.google-drive_16": "16x16",
  "integrations.dropbox_16": "16x16",
  "integrations.google-signin_16": "16x16",
  "integrations.figma_16": "16x16",
  "integrations.custom-colors_16": "16x16",
  "integrations.grid_16": "16x16",
  "integrations.checkered_16": "16x16",
  "editor.bold": "24x24",
  "editor.bucket": "24x24",
  "editor.code": "24x24",
  "editor.italic": "24x24",
  "editor.line": "24x24",
  "editor.link": "24x24",
  "editor.ordered-list": "24x24",
  "editor.quote": "24x24",
  "editor.strike": "24x24",
  "editor.underline": "24x24",
  "editor.unordered-list": "24x24",
  "editor.bold_16": "16x16",
  "editor.bucket_16": "16x16",
  "editor.code_16": "16x16",
  "editor.italic_16": "16x16",
  "editor.line_16": "16x16",
  "editor.link_16": "16x16",
  "editor.ordered-list_16": "16x16",
  "editor.quote_16": "16x16",
  "editor.strike_16": "16x16",
  "editor.underline_16": "16x16",
  "editor.unordered-list_16": "16x16"
};

var legacyNames = {
  plus: "action.add",
  "checkbox-checked": "action.checkbox-checked",
  "checkbox-unchecked": "action.checkbox-unchecked",
  clear: "action.clear",
  close: "action.close",
  clipboard: "action.copy",
  download: "action.download",
  editable: "action.edit",
  "badge-icon": "action.expand",
  "external-link": "action.external-link",
  link: "action.link",
  logout: "action.logout",
  maximize: "action.maximize",
  minimize: "action.minimize",
  "play-video": "action.play",
  "radio-unchecked": "action.radio-deselected",
  "radio-checked": "action.radio-selected",
  "action.table-sort-default": "action.expand",
  "table-sort-default": "action.expand",
  "table-sort-ascending": "action.table-sort-ascending",
  "table-sort-descending": "action.table-sort-descending",
  "icon-reorder": "action.reorder",
  trash: "action.trash",
  code: "content.code",
  color: "content.color",
  "text-file": "content.file-document",
  "graphic-file": "content.file-graphic",
  "icon-file": "content.file",
  "icon-font": "content.font",
  "icon-guide": "content.guide",
  "icon-heading": "content.heading",
  "big-kit": "content.kit",
  kit: "content.kit",
  "icon-text": "content.note",
  "icon-support-image": "content.supporting-image",
  version: "content.version",
  "empty-section": "empty-state.assets",
  building: "info.building",
  "checkmark-circle": "info.check-circle",
  checkmark: "info.checkmark",
  info: "info.info",
  error: "info.error",
  warning: "info.warning",
  "warning-filled": "info.warning",
  "globe-lock": "info.globe-lock",
  globe: "info.globe",
  lock: "info.lock-closed",
  "lock-fill": "info.lock-open",
  "lock-open": "info.lock-open",
  spinner: "info.spinner",
  "star-filled": "info.star-filled",
  star: "info.star",
  logo: "logo.full",
  brandmark: "logo.mark",
  "store-logo": "logo.store",
  "icon-asset-library": "marketing.asset-library",
  "icon-design-system": "marketing.design-system",
  "icon-distribution": "marketing.distribution",
  "icon-enterprise-security": "marketing.security",
  "icon-storage": "marketing.storage",
  "icon-style-guide": "marketing.style-guide",
  "icon-enterprise-support": "marketing.support",
  "icon-enterprise-terms": "marketing.terms",
  "icon-curation": "content.guide",
  "icon-usage": "marketing.usage",
  "triangle-collapsed": "navigation.chevron-right",
  "triangle-expanded": "navigation.chevron-down",
  "triangle-double": "action.expand",
  "triangle-double-small": "action.expand_16",
  "arrow-down": "navigation.chevron-down",
  "arrow-left": "navigation.chevron-left",
  "arrow-right": "navigation.chevron-right",
  "triangle-left": "navigation.chevron-left",
  "triangle-right": "navigation.chevron-right",
  "arrow-right-full": "navigation.chevron-right",
  billing: "navigation.credit-card",
  overview: "navigation.kit-menu",
  "layout-detailed": "navigation.layout-detailed",
  "layout-simple": "navigation.layout-simple",
  mail: "navigation.mail",
  menu: "navigation.menu",
  overflow: "navigation.overflow",
  eye: "navigation.privacy",
  search: "navigation.search",
  settings: "navigation.settings",
  users: "navigation.user-group",
  user: "navigation.user",
  profile: "navigation.user",
  facebook: "social.facebook",
  twitter: "social.twitter"
};

const coverStyle = css(["position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%);max-height:100%;max-width:100%;"]);
const IconSvg = styled.svg.withConfig({
  displayName: "Icon__IconSvg"
})(["cursor:", ";fill:", ";", ";", ";user-select:none;", " ", " flex-shrink:0;"], props => getCursorStyle(props), props => {
  var _props$theme$props$fi;
  return getColor(props.disabled ? "grayDark" : (_props$theme$props$fi = props.theme[props.fill]) !== null && _props$theme$props$fi !== void 0 ? _props$theme$props$fi : props.fill);
}, props => getSizeStyle(props), props => props.coverParent ? coverStyle : null, positioningCSS, flexCSS);
const getSizeStyle = _ref => {
  let {
    iconId,
    size,
    width,
    height
  } = _ref;
  let w = width || size,
    h = height || size;

  // Adjust one dimension (x) based on the alternate dimension (y)
  // pX: the provided dimension to adjust
  // x: the actual dimension of the icon
  // pY: the provided alternate dimension
  // y: the actual alternate dimension
  function adjustDimension(pX, x, pY, y) {
    if (pX) return pX;
    return pY ? Math.round(x * (pY / y)) : x;
  }
  if (!w || !h) {
    const dims = iconIndex[iconId];
    if (dims) {
      const [actualWidth, actualHeight] = dims.split("x").map(Number);
      w = adjustDimension(w, actualWidth, h, actualHeight);
      h = adjustDimension(h, actualHeight, w, actualWidth);
    } else {
      console.warn("Icon id ".concat(iconId, " not found"));
    }
  }
  return {
    width: cssVal(w),
    height: cssVal(h)
  };
};
const getCursorStyle = _ref2 => {
  let {
    onClick,
    disabled
  } = _ref2;
  if (disabled) return "not-allowed";
  if (onClick) return "pointer";
  return null;
};
function resolveIconId(id, _ref3) {
  let {
    size,
    width
  } = _ref3;
  if (cssVal(size || width) === "16px") {
    const smallId = "".concat(id, "_16");
    return iconIndex[smallId] ? smallId : id;
  }
  return id;
}
function getViewBox(iconId) {
  const dims = iconIndex[iconId];
  if (dims) {
    const [w, h] = dims.split("x").map(Number);
    return [0, 0, w, h].join(" ");
  }
  console.warn("Unexpected icon ID ".concat(iconId, ". This id does not exist."));
  return "0 0 24 24";
}
const Icon = props => {
  const {
    id,
    iconId,
    title,
    onClick,
    disabled = false
  } = props;
  const _iconId = legacyNames[iconId] || iconId;
  const resolvedId = resolveIconId(_iconId, props);
  const viewBox = props.viewBox || getViewBox(resolvedId);
  return /*#__PURE__*/React__default.createElement(IconSvg, _extends({
    "data-testid": id || "icon-svg"
  }, props, {
    iconId: resolvedId,
    viewBox: viewBox,
    onClick: disabled ? null : onClick,
    role: "img"
  }), title ? /*#__PURE__*/React__default.createElement("title", null, title) : null, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#".concat(resolvedId)
  }));
};
var Icon$1 = Icon;

function isBrowser() {
  return typeof window !== "undefined";
}

function ownKeys$j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$j(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * An internal utility wrapper to handle internal/external links for clickable components.
 *
 * If `link` is provided, the string is considered internal if it begins with # or /
 * all other strings are considered external.
 *
 * If no link is provided, the component is rendered with no wrapper.
 */

const LinkWrapper = _ref => {
  let {
    disabled = false,
    link = undefined,
    title = undefined,
    target = undefined,
    children,
    style
  } = _ref;
  // line height stops the a tag from doing weird things
  const linkProps = {
    target: undefined,
    rel: undefined,
    title,
    style: _objectSpread$j(_objectSpread$j({
      lineHeight: 0,
      textDecoration: "none"
    }, disabled && {
      pointerEvents: "none"
    }), style)
  };
  function isSameHost() {
    if (isBrowser()) {
      try {
        var _window;
        const url = new URL(link);
        return url.host === ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.host);
      } catch (_unused) {
        var _window2;
        return link.includes((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.host);
      }
    }
    return false;
  }
  function isLingoHost() {
    return link.includes(".lingoapp.com");
  }
  function isSpecialScheme() {
    const specialSchemes = ["mailto:", "tel:", "sms:"];
    return specialSchemes.some(s => link.startsWith(s));
  }
  let role = "externalLink",
    url = link;
  if (!link) {
    role = "action";
  } else if (isSpecialScheme() || target) {
    role = "externalLink";
    linkProps.target = target || "_blank";
    linkProps.rel = "nofollow noopener noreferrer";
  } else if ((isSameHost() || link.startsWith("/")) && link.includes("#")) {
    if (isSameHost()) {
      // Removes host from url (Workaround for internal markdown links passed into HashLink)
      //eslint-disable-next-line no-useless-escape
      url = url.replace(/^.*\/\/[^\/]+/, "");
    }
    role = "internalHashLink";
  } else if (link.startsWith("/") || link.startsWith("#")) {
    role = "internalLink";
  } else if (isSameHost()) {
    role = "internalLink";
    const idx = link.indexOf(window.location.host) + window.location.host.length;
    url = link.substring(idx);
  } else {
    role = "externalLink";
    if (!isLingoHost()) {
      // Open non-lingo links in a new window
      linkProps.target = "_blank";
      linkProps.rel = "nofollow noopener noreferrer";
    }
    if (!link.includes("//")) {
      url = "//".concat(link);
    }
  }
  switch (role) {
    case "externalLink":
      return /*#__PURE__*/React__default.createElement("a", _extends({}, linkProps, {
        href: url
      }), children);
    case "internalLink":
      return /*#__PURE__*/React__default.createElement(Link, _extends({}, linkProps, {
        to: url
      }), children);
    case "internalHashLink":
      return /*#__PURE__*/React__default.createElement(HashLink, _extends({}, linkProps, {
        to: url
      }), children);
    default:
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }
};
var LinkWrapper$1 = LinkWrapper;

const BaseCircle = _ref => {
  let {
    r,
    stroke,
    strokeWidth,
    strokeDasharray,
    strokeDashoffset,
    transform = "rotate(90 12 12)",
    style
  } = _ref;
  return /*#__PURE__*/React__default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: r,
    stroke: stroke,
    strokeWidth: strokeWidth,
    fill: "none",
    strokeDasharray: strokeDasharray,
    strokeDashoffset: strokeDashoffset,
    strokeLinecap: "round",
    transform: transform,
    style: style,
    role: "img"
  });
};
var BaseCircle$1 = BaseCircle;

const _excluded$A = ["size", "center", "color", "indeterminate", "progress"];
const spinning$1 = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const Spinner = styled(Box$1).attrs({
  position: "relative",
  display: "block"
}).withConfig({
  displayName: "ActivityIndicator__Spinner"
})(["pointer-events:none;transform:", ";& svg{animation:", " 1s infinite linear;transform-origin:50% 50%;}& svg::selection{background:transparent;}"], props => props.center ? "translateY(-50%)" : null, spinning$1);
const sizes$1 = {
  extraSmall: 16,
  small: 24,
  default: 40,
  large: 100
};
const strokeWidths = {
  extraSmall: 3,
  // 2px visually at 16px size with 24px viewBox
  small: 2,
  // 2px visually at 24px size with 24px viewBox
  default: 1.8,
  // 3px visually at 40px size with 24px viewBox
  large: 1.92 // 8px visually at 100px size with 24px viewBox
};
const ActivityIndicator = _ref => {
  let {
      size,
      center,
      color,
      indeterminate = true,
      progress
    } = _ref,
    styling = _objectWithoutProperties(_ref, _excluded$A);
  const theme = useContext(ThemeContext);
  const _size = sizes$1[size] || sizes$1.default;
  const strokeWidth = strokeWidths[size] || strokeWidths.default;
  const radius = 10;
  const circumference = 2 * Math.PI * radius;
  const spinnerProps = useMemo(() => center ? {
    m: "auto",
    width: "100%",
    top: "50%",
    textAlign: "center",
    height: null
  } : {
    height: _size,
    width: _size
  }, [center, _size]);
  const baseProps = useMemo(() => ({
    r: radius,
    strokeWidth
  }), [radius, strokeWidth]);
  const renderProgressIndicator = useCallback(() => {
    const offset = circumference * (1 - progress / 100);
    return /*#__PURE__*/React__default.createElement("svg", {
      width: _size,
      height: _size,
      viewBox: "0 0 24 24",
      style: {
        display: "block"
      }
    }, /*#__PURE__*/React__default.createElement(BaseCircle$1, _extends({
      stroke: getColor("gray")
    }, baseProps)), /*#__PURE__*/React__default.createElement(BaseCircle$1, _extends({
      stroke: getColor(color || theme && theme.primaryColor, "primary"),
      strokeDasharray: circumference,
      strokeDashoffset: offset,
      style: {
        transition: "stroke-dashoffset 0.3s ease"
      }
    }, baseProps)));
  }, [circumference, color, theme, progress, baseProps, _size]);
  const renderIndeterminate = useCallback(() => {
    return /*#__PURE__*/React__default.createElement(Spinner, _extends({
      role: "progressbar",
      center: center
    }, spinnerProps), /*#__PURE__*/React__default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: _size,
      height: _size
    }, /*#__PURE__*/React__default.createElement(BaseCircle$1, _extends({}, baseProps, {
      stroke: getColor(color || "gray"),
      strokeDasharray: circumference,
      strokeDashoffset: circumference * 0.25
    }))));
  }, [circumference, center, spinnerProps, _size, color, baseProps]);
  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    height: center ? "100%" : _size,
    width: center ? "100%" : _size,
    "aria-valuemin": indeterminate ? undefined : 0,
    "aria-valuemax": indeterminate ? undefined : 100,
    "aria-valuenow": indeterminate ? undefined : progress
  }, styling, {
    "data-testid": "loading"
  }), indeterminate ? renderIndeterminate() : renderProgressIndicator());
};
var ActivityIndicator$1 = ActivityIndicator;

const _excluded$z = ["id", "type", "text", "icon", "loading", "iconBefore", "onClick", "onDoubleClick", "buttonStyle", "link", "title", "newWindow", "truncate", "size", "themeOverrides"];
function ownKeys$i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$i(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
let ButtonStyle = /*#__PURE__*/function (ButtonStyle) {
  ButtonStyle["primary"] = "primary";
  ButtonStyle["secondary"] = "secondary";
  ButtonStyle["tertiary"] = "tertiary";
  ButtonStyle["outline"] = "outline";
  return ButtonStyle;
}({});
var ButtonSize = /*#__PURE__*/function (ButtonSize) {
  ButtonSize["small"] = "small";
  ButtonSize["regular"] = "regular";
  return ButtonSize;
}(ButtonSize || {});
const buttonHeights$1 = {
  [ButtonSize.regular]: "36px",
  [ButtonSize.small]: "28px"
};
function getTintColor(props) {
  var _props$themeOverrides;
  let hover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const color = getColor(props.tintColor);
  if (color) return color;
  const theme = _objectSpread$i(_objectSpread$i({}, props.theme), props.themeOverrides);
  switch (props.buttonStyle) {
    case "primary":
      return hover ? null : getColor(theme.primaryColorTint, "white");
    case "secondary":
      return hover ? null : getColor("black");
    case "tertiary":
      return hover ? getColor(theme.primaryColorDark, "primaryDark") : getColor(theme.primaryColor, "primary");
    case "outline":
      if (hover) return getColor("black");
      return getColor(((_props$themeOverrides = props.themeOverrides) === null || _props$themeOverrides === void 0 ? void 0 : _props$themeOverrides.outlineStyle) === "dark" ? "white" : "black");
    default:
      return getColor("black");
  }
}
function getBackgroundColor(props, hover) {
  const color = getColor(props.background);
  if (color) return color;
  const theme = _objectSpread$i(_objectSpread$i({}, props.theme), props.themeOverrides);
  switch (props.buttonStyle) {
    case "primary":
      return hover ? getColor(theme.primaryColorDark, "primaryDark") : getColor(theme.primaryColor, "primary");
    case "secondary":
      return hover ? getColor("gray") : getColor("grayLight");
    case "outline":
      return hover ? getColor("grayLighter") : "transparent";
    case "tertiary":
    default:
      return null;
  }
}
const ButtonBase = styled.button.withConfig({
  displayName: "Button__ButtonBase"
})(["background:", ";color:", ";border:none;", ";cursor:pointer;pointer-events:", ";", " opacity:", ";height:", ";user-select:none;box-shadow:none;span{font-family:", ";}div,svg,span{pointer-events:none;}svg{fill:", ";", "}&:hover{background:", ";color:", ";svg{fill:", ";}}"], props => getBackgroundColor(props, false), props => getTintColor(props), props => getFont(props.fontStyle, props.size === "small" ? "ui.smallBold" : "ui.regularSemiBold", props), props => props.disabled ? "none" : null, transitionCSS({
  transitionProperty: "background, opacity, color, text-decoration, box-shadow"
}), props => props.disabled ? ".5" : "1", props => buttonHeights$1[props.size], props => getCustomFontFamily(props), props => getTintColor(props, false), transitionCSS({
  transitionProperty: "fill"
}), props => getBackgroundColor(props, true), props => getTintColor(props, true), props => getTintColor(props, true));
const Wrapped = styled(ButtonBase).attrs(_objectSpread$i({}, ellipsis)).withConfig({
  displayName: "Button__Wrapped"
})(["border-radius:", ";width:", ";", " ", " ", ""], props => {
  var _props$theme;
  return getBorderRadius(props === null || props === void 0 || (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.themeName, "default");
}, props => {
  if (props.fullWidth) return "100%";
  if (props.iconOnly) return buttonHeights$1[props.size];
}, props => props.iconOnly ? null : positioningCSS({
  px: props.size === "small" ? "m" : "l",
  py: "xs"
}), positioningCSS, flexCSS);
const Outline = styled(ButtonBase).attrs(_objectSpread$i({}, ellipsis)).withConfig({
  displayName: "Button__Outline"
})(["border-radius:", ";background:", ";border:1px solid ", ";width:", ";", " ", " ", " &:hover{background:", ";}"], props => {
  var _props$theme2;
  return getBorderRadius(props === null || props === void 0 || (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.themeName, "default");
}, props => getBackgroundColor(props, false), props => {
  var _props$themeOverrides2, _props$themeOverrides4;
  if ((_props$themeOverrides2 = props.themeOverrides) !== null && _props$themeOverrides2 !== void 0 && _props$themeOverrides2.outlineStyle) {
    var _props$themeOverrides3;
    return getColor(((_props$themeOverrides3 = props.themeOverrides) === null || _props$themeOverrides3 === void 0 ? void 0 : _props$themeOverrides3.outlineStyle) === "dark" ? "white" : "black");
  }
  if ((_props$themeOverrides4 = props.themeOverrides) !== null && _props$themeOverrides4 !== void 0 && _props$themeOverrides4.customOutlineColor) {
    var _props$themeOverrides5;
    return getColor((_props$themeOverrides5 = props.themeOverrides) === null || _props$themeOverrides5 === void 0 ? void 0 : _props$themeOverrides5.customOutlineColor);
  }
  return getColor("black");
}, props => {
  if (props.fullWidth) return "100%";
  if (props.iconOnly) return buttonHeights$1[props.size];
}, props => props.iconOnly ? null : positioningCSS({
  px: "m",
  py: "xs"
}), positioningCSS, flexCSS, props => getBackgroundColor(props, true));
const Tertiary = styled(ButtonBase).withConfig({
  displayName: "Button__Tertiary"
})(["", " background:none;padding:0;height:auto;min-width:0;", ";", " ", " &:hover{text-decoration:underline;}"], ellipsis, props => getFont(props.fontStyle, props.size === "small" ? "ui.small" : "ui.regular", props), positioningCSS, flexCSS);
const Button = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  const {
      id,
      type = "button",
      text,
      icon,
      loading,
      iconBefore,
      onClick,
      onDoubleClick,
      buttonStyle = "primary",
      link,
      title,
      newWindow,
      truncate,
      size = ButtonSize.regular,
      themeOverrides = {}
    } = props,
    style = _objectWithoutProperties(props, _excluded$z);
  const iconOnly = !(text && text.length) && Boolean(icon),
    linkProps = {
      disabled: props.disabled,
      link,
      target: newWindow ? "_blank" : undefined,
      // allow setting overflow hidden for tertiary buttons to truncate buttons
      style: _objectSpread$i({
        flexShrink: style.flexShrink
      }, buttonStyle === "tertiary" && truncate ? {
        overflow: "hidden",
        display: "contents"
      } : {})
    };
  function renderContent() {
    if (!icon && !iconBefore) return /*#__PURE__*/React__default.createElement("span", null, text);
    const truncateCss = {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
    return /*#__PURE__*/React__default.createElement(Flex$1, {
      justifyContent: "center",
      alignItems: "center"
    }, loading ? /*#__PURE__*/React__default.createElement(ActivityIndicator$1, {
      size: "extraSmall"
    }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, iconBefore && /*#__PURE__*/React__default.createElement(Icon$1, {
      size: size === "small" ? "16" : "24",
      mr: "xs",
      iconId: iconBefore
    }), text && /*#__PURE__*/React__default.createElement("span", {
      style: truncate ? truncateCss : undefined
    }, text), icon && /*#__PURE__*/React__default.createElement(Icon$1, {
      size: size === "small" ? "16" : "24",
      ml: text ? "xs" : undefined,
      iconId: icon
    })));
  }
  function renderInner() {
    const buttonProps = _objectSpread$i(_objectSpread$i({}, style), {}, {
      ref,
      buttonStyle,
      type,
      title,
      iconOnly,
      size,
      onClick,
      disabled: props.disabled,
      onDoubleClick,
      truncate,
      themeOverrides
    });
    switch (buttonStyle) {
      case "tertiary":
        return /*#__PURE__*/React__default.createElement(Tertiary, _extends({
          "data-testid": id,
          "data-popup-source": buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.dataPopupSource
        }, buttonProps), renderContent());
      case "outline":
        return /*#__PURE__*/React__default.createElement(Outline, _extends({
          "data-testid": id,
          "data-popup-source": buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.dataPopupSource
        }, buttonProps), renderContent());
      default:
        return /*#__PURE__*/React__default.createElement(Wrapped, _extends({
          "data-testid": id,
          "data-popup-source": buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.dataPopupSource
        }, buttonProps), renderContent());
    }
  }
  return /*#__PURE__*/React__default.createElement(LinkWrapper$1, linkProps, renderInner());
});
Button.displayName = "Button";
var Button$1 = Button;

/**
 * We use these Normalizr schemas to transform API responses from a nested form
 * to a flat form where repos and users are placed in `entities`, and nested
 * JSON objects are replaced with their IDs. This is very convenient for
 * consumption by reducers, because we can easily build a normalized tree
 * and keep it updated as we fetch more data.
 *
 * Read more about Normalizr at https://github.com/paularmstrong/normalizr
 */

const User = new schema.Entity("users", {}, {
  idAttribute: "id"
});
const Invitation = new schema.Entity("invitations", {}, {
  idAttribute: "id"
});
const Space = new schema.Entity("spaces", {}, {
  idAttribute: "id"
});
const ApiToken = new schema.Entity("apiTokens", {}, {
  idAttribute: "token"
});
const SpaceMember = new schema.Entity("spaceMembers", {}, {
  idAttribute: val => "".concat(val.spaceId, "-").concat(val.userId)
});
const KitCollection = new schema.Entity("kitCollections", {}, {
  idAttribute: "uuid"
});
const KitCollectionItem = new schema.Entity("kitCollectionItems", {}, {
  idAttribute: val => "".concat(val.collectionUuid, "-").concat(val.kit.kitId)
});
const Portal = new schema.Entity("portals", {}, {
  idAttribute: "id"
});
const PortalMember = new schema.Entity("portalMembers", {}, {
  idAttribute: val => [val.portalId, val.userId].join("-")
});
const PortalItem = new schema.Entity("portalItems", {}, {
  idAttribute: "id"
});
const Kit = new schema.Entity("kits", {}, {
  idAttribute: "kitId"
});
const KitMember = new schema.Entity("kitMembers", {}, {
  idAttribute: val => "".concat(val.spaceId, "-").concat(val.userId, "-").concat(val.kitId)
});
const KitVersion = new schema.Entity("kitVersions", {}, {
  idAttribute: val => "".concat(val.kitId, "-").concat(val.version)
});
const Section$2 = new schema.Entity("sections", {}, {
  idAttribute: val => "".concat(val.id, "-").concat(val.version)
});
const Item$4 = new schema.Entity("items", {}, {
  idAttribute: val => "".concat(val.id, "-").concat(val.version)
});
const Asset = new schema.Entity("assets", {}, {
  idAttribute: "id"
});
const CustomField = new schema.Entity("fields", {}, {
  idAttribute: "id"
});
const AssetView = new schema.Entity("views", {}, {
  idAttribute: "id"
});
const DownloadRequest = new schema.Entity("downloadRequests", {}, {
  idAttribute: "id"
});
const DirectLink = new schema.Entity("directLinks", {}, {
  idAttribute: "id"
});
Asset.define({
  items: new schema.Array(Item$4),
  uploader: User
});
User.define({
  spaces: new schema.Array(Space)
});
KitCollectionItem.define({
  kit: Kit
});
KitCollection.define({
  kits: new schema.Array(Kit),
  items: new schema.Array(KitCollectionItem)
});
Space.define({
  fields: new schema.Array(CustomField),
  kits: new schema.Array(Kit),
  kitCollections: new schema.Array(KitCollection)
});
SpaceMember.define({
  user: User,
  kitAccess: new schema.Array(KitMember),
  portalAccess: new schema.Array(PortalMember)
});
Portal.define({
  space: Space
});
PortalMember.define({
  portal: Portal,
  user: User
});
PortalItem.define({
  kit: Kit,
  asset: Asset
});
Kit.define({
  space: Space,
  versions: new schema.Array(KitVersion)
});
KitVersion.define({
  sections: new schema.Array(Section$2),
  creator: User
});
KitMember.define({
  kit: Kit,
  user: User
});
Section$2.define({
  items: new schema.Array(Item$4)
});
Item$4.define({
  section: Section$2,
  kit: Kit,
  kitVersion: KitVersion,
  space: Space,
  asset: Asset,
  items: new schema.Array(Item$4)
});
CustomField.define({
  space: Space
});
const SpaceSearch = new schema.Object({
  kits: new schema.Array({
    kit: Kit,
    version: KitVersion,
    items: new schema.Array(Item$4)
  })
});
const Schemas = {
  user: User,
  space: Space,
  spaceMember: SpaceMember,
  apiToken: ApiToken,
  spaceSearch: SpaceSearch,
  kitCollectionItem: KitCollectionItem,
  kitCollection: KitCollection,
  kit: Kit,
  portal: Portal,
  portalMember: PortalMember,
  portalItem: PortalItem,
  kitVersion: KitVersion,
  kitMember: KitMember,
  invitation: Invitation,
  section: Section$2,
  item: Item$4,
  asset: Asset,
  customField: CustomField,
  assetView: AssetView,
  downloadRequest: DownloadRequest,
  directLink: DirectLink
};
var Schemas$1 = Schemas;

var _AssetType;
class AssetType {
  static displayName(type) {
    return typeDisplayNames[type] || (type || "").replace("_", " ").toLowerCase();
  }
}
_AssetType = AssetType;
_defineProperty(AssetType, "png", "PNG");
_defineProperty(AssetType, "jpg", "JPG");
_defineProperty(AssetType, "gif", "GIF");
_defineProperty(AssetType, "svg", "SVG");
_defineProperty(AssetType, "pdf", "PDF");
_defineProperty(AssetType, "eps", "EPS");
_defineProperty(AssetType, "tiff", "TIFF");
_defineProperty(AssetType, "color", "COLOR");
_defineProperty(AssetType, "URL", "URL");
_defineProperty(AssetType, "textStyle", "TEXT_STYLE");
_defineProperty(AssetType, "sketchLayer", "SKETCH_LAYER");
_defineProperty(AssetType, "sketchSymbol", "SKETCH_SYMBOL");
_defineProperty(AssetType, "sketchLayerStyle", "SKETCH_LAYER_STYLE");
_defineProperty(AssetType, "sketchTextStyle", "SKETCH_TEXT_STYLE");
// Motion
_defineProperty(AssetType, "mov", "MOV");
_defineProperty(AssetType, "mp4", "MP4");
_defineProperty(AssetType, "lottie", "LOTTIE");
// Audio
_defineProperty(AssetType, "wav", "WAV");
_defineProperty(AssetType, "flac", "FLAC");
_defineProperty(AssetType, "m4a", "M4A");
_defineProperty(AssetType, "mp3", "MP3");
_defineProperty(AssetType, "ogg", "OGG");
// Generic
_defineProperty(AssetType, "ai", "AI");
_defineProperty(AssetType, "txt", "TXT");
_defineProperty(AssetType, "docx", "DOCX");
_defineProperty(AssetType, "dotx", "DOTX");
_defineProperty(AssetType, "indd", "INDD");
_defineProperty(AssetType, "keynoteTheme", "KEYNOTE_THEME");
_defineProperty(AssetType, "keynote", "KEYNOTE");
_defineProperty(AssetType, "pagesTemplate", "PAGES_TEMPLATE");
_defineProperty(AssetType, "pages", "PAGES");
_defineProperty(AssetType, "potx", "POTX");
_defineProperty(AssetType, "pptx", "PPTX");
_defineProperty(AssetType, "psd", "PSD");
_defineProperty(AssetType, "zip", "ZIP");
_defineProperty(AssetType, "imageTypes", new Set([_AssetType.png, _AssetType.jpg, _AssetType.gif, _AssetType.svg, _AssetType.pdf, _AssetType.eps, _AssetType.tiff]));
_defineProperty(AssetType, "genericTypes", new Set([_AssetType.ai, _AssetType.txt, _AssetType.docx, _AssetType.dotx, _AssetType.indd, _AssetType.keynoteTheme, _AssetType.keynote, _AssetType.pagesTemplate, _AssetType.pages, _AssetType.potx, _AssetType.pptx, _AssetType.psd, _AssetType.zip]));
_defineProperty(AssetType, "textTypes", new Set([_AssetType.txt, _AssetType.docx, _AssetType.dotx, _AssetType.pagesTemplate, _AssetType.pages, _AssetType.zip]));
_defineProperty(AssetType, "graphicTypes", new Set([_AssetType.ai, _AssetType.indd, _AssetType.keynoteTheme, _AssetType.keynote, _AssetType.potx, _AssetType.pptx, _AssetType.psd]));
_defineProperty(AssetType, "sketchTypes", new Set([_AssetType.sketchLayerStyle, _AssetType.sketchLayer, _AssetType.sketchSymbol, _AssetType.sketchTextStyle]));
_defineProperty(AssetType, "videoTypes", new Set([_AssetType.mov, _AssetType.mp4]));
_defineProperty(AssetType, "motionTypes", new Set([..._AssetType.videoTypes, _AssetType.lottie, _AssetType.gif]));
_defineProperty(AssetType, "audioTypes", new Set([_AssetType.wav, _AssetType.flac, _AssetType.m4a, _AssetType.mp3, _AssetType.ogg]));
const typeDisplayNames = {
  [AssetType.ai]: "Illustrator",
  [AssetType.color]: "Color",
  [AssetType.URL]: "URL",
  [AssetType.docx]: "Word",
  [AssetType.dotx]: "Word template",
  [AssetType.eps]: "EPS",
  [AssetType.flac]: "FLAC",
  [AssetType.gif]: "GIF",
  [AssetType.indd]: "InDesign",
  [AssetType.jpg]: "JPG",
  [AssetType.keynoteTheme]: "Keynote theme",
  [AssetType.keynote]: "Keynote",
  [AssetType.lottie]: "Lottie",
  [AssetType.mov]: "MOV",
  [AssetType.mp3]: "MP3",
  [AssetType.mp4]: "MP4",
  [AssetType.m4a]: "M4A",
  [AssetType.ogg]: "OGG",
  [AssetType.pagesTemplate]: "Pages template",
  [AssetType.pages]: "Pages",
  [AssetType.pdf]: "PDF",
  [AssetType.png]: "PNG",
  [AssetType.potx]: "PowerPoint template",
  [AssetType.pptx]: "PowerPoint",
  [AssetType.psd]: "Photoshop",
  [AssetType.sketchLayerStyle]: "Sketch layer style",
  [AssetType.sketchLayer]: "Sketch layer",
  [AssetType.sketchSymbol]: "Sketch symbol",
  [AssetType.sketchTextStyle]: "Sketch text style",
  [AssetType.svg]: "SVG",
  [AssetType.txt]: "Text File",
  [AssetType.textStyle]: "Font",
  [AssetType.tiff]: "TIFF",
  [AssetType.wav]: "WAV",
  [AssetType.zip]: "ZIP"
};
let ItemType = /*#__PURE__*/function (ItemType) {
  ItemType["asset"] = "asset";
  ItemType["heading"] = "heading";
  ItemType["note"] = "inline_note";
  ItemType["supportingImage"] = "supporting_image";
  ItemType["codeSnippet"] = "code_snippet";
  ItemType["guide"] = "guide";
  ItemType["link"] = "link";
  ItemType["gallery"] = "gallery";
  return ItemType;
}({});
let PortalItemType = /*#__PURE__*/function (PortalItemType) {
  PortalItemType["heading"] = "heading";
  PortalItemType["note"] = "inline_note";
  PortalItemType["supportingImage"] = "supporting_image";
  PortalItemType["kit"] = "kit";
  return PortalItemType;
}({});
let PrivacyLevel = /*#__PURE__*/function (PrivacyLevel) {
  PrivacyLevel["private"] = "private";
  PrivacyLevel["password"] = "password";
  PrivacyLevel["public"] = "public";
  return PrivacyLevel;
}({});

/**
 * Create a slug compatible id for an object with the name and shortID
 *
 * @param {String} name The name of the object
 * @param {String} shortId The short ID for the object
 */
function slugifyName(name, shortId) {
  const a = "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
  const b = "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
  const p = new RegExp(a.split("").join("|"), "g");
  const slugName = (name || "").replace(/\s+/g, "-") // Replace spaces with -
  .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
  .replace(/&/g, "-and-") // Replace & with 'and'
  // eslint-disable-next-line no-useless-escape
  .replace(/[^\w\-]+/g, "") // Remove all non-word characters
  // eslint-disable-next-line no-useless-escape
  .replace(/\-\-+/g, "-") // Replace multiple - with single -
  .replace(/^-+/, "") // Trim - from start of text
  .replace(/-+$/, ""); // Trim - from end of text

  return [slugName, shortId].filter(comp => comp && comp.length > 0).join("-");
}

/* eslint-disable line-comment-position */
/* eslint-disable no-useless-escape */
/**
 * Subdomains will be typed by the user, so we need to give them the option to type spaces & underscores.
 * End spaces can be trimmed with trimSubdomain on submit
 */
function slugifySubdomain(name) {
  const a = "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
  const b = "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
  return name.replace(/\s+/g, "-") // Replace spaces with -
  .replace("[^\\P{Punct}_]+", c => b.charAt(a.indexOf(c))) // Replace special characters besides underscore
  .replace(/&/g, "-and-") // Replace & with 'and'
  .replace(/[^\w\-]+/g, "") // Remove all non-word characters
  .replace(/\-\-+/g, "-") // Replace multiple - with single -
  .replace(/\_\_+/g, "_") // Replace multiple underscore with single underscore
  .replace(/^-+/, "") // Trim - from start of text
  .toLowerCase();
}
function trimSubdomain(name) {
  return name.replace(/[-_]+$/, ""); // Remove trailing _ & -
}

const keyTransforms = {
  uuid: "id",
  sectionUuid: "sectionId",
  kitUuid: "kitId",
  itemUuid: "itemId",
  portalUuid: "portalId",
  assetUuid: "assetId",
  sourceUuid: "sourceId"
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type

const ignoreKeys = ["upgradePermissions"];
function camelize(obj) {
  if (obj === null || obj === undefined) return obj;
  return Object.keys(obj).reduce((acc, key) => {
    let _key = key;
    if (typeof key === "string") {
      const camelKey = camelCase(key);
      _key = keyTransforms[camelKey] || camelKey;
    }
    const value = obj[key];
    if (Array.isArray(value)) {
      acc[_key] = value.map(item => isObject(item) ? camelize(item) : item);
    } else if (isObject(value) && !ignoreKeys.includes(_key)) {
      acc[_key] = camelize(value);
    } else {
      acc[_key] = value;
    }
    return acc;
  }, {});
}

const _excluded$y = ["users"],
  _excluded2$4 = ["user", "spaces"],
  _excluded3 = ["spaces"],
  _excluded4 = ["members"],
  _excluded5 = ["result"],
  _excluded6 = ["members"],
  _excluded7 = ["portals"],
  _excluded8 = ["members"],
  _excluded9 = ["result"],
  _excluded10 = ["members"],
  _excluded11 = ["portal_items"],
  _excluded12 = ["result"],
  _excluded13 = ["portal_items"],
  _excluded14 = ["kits"],
  _excluded15 = ["members"],
  _excluded16 = ["result"],
  _excluded17 = ["invitations"],
  _excluded18 = ["result"],
  _excluded19 = ["invitations"],
  _excluded20 = ["sections"],
  _excluded21 = ["result"],
  _excluded22 = ["views"],
  _excluded23 = ["result"],
  _excluded24 = ["fields"],
  _excluded25 = ["result"],
  _excluded26 = ["items"],
  _excluded27 = ["result"],
  _excluded28 = ["assets"],
  _excluded29 = ["result"],
  _excluded30 = ["result"],
  _excluded31 = ["font", "textStyle", "filecuts", "assetProcessing", "backgroundColor"],
  _excluded32 = ["requests"];
function ownKeys$h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$h(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function camelCaseKeys(object) {
  const snakeToCamel = str => str.replace(/([-_][a-z0-9])/g, group => group.toUpperCase().replace("-", "").replace("_", ""));
  return Object.keys(object).reduce((acc, key) => {
    acc[snakeToCamel(key)] = object[key];
    return acc;
  }, {});
}

/**
 *
 * @param {*} dataList
 * @returns Returns  true if the provided list is in the format:
 * ```
 * [{
 *  success: true|false,
 *  result?: {}?,
 *  error?: {}
 * }]
 * ```
 * This is a common format for batch update API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isResultList(dataList) {
  if (!Array.isArray(dataList)) return false;
  const first = dataList[0];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return typeof (first === null || first === void 0 ? void 0 : first.success) === "boolean" && (first.result || first.error);
}

// MARK : User
/*-------------------------------------------------------------------------------*/
const user = json => {
  if (json.users) {
    const {
        users
      } = json,
      rest = _objectWithoutProperties(json, _excluded$y);
    return normalize$1(_objectSpread$h({
      users: users.map(formatUser)
    }, rest), {
      users: [Schemas$1.user]
    });
  }
  const {
      user: userData,
      spaces: spaceData
    } = json,
    rest = _objectWithoutProperties(json, _excluded2$4);
  const u = formatUser(userData);
  const spaces = (spaceData || []).map(formatSpace);
  return normalize$1(_objectSpread$h({
    user: _objectSpread$h(_objectSpread$h({}, u), {}, {
      spaces
    })
  }, rest), {
    user: Schemas$1.user
  });
};
function formatUser(data) {
  return camelCaseKeys(data);
}

// MARK : Space
/*-------------------------------------------------------------------------------*/

const space = json => {
  if (json.spaces) {
    const {
        spaces
      } = json,
      rest = _objectWithoutProperties(json, _excluded3);
    return normalize$1(_objectSpread$h({
      spaces: spaces.map(formatSpace)
    }, rest), {
      spaces: [Schemas$1.space]
    });
  }
  const _space = formatSpace(json.space);
  return normalize$1(_space, Schemas$1.space);
};
function formatSpace(data) {
  var _ref;
  const res = camelCaseKeys(data);
  res.avatar = data.avatars.avatar || data.avatars.default_avatar;
  res.avatars = camelize(data.avatars);
  res.fields = (data.fields || []).map(formatCustomField);
  res.joinSettings = data.join_settings && formatSpaceJoinSettings(data.join_settings);
  res.access = (_ref = data.access && formatSpaceMember(data.access)) !== null && _ref !== void 0 ? _ref : {};
  res.kits = (data.kits || []).map(formatKit);
  res.kitCollections = (data.kit_collections || []).map(formatKitCollection);
  res.theme = formatTheme(data.theme);
  res.account = formatSpaceAccount(data);
  delete res.charges;
  delete res.card;
  delete res.balance;
  res.ssoOrganization = data.sso_organization && formatSsoOrganization(data.sso_organization);
  res.subscription = data.subscription && formatSubscription(data.subscription);
  res.plan = data.plan && camelize(data.plan);
  return res;
}
function formatSpaceJoinSettings(data) {
  // join_with, allowed_domains, token
  return camelCaseKeys(data);
}
function contextIdentification(json) {
  return normalize$1(_objectSpread$h(_objectSpread$h({}, camelize(json)), {}, {
    portal: json.portal ? formatPortal(json.portal) : null,
    space: json.space ? formatSpace(json.space) : null,
    kitCollection: json.kit_collection ? formatKitCollection(json.kit_collection) : null,
    kit: json.kit ? formatKit(json.kit) : null,
    kitVersion: json.kit_version ? formatKitVersion(json.kit_version) : null,
    section: json.section ? formatSection(json.section) : null,
    item: json.item ? formatItem(json.item) : null,
    gallery: json.gallery ? formatItem(json.gallery) : null,
    asset: json.asset ? formatAsset(json.asset) : null
  }), {
    portal: Schemas$1.portal,
    space: Schemas$1.space,
    kitCollection: Schemas$1.kitCollection,
    kit: Schemas$1.kit,
    kitVersion: Schemas$1.kitVersion,
    section: Schemas$1.section,
    item: Schemas$1.item,
    gallery: Schemas$1.item,
    asset: Schemas$1.asset
  });
}
function contextIdentificationPreview(json) {
  return normalize$1(_objectSpread$h(_objectSpread$h({}, camelize(json)), {}, {
    portal: json.portal ? formatPortal(json.portal) : null,
    space: json.space ? formatSpacePreview(json.space) : null,
    kit: json.kit ? formatKit(json.kit) : null,
    section: json.section ? formatSection(json.section) : null,
    item: json.item ? formatItem(json.item) : null,
    asset: json.asset ? formatAsset(json.asset) : null
  }), {});
}
function spacePreview(json) {
  if (json.spaces) {
    return normalize$1(json.spaces.map(formatSpacePreview), [{}]);
  }
  return normalize$1(formatSpacePreview(json.preview), {});
}
function formatSpacePreview(data) {
  function formatPreviewMember(m) {
    return {
      id: m.id,
      name: m.name,
      email: m.email,
      avatar: m.avatar,
      role: m.role
    };
  }
  if (!data) return null;
  return _objectSpread$h(_objectSpread$h({}, camelize(data)), {}, {
    theme: formatTheme(data.theme),
    members: data.members && data.members.map(formatPreviewMember)
  });
}
function formatSsoOrganization(data) {
  return camelCaseKeys(data);
}
function formatTheme(data) {
  if (!data) return null;
  const converted = camelCaseKeys(data);
  if (converted.headerTitleStyle === "space_name") {
    converted.headerTitleStyle = ThemeHeaderTitleOptions.name;
  }
  return _objectSpread$h({
    // default
    headerBackgroundColor: "#FAFAFA"
  }, converted);
}
function formatSubscription(data) {
  const res = camelCaseKeys(data);
  res["customer"] = res.customer ? camelCaseKeys(res.customer) : {};
  return res;
}
function formatSpaceAccount(data) {
  return {
    balance: data.balance,
    card: data.card && formatCard(data.card),
    charges: data.charges && data.charges.map(formatCharge)
  };
}
function formatCard(data) {
  return camelCaseKeys(data);
}
const charge = json => {
  return json.charges ? normalize$1({
    charges: json.charges.map(formatCharge)
  }, {
    charges: [{}]
  }) : normalize$1(formatCharge(json.charge), {});
};
function formatCharge(data) {
  return camelCaseKeys(data);
}

// MARK : Space Member
/*-------------------------------------------------------------------------------*/

const spaceMember = json => {
  if (isResultList(json.members)) {
    const {
        members
      } = json,
      rest = _objectWithoutProperties(json, _excluded4);
    const results = members.map(_ref2 => {
      let {
          result
        } = _ref2,
        other = _objectWithoutProperties(_ref2, _excluded5);
      return _objectSpread$h({
        result: formatSpaceMember(result === null || result === void 0 ? void 0 : result.member)
      }, other);
    });
    return normalize$1(_objectSpread$h({
      members: results
    }, rest), {
      members: [{
        result: Schemas$1.spaceMember
      }]
    });
  }
  if (json.members) {
    const {
        members
      } = json,
      rest = _objectWithoutProperties(json, _excluded6);
    return normalize$1(_objectSpread$h({
      members: members.map(formatSpaceMember)
    }, rest), {
      members: [Schemas$1.spaceMember]
    });
  }
  const res = formatSpaceMember(json.member);
  return normalize$1(res, Schemas$1.spaceMember);
};
function formatSpaceMember(data) {
  if (!data) return data;
  const kits = data.kits && data.kits.map(formatKit),
    kitCount = data.joined_kits || kits && kits.reduce((res, k) => {
      return res + (k.access.status === "active" ? 1 : 0);
    }, 0),
    kitAccess = data.kit_access && data.kit_access.map(formatKitMember),
    portalAccess = data.portal_access && data.portal_access.map(formatPortalMember);
  return _objectSpread$h(_objectSpread$h({}, camelCaseKeys(data)), {}, {
    id: data.id,
    role: data.role,
    counts: kits,
    status: data.status,
    kitAccess,
    portalAccess,
    isPublic: Boolean(data.user_id) === false || data.role === "guest",
    userId: data.user_id,
    spaceId: data.space_id,
    joinedKits: kitCount,
    user: data.user ? formatUser(data.user) : undefined,
    notificationPrefs: data.notification_prefs ? camelCaseKeys(data.notification_prefs) : {},
    permissions: data.permissions || [],
    ssoEnabled: data.sso_enabled,
    dateAdded: data.date_added,
    dateUpdated: data.date_updated,
    isEditor: data.is_editor
  });
}

// MARK : API Token
/*-------------------------------------------------------------------------------*/

const apiToken = json => {
  return json.tokens ? normalize$1({
    apiTokens: json.tokens.map(formatApiToken)
  }, {
    apiTokens: [Schemas$1.apiToken]
  }) : normalize$1(formatApiToken(json.token), Schemas$1.apiToken);
};
function formatApiToken(data) {
  return camelCaseKeys(data);
}

// MARK : Kit Collection
/*-------------------------------------------------------------------------------*/
const kitCollection = json => {
  return json.kit_collections ? normalize$1({
    kitCollections: json.kit_collections.map(formatKitCollection)
  }, {
    kitCollections: [Schemas$1.kitCollection]
  }) : normalize$1(formatKitCollection(json.kit_collection), Schemas$1.kitCollection);
};
function formatKitCollection(data) {
  var _data$items;
  return _objectSpread$h(_objectSpread$h({}, camelCaseKeys(data)), {}, {
    url: "/c/".concat(slugifyName(data.name, data.short_id)),
    items: (data === null || data === void 0 || (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(formatKitCollectionItem)) || []
  });
}

// MARK : Kit Collection Item
/*-------------------------------------------------------------------------------*/
const kitCollectionItem = json => {
  return json.items ? normalize$1({
    kitCollectionItems: json.items.map(formatKitCollectionItem)
  }, {
    kitCollectionItems: [Schemas$1.kitCollectionItem]
  }) : normalize$1(formatKitCollectionItem(json.items), Schemas$1.kitCollectionItem);
};
function formatKitCollectionItem(data) {
  const d = data.result || data;
  return _objectSpread$h(_objectSpread$h({}, camelCaseKeys(d)), {}, {
    kit: formatKit(d.kit)
  });
}

// MARK : Portal
/*-------------------------------------------------------------------------------*/

const portal = json => {
  if (Array.isArray(json.portals)) {
    const {
        portals
      } = json,
      rest = _objectWithoutProperties(json, _excluded7);
    return normalize$1(_objectSpread$h({
      portals: portals.map(formatPortal)
    }, rest), {
      portals: [Schemas$1.portal]
    });
  }
  return normalize$1(formatPortal(json.portal), Schemas$1.portal);
};
function portalPreview(json) {
  return normalize$1(formatPortal(json.preview), {});
}
function formatPortal(data) {
  if (!data) return null;
  const res = camelize(data);
  if (res.access) {
    res.access.isPublic = Boolean(data.access.user_id) === false;
  }
  res.space = data.space ? formatSpace(data.space) : undefined;
  res.urlId = slugifyName(res.name, res.shortId);
  return res;
}

// MARK : Portal Member
// -------------------------------------------------------------------------------

const portalMember = json => {
  if (isResultList(json.members)) {
    const {
        members
      } = json,
      rest = _objectWithoutProperties(json, _excluded8);
    const results = members.map(_ref3 => {
      let {
          result
        } = _ref3,
        other = _objectWithoutProperties(_ref3, _excluded9);
      return _objectSpread$h({
        result: formatPortalMember(result === null || result === void 0 ? void 0 : result.member)
      }, other);
    });
    return normalize$1(_objectSpread$h({
      members: results
    }, rest), {
      members: [{
        result: Schemas$1.portalMember
      }]
    });
  }
  if (json.members) {
    const {
        members
      } = json,
      rest = _objectWithoutProperties(json, _excluded10);
    return normalize$1(_objectSpread$h({
      members: members.map(formatPortalMember)
    }, rest), {
      members: [Schemas$1.portalMember]
    });
  }
  const res = formatPortalMember(json.member);
  return normalize$1(res, Schemas$1.portalMember);
};
function formatPortalMember(data) {
  if (!data) return data;
  return _objectSpread$h(_objectSpread$h({}, camelize(data)), {}, {
    user: data.user ? formatUser(data.user) : undefined,
    portal: data.portal ? formatPortal(data.portal) : undefined,
    permissions: data.permissions || [],
    portalId: data.portal_uuid,
    isPublic: Boolean(data.user_id) === false
  });
}

// MARK : Portal Item
/*-------------------------------------------------------------------------------*/

const portalItem = json => {
  if (isResultList(json.portal_items)) {
    const {
        portal_items: portalItems
      } = json,
      rest = _objectWithoutProperties(json, _excluded11);
    const results = portalItems.map(_ref4 => {
      let {
          result
        } = _ref4,
        other = _objectWithoutProperties(_ref4, _excluded12);
      return _objectSpread$h({
        result: formatPortalItem(result === null || result === void 0 ? void 0 : result.portal_item)
      }, other);
    });
    return normalize$1(_objectSpread$h({
      portalItems: results
    }, rest), {
      portalItems: [{
        result: Schemas$1.portalItem
      }]
    });
  }
  if (Array.isArray(json.portal_items)) {
    const {
        portal_items
      } = json,
      rest = _objectWithoutProperties(json, _excluded13);
    return normalize$1(_objectSpread$h({
      portalItems: portal_items.map(formatPortalItem)
    }, rest), {
      portalItems: [Schemas$1.portalItem]
    });
  }
  return normalize$1(formatPortalItem(json.portal_item), Schemas$1.portalItem);
};
function formatPortalItem(data) {
  var _res$kit;
  if (!data) return null;
  const res = camelize(data);
  res.kit = data.kit && formatKit(data.kit);
  res.kitId = (_res$kit = res.kit) === null || _res$kit === void 0 ? void 0 : _res$kit.kitId;
  res.asset = data.asset && formatAsset(data.asset);
  if (res.data) {
    res.data.backgroundColor = res.data.backgroundColor || "default";
  }
  return res;
}

// MARK : Kit
/*-------------------------------------------------------------------------------*/

const kit = json => {
  if (json.kits) {
    const {
        kits
      } = json,
      rest = _objectWithoutProperties(json, _excluded14);
    return normalize$1(_objectSpread$h({
      kits: kits.map(formatKit)
    }, rest), {
      kits: [Schemas$1.kit]
    });
  }
  return normalize$1(formatKit(json.kit), Schemas$1.kit);
};
function formatKit(data) {
  const access = data.access;
  const userVersion = access && access.use_version;
  const recommendedVersion = data.use_version;
  return {
    kitId: data.kit_uuid,
    shortId: data.short_id,
    urlId: slugifyName(data.name, data.short_id),
    dateAdded: data.date_added,
    dateUpdated: data.date_updated,
    name: data.name,
    description: data.description,
    status: data.status,
    portalAccess: data.portal_access,
    portals: data.portals && data.portals.map(formatPortal),
    images: data.images,
    counts: data.counts || {},
    privacy: data.privacy,
    indexable: data.indexable,
    shareToken: data.token,
    recommendedVersion: recommendedVersion,
    userVersion: userVersion === null ? recommendedVersion : userVersion,
    access: data.access && formatKitMember(data.access) || {},
    theme: data.theme ? camelCaseKeys(data.theme) : null,
    // Relationships
    spaceId: data.space_id,
    space: data.space ? formatSpace(data.space) : null,
    versions: data.versions && data.versions.map(formatKitVersion),
    members: (data.members || []).map(formatKitMember),
    purchase: data.purchase ? camelCaseKeys(data.purchase) : null,
    publisher: data.publisher && camelCaseKeys(data.publisher),
    downloadsRestricted: data.downloads_restricted || false,
    downloadsRestrictedApproveMode: data.downloads_restricted_approve_mode
  };
}

// MARK : Kit Member
/*-------------------------------------------------------------------------------*/

const kitMember = json => {
  if (isResultList(json.members)) {
    const {
        members
      } = json,
      rest = _objectWithoutProperties(json, _excluded15);
    const results = members.map(_ref5 => {
      let {
          result
        } = _ref5,
        other = _objectWithoutProperties(_ref5, _excluded16);
      return _objectSpread$h({
        result: formatKitMember(result === null || result === void 0 ? void 0 : result.member)
      }, other);
    });
    return normalize$1(_objectSpread$h({
      members: results
    }, rest), {
      members: [{
        result: Schemas$1.kitMember
      }]
    });
  }
  if (json.members || json.unjoined_members) {
    const members = (json.members || []).map(formatKitMember),
      unjoinedMembers = (json.unjoined_members || []).map(formatSpaceMember);
    return normalize$1({
      members,
      unjoinedMembers
    }, {
      members: [Schemas$1.kitMember],
      unjoinedMembers: [Schemas$1.spaceMember]
    });
  }
  return normalize$1(formatKitMember(json.member), Schemas$1.kitMember);
};
function formatKitMember(data) {
  if (!data) return null;
  if (data.result) data = data.result.member;
  return _objectSpread$h(_objectSpread$h({}, camelCaseKeys(data)), {}, {
    user: data.user ? formatUser(data.user) : null,
    permissions: data.permissions || [],
    isFavorite: Boolean(data.is_favorite),
    isPublic: Boolean(data.user_id) === false,
    kitId: data.kit_uuid,
    kit: data.kit && formatKit(data.kit)
  });
}

// MARK : Invitation
/*-------------------------------------------------------------------------------*/

const invitation = json => {
  if (isResultList(json.invitations)) {
    const {
        invitations
      } = json,
      rest = _objectWithoutProperties(json, _excluded17);
    const results = invitations.map(_ref6 => {
      let {
          result
        } = _ref6,
        other = _objectWithoutProperties(_ref6, _excluded18);
      return _objectSpread$h({
        result: formatInvitation(result === null || result === void 0 ? void 0 : result.invitation)
      }, other);
    });
    return normalize$1(_objectSpread$h({
      invitations: results
    }, rest), {
      invitations: [{
        result: Schemas$1.invitation
      }]
    });
  }
  if (json.invitations) {
    const {
        invitations
      } = json,
      rest = _objectWithoutProperties(json, _excluded19);
    return normalize$1(_objectSpread$h({
      invitations: invitations.map(formatInvitation)
    }, rest), {
      invitations: [Schemas$1.invitation]
    });
  }
  const res = formatInvitation(json.invitation);
  return normalize$1(res, Schemas$1.invitation);
};
function formatInvitation(data) {
  if (!data) return data;
  if (data.result) data = data.result;
  return camelCaseKeys(data);
}

// MARK : Kit Version
/*-------------------------------------------------------------------------------*/

const kitVersion = json => {
  const version = formatKitVersion(json.kit_version);
  return normalize$1(version, Schemas$1.kitVersion);
};
function formatKitVersion(data) {
  var _data$sections;
  return {
    version: data.version,
    kitId: data.kit_uuid,
    versionIdentifier: data.version_identifier,
    notes: data.notes,
    creator: data.creator ? formatUser(data.creator) : null,
    dateAdded: data.date_added,
    dateUpdated: data.date_updated,
    spaceId: data.space_id,
    status: data.status,
    counts: data.counts,
    sections: (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections.map(s => {
      return _objectSpread$h(_objectSpread$h({}, formatSection(s)), {}, {
        kitId: data.kit_uuid
      });
    })
  };
}

// MARK : Section
/*-------------------------------------------------------------------------------*/

const section = json => {
  if (isResultList(json.sections)) {
    const {
        sections
      } = json,
      rest = _objectWithoutProperties(json, _excluded20);
    const results = sections.map(_ref7 => {
      let {
          result
        } = _ref7,
        other = _objectWithoutProperties(_ref7, _excluded21);
      return _objectSpread$h({
        result: formatSection(result === null || result === void 0 ? void 0 : result.section)
      }, other);
    });
    return normalize$1(_objectSpread$h({
      sections: results
    }, rest), {
      sections: [{
        result: Schemas$1.section
      }]
    });
  }
  if (json.sections) {
    return normalize$1({
      sections: json.sections.map(formatSection)
    }, {
      sections: [Schemas$1.section]
    });
  }
  return normalize$1(formatSection(json.section), Schemas$1.section);
};
function formatSection(data) {
  var _data$items2;
  return {
    id: data.uuid,
    counts: data.counts,
    version: data.version,
    shortId: data.short_id,
    urlId: slugifyName(data.name, data.short_id),
    name: data.name,
    status: data.status,
    displayOrder: data.display_order,
    items: (_data$items2 = data.items) === null || _data$items2 === void 0 ? void 0 : _data$items2.map(i => formatItem(i)),
    kitId: data.kit_uuid,
    headers: data.headers && data.headers.map(formatOutlineHeader)
  };
}
function formatOutlineHeader(data) {
  return {
    id: data.uuid,
    shortId: data.short_id,
    name: data.name,
    version: data.version,
    displayOrder: data.display_order
  };
}

// MARK : Saved Views
/*-------------------------------------------------------------------------------*/

const formatAssetView = data => {
  return {
    id: data.id,
    name: data.name,
    spaceId: data.space_id,
    filters: data.filters || [],
    status: data.status
  };
};
const assetView = json => {
  if (isResultList(json.views)) {
    const {
        views
      } = json,
      rest = _objectWithoutProperties(json, _excluded22);
    const results = views.map(_ref8 => {
      let {
          result
        } = _ref8,
        other = _objectWithoutProperties(_ref8, _excluded23);
      return _objectSpread$h({
        result: formatAssetView(result === null || result === void 0 ? void 0 : result.view)
      }, other);
    });
    return normalize$1(_objectSpread$h({
      views: results
    }, rest), {
      views: [{
        result: Schemas$1.assetView
      }]
    });
  }
  if (json.views) {
    return normalize$1({
      views: json.views.map(formatAssetView)
    }, {
      views: [Schemas$1.assetView]
    });
  }
  return normalize$1(formatAssetView(json.view), Schemas$1.assetView);
};

// MARK : Custom Fields
/*-------------------------------------------------------------------------------*/

const formatCustomField = data => {
  return _objectSpread$h(_objectSpread$h({}, camelCaseKeys(data)), {}, {
    options: data.options ? data.options.map(camelCaseKeys) : undefined
  });
};
const customField = json => {
  if (isResultList(json.fields)) {
    const {
        fields
      } = json,
      rest = _objectWithoutProperties(json, _excluded24);
    const results = fields.map(_ref9 => {
      let {
          result
        } = _ref9,
        other = _objectWithoutProperties(_ref9, _excluded25);
      return _objectSpread$h({
        result: formatCustomField(result === null || result === void 0 ? void 0 : result.field)
      }, other);
    });
    return normalize$1(_objectSpread$h({
      fields: results
    }, rest), {
      fields: [{
        result: Schemas$1.customField
      }]
    });
  }
  if (json.fields) {
    return normalize$1({
      fields: json.fields.map(formatCustomField)
    }, {
      fields: [Schemas$1.customField]
    });
  }
  return normalize$1(formatCustomField(json.field), Schemas$1.customField);
};

// MARK : Item
/*-------------------------------------------------------------------------------*/

const item = json => {
  if (isResultList(json.items)) {
    const {
        items
      } = json,
      rest = _objectWithoutProperties(json, _excluded26);
    const results = items.map(_ref10 => {
      let {
          result
        } = _ref10,
        other = _objectWithoutProperties(_ref10, _excluded27);
      return _objectSpread$h({
        result: formatItem(result === null || result === void 0 ? void 0 : result.item)
      }, other);
    });
    return normalize$1(_objectSpread$h({
      items: results
    }, rest), {
      items: [{
        result: Schemas$1.item
      }]
    });
  }
  if (json.items) {
    return normalize$1({
      items: json.items.map(formatItem)
    }, {
      items: [Schemas$1.item]
    });
  }
  return normalize$1(formatItem(json.item), Schemas$1.item);
};
const search = json => {
  const formattedJson = _objectSpread$h(_objectSpread$h({}, json), {}, {
    queries: Object.keys(json.queries).reduce((acc, q) => {
      const jsonQuery = camelCaseKeys(json.queries[q]);
      if (jsonQuery.type === "content") {
        acc[q] = _objectSpread$h(_objectSpread$h({}, jsonQuery), {}, {
          results: jsonQuery.results.map(o => _objectSpread$h(_objectSpread$h({}, formatItem(o.object)), {}, {
            section: o.object.section && formatSection(o.object.section),
            kit: formatKit(o.object.kit),
            item: o.object.item && formatItem(o.object.item)
          }))
        });
      } else if (jsonQuery.type === "jump_to") {
        acc[q] = _objectSpread$h(_objectSpread$h({}, jsonQuery), {}, {
          results: jsonQuery.results.map(o => {
            switch (o.type) {
              case "item":
              case "gallery":
                return _objectSpread$h(_objectSpread$h({}, camelCaseKeys(o)), {}, {
                  object: _objectSpread$h(_objectSpread$h({}, formatItem(o.object)), {}, {
                    section: formatSection(o.object.section),
                    kit: formatKit(o.object.kit),
                    item: formatItem(o.object.item)
                  })
                });
              case "section":
                return _objectSpread$h(_objectSpread$h({}, camelCaseKeys(o)), {}, {
                  object: _objectSpread$h(_objectSpread$h({}, formatSection(o.object)), {}, {
                    kit: formatKit(o.object.kit)
                  })
                });
              case "kit":
                return _objectSpread$h(_objectSpread$h({}, camelCaseKeys(o)), {}, {
                  object: formatKit(o.object)
                });
              default:
                return o;
            }
          })
        });
      } else acc[q] = jsonQuery;
      return acc;
    }, {})
  });
  return normalize$1(formattedJson, {});
};
function formatItem(data) {
  var _ref11, _itemData$viewName, _data$asset;
  if (!data) return null;
  const itemData = formatItemData(data.data);
  return {
    id: data.uuid,
    version: data.version,
    shortId: data.short_id,
    kitId: data.kit_uuid,
    sectionId: data.section_uuid,
    itemId: data.item_uuid,
    urlId: slugifyName((_ref11 = (_itemData$viewName = itemData.viewName) !== null && _itemData$viewName !== void 0 ? _itemData$viewName : itemData.name) !== null && _ref11 !== void 0 ? _ref11 : (_data$asset = data.asset) === null || _data$asset === void 0 ? void 0 : _data$asset.name, data.short_id),
    spaceId: data.space_id,
    assetId: data.asset_uuid,
    displayOrder: data.display_order,
    status: data.status,
    type: data.type,
    data: itemData,
    dateAdded: data.date_added,
    dateUpdated: data.date_updated,
    // Relationships
    space: data.space && formatSpace(data.space),
    item: data.item && formatItem(data.item),
    items: data.items && data.items.map(formatItem),
    kit: data.kit && formatKit(data.kit),
    section: data.section && formatSection(data.section),
    kitVersion: data.kitVersion && formatKitVersion(data.kit_version),
    asset: data.asset && formatAsset(data.asset)
  };
}
function formatItemData(data) {
  const res = camelCaseKeys(data);
  res.backgroundColor = res.backgroundColor || "default";
  return res;
}

// MARK : Item.Asset
// asset is always contained in an item
/*-------------------------------------------------------------------------------*/

const asset = json => {
  if (isResultList(json.assets)) {
    const {
        assets
      } = json,
      rest = _objectWithoutProperties(json, _excluded28);
    const assetResults = assets.filter(r => {
      var _r$result;
      return !((_r$result = r.result) !== null && _r$result !== void 0 && _r$result.item);
    }).map(_ref12 => {
      let {
          result
        } = _ref12,
        other = _objectWithoutProperties(_ref12, _excluded29);
      return _objectSpread$h({
        result: result !== null && result !== void 0 && result.asset ? formatAsset(result === null || result === void 0 ? void 0 : result.asset) : null
      }, other);
    });
    // Mutating an asset may affect kit items
    const items = assets.filter(f => {
      var _f$result;
      return Boolean(f === null || f === void 0 || (_f$result = f.result) === null || _f$result === void 0 ? void 0 : _f$result.item);
    }).map(_ref13 => {
      let {
          result
        } = _ref13,
        rest = _objectWithoutProperties(_ref13, _excluded30);
      return _objectSpread$h({
        result: formatItem(result.item)
      }, rest);
    });
    return normalize$1(_objectSpread$h({
      assets: assetResults,
      items
    }, rest), {
      assets: [{
        result: Schemas$1.asset
      }],
      items: [{
        result: Schemas$1.item
      }]
    });
  }
  if (json.assets) {
    return normalize$1({
      assets: json.assets.map(formatAsset)
    }, {
      assets: [Schemas$1.asset]
    });
  }
  return normalize$1(formatAsset(json.asset), Schemas$1.asset);
};
const assetSearch = json => {
  const results = json.queries.assets.results.map(r => formatAsset(r.object));
  return normalize$1({
    assets: results,
    total: json.queries.assets.total
  }, {
    assets: [Schemas$1.asset]
  });
};
function formatAsset(data) {
  var _data$versioned_field, _data$items3;
  if (!data) return null;
  if (!data.meta) data.meta = {};
  function decacheUrl(url) {
    if (typeof url !== "string") return url;
    return url.includes("?") ? "".concat(url, "&hash=").concat(data.file_hash) : "".concat(url, "?hash=").concat(data.file_hash);
  }
  return _objectSpread$h(_objectSpread$h({
    id: data.uuid,
    sourceId: data.source_uuid,
    spaceId: data.space_id,
    name: data.name,
    notes: data.notes,
    keywords: data.keywords,
    autoKeywords: data.auto_keywords,
    type: data.type,
    category: data.category,
    size: data.size,
    shareToken: data.token
  }, getAssetDimensions(data)), {}, {
    colors: (data.colors || []).map(formatAssetColor),
    isFont: assetIsFont(data),
    permalink: decacheUrl(data.permalink),
    thumbnails: data.thumbnails && Object.keys(data.thumbnails).reduce((res, k) => {
      res[k] = decacheUrl(data.thumbnails[k]);
      return res;
    }, {}),
    thumbnailPlaceholders: data.thumbnail_placeholders,
    meta: formatAssetMeta(data.meta),
    uploaderId: data.uploader_id,
    uploader: data.uploader && formatUser(data.uploader),
    fields: data.fields,
    versionedFields: (_data$versioned_field = data.versioned_fields) === null || _data$versioned_field === void 0 ? void 0 : _data$versioned_field.map(formatCustomField),
    fileId: data.file_id,
    fileHash: data.file_hash,
    fileUpdated: data.file_updated,
    dateAdded: data.date_added,
    dateUpdated: data.date_updated,
    items: (_data$items3 = data.items) === null || _data$items3 === void 0 ? void 0 : _data$items3.map(r => formatItem(r))
  });
}
function formatAssetColor(color) {
  const c = new TinyColor("hsva(".concat(color.hue, ", ").concat(color.saturation, "%, ").concat(color.brightness, "%, ").concat(color.alpha / 100, ")"));
  return _objectSpread$h(_objectSpread$h({}, color), {}, {
    hex: c.toHexString(),
    hex8: c.toHex8String(),
    rgb: c.toRgbString(),
    hsb: c.toHsvString().replace("hsv", "hsb"),
    name: color.name,
    pms: color.pms || null,
    cmyk: color.cmyk || null
  });
}
function formatAssetMeta(meta) {
  const _camelCaseKeys = camelCaseKeys(meta),
    {
      font,
      textStyle,
      filecuts,
      assetProcessing,
      backgroundColor
    } = _camelCaseKeys,
    rest = _objectWithoutProperties(_camelCaseKeys, _excluded31);
  return _objectSpread$h({
    assetProcessing,
    font: font && formatFontData(font),
    textStyle: textStyle && formatAssetTextStyle(textStyle),
    filecuts: filecuts && formatFilecuts(filecuts),
    backgroundColor
  }, rest);
}
function formatFilecuts(data) {
  return {
    availableTypes: data.available_types || [],
    presets: data.presets || []
  };
}
function formatFontData(data) {
  return {
    displayName: data.display_name,
    name: data.font_name,
    family: data.family,
    variant: data.variant,
    googleVariant: data.g_variant,
    extension: data.extension,
    source: data.source,
    stylesheetUrl: data.stylesheet_url
  };
}
function formatAssetTextStyle(data) {
  return {
    color: data.color || null,
    decoration: data.decoration || null,
    lineHeight: data.line_height || null,
    size: data.size || null,
    transform: data.transform || null
  };
}
function assetIsFont(a) {
  if (a.type !== AssetType.textStyle) return false;
  return Boolean(a.meta.text_style && Object.keys(a.meta.text_style).length);
}
function getAssetDimensions(a) {
  // Convert dimensions to ints (96.0x96.0 -> 96x96)
  const comps = a.dimensions.split("x").map(px => Math.round(parseFloat(px)));
  return {
    dimensions: comps.join("x"),
    width: comps[0],
    height: comps[1]
  };
}

// MARK : Space Search
/*-------------------------------------------------------------------------------*/

const spaceSearch = json => {
  const kits = json.kits.map(k => {
    return {
      total: k.total,
      kit: formatKit(k.kit),
      items: k.items.map(formatItem),
      version: formatKitVersion(k.version)
    };
  });
  return normalize$1(_objectSpread$h(_objectSpread$h({}, json), {}, {
    kits
  }), Schemas$1.spaceSearch);
};
const analytics = json => {
  return normalize$1(camelize(json), {});
};
const downloadRequest = json => {
  if (Array.isArray(json.requests)) {
    const {
        requests
      } = json,
      rest = _objectWithoutProperties(json, _excluded32);
    return normalize$1(_objectSpread$h({
      requests: requests.map(camelize)
    }, rest), {
      requests: [Schemas$1.downloadRequest]
    });
  }
  return normalize$1(camelize(json.request), Schemas$1.downloadRequest);
};
const assetFilters = json => {
  return normalize$1(camelize(json), {});
};
const directLink = json => {
  if (Array.isArray(json.direct_links)) {
    const {
      direct_links
    } = json;
    return normalize$1({
      directLinks: direct_links.map(camelize)
    }, {
      directLinks: [Schemas$1.directLink]
    });
  }
  const {
    direct_link
  } = json;
  return normalize$1(camelize(direct_link), Schemas$1.directLink);
};

// MARK : Exports
/*-------------------------------------------------------------------------------*/

var normalizers = {
  user,
  space,
  spacePreview,
  spaceMember,
  apiToken,
  charge,
  kitCollection,
  kitCollectionItem,
  portal,
  portalPreview,
  portalMember,
  portalItem,
  kit,
  kitVersion,
  kitMember,
  invitation,
  section,
  item,
  asset,
  assetSearch,
  spaceSearch,
  search,
  customField,
  assetView,
  analytics,
  downloadRequest,
  assetFilters,
  contextIdentification,
  contextIdentificationPreview,
  directLink
};

function ownKeys$g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$g(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function genUUID() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  return v4();
}
function genShortId() {
  return "xxxxxxxx".replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0,
      // eslint-disable-line no-bitwise
      v = c === "x" ? r : r & 0x3 | 0x8; // eslint-disable-line no-bitwise
    return v.toString(16);
  });
}
function genID() {
  return Math.round(Math.random() * 10000) + 1;
}
function genEmail() {
  const name = genName().replace(" ", "_");
  return "".concat(name, "@lingoapp.com");
}

/**
 * Generates a alpha string
 * @param {*} length
 */
function genString() {
  let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
    charactersLength = characters.length;
  return Array(length).fill(null).map(() => characters.charAt(Math.floor(Math.random() * charactersLength))).join("");
}
function genName() {
  const words = ["ants", "excited", "press", "spotty", "coat", "gato", "bathe", "heat", "deeply", "embarrass", "mist", "craven", "neighborly", "funny", "man", "van", "tranquil", "grandiose", "march", "road"];
  const wordCount = words.length;
  const numWords = 2 + Math.floor(Math.random() * 2);
  const res = [];
  for (let i = 0; i < numWords; i += 1) {
    const w = words[Math.floor(Math.random() * wordCount)];
    res.push(w);
  }
  return res.join(" ");
}

// MARK : Default IDs
/*-------------------------------------------------------------------------------*/
const portalUUID = genUUID();
const kitUUID = genUUID();
const sectionUUID = genUUID();
const spaceID = genID();
const userID = genID();

// MARK : Generators
/*-------------------------------------------------------------------------------*/

function mergeRules(objValue, srcValue) {
  if (_isArray(objValue)) {
    return srcValue || objValue;
  }
}
function createUser() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    id: userID,
    name: "Jordan Smith",
    email: "jsmith@thenounproject.com",
    app_progress: "onboard_v1,app_login,download,example_kit,created_in_app",
    avatar: "https://static-test.lingoapp.com/avatar/3efacf39-cc23-41e4-afc2-9fb2631c5563.png",
    features: [],
    installed_app: "2016-01-05 22:06:22.942431+0000",
    is_active: true,
    is_admin: true,
    last_login: "2018-12-13 22:44:15.454399+0000",
    created_at: "2016-01-12 19:46:59.683120+0000",
    updated_at: "2018-12-13 20:43:47.785993+0000"
  }, overrides);
}
function createNestedUser() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    avatar: "https://www.gravatar.com/avatar/64fe995229067daf8862575df759b43a?s=240&d=https%3A%2F%2Fstatic.lingoapp.com%2Fassets%2Fimages%2Fuser-avatars%2Fv2-12.png",
    email: "jSmith@thenounproject.com",
    id: userID,
    name: "Jordan Smith"
  }, overrides);
}
function createSpace() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _mergeWith({
    access: {
      date_added: "2016-01-19 20:29:34.669786+0000",
      date_updated: "2016-01-19 20:29:34.669786+0000",
      id: genID(),
      permissions: ["delete", "create_kit", "edit", "invite_user", "change_user_role", "revoke_invitation", "remove_user", "manage_billing", "manage_resources", "view_members", "create_asset"],
      upgrade_permissions: {},
      role: "owner",
      space_id: overrides.id || spaceID,
      status: "active",
      user_id: userID
    },
    avatar: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF.png",
    avatars: createSpaceAvatars(),
    counts: createSpaceCounts(),
    date_added: "2016-01-19 20:29:34.669786+0000",
    date_updated: "2018-11-16 20:54:13.815200+0000",
    features: ["space_theme", "web_edit_content", "kit_versioning"],
    id: spaceID,
    max_assets: null,
    max_users: null,
    name: "Guest Mania",
    slug: "guest-mania",
    status: "active",
    privacy: "private",
    join_settings: {
      token: null,
      join_with: {},
      allowed_domains: null
    },
    subscription: {
      cancel_at_period_end: false,
      current_period_end: "2016-11-26 00:04:05+00:00",
      customer: {
        coupon: null,
        stripe_id: "cus_8KzfYdDX0a6WGE"
      },
      interval: "month",
      plan: "tier-enterprise-month",
      price: 4900,
      price_per_user: null,
      quantity: 1,
      status: "active",
      stripe_id: "sub_8KzffcSRwSnAm6",
      total_price: null
    },
    theme: createSpaceTheme(),
    uuid: "team_18"
  }, overrides, mergeRules);
}
function createSpaceAvatars() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    avatar: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF.png",
    avatar_16: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF_16.png",
    avatar_180: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF_180.png",
    avatar_32: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF_32.png",
    card: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF_card.png",
    default_avatar: "https://static-test.lingoapp.com/assets/images/user-avatars/space.png"
  }, overrides);
}
function createSpaceCounts() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    assets: 20,
    invitations: 16,
    storage: 958991,
    users: 376
  }, overrides);
}
function createSpaceTheme() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    primary_color: "#AAAAAA",
    primary_color_dark: "#555555",
    primary_color_light: "#BBBBBB",
    primary_color_tint: "#FFFFFF"
  }, overrides);
}
function createSpacePreview() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    id: spaceID,
    name: genName(),
    subdomain: null,
    avatar: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF.png",
    avatars: createSpaceAvatars(),
    theme: createSpaceTheme()
  }, overrides);
}
function createSpacePreviewMember() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    id: genID(),
    name: genName(),
    email: genEmail(),
    avatar: "https://www.gravatar.com/avatar/64fe995229067daf8862575df759b43a?s=240&d=https%3A%2F%2Fstatic.lingoapp.com%2Fassets%2Fimages%2Fuser-avatars%2Fv2-12.png",
    role: "admin"
  }, overrides);
}
function createSpaceCard() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const stripeId = "ch_".concat(genShortId());
  return _objectSpread$g({
    brand: "Visa",
    country: "US",
    exp_month: 2,
    exp_year: 2024,
    last4: "4242",
    receipt_extra: null,
    stripe_id: stripeId
  }, overrides);
}
function createSpaceCharge() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const stripeId = overrides.stripe_id || "ch_".concat(genShortId());
  return _objectSpread$g({
    id: genID(),
    amount: 165.31,
    card: "Visa 4242",
    date: "2016-11-03 23:47:26.421327+0000",
    invoice_url: "/v4/invoices/".concat(stripeId),
    receipt_extra: null,
    refunded: false,
    status: "succeeded",
    stripe_id: stripeId
  }, overrides);
}
function createApiToken() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    token: genUUID(),
    name: "My Api Token",
    writeAccess: false,
    status: "active",
    space_id: spaceID,
    created_at: "2016-11-03 23:47:26.421327+0000"
  }, overrides);
}
function createSpaceMember() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const userId = overrides.user_id || genID();
  return _mergeWith({
    id: genID(),
    role: "member",
    space_id: spaceID,
    status: "active",
    joined_kits: 0,
    permissions: ["search_assets", "view_members", "remove_self"],
    user_id: userId,
    user: createNestedUser({
      id: userId
    }),
    date_added: "2016-11-03 23:47:26.421327+0000",
    date_updated: "2017-06-15 16:19:48.204267+0000"
  }, overrides, mergeRules);
}
function createInvitation() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _mergeWith({
    id: genID(),
    email: "".concat(genName().split(" ").join("_"), "@lingoapp.com"),
    space_id: spaceID,
    join_with: {
      role: "admin",
      kits: []
    },
    note: "",
    token: genUUID(),
    invited_at: "2017-06-15 16:19:48.204267+0000",
    accepted_at: null,
    status: "pending",
    from_user_id: genID()
  }, overrides, mergeRules);
}
function createPortal() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _spaceID = overrides.space_id || spaceID,
    _portalID = overrides.portal_uuid || portalUUID;
  return _mergeWith({
    access: {
      date_added: "2018-03-12 04:59:16.472477+0000",
      date_updated: "2018-03-12 04:59:16.472477+0000",
      id: genID(),
      permissions: ["view", "edit", "delete", "change_member_role", "manage_sharelinks"],
      upgrade_permissions: {},
      role: "admin",
      space_id: _spaceID,
      status: "active",
      use_version: null,
      user_id: 2
    },
    id: _portalID,
    shortId: genShortId(),
    spaceId: _spaceID,
    name: genName(),
    description: "Best portal ever",
    status: "active",
    theme: null,
    counts: {
      kits: 1,
      members: 1,
      items: 1
    },
    images: {
      cover: "https://lingo-test.s3.amazonaws.com/kits/factory.spaceID/216F2D9A-68C0-4F4E-B728-DB0042A97791/cover_1524242220.png"
    },
    privacy: "private",
    indexable: false,
    downloadsRestricted: false,
    dateAdded: "2024-05-12 04:59:16.472477+0000",
    dateUpdated: "2024-05-12 04:59:16.472477+0000"
  }, overrides, mergeRules);
}
function createKit() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _spaceID = overrides.space_id || spaceID,
    _kitID = overrides.kit_uuid || kitUUID;
  return _mergeWith({
    access: {
      date_added: "2018-03-12 04:59:16.472477+0000",
      date_updated: "2018-03-12 04:59:16.472477+0000",
      id: 7929,
      is_favorite: false,
      kit_uuid: _kitID,
      permissions: ["manage", "view", "edit", "delete", "change_member_role", "manage_sharelinks", "change_own_status", "edit_content", "search_assets", "view_all_content", "favorite"],
      upgrade_permissions: {},
      role: "admin",
      space_id: _spaceID,
      status: "active",
      use_version: null,
      user_id: 2
    },
    counts: {
      invitations: 0,
      members: 6
    },
    date_added: "2018-03-12 04:59:16.472477+0000",
    date_updated: "2018-04-20 16:37:00.807095+0000",
    id: 2474,
    images: {
      cover: "https://lingo-test.s3.amazonaws.com/kits/factory.spaceID/216F2D9A-68C0-4F4E-B728-DB0042A97791/cover_1524242220.png"
    },
    privacy: "private",
    portal_access: false,
    kit_uuid: _kitID,
    short_id: genShortId(),
    name: genName(),
    notes: "",
    space_id: _spaceID,
    status: "active",
    token: null,
    use_version: 0
  }, overrides, mergeRules);
}
function createKitMember() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const userId = overrides.user_id || genID();
  return _mergeWith({
    id: genID(),
    role: "admin",
    space_id: spaceID,
    kit_uuid: kitUUID,
    user_id: userId,
    status: "active",
    is_favorite: false,
    use_version: 0,
    permissions: ["manage", "view", "edit", "delete", "change_member_role", "manage_sharelinks", "change_own_status", "edit_content", "search_assets", "view_all_content"],
    user: createNestedUser({
      id: userId
    }),
    date_added: "2016-11-03 23:47:26.421327+0000",
    date_updated: "2017-06-15 16:19:48.204267+0000"
  }, overrides, mergeRules);
}
function createVersion() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge({
    counts: {
      assets: 0,
      items: 0,
      sections: 0
    },
    date_added: "2018-03-12 04:59:16.472477+0000",
    date_updated: "2018-03-12 04:59:16.472477+0000",
    kit_uuid: kitUUID,
    notes: "",
    space_id: spaceID,
    status: "active",
    store_status: "inactive",
    version: 0,
    version_identifier: "0.0",
    sections: []
  }, overrides);
}
function createOutlineSection() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge({
    uuid: genUUID(),
    short_id: genShortId(),
    name: genName(),
    display_order: 0,
    headers: [],
    counts: {
      assets: 0,
      items: 0
    },
    version: 0
  }, overrides);
}
function createOutlineHeader() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    uuid: genUUID(),
    short_id: genShortId(),
    name: genName(),
    version: 0,
    display_order: 0
  }, overrides);
}
function createSection() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge({
    uuid: genUUID(),
    short_id: genShortId(),
    kit_uuid: kitUUID,
    name: genName(),
    counts: {
      assets: 1,
      items: 1
    },
    display_order: 0,
    status: "active",
    version: 0,
    creator_id: 2,
    date_added: "2018-03-12 04:59:22.760599+0000",
    date_updated: "2018-03-12 04:59:22.760599+0000"
  }, overrides);
}
function createItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge({
    asset_uuid: null,
    data: {},
    date_added: "2018-04-05 20:13:53.528112+0000",
    date_updated: "2018-04-05 20:13:53.528121+0000",
    display_order: -20,
    status: "active",
    type: ItemType.heading,
    uuid: genUUID(),
    version: 0,
    short_id: genShortId(),
    space_id: spaceID,
    kit_uuid: kitUUID,
    section_uuid: sectionUUID
  }, overrides);
}
function createHeadingItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createItem(_objectSpread$g(_objectSpread$g({}, _merge({
    data: {
      content: "Stars & Nebulas",
      display_size: "0"
    }
  }, overrides)), {}, {
    asset_uuid: null,
    type: ItemType.heading
  }));
}
function createNoteItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createItem(_objectSpread$g(_objectSpread$g({}, _merge({
    data: {
      content: "These photos provided by NASA.",
      display_size: "0"
    }
  }, overrides)), {}, {
    asset_uuid: null,
    type: ItemType.note
  }));
}
function createGuideItem() {
  let asset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createItem(_objectSpread$g(_objectSpread$g({}, _merge({
    data: {
      content: "Make sure you do this",
      color: "green",
      title: "DO",
      display_style: "image",
      display_size: 1
    }
  }, overrides)), {}, {
    type: ItemType.guide,
    asset_uuid: asset ? asset.uuid : null,
    space_id: asset ? asset.space_id : spaceID,
    asset: asset
  }));
}
function createGalleryItem() {
  let asset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createItem(_objectSpread$g(_objectSpread$g({}, _merge({
    data: {
      view_id: "Make sure you do this",
      view_name: "green",
      assets: 0
    }
  }, overrides)), {}, {
    type: ItemType.gallery,
    asset_uuid: asset ? asset.uuid : null,
    space_id: asset ? asset.space_id : spaceID,
    asset: asset
  }));
}
function createCodeSnippetItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createItem(_objectSpread$g(_objectSpread$g({}, _merge({
    data: {
      content: 'const name = "Bob"',
      display_size: "0",
      code_language: "Javascript"
    }
  }, overrides)), {}, {
    asset_uuid: null,
    type: ItemType.codeSnippet
  }));
}
function createAssetItem(asset) {
  let overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createItem(_objectSpread$g(_objectSpread$g({}, overrides), {}, {
    type: ItemType.asset,
    asset_uuid: asset.uuid,
    space_id: asset.space_id,
    asset: asset
  }));
}
function createImageItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createImageAsset(), overrides);
}
function createVideoItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createVideoAsset(), overrides);
}
function createLottieItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createLottieAsset(), overrides);
}
function createAudioItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createAudioAsset(), overrides);
}
function createColorItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createColorAsset(), overrides);
}
function createFontItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createFontAsset(), overrides);
}
function createSupportingImageItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const item = createAssetItem(createImageAsset(), overrides);
  item.type = ItemType.supportingImage;
  return item;
}
function createSupportingVideoItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const item = createAssetItem(createVideoAsset(), overrides);
  item.type = ItemType.supportingImage;
  return item;
}
function createSupportingLottieItem() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const item = createAssetItem(createLottieAsset(), overrides);
  item.type = ItemType.supportingImage;
  return item;
}
const thumbnails = {
  thumbnail_placeholders: {
    292: "https://lingo-test.s3.amazonaws.com/thumbnails/placeholder/svg/292x292.png",
    480: "https://lingo-test.s3.amazonaws.com/thumbnails/placeholder/svg/480x480.png",
    1232: "https://lingo-test.s3.amazonaws.com/thumbnails/placeholder/svg/1232x1232.png"
  },
  thumbnails: {
    292: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/preview?size=292&asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    480: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/preview?size=480&asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    1232: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/preview?size=1232&asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY"
  }
};
function createImageAsset() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g(_objectSpread$g({
    category: "raster",
    colors: [],
    date_added: "2018-03-12 04:59:44.891239+0000",
    date_updated: "2018-12-14 15:49:21.701801+0000",
    dimensions: "100.0x100.0",
    file_hash: "9622e706196bf2dd6db976c10cdb2c4c97a4673c",
    file_id: "4D421CC8-353C-49F6-9538-124A924A76B2",
    file_updated: "2018-03-12 04:59:44.891239+0000",
    keywords: "Kaiser,antimodernization,pretraveling,tubercularise",
    meta: {
      assetProcessing: "complete",
      filecuts: {
        available_types: [{
          enabled: true,
          resizable: true,
          type: "PNG"
        }, {
          enabled: true,
          resizable: true,
          type: "JPG"
        }],
        presets: [{
          description: "",
          size: "1x",
          type: "PNG"
        }, {
          description: "",
          size: "1x",
          type: "JPG"
        }]
      }
    },
    name: genName(),
    notes: "",
    permalink: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/download?asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    size: 16326,
    space_id: spaceID,
    token: "G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    type: AssetType.png,
    uploader_id: 2,
    uuid: genUUID()
  }, thumbnails), overrides);
}
function createLottieAsset() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g(_objectSpread$g({
    category: "video",
    colors: [],
    date_added: "2018-03-12 04:59:44.891239+0000",
    date_updated: "2018-12-14 15:49:21.701801+0000",
    dimensions: "100.0x100.0",
    file_hash: "9622e706196bf2dd6db976c10cdb2c4c97a4673c",
    file_id: "4D421CC8-353C-49F6-9538-124A924A76B2",
    file_updated: "2018-03-12 04:59:44.891239+0000",
    keywords: "Kaiser,antimodernization,pretraveling,tubercularise",
    name: genName(),
    notes: "",
    permalink: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/download?asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    size: 16326,
    space_id: spaceID,
    token: "G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    type: AssetType.lottie,
    uploader_id: 2,
    uuid: genUUID(),
    meta: {
      assetProcessing: "complete"
    }
  }, thumbnails), overrides);
}
function createVideoAsset() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge(_objectSpread$g({
    category: "video",
    colors: [],
    date_added: "2018-03-12 04:59:44.891239+0000",
    date_updated: "2018-12-14 15:49:21.701801+0000",
    dimensions: "100.0x100.0",
    file_hash: "9622e706196bf2dd6db976c10cdb2c4c97a4673c",
    file_id: "4D421CC8-353C-49F6-9538-124A924A76B2",
    file_updated: "2018-03-12 04:59:44.891239+0000",
    keywords: "Kaiser,antimodernization,pretraveling,tubercularise",
    name: genName(),
    notes: "",
    permalink: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/download?asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    size: 16326,
    space_id: spaceID,
    token: "G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    type: AssetType.mp4,
    uploader_id: 2,
    uuid: genUUID(),
    meta: {
      assetProcessing: "complete",
      duration: 30
    }
  }, thumbnails), overrides);
}
function createAudioAsset() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g(_objectSpread$g({
    category: "audio",
    colors: [],
    date_added: "2018-03-12 04:59:44.891239+0000",
    date_updated: "2018-12-14 15:49:21.701801+0000",
    dimensions: "0x0",
    file_hash: "9622e706196bf2dd6db976c10cdb2c4c97a4673c",
    file_id: "4D421CC8-353C-49F6-9538-124A924A76B2",
    file_updated: "2018-03-12 04:59:44.891239+0000",
    keywords: "Kaiser,antimodernization,pretraveling,tubercularise",
    name: genName(),
    notes: "",
    permalink: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/download?asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    size: 16326,
    space_id: spaceID,
    token: "G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    type: AssetType.mp3,
    uploader_id: 2,
    uuid: genUUID(),
    meta: {
      assetProcessing: "complete",
      duration: 1.175
    }
  }, thumbnails), overrides);
}
function createColorAsset() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    category: "color",
    colors: [{
      alpha: 100,
      brightness: 81.96078,
      coverage: 100,
      hue: 360,
      name: "Candy",
      saturation: 100
    }],
    date_added: "2018-07-16 19:26:22.771418+0000",
    date_updated: "2018-08-31 15:51:52.472919+0000",
    dimensions: "0x0",
    file_hash: "8e7e4c3c4c16c5422116153ae300160901186e9d",
    file_id: null,
    file_updated: "2018-07-16 19:26:22.771418+0000",
    keywords: "red",
    meta: {
      external_id: genUUID()
    },
    name: genName(),
    notes: "red",
    size: 0,
    space_id: spaceID,
    token: "zo8YcVI-Ih0-Wbk4bQrgjNczhZMyNpIQH7kfvzDMskw",
    type: AssetType.color,
    uploader_id: 2,
    uuid: genUUID()
  }, overrides);
}
function createLinkAsset() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g({
    category: "link",
    date_added: "2018-07-16 19:26:22.771418+0000",
    date_updated: "2018-08-31 15:51:52.472919+0000",
    dimensions: "0x0",
    file_hash: "8e7e4c3c4c16c5422116153ae300160901186e9d",
    file_id: null,
    file_updated: "2018-07-16 19:26:22.771418+0000",
    meta: {
      content: {
        url: "https://www.lingoapp.com/",
        description: "Lingo is the visual home for your brand. It is designed to help teams organize, manage and share their assets in one place.",
        title: "Lingo App",
        site_name: "Lingo",
        favicon: "https://lingo-test.s3.amazonaws.com/340a0dc8-d415-4c9e-8966-b712bb1f3d93.png",
        fld: "lingoapp.com"
      }
    },
    name: "Lingo App",
    size: 0,
    space_id: spaceID,
    token: "zo8YcVI-Ih0-Wbk4bQrgjNczhZMyNpIQH7kfvzDMskw",
    type: AssetType.URL,
    uploader_id: 2,
    uuid: genUUID()
  }, overrides);
}
function createFontAsset() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g(_objectSpread$g({
    category: "text_style",
    colors: [],
    date_added: "2018-10-02 18:52:29.586325+0000",
    date_updated: "2018-10-24 19:18:01.357386+0000",
    dimensions: "0.0x0.0",
    file_hash: "5cab77a2faac5b6bdbdb22808f8e9296100b1529",
    file_id: "e86cc57a-2dfb-47e8-befb-afcc4243b065",
    file_updated: "2018-10-02 18:52:29.586325+0000",
    keywords: "font,heading,big,bold,sans-serif",
    meta: {
      font: {
        display_name: "Input Bold",
        extension: "ttf",
        family: "Input",
        font_name: "Input-Bold",
        source: "file",
        stylesheet_url: "https://api-test.lingoapp.com/v4/assets/8424E3C7-4AF5-46D4-8BD1-C4363BF78CF6/css?asset_token=_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
        variant: "Bold"
      }
    },
    name: "Heading",
    notes: "Use this for all the headings",
    permalink: "https://api-test.lingoapp.com/v4/assets/8424E3C7-4AF5-46D4-8BD1-C4363BF78CF6/download?asset_token=_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
    size: 122340,
    space_id: spaceID,
    token: "_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
    type: AssetType.textStyle,
    uploader_id: 2,
    uuid: genUUID()
  }, thumbnails), overrides);
}
function createDocumentAsset() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$g(_objectSpread$g({
    category: "document",
    colors: [],
    date_added: "2018-10-02 18:52:29.586325+0000",
    date_updated: "2018-10-24 19:18:01.357386+0000",
    dimensions: "0.0x0.0",
    file_hash: "5cab77a2faac5b6bdbdb22808f8e9296100b1529",
    file_id: "e86cc57a-2dfb-47e8-befb-afcc4243b065",
    file_updated: "2018-10-02 18:52:29.586325+0000",
    keywords: "file,presentation,keynote",
    meta: {},
    name: "Presentation",
    notes: "Use this for all the presentations",
    permalink: "https://api-test.lingoapp.com/v4/assets/8424E3C7-4AF5-46D4-8BD1-C4363BF78CF6/download?asset_token=_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
    size: 122340,
    space_id: spaceID,
    token: "_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
    type: AssetType.pptx,
    uploader_id: 2,
    uuid: genUUID()
  }, thumbnails), overrides);
}
function createSketchAsset() {
  let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _mergeWith(_objectSpread$g({
    category: "sketch",
    colors: [],
    date_added: "2018-03-12 05:01:26.570207+0000",
    date_updated: "2018-03-12 05:01:26.570713+0000",
    dimensions: "320.0x200.0",
    file_hash: "9a427051418fbfaa14c30cbd9b95ecd58cc0f86c",
    file_id: "EDCB69C7-6BB4-4677-8A73-4BDB72C2BD2D",
    file_updated: "2018-03-12 05:01:26.570207+0000",
    keywords: "Image",
    meta: {
      embedded_cuts: "SVG,PDF",
      external_hash: "3dc6e4a666b4b1a2d7762d074457ef0528e6464a",
      sketch_object_id: genUUID(),
      sketch_format_version: "101_2",
      sketch_pathname: "Image / 16 : 1",
      filecuts: {
        available_types: [{
          enabled: true,
          resizable: true,
          type: "PNG"
        }, {
          enabled: true,
          resizable: true,
          type: "JPG"
        }, {
          enabled: true,
          resizable: false,
          type: "SVG"
        }],
        presets: [{
          description: "",
          size: "1x",
          type: "SVG"
        }, {
          description: "",
          size: "1x",
          type: "PNG"
        }, {
          description: "",
          size: "1x",
          type: "JPG"
        }]
      }
    },
    name: genName(),
    notes: "",
    permalink: "http://local.lingoapp.com:9000/v4/assets/A4508D1F-51E4-477D-A747-F2FC3CB903B5/download?asset_token=C4kl9Nba7X44Ha54wAn1B40hf1B0B93iOZxo9_KGOY8",
    size: 15681,
    space_id: spaceID,
    token: "C4kl9Nba7X44Ha54wAn1B40hf1B0B93iOZxo9_KGOY8",
    uploader_id: 2,
    type: AssetType.sketchSymbol,
    uuid: genUUID()
  }, thumbnails), overrides, mergeRules);
}

// MARK : Normalized/State data
/*-------------------------------------------------------------------------------*/

/**
 * Easily normalize factory objects as they would be in state.
 *
 * ex. `factory.normalize.space(factory.createSpace())`
 *
 * Note that the overrides use with the factory object creators may be different
 * than the keys you are expecting from the normalized version. Overrides should
 * be supplied as they would come from the API.
 */

const createState = function (entities) {
  const {
    spaces = [],
    kits = [],
    sections = [],
    items = []
  } = entities;
  const res = normalize$1({
    spaces: spaces.map(formatSpace),
    kits: kits.map(formatKit),
    sections: sections.map(formatSection),
    items: items.map(formatItem)
  }, {
    spaces: [Schemas$1.space],
    kits: [Schemas$1.kit],
    sections: [Schemas$1.section],
    items: [Schemas$1.item]
  });
  const migratedEntities = ["kits", "items", "spaces", "sections"];
  migratedEntities.forEach(key => {
    res.entities[key] = {
      objects: res.entities[key]
    };
  });
  return res;
};
const normalize = {
  user: data => formatUser(data),
  space: data => formatSpace(data),
  spacePreview: data => formatSpacePreview(data),
  charge: data => formatCharge(data),
  apiToken: data => formatApiToken(data),
  spaceMember: data => formatSpaceMember(data),
  invitation: data => formatInvitation(data),
  kit: data => formatKit(data),
  kitMember: data => formatKitMember(data),
  kitVersion: data => formatKitVersion(data),
  section: data => formatSection(data),
  item: data => formatItem(data),
  asset: data => formatAsset(data),
  outlineHeader: data => formatOutlineHeader(data),
  portal: data => formatPortal(data)
};
var factory = {
  normalize,
  genID,
  genUUID,
  genString,
  createUser,
  createNestedUser,
  createSpace,
  createSpacePreview,
  createSpacePreviewMember,
  createSpaceTheme,
  createSpaceCounts,
  createSpaceCard,
  createSpaceCharge,
  createInvitation,
  createApiToken,
  createSpaceMember,
  createKit,
  createKitMember,
  createVersion,
  createOutlineHeader,
  createOutlineSection,
  createSection,
  createHeadingItem,
  createNoteItem,
  createGuideItem,
  createGalleryItem,
  createCodeSnippetItem,
  createAssetItem,
  createImageItem,
  createVideoItem,
  createLottieItem,
  createAudioItem,
  createColorItem,
  createFontItem,
  createSupportingImageItem,
  createSupportingVideoItem,
  createSupportingLottieItem,
  createImageAsset,
  createVideoAsset,
  createLottieAsset,
  createAudioAsset,
  createColorAsset,
  createLinkAsset,
  createFontAsset,
  createDocumentAsset,
  createSketchAsset,
  createState,
  createPortal
};

/**
 *
 * @param {Boolean} val The default value
 *
 * Wraps a boolean in state, providing callbacks for setting the value to true and false.
 *
 * const [isModalShown, showModal, hideModal] = useBoolean(false)
 *
 * <Button onClick={showModal} text="Open Modal" />
 * <Modal open={isModalShown} close={hideModal} />
 */

function useBoolean(val) {
  const [value, setValue] = useState(val);
  const setTrue = useCallback(() => setValue(true), [setValue]),
    setFalse = useCallback(() => setValue(false), [setValue]);
  return [value, setTrue, setFalse];
}

// This const/type approach is an alternative to enums that
// is supposed to be more efficient and reliable. babel also doesn't support
// const enums which is problematic.
const TooltipDirection = {
  Top: "top",
  Left: "left",
  Right: "right",
  Bottom: "bottom"
};

// Internal helper for passing around position data

function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const TooltipTail = styled(Box$1).attrs(props => {
  const style = () => {
    const translateValue = props.offset ? "calc(-50% + ".concat(props.offset, "px)") : "-50%";
    const horizontalPosition = () => ({
      left: "50%",
      transform: "translateX(".concat(translateValue, ")")
    });
    const verticalPosition = () => ({
      top: "50%",
      transform: "translateY(".concat(translateValue, ")")
    });
    switch (props.direction) {
      case TooltipDirection.Top:
        return _objectSpread$f({
          borderBottomColor: getColor("modalOverlay"),
          top: "-16px"
        }, horizontalPosition());
      case TooltipDirection.Bottom:
        return _objectSpread$f({
          borderTopColor: getColor("modalOverlay"),
          bottom: "-16px"
        }, horizontalPosition());
      case TooltipDirection.Right:
        return _objectSpread$f({
          borderLeftColor: getColor("modalOverlay"),
          right: "-16px"
        }, verticalPosition());
      case TooltipDirection.Left:
        return _objectSpread$f({
          borderRightColor: getColor("modalOverlay"),
          left: "-16px"
        }, verticalPosition());
      default:
        return null;
    }
  };
  return {
    border: "solid 8px transparent",
    position: "absolute",
    style: style()
  };
}).withConfig({
  displayName: "TooltipTail"
})(["pointer-events:none;"]);
var TooltipTail$1 = TooltipTail;

const _excluded$x = ["source", "direction", "children", "interactive", "onVisibilityChange"],
  _excluded2$3 = ["tail"];
function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Wrapper$6 = styled(Flex$1).attrs(props => {
  return {
    background: "modalOverlay",
    boxShadow: "panel",
    maxWidth: props.maxWidth || 360,
    minWidth: props.minWidth || 50,
    flexDirection: "column",
    position: "fixed",
    display: "block",
    borderRadius: "default",
    zIndex: props.zIndex || "tooltip",
    style: _objectSpread$e({
      lineHeight: "30px",
      transition: "opacity 0.1s",
      opacity: props.isOpen ? 1 : 0,
      pointerEvents: props.isOpen ? null : "none",
      transitionDelay: props.isOpen ? props.transitionDelay : "0s"
    }, props.tooltipPositioning)
  };
}).withConfig({
  displayName: "Tooltip__Wrapper"
})([""]);

// Helper function for getting DOM elements
function getElement$1(name, value) {
  let el;
  if (typeof value === "string") {
    try {
      el = document.querySelector(value);
    } catch (_unused) {
      // Retry another selector below
    }
    if (!el) el = document.querySelector("[".concat(name, "='").concat(value, "']"));
  }
  return el;
}

/**
 * A Tooltip component
 *
 * ### Example usage
 * ```
 * const tooltipID = "my-tooltip"
 * <>
 *  <Text data-tooltip-source={tooltipId}>I have a tooltip</Text>
 *  <Tooltip source={tooltipId} direction={}>
 *    You found the tooltip!
 *  </Tooltip>
 * </>
 * ```
 */

const Tooltip$1 = _ref => {
  let {
      source,
      direction = "right",
      children,
      interactive = true,
      onVisibilityChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$x);
  const [isOpen, setOpen, setClosed] = useBoolean(false);
  const [wantsOpen, setWantsOpen, setWantsClosed] = useBoolean(false);
  const [position, setPosition] = useState({});
  const contentIdentifier = useMemo(() => factory.genString(), []);
  useEffect(() => {
    onVisibilityChange === null || onVisibilityChange === void 0 || onVisibilityChange(isOpen);
  }, [isOpen, onVisibilityChange]);

  // MARK : Elemenets
  // -------------------------------------------------------------------------------
  const getContentElement = useCallback(() => document.body.querySelector("#".concat(contentIdentifier)), [contentIdentifier]);
  const getSource = useCallback(() => {
    return getElement$1("data-tooltip-source", source);
  }, [source]);
  const getTrigger = useCallback(() => {
    return getElement$1("data-tooltip-trigger", source) || getSource();
  }, [getSource, source]);

  // Set accessability attributes on the source
  // This obviously isn't very JSX-like but it allows for a more flexibility
  // when composing tooltips with components since we don't have to pass around
  // refs or props. This way it is all handled implicitly.
  useEffect(() => {
    var _getSource;
    (_getSource = getSource()) === null || _getSource === void 0 || _getSource.setAttribute("aria-describedby", contentIdentifier);
  }, [contentIdentifier, getSource]);

  // MARK : Positioning
  // -------------------------------------------------------------------------------
  const calculatePosition = useCallback(() => {
    const sourceEl = getSource();
    const contentEl = getContentElement();
    if (!sourceEl || !contentEl) return;
    const rect = sourceEl.getBoundingClientRect(),
      windowRect = document.body.getBoundingClientRect(),
      contentRect = contentEl.getBoundingClientRect();
    const pos = {
      tail: {
        direction: TooltipDirection.Left
      }
    };
    const defaultPad = 8;
    const tailSize = 8;
    function positionCenterY() {
      const sourceCenter = rect.top + rect.height / 2;
      pos.top = sourceCenter - contentRect.height / 2;
      pos.top = Math.max(defaultPad, pos.top);
      let contentCenter = pos.top + contentRect.height / 2;
      const estimatedTop = pos.top + contentRect.height;
      if (estimatedTop > windowRect.height) {
        pos.bottom = 8;
        pos.top = null;
        contentCenter = windowRect.height - 8 - contentRect.height / 2;
      }
      if (contentCenter !== sourceCenter) {
        pos.tail.offset = sourceCenter - contentCenter;
      }
    }
    function positionCenterX() {
      const sourceCenter = rect.left + rect.width / 2;
      pos.left = sourceCenter - contentRect.width / 2;
      pos.left = Math.max(defaultPad, pos.left);
      let contentCenter = pos.left + contentRect.width / 2;
      const estimatedRight = pos.left + contentRect.width;
      if (estimatedRight > windowRect.width) {
        pos.right = 8;
        pos.left = null;
        contentCenter = windowRect.width - 8 - contentRect.width / 2;
      }
      if (contentCenter !== sourceCenter) {
        pos.tail.offset = sourceCenter - contentCenter;
      }
    }
    switch (direction) {
      case TooltipDirection.Left:
        positionCenterY();
        if (rect.left - contentRect.width < 8) {
          pos.left = rect.left + tailSize;
          pos.tail.direction = TooltipDirection.Left;
        } else {
          pos.right = windowRect.width - rect.left + tailSize;
          pos.tail.direction = TooltipDirection.Right;
        }
        break;
      case TooltipDirection.Right:
        {
          const maxX = rect.left + rect.width;
          positionCenterY();
          if (maxX > windowRect.width - tailSize) {
            // If the source is past the endge
            pos.right = defaultPad + tailSize;
            pos.tail.direction = TooltipDirection.Right;
          } else if (maxX + contentRect.width > windowRect.width) {
            // If the source is inset but too close
            pos.right = windowRect.width - rect.right + tailSize;
            pos.tail.direction = TooltipDirection.Right;
          } else {
            pos.left = maxX + tailSize;
            pos.tail.direction = TooltipDirection.Left;
          }
          break;
        }
      case TooltipDirection.Top:
        {
          const desiredBottom = windowRect.height - rect.top;
          positionCenterX();
          if (rect.top < 0) {
            pos.top = rect.bottom + tailSize;
            pos.tail.direction = TooltipDirection.Top;
          } else if (desiredBottom + contentRect.height > windowRect.height) {
            pos.top = rect.top + tailSize;
            pos.tail.direction = TooltipDirection.Top;
          } else {
            pos.bottom = desiredBottom + tailSize;
            pos.tail.direction = TooltipDirection.Bottom;
          }
          break;
        }
      case TooltipDirection.Bottom:
        {
          const desiredTop = rect.bottom;
          positionCenterX();
          if (rect.bottom > windowRect.height) {
            pos.bottom = windowRect.height - rect.top;
            pos.tail.direction = TooltipDirection.Bottom;
          } else if (desiredTop + contentRect.height > windowRect.height) {
            pos.bottom = windowRect.height - rect.bottom;
            pos.tail.direction = TooltipDirection.Bottom;
          } else {
            pos.top = desiredTop;
            pos.tail.direction = TooltipDirection.Top;
          }
        }
        break;
    }
    setPosition(pos);
  }, [direction, getContentElement, getSource]);
  useLayoutEffect(() => {
    calculatePosition();
  }, [isOpen, direction, children, calculatePosition]);
  useEffect(() => {
    if (wantsOpen && !isOpen) setOpen();else if (!wantsOpen && isOpen) {
      const timeout = setTimeout(setClosed, 150);
      return () => clearTimeout(timeout);
    }
  }, [isOpen, setClosed, setOpen, wantsOpen]);

  // MARK : Managing Open State
  // -------------------------------------------------------------------------------

  useEffect(() => {
    const triggerEl = getTrigger();
    if (!triggerEl) return;
    const openEvents = ["focus", "mouseenter"];
    const closeEvents = ["blur", "mouseleave"];
    const elements = [triggerEl];
    const contentEl = getContentElement();
    if (contentEl && interactive) elements.push(contentEl);
    openEvents.forEach(e => elements.forEach(el => el.addEventListener(e, setWantsOpen)));
    closeEvents.forEach(e => elements.forEach(el => el.addEventListener(e, setWantsClosed)));
    return () => {
      openEvents.forEach(e => elements.forEach(el => el.removeEventListener(e, setWantsOpen)));
      closeEvents.forEach(e => elements.forEach(el => el.removeEventListener(e, setWantsClosed)));
    };
  }, [getContentElement, getTrigger, wantsOpen, setWantsClosed, setWantsOpen, interactive]);
  useEffect(() => {
    if (isOpen) window.addEventListener("scroll", calculatePosition, true);
    return () => {
      window.removeEventListener("scroll", calculatePosition, true);
    };
  }, [calculatePosition, isOpen]);

  // MARK : Rendering
  // -------------------------------------------------------------------------------
  function renderContent() {
    return /*#__PURE__*/React__default.createElement(Text, {
      as: "span",
      font: "ui.small",
      color: "white"
    }, children);
  }
  function renderTooltip() {
    const {
        tail
      } = position,
      style = _objectWithoutProperties(position, _excluded2$3);
    return (
      /*#__PURE__*/
      // Use style instead of passing the position props via Box/Flex
      // to avoid styled components generating too many classes
      React__default.createElement(Wrapper$6, _extends({
        id: contentIdentifier,
        "data-testid": "tooltip-wrapper",
        tooltipPositioning: style,
        onClick: close
      }, props, {
        isOpen: isOpen,
        role: "tooltip"
      }), /*#__PURE__*/React__default.createElement(TooltipTail$1, tail), /*#__PURE__*/React__default.createElement(Flex$1, {
        flexDirection: "column",
        alignItems: "center",
        maxHeight: "368",
        overflow: "auto",
        "data-testid": "tooltip-content",
        p: "s"
      }, renderContent()))
    );
  }
  return /*#__PURE__*/createPortal$1(renderTooltip(), document.body);
};
var Tooltip$2 = Tooltip$1;

const _excluded$w = ["iconId", "fill", "children", "direction", "interactive"];
const InfoTip = _ref => {
  let {
      iconId = "info",
      fill = undefined,
      children,
      direction = TooltipDirection.Top,
      interactive
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$w);
  const id = useMemo(() => factory.genUUID(), []);
  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    flexGrow: "0",
    ml: "s",
    display: "inline-flex",
    style: {
      verticalAlign: "text-top"
    }
  }, rest, {
    "data-tooltip-source": id
  }), children && /*#__PURE__*/React__default.createElement(Tooltip$2, {
    source: id,
    direction: direction,
    interactive: interactive
  }, children), /*#__PURE__*/React__default.createElement(Icon$1, {
    size: "16",
    iconId: iconId || "info",
    fill: fill,
    style: {
      verticalAlign: "text-top"
    }
  }));
};
var InfoTip$1 = InfoTip;

const Component$c = Tooltip$2;
Component$c.Direction = TooltipDirection;
Component$c.InfoTip = InfoTip$1;
var Tooltip = Component$c;

const Badge = _ref => {
  let {
    id,
    text,
    font = "ui.smallBold",
    textColor = "white",
    background = "info",
    tooltip,
    styleOverrides
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box$1, _extends({
    background: background,
    p: "2px 4px",
    borderRadius: "default",
    "data-tooltip-source": id
  }, styleOverrides), /*#__PURE__*/React__default.createElement(Text, {
    font: font,
    color: textColor
  }, text)), tooltip && /*#__PURE__*/React__default.createElement(Tooltip, {
    border: "none",
    direction: Tooltip.Direction.Bottom,
    source: id,
    minWidth: "40",
    maxWidth: "250"
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    font: "ui.small"
  }, tooltip, " ", /*#__PURE__*/React__default.createElement(Button$1, {
    fontStyle: "ui.smallBold",
    size: "small",
    buttonStyle: "tertiary",
    link: "/pricing",
    text: "View plans",
    themeOverrides: {
      primaryColor: "white",
      primaryColorDark: "white"
    },
    newWindow: true
  }))));
};

const BigNumberContainer = styled(Box$1).attrs({
  flex: 1,
  py: "m",
  border: "default",
  background: "grayLightest",
  borderRadius: "default",
  textAlign: "center",
  minWidth: "150px"
}).withConfig({
  displayName: "BigNumber__BigNumberContainer"
})([""]);
const BigNumberDiff = styled(Text).attrs(props => {
  return {
    font: "ui.smallBold",
    color: props.diff < 0 ? "error" : "success"
  };
}).withConfig({
  displayName: "BigNumber__BigNumberDiff"
})([""]);
const BigNumberDiffIcon = styled(Icon$1).attrs(props => {
  return {
    iconId: props.diff < 0 ? "navigation.chevron-down" : "navigation.chevron-up",
    fill: props.diff < 0 ? "error" : "success",
    size: "16"
  };
}).withConfig({
  displayName: "BigNumber__BigNumberDiffIcon"
})([""]);
const BigNumber = _ref => {
  let {
    title,
    value,
    diff,
    formattedDiff,
    tooltip
  } = _ref;
  const bigNumberDiff = formattedDiff !== null && formattedDiff !== void 0 ? formattedDiff : Math.abs(diff).toString();
  return /*#__PURE__*/React__default.createElement(BigNumberContainer, {
    height: "100%"
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Text, {
    truncate: true,
    font: "ui.regular",
    color: "grayDarkest"
  }, title), tooltip && /*#__PURE__*/React__default.createElement(InfoTip$1, {
    direction: "bottom",
    fill: "grayDarkest"
  }, tooltip)), /*#__PURE__*/React__default.createElement(Text, {
    font: "ui.pageTitle"
  }, value !== null && value !== void 0 ? value : "-"), _isFinite(diff) && (diff === 0 ? /*#__PURE__*/React__default.createElement(Text, {
    font: "ui.smallBold",
    color: "grayDarkest"
  }, "0") : /*#__PURE__*/React__default.createElement(Flex$1, {
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(BigNumberDiffIcon, {
    diff: diff,
    iconId: ""
  }), /*#__PURE__*/React__default.createElement(BigNumberDiff, {
    diff: diff
  }, bigNumberDiff))));
};
var BigNumber$1 = BigNumber;

const CheckboxWrapper = styled(Flex$1).attrs({}).withConfig({
  displayName: "Checkbox__CheckboxWrapper"
})(["input[type=\"checkbox\"]{display:none;}"]);
const Checkbox$1 = _ref => {
  let {
    id = null,
    type = "checkbox",
    size = "regular",
    truncate = false,
    isSelected = false,
    label = null,
    onClick = null,
    disabled = false,
    styleOverrides
  } = _ref;
  const iconState = isSelected ? "checked" : "unchecked";
  const iconId = type === "indeterminate" ? "action.checkbox-indeterminate" : "".concat(type, "-").concat(iconState);
  const theme = useContext(ThemeContext);
  const fill = disabled ? getColor("grayDark") : getColor(theme && theme.primaryColor || "primary");
  let text = label;
  // Wrap string label in a Text element
  // Non string labels are typically used to include a text link in the label
  if (typeof label === "string") {
    text = /*#__PURE__*/React__default.createElement(Text, {
      font: size === "small" ? "ui.small" : "ui.regular",
      truncate: truncate,
      color: disabled ? "grayDarker" : "black"
    }, label);
  }
  return /*#__PURE__*/React__default.createElement(CheckboxWrapper, _extends({
    as: "label",
    style: {
      cursor: disabled ? "not-allowed" : "pointer"
    },
    alignItems: "center",
    onClick: e => {
      e.stopPropagation();
    }
  }, styleOverrides), /*#__PURE__*/React__default.createElement("input", {
    "data-testid": id,
    type: "checkbox",
    "aria-checked": isSelected,
    checked: isSelected,
    onChange: disabled ? null : onClick,
    disabled: disabled,
    role: type === "radio" ? "radio" : "checkbox"
  }), /*#__PURE__*/React__default.createElement(Icon$1, {
    disabled: disabled,
    flexShrink: "0",
    fill: fill,
    iconId: iconId,
    size: size === "small" ? "16" : undefined,
    mr: text ? "xs" : null,
    "aria-hidden": true
  }), text);
};
var Checkbox$2 = Checkbox$1;

const _excluded$v = ["iconProps", "title", "subtitle", "size", "button", "extra", "dropZone", "styleOverrides", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"];
const styleReference = {
  large: {
    titleStyles: {
      as: "h1",
      font: "ui.mediumTitle",
      mb: "s"
    },
    subtitleStyles: {
      as: "h2",
      font: "ui.pageTitle",
      color: "grayDarkest"
    }
  },
  regular: {
    titleStyles: {
      as: "h2",
      font: "ui.title",
      mb: "xxs",
      color: "grayDarker"
    },
    subtitleStyles: {
      as: "h3",
      font: "ui.regular",
      color: "grayDarker",
      maxWidth: "400px"
    }
  },
  small: {
    titleStyles: {
      as: "h3",
      font: "ui.regularBold",
      mb: "xxs",
      color: "grayDarker"
    },
    subtitleStyles: {
      font: "ui.regular",
      color: "grayDarker",
      maxWidth: "400px"
    }
  }
};
const EmptyState = _ref => {
  let {
      iconProps = null,
      title,
      subtitle,
      size = "regular",
      button = null,
      extra = null,
      dropZone = null,
      styleOverrides,
      onDragEnter,
      onDragOver,
      onDragLeave,
      onDrop
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$v);
  const sizeStyles = styleReference[size] || styleReference.regular;
  function renderImage() {
    if (!iconProps) return null;
    return /*#__PURE__*/React__default.createElement(Icon$1, _extends({
      size: "60px",
      fill: "gray",
      my: size === "small" ? "s" : "m"
    }, iconProps));
  }
  return /*#__PURE__*/React__default.createElement(Flex$1, _extends({
    alignItems: "center",
    py: "120px",
    flexDirection: "column",
    textAlign: "center",
    position: "relative",
    width: "100%",
    onDragEnter: onDragEnter,
    onDragOver: onDragOver,
    onDragLeave: onDragLeave,
    onDrop: onDrop
  }, styleOverrides, rest), renderImage(), dropZone, /*#__PURE__*/React__default.createElement(Text, sizeStyles.titleStyles, title), /*#__PURE__*/React__default.createElement(Text, sizeStyles.subtitleStyles, subtitle), button && /*#__PURE__*/React__default.createElement(Button$1, _extends({
    mt: "l"
  }, button)), extra);
};
var EmptyState$1 = EmptyState;

function variableStyle(props) {
  let gridTemplateColumns = props.templateColumns;
  if (Number.isInteger(Number(gridTemplateColumns))) {
    gridTemplateColumns = "repeat(".concat(gridTemplateColumns, ", 1fr)");
  }
  return css(["grid-template-columns:", ";gap:", ";", ""], gridTemplateColumns, props.gap, getVariations(props, variableStyle));
}
const Grid = styled(Box$1).withConfig({
  displayName: "Grid"
})(["display:grid;", ""], variableStyle);
var Grid$1 = Grid;

const _excluded$u = ["id", "alt", "src", "srcFallback", "onDragStart", "onLoad", "icon", "iconSize", "iconFill", "cover", "animate"];
const imageAnimation = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
const ContainImage = styled.img.withConfig({
  displayName: "ImageView__ContainImage"
})(["", " max-height:100%;max-width:100%;animation:", " 0.3s ease;animation-duration:", ";"], centered, imageAnimation, props => props.animate ? "0.3s" : "0s");
const CoverImage = styled(Box$1).withConfig({
  displayName: "ImageView__CoverImage"
})(["", " width:100%;height:100%;background:", ";background-position:center;background-size:cover;animation:", " 0.3s ease;animation-duration:", ";"], centered, props => "url(".concat(props.src, ")"), imageAnimation, props => props.animate ? "0.3s" : "0s");
// Wrap in styled to support built in props
const ImageView = _ref => {
  let {
      id,
      alt,
      src,
      srcFallback,
      onDragStart,
      onLoad,
      icon,
      iconSize,
      iconFill,
      cover,
      animate = true
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$u);
  const [loadedSrc, setLoadedSrc] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const onImageLoad = useCallback(() => {
    setLoadedSrc(src);
    setLoaded(true);
    if (onLoad) onLoad(true);
  }, [src, onLoad]);
  const onImageError = useCallback(() => {
    setLoadedSrc(srcFallback);
    setLoaded(true);
    if (onLoad) onLoad(false);
  }, [srcFallback, onLoad]);
  const onImageFallbackLoad = useCallback(() => {
    setLoadedSrc(srcFallback);
    setLoaded(true);
  }, [srcFallback]);
  useLayoutEffect(() => {
    if (src !== loadedSrc) {
      setLoaded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);
  useEffect(() => {
    if (!src) {
      if (loadedSrc) {
        onImageFallbackLoad();
      }
      return;
    }
    const img = new Image();
    img.src = src;
    img.addEventListener("load", onImageLoad);
    img.addEventListener("error", onImageError);
    return () => {
      img.removeEventListener("load", onImageLoad);
      img.removeEventListener("error", onImageError);
    };
  }, [onImageFallbackLoad, onImageError, onImageLoad, src, loadedSrc, srcFallback]);
  function renderIcon() {
    return icon ? /*#__PURE__*/React__default.createElement(Icon$1, {
      id: "image-view-icon",
      coverParent: true,
      fill: getColor(iconFill, "grayDark"),
      iconId: icon,
      size: iconSize
    }) : null;
  }
  function renderThumb() {
    const Comp = cover ? CoverImage : ContainImage;
    return /*#__PURE__*/React__default.createElement(Comp, {
      animate: animate,
      alt: alt,
      "data-testid": "image-view-image",
      src: loadedSrc,
      onDragStart: onDragStart
    });
  }
  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    "data-testid": id,
    flexShrink: "0",
    overflow: "hidden"
  }, otherProps), loaded && loadedSrc ? renderThumb() : renderIcon());
};
var ImageView$1 = ImageView;

const _excluded$t = ["id", "label", "message", "inputStyle", "size", "children", "font", "disabled", "readOnly", "autoFocus", "autoSelect", "onSubmit", "styleOverrides"];
const Element = styled.input.withConfig({
  displayName: "Input__Element"
})(["width:100%;border:", ";border-radius:", ";background:white;box-sizing:border-box;", ";", " ", " &::placeholder{", ";color:", ";}&.active,&:focus{border:", ";outline:none;}&.error{border:", ";}&.disabled,&:read-only{border:", ";background:", ";color:", ";}&[type=\"search\"]{-webkit-appearance:textfield;}&[type=\"text\"]::-ms-clear{display:none;width:0;height:0;}&[type=\"text\"]::-ms-reveal{display:none;width:0;height:0;}&[type=\"search\"]::-webkit-search-decoration,&[type=\"search\"]::-webkit-search-cancel-button,&[type=\"search\"]::-webkit-search-results-button,&[type=\"search\"]::-webkit-search-results-decoration{-webkit-appearance:none;display:none;}"], getBorder("1px solid border"), props => {
  var _props$theme;
  return getBorderRadius(props === null || props === void 0 || (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.themeName, "default");
}, props => getFont(props.font, props.defaultFontSize, props), props => positioningCSS({
  px: "8px",
  py: "5px",
  height: props.height
}), positioningCSS, props => getFont(props.font, props.defaultFontSize, props), getColor("grayDark"), getBorder("1px solid focus"), getBorder("1px solid error"), getBorder("1px solid border"), getColor("grayLighter"), getColor("grayDark"));
const Input$1 = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
      id,
      label,
      message,
      inputStyle,
      size,
      children,
      font,
      disabled,
      readOnly,
      autoFocus,
      autoSelect,
      onSubmit,
      styleOverrides
    } = _ref,
    inputAttributes = _objectWithoutProperties(_ref, _excluded$t);
  const inputRef = useRef();
  const innerRef = ref || inputRef;
  useEffect(() => {
    if (autoFocus) {
      var _innerRef$current;
      innerRef === null || innerRef === void 0 || (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 || _innerRef$current.focus();
    }
    if (autoSelect) {
      var _innerRef$current2;
      innerRef === null || innerRef === void 0 || (_innerRef$current2 = innerRef.current) === null || _innerRef$current2 === void 0 || _innerRef$current2.select();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getIcon() {
    switch (inputStyle) {
      case "error":
        return /*#__PURE__*/React__default.createElement(Icon$1, {
          size: "16",
          fill: "error",
          iconId: "error",
          mr: "xs"
        });
      case "success":
        return /*#__PURE__*/React__default.createElement(Icon$1, {
          size: "16",
          fill: "success",
          iconId: "checkmark",
          mr: "xs"
        });
      case "warning":
        return /*#__PURE__*/React__default.createElement(Icon$1, {
          size: "16",
          fill: "warning",
          iconId: "warning",
          mr: "xs"
        });
      default:
        return null;
    }
  }
  function renderContent() {
    const height = size === "small" ? "28px" : "36px",
      defaultFontSize = size === "small" ? "ui.small" : "ui.regular";
    return /*#__PURE__*/React__default.createElement(Flex$1, {
      alignItems: "center",
      width: "100%"
    }, /*#__PURE__*/React__default.createElement(Element, _extends({
      id: id,
      role: "textbox",
      ref: innerRef,
      disabled: disabled,
      readOnly: readOnly,
      className: disabled || readOnly ? "disabled" : inputStyle,
      defaultFontSize: defaultFontSize,
      height: height,
      font: font
    }, inputAttributes)), children);
  }
  function renderForm() {
    if (!onSubmit) {
      return renderContent();
    }
    return /*#__PURE__*/React__default.createElement("form", {
      onSubmit: e => {
        e.preventDefault();
        if (onSubmit) onSubmit(e);
      }
    }, renderContent());
  }
  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    "data-testid": id,
    width: "100%"
  }, styleOverrides), label ? /*#__PURE__*/React__default.createElement(Text, {
    as: "label",
    "data-testid": "input-label",
    display: "block",
    color: "black",
    mb: "4px",
    htmlFor: id,
    textAlign: "left"
  }, label) : null, renderForm(), message ? /*#__PURE__*/React__default.createElement(Flex$1, {
    "data-testid": "input-message",
    ml: "s",
    flexDirection: "row",
    alignItems: "center"
  }, getIcon(), /*#__PURE__*/React__default.createElement(Text, {
    as: "span",
    my: "xs",
    font: "ui.small",
    color: inputStyle === "error" ? "error" : "black"
  }, message)) : null);
});
Input$1.displayName = "Input";
var Input$2 = Input$1;

function useWindowSize() {
  function getSize() {
    if (!isBrowser()) {
      return {
        width: 0,
        height: 0,
        belowInspectorThreshold: false
      };
    }
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      // Custom screen size metric bools
      belowInspectorThreshold: window.innerWidth <= 1200,
      isMobile: window.innerWidth <= 768
    };
  }
  const [windowSize, setWindowSize] = useState(getSize);
  useEffect(() => {
    function handleResize() {
      setWindowSize(getSize());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return useMemo(() => windowSize, [windowSize]);
}

const _excluded$s = ["source", "open", "vPos", "hPos", "width", "maxHeight", "close", "stayOpenOnClick", "clickAwayClose", "children"];
const MenuContainer = styled(Flex$1).attrs(props => {
  return {
    maxWidth: "100%",
    border: "default",
    background: "white",
    boxShadow: "panel",
    width: props.width || 236,
    flexDirection: "column",
    position: props.position || "absolute",
    display: "block",
    borderRadius: "default",
    overflow: "hidden",
    zIndex: "popupMenu",
    transition: "none"
  };
}).withConfig({
  displayName: "PopupMenu__MenuContainer"
})(["line-height:30px;"]);
const PopupMenu$1 = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
      source,
      open = true,
      vPos = "floatBelow",
      hPos = "alignLeft",
      width = 236,
      maxHeight = 368,
      close,
      stayOpenOnClick = false,
      clickAwayClose = true,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$s);
  // const [bodyStyle, setBodyStyle] = useState<Record<string, string>>();
  const [position, setPosition] = useState({});
  const contentIdentifier = useRef(factory.genString());
  const [zIndex, setZIndex] = useState(0);
  const windowSize = useWindowSize();
  useEffect(() => {
    function preventScroll() {
      setZIndex(document.body.querySelectorAll(".popup-menu-open").length);
      // Allows all scrolling to happen within the overlay, and saves previous scroll position.
      const body = document.querySelector("body");
      body.style.overflow = "hidden";
    }
    function restoreScroll() {
      // Restores scroll position to state before overlay was opened.
      const body = document.querySelector("body");
      body.style.overflow = null;
    }
    if (open) preventScroll();else restoreScroll();
    return () => restoreScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const calculatePosition = useCallback(() => {
    let sourceEl;
    if (typeof source === "string") {
      try {
        sourceEl = document.querySelector(source);
      } catch (_unused) {
        // Retry another selector below
      }
      if (!sourceEl) sourceEl = document.querySelector("[data-popup-source='".concat(source, "']"));
    } else {
      sourceEl = source;
    }
    if (!sourceEl || !sourceEl.getBoundingClientRect) {
      // Something about the test environment causes this querySelector to fail
      // and this log pollutes the test output.
      if (_lingoConfig.environment !== "test-runner") {
        var _sourceEl;
        console.error("Unable to find source element ".concat(source), sourceEl, (_sourceEl = sourceEl) === null || _sourceEl === void 0 ? void 0 : _sourceEl.getBoundingClientRect);
      }
      return;
    }
    const rect = sourceEl.getBoundingClientRect(),
      windowRect = document.body.getBoundingClientRect(),
      contentEl = document.body.querySelector("#".concat(contentIdentifier.current)),
      contentRect = contentEl.getBoundingClientRect();
    const transform = {
      x: 0,
      y: 0
    };
    const pos = {
      width: Number(width)
    };
    switch (hPos) {
      case "alignLeft":
        if (rect.left + contentRect.width > windowRect.width) {
          pos.right = "s";
        } else {
          pos.left = rect.left;
        }
        break;
      case "alignRight":
        if (rect.left + rect.width < contentRect.width) pos.left = "s";else {
          pos.left = rect.left + rect.width;
          transform.x = "-100%";
        }
        break;
      case "center":
        {
          const center = rect.left + rect.width / 2;
          if (center + contentRect.width / 2 > windowRect.width) {
            pos.right = "s";
          } else if (center < contentRect.width / 2) {
            pos.left = "s";
          } else {
            pos.left = center - contentRect.width / 2;
          }
          break;
        }
      case "floatLeft":
        if (rect.left < contentRect.width) {
          pos.left = "s";
        } else {
          pos.left = rect.left;
          transform.x = "-100%";
        }
        break;
      case "floatRight":
        if (rect.left + rect.width + contentRect.width > windowRect.width) {
          pos.right = "s";
        } else {
          pos.left = rect.left + rect.width;
        }
        break;
    }
    switch (vPos) {
      case "alignTop":
        if (rect.top + contentRect.height > windowRect.height) {
          pos.bottom = "s";
        } else {
          pos.top = rect.top;
        }
        break;
      case "alignBottom":
        if (rect.top + rect.height < contentRect.height) {
          pos.top = "s";
        } else {
          pos.top = rect.top + rect.height;
          transform.y = "-100%";
        }
        break;
      case "center":
        {
          const center = rect.top + rect.height / 2;
          if (center + contentRect.height / 2 > windowRect.height) {
            pos.bottom = "s";
          } else if (center < contentRect.height / 2) {
            pos.top = "s";
          } else {
            pos.top = rect.top;
            transform.y = "-50%";
          }
          break;
        }
      case "floatAbove":
        if (rect.top < contentRect.height) {
          pos.top = "s";
        } else {
          pos.top = rect.top;
          transform.y = "-100%";
        }
        break;
      case "floatBelow":
        if (rect.top + rect.height + contentRect.height > windowRect.height) {
          pos.bottom = "s";
        } else {
          pos.top = rect.top + rect.height;
        }
        break;
    }
    pos.transform = "translate(".concat(transform.x, ", ").concat(transform.y, ")");
    setPosition(pos);
  }, [hPos, source, vPos, width]);
  useLayoutEffect(() => {
    if (!open) return;
    calculatePosition();
  }, [hPos, open, vPos, width, windowSize, children, calculatePosition]);
  const noBubble = useCallback(e => e.stopPropagation(), []);
  function renderMenu() {
    return /*#__PURE__*/React__default.createElement(MenuContainer, _extends({}, position, {
      onClick: !stayOpenOnClick ? close : undefined,
      position: clickAwayClose ? "absolute" : "fixed"
    }, props, {
      ref: ref,
      display: open ? undefined : "none",
      zIndex: 50000 + zIndex,
      className: open ? "popup-menu-open" : null
    }), /*#__PURE__*/React__default.createElement(Flex$1, {
      id: contentIdentifier.current,
      flexDirection: "column",
      maxHeight: maxHeight,
      overflow: "auto",
      "data-testid": "popup-menu-content"
    }, children));
  }
  function renderWrappedMenu() {
    return /*#__PURE__*/React__default.createElement(Box$1, {
      display: open ? undefined : "none",
      zIndex: 50000 + zIndex,
      position: "fixed",
      top: "0",
      bottom: "0",
      right: "0",
      left: "0",
      onClick: noBubble,
      onDoubleClick: noBubble
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      position: "absolute",
      top: "0",
      bottom: "0",
      right: "0",
      left: "0",
      onClick: close
    }), renderMenu());
  }

  // Support for NextJS SSR for the docs site
  if (typeof window === "undefined") return null;
  return /*#__PURE__*/createPortal$1(clickAwayClose ? renderWrappedMenu() : renderMenu(), document.body);
});
PopupMenu$1.displayName = "PopupMenu";
var PopupMenu$2 = PopupMenu$1;

const _excluded$r = ["id", "title", "onClick", "link", "image", "font", "children", "checked", "disabled", "truncate", "bordered", "badge", "tooltip", "accessory", "hPos", "isActive", "innerRef"],
  _excluded2$2 = ["src", "iconId", "imageStyle", "color"];
// Wes: I believe this consumes clicks on disabled/non-clickable PopupMenu items
// Without it the click is passed through the menu which closes the menu
function noOp(e) {
  e.preventDefault();
  e.stopPropagation();
}
const ItemWrapper$2 = styled(Flex$1).attrs(props => {
  return {
    p: "8px",
    alignItems: props.alignItems || "center",
    background: props.isActive ? "grayLighter" : "white",
    textAlign: "left",
    variations: {
      "&:hover": {
        background: "grayLighter"
      },
      "&:last-of-type": {
        borderBottom: "none"
      }
    },
    style: {
      cursor: props.disabled ? "not-allowed" : "pointer",
      opacity: props.disabled ? 0.5 : 1
    }
  };
}).withConfig({
  displayName: "Item__ItemWrapper"
})(["", ""], positioningCSS);
const Pill$2 = styled.span.withConfig({
  displayName: "Item__Pill"
})(["background:", ";color:white;padding:4px 8px;border-radius:4px;", ""], getColor("info"), getFont("ui.smallBold", null));
const ColorPreview = styled.span.withConfig({
  displayName: "Item__ColorPreview"
})(["height:16px;width:16px;border-radius:2px;border:", ";background-color:", ";margin-right:8px;"], props => props.color === "transparent" && "1px solid ".concat(getColor("grayLight")), props => props.color);
const Item$3 = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
      id,
      title,
      onClick,
      link,
      image,
      font = "ui.regular",
      children,
      checked = false,
      disabled = false,
      truncate = false,
      bordered = false,
      badge,
      tooltip,
      accessory,
      hPos,
      isActive = false,
      innerRef
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded$r);
  const [nestedOpen, openNested, closeNested] = useBoolean(false);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const nestedPopupKey = useMemo(() => v4(), []);
  function renderImage() {
    if (!image) return null;
    const {
        src,
        iconId,
        imageStyle,
        color
      } = image,
      imageProps = _objectWithoutProperties(image, _excluded2$2);
    if (src) {
      var _imageProps$size, _imageProps$width, _imageProps$height;
      const rounded = imageStyle === "circle" ? "50%" : "default";
      return /*#__PURE__*/React__default.createElement(ImageView$1, _extends({
        mr: "s",
        iconSize: (_imageProps$size = imageProps.size) !== null && _imageProps$size !== void 0 ? _imageProps$size : 16,
        icon: iconId,
        width: (_imageProps$width = imageProps.width) !== null && _imageProps$width !== void 0 ? _imageProps$width : 24,
        height: (_imageProps$height = imageProps.height) !== null && _imageProps$height !== void 0 ? _imageProps$height : 24,
        src: src,
        cover: true,
        background: "grayLighter",
        iconFill: imageProps.fill || "grayDark",
        borderRadius: rounded
      }, imageProps));
    }
    if (iconId) return /*#__PURE__*/React__default.createElement(Icon$1, _extends({
      mr: "s",
      iconId: iconId,
      fill: "black"
    }, imageProps));
    if (color) {
      return /*#__PURE__*/React__default.createElement(ColorPreview, {
        color: color
      });
    }
    return null;
  }
  function renderContent() {
    let popupSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return /*#__PURE__*/React__default.createElement(LinkWrapper$1, {
      disabled: disabled,
      title: typeof title === "string" ? title : "",
      link: link
    }, /*#__PURE__*/React__default.createElement(ItemWrapper$2, _extends({
      "data-tooltip-source": id,
      "data-testid": id,
      onClick: disabled ? noOp : onClick,
      "data-popup-source": popupSource,
      disabled: disabled,
      borderBottom: bordered ? "default" : null,
      isActive: isActive,
      ref: ref || innerRef
    }, other), checked ? /*#__PURE__*/React__default.createElement(Icon$1, {
      flexShrink: "0",
      flexGrow: "0",
      iconId: "checkmark",
      fill: "black",
      mr: "xs",
      size: "16"
    }) : /*#__PURE__*/React__default.createElement(Box$1, {
      flexShrink: "0",
      mr: "xs",
      width: "16",
      height: "16"
    }), renderImage(), typeof title === "string" ? /*#__PURE__*/React__default.createElement(Text, {
      truncate: truncate,
      flex: "1",
      title: title,
      font: font
    }, title) : title, accessory, badge && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Pill$2, null, badge)), tooltip && /*#__PURE__*/React__default.createElement(Tooltip, {
      width: 230,
      direction: "bottom",
      source: id
    }, tooltip)));
  }
  function renderAsNested() {
    accessory = accessory || /*#__PURE__*/React__default.createElement(Icon$1, {
      iconId: "triangle-collapsed",
      justifySelf: "center",
      size: "16"
    });
    onClick = onClick || noOp;
    return /*#__PURE__*/React__default.createElement(Box$1, {
      onMouseEnter: openNested,
      onMouseLeave: closeNested
    }, renderContent(nestedPopupKey), nestedOpen && /*#__PURE__*/React__default.createElement(PopupMenu$2, {
      hPos: hPos ? hPos : "floatRight",
      vPos: "alignTop",
      source: nestedPopupKey,
      close: closeNested,
      clickAwayClose: false
    }, children));
  }
  return children ? renderAsNested() : renderContent();
});
Item$3.displayName = "Item";
var PopupItem = Item$3;

const _excluded$q = ["id", "title", "children", "button"];
function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const SectionHeading = styled(Flex$1).attrs({
  background: "grayLightest",
  borderBottom: "default",
  flexDirection: "row",
  px: "m",
  py: "xs",
  justifyContent: "space-between",
  textAlign: "left",
  position: "sticky",
  top: 0,
  zIndex: 5
}).withConfig({
  displayName: "Section__SectionHeading"
})([""]);

// Wrapper is used to avoid adding a border to the first section header
// but still contain the contents of each section
const SectionContainer = styled(Box$1).attrs(props => {
  return _objectSpread$d({
    borderTop: "default",
    variations: {
      "&:first-child": {
        borderTop: "none"
      }
    }
  }, props);
}).withConfig({
  displayName: "Section__SectionContainer"
})([""]);
const Section = _ref => {
  let {
      id,
      title,
      children,
      button
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$q);
  function renderHeader() {
    const headerButton = (() => {
      if (!button || !button.text) return null;
      return /*#__PURE__*/React__default.createElement(Button$1, _extends({}, button, {
        buttonStyle: "tertiary",
        size: "small",
        m: 0
      }));
    })();
    if (!title && !headerButton) return null;
    return /*#__PURE__*/React__default.createElement(SectionHeading, {
      "data-testid": "menu-section-heading"
    }, /*#__PURE__*/React__default.createElement(Text, {
      truncate: true,
      font: "ui.smallBold",
      color: "grayDarkest"
    }, title), headerButton);
  }
  const header = renderHeader();
  if (!header && !children) return null;
  return /*#__PURE__*/React__default.createElement(SectionContainer, _extends({
    "data-testid": id
  }, rest), header, children);
};
var Section$1 = Section;

const Dialog = _ref => {
  let {
    text,
    color = "grayDarkest",
    borderBottom = "default",
    borderTop = "none",
    background = "white"
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box$1, {
    p: "s",
    borderBottom: borderBottom,
    borderTop: borderTop,
    background: background
  }, /*#__PURE__*/React__default.createElement(Text, {
    ml: "20px",
    font: "ui.smallBold",
    color: color
  }, text));
};
var Dialog$1 = Dialog;

const ContextMenuAnchor = styled.div.withConfig({
  displayName: "ContextMenuAnchor"
})(["position:fixed;top:", ";left:", ";height:1px;width:1px;background:transparent;pointer-events:none;"], props => props.yPos, props => props.xPos);
var ContextMenuAnchor$1 = ContextMenuAnchor;

const MenuItemRenderer = _ref => {
  let {
    menuItems
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, menuItems.map((menuItem, index) => {
    switch (menuItem.type) {
      case "Item":
        return /*#__PURE__*/React__default.createElement(PopupItem, _extends({}, menuItem.itemProps, {
          key: index
        }));
      case "Dialog":
        return /*#__PURE__*/React__default.createElement(Dialog$1, _extends({}, menuItem.dialogProps, {
          key: index
        }));
      default:
        return null;
    }
  }));
};
var MenuItemRenderer$1 = MenuItemRenderer;

const Component$b = PopupMenu$2;
Component$b.Item = PopupItem;
Component$b.Dialog = Dialog$1;
Component$b.Section = Section$1;
Component$b.ContextMenuAnchor = ContextMenuAnchor$1;
Component$b.MenuContainer = MenuContainer;
Component$b.MenuItemRenderer = MenuItemRenderer$1;
var PopupMenu = Component$b;

/**
 * Pluralize helper function
 * @param {string} word
 * @param {number} length
 * @returns Singular or plural string
 */
function pluralize(word, length) {
  if (length !== 1) word += "s";
  return word;
}

function getVerticalDragDirection(e, dragRef) {
  const dragEventY = e.pageY;
  let sideY = "top";
  /**
   * Null check the ref for tests
   */
  if (dragRef.current) {
    const {
      bottom,
      top
    } = dragRef.current.getBoundingClientRect();
    sideY = Math.abs(top - dragEventY) < Math.abs(bottom - dragEventY) ? "top" : "bottom";
  }
  return sideY;
}
function getHorizontalDragDirection(e, dragRef) {
  const dragEventX = e.pageX;
  let sideX = "left";

  /**
   * Null check the ref for tests
   */
  if (dragRef.current) {
    const {
      left,
      right
    } = dragRef.current.getBoundingClientRect();
    sideX = Math.abs(left - dragEventX) < Math.abs(right - dragEventX) ? "left" : "right";
  }
  return sideX;
}

function useDrag(_ref) {
  let {
    dragRef,
    doOnDragStart,
    doOnDragOver,
    doOnDragEnd,
    doOnDragLeave,
    doOnDrop
  } = _ref;
  const [dragDirection, setDragDirection] = React__default.useState(null);
  const onDragStart = e => {
    if (doOnDragStart) doOnDragStart(e);
  };
  const onDragOver = e => {
    if (e) e.preventDefault();
    if (doOnDragOver) doOnDragOver(e);
    const h = getHorizontalDragDirection(e, dragRef);
    const v = getVerticalDragDirection(e, dragRef);
    if (h !== (dragDirection === null || dragDirection === void 0 ? void 0 : dragDirection.horizontal) || v !== (dragDirection === null || dragDirection === void 0 ? void 0 : dragDirection.vertical)) setDragDirection({
      horizontal: h,
      vertical: v
    });
  };
  const onDragEnd = e => {
    if (e) e.preventDefault();
    if (doOnDragEnd) doOnDragEnd(e);
    setDragDirection(null);
  };
  const onDragLeave = e => {
    if (e) e.preventDefault();
    if (doOnDragLeave) doOnDragLeave(e);
    setDragDirection(null);
  };
  const onDrop = e => {
    if (e) e.preventDefault();
    if (doOnDrop) doOnDrop(e);
    setDragDirection(null);
  };
  return {
    dragDirection,
    dragProps: {
      draggable: true,
      onDragStart,
      onDragOver,
      onDragEnd,
      onDragLeave,
      onDrop
    }
  };
}

const retiredThemeNameMap = {
  pismo: SpaceThemeNames.wyman,
  dockweiler: SpaceThemeNames.scher
};
function useSpaceThemeName() {
  const theme = useTheme();
  const themeName = React__default.useMemo(() => {
    if (retiredThemeNameMap[theme === null || theme === void 0 ? void 0 : theme.themeName]) return retiredThemeNameMap[theme === null || theme === void 0 ? void 0 : theme.themeName];
    return (theme === null || theme === void 0 ? void 0 : theme.themeName) || SpaceThemeNames.classic;
  }, [theme]);
  return themeName;
}

function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const KitCardWrapper = styled(Flex$1).withConfig({
  displayName: "KitCard__KitCardWrapper"
})(["flex-direction:column;cursor:pointer;background-color:", ";transition:box-shadow 0.3s ease,background-color 0.3s ease;user-select:none;&:before,&:after{top:0;content:\"\";height:100%;width:4px;background:", ";position:absolute;border-radius:4px;}&:after{right:-12px;", "}&:before{left:-12px;", "}", " .hover{opacity:", ";background:linear-gradient( 180deg,rgba(42,42,42,0) 0%,rgba(42,42,42,0.45) 36.98%,rgba(42,42,42,0.9) 88.02% );transition:opacity 0.3s ease;}&:hover{box-shadow:", ";.hover{opacity:1;}}"], getColor("white"), props => props.theme.primaryColor, props => props.dragStyle !== "right" && "\n      opacity: 0;\n      display: none;\n    ", props => props.dragStyle !== "left" && "\n      opacity: 0;\n      display: none;\n    ", _ref => {
  let {
    theme
  } = _ref;
  return theme.themeName === SpaceThemeNames.wyman && "\n    height: 100%;\n    &:hover {\n    background-color: ".concat(getColor("grayLightest"), "\n    }");
}, props => props.showOverlay ? "1" : "0", props => props.shadowOnHover ? "0px 4px 16px 0px rgba(0, 0, 0, 0.07), 0px 1.541px 5.096px 0px rgba(0, 0, 0, 0.04), 0px 0.326px 1.304px 0px rgba(0, 0, 0, 0.03);" : "none");
const KitDescription = styled(Text).withConfig({
  displayName: "KitCard__KitDescription"
})(["overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;line-clamp:3;-webkit-box-orient:vertical;"]);
const iconMap$1 = {
  [PrivacyLevel.public]: "globe",
  [PrivacyLevel.private]: "users",
  [PrivacyLevel.password]: "globe-lock"
};
const SelectionBorder = styled(Box$1).attrs(props => {
  return {
    position: "absolute",
    top: -1,
    left: -1,
    right: -1,
    bottom: -1,
    border: props.isSelected ? "2px solid ".concat(getColor(props.theme.primaryColor, "primary")) : "2px solid transparent",
    transition: "border 0.3s ease"
  };
}).withConfig({
  displayName: "KitCard__SelectionBorder"
})(["pointer-events:none;"]);
const PillWrapper = styled(Flex$1).attrs(() => {
  return {
    py: "xs",
    px: "s",
    borderRadius: "4px",
    background: getColor("grayLighter"),
    maxWidth: "120px",
    justifyContent: "center",
    alignItems: "center"
  };
}).withConfig({
  displayName: "KitCard__PillWrapper"
})(["&:hover{background:", ";}"], getColor("grayLight"));
const ResponsiveKitCardWrapper = styled(KitCardWrapper).withConfig({
  displayName: "KitCard__ResponsiveKitCardWrapper"
})(["@media (max-width:560px){padding:16px;}"]);
const ResponsiveGrid = styled(Grid$1).withConfig({
  displayName: "KitCard__ResponsiveGrid"
})(["@media (max-width:560px){display:flex;flex-direction:column;gap:16px;}"]);
const ResponsiveImageWrapper = styled(Flex$1).withConfig({
  displayName: "KitCard__ResponsiveImageWrapper"
})(["@media (max-width:560px){width:100%;}"]);
const ResponsiveContentWrapper = styled(Flex$1).withConfig({
  displayName: "KitCard__ResponsiveContentWrapper"
})(["@media (max-width:560px){width:100%;flex-direction:column;}"]);

/**
 *
 * Renders a kit card including an image, name, and description.
 *
 * The buttons on the card are shown based on the provided props:
 * Favorite button: setFavorited && kit.access.permissions.includes("favorite")
 * Overflow button: menuItems
 * @param {Object} props
 */
const KitCard = _ref2 => {
  let {
    id,
    kit,
    space,
    onClick,
    onDoubleClick,
    onPillClick,
    isSelected,
    setFavorited,
    menuItems,
    kitCollectionId,
    reorderKitCollectionItems,
    identifier,
    overrideTheme,
    fullWidth,
    selectionProps
  } = _ref2;
  let themeName = useSpaceThemeName();
  if (overrideTheme) {
    themeName = SpaceThemeNames.classic;
  }
  const kitPortals = kit === null || kit === void 0 ? void 0 : kit.portals;
  const dragRef = useRef(null);
  const permissions = kit.access.permissions || [],
    spacePermissions = ((space || {}).access || {}).permissions || [],
    canFavorite = setFavorited && permissions.includes("favorite"),
    canViewMembers = spacePermissions.includes("view_members"),
    isFavorited = kit.access.isFavorite;
  const {
    dragDirection,
    dragProps
  } = useDrag({
    dragRef,
    doOnDragStart: e => e.dataTransfer.setData("kitId", kit.kitId),
    doOnDrop: e => {
      const droppingId = e.dataTransfer.getData("kitId");
      if (kit.kitId === droppingId) return;
      const displayDirection = (dragDirection === null || dragDirection === void 0 ? void 0 : dragDirection.horizontal) === "left" ? "before" : "after";
      reorderKitCollectionItems({
        kitId: droppingId,
        kitCollectionId,
        displayOrder: "".concat(displayDirection, ":").concat(kit.kitId)
      });
    }
  });
  const [menuVisible, setMenuVisible] = useState(false);
  const menuId = identifier ? "".concat(kit.kitId, "-").concat(identifier, "-overflow-menu") : "".concat(kit.kitId, "-overflow-menu");
  const menu = menuVisible && menuItems ? /*#__PURE__*/React__default.createElement(PopupMenu, {
    source: menuId,
    "data-testid": "kit-card-menu",
    verticalPosition: "below",
    close: () => setMenuVisible(!menuVisible)
  }, menuItems) : null;
  const handleClick = e => {
    onClick(e);
  };
  const handlePillClick = (e, kit, portal) => {
    e.stopPropagation();
    onPillClick(kit, portal);
  };
  const buttonThemeVals = {
    [SpaceThemeNames.classic]: {
      themeOverrides: {
        primaryColor: "black"
      }
    },
    [SpaceThemeNames.scher]: {
      themeOverrides: {
        primaryColor: "white"
      }
    },
    [SpaceThemeNames.wyman]: {
      themeOverrides: {
        primaryColor: "black"
      }
    }
  };
  const buttonOverrides = buttonThemeVals[themeName];
  function renderFavoriteButton() {
    return /*#__PURE__*/React__default.createElement(Button$1, _extends({
      id: "favorite-button",
      buttonStyle: "tertiary",
      icon: isFavorited ? "star-filled" : "star",
      m: "none",
      ml: fullWidth ? "none" : "xs",
      p: "none",
      width: "24",
      height: "24",
      background: "none",
      onClick: e => {
        e.stopPropagation();
        setFavorited(kit, !isFavorited);
      }
    }, buttonOverrides));
  }
  function renderOverflowButton() {
    return /*#__PURE__*/React__default.createElement(Button$1, _extends({
      id: "overflow-button",
      "data-popup-source": menuId,
      buttonStyle: "tertiary",
      icon: "overflow",
      width: "24",
      height: "24",
      onClick: e => {
        e.stopPropagation();
        setMenuVisible(!menuVisible);
      }
    }, buttonOverrides));
  }
  const memberCountTextThemeVals = {
    [SpaceThemeNames.classic]: {
      color: "grayDarker"
    },
    [SpaceThemeNames.scher]: {
      color: "white"
    }
  };
  function renderMemberCount() {
    const overrides = memberCountTextThemeVals[themeName];
    return /*#__PURE__*/React__default.createElement(Text, _extends({
      id: "member-count",
      my: "none",
      p: "none",
      font: "ui.small",
      flex: "0 0 auto",
      truncate: true
    }, overrides), kit.counts.members, pluralize(" user", kit.counts.members));
  }
  const descriptionThemeVals = {
    [SpaceThemeNames.scher]: {
      color: "white"
    }
  };
  function renderDescription() {
    const overrides = descriptionThemeVals[themeName];
    return /*#__PURE__*/React__default.createElement(KitDescription, _extends({
      id: "kit-description",
      mt: "xs"
    }, overrides), kit.description);
  }
  function renderPortalPills() {
    if (!(kitPortals !== null && kitPortals !== void 0 && kitPortals.length)) return null;
    return /*#__PURE__*/React__default.createElement(Flex$1, {
      flexDirection: "column",
      gap: "4px",
      pt: "s"
    }, /*#__PURE__*/React__default.createElement(Text, {
      color: "grayDarkest",
      font: "ui.smallBold"
    }, "Portals:"), /*#__PURE__*/React__default.createElement(Flex$1, {
      gap: "4px",
      maxWidth: "600px",
      flexWrap: "wrap"
    }, kitPortals.map(portal => /*#__PURE__*/React__default.createElement(PillWrapper, {
      key: portal.id,
      onClick: e => handlePillClick(e, kit, portal)
    }, /*#__PURE__*/React__default.createElement(Text, {
      truncate: true,
      font: "ui.small"
    }, portal.name)))));
  }
  const normalKitCardThemeVals = {
    [SpaceThemeNames.classic]: {
      contentContainerOverrides: {
        mt: "s"
      },
      imageViewOverrides: {
        borderRadius: "small"
      }
    },
    [SpaceThemeNames.wyman]: {
      kitCardWrapperOverrides: {
        border: "default",
        borderRadius: "large"
      },
      imageViewOverrides: {
        mt: "s",
        mx: "s",
        borderRadius: "medium"
      },
      contentContainerOverrides: {
        m: "m"
      }
    }
  };
  function renderNormalKitCard() {
    const {
      kitCardWrapperOverrides,
      imageViewOverrides,
      contentContainerOverrides
    } = normalKitCardThemeVals[themeName];
    return /*#__PURE__*/React__default.createElement(KitCardWrapper, _extends({
      ref: dragRef,
      "data-testid": id,
      "data-kitid": id,
      width: "100%",
      onClick: handleClick,
      onDoubleClick: onDoubleClick
    }, kitCardWrapperOverrides, _dragProps, selectionProps), /*#__PURE__*/React__default.createElement(Box$1, {
      width: "100%"
    }, /*#__PURE__*/React__default.createElement(_StyledImageView$2, _extends({
      src: kit.images.cover,
      icon: "content.kit",
      alt: kit.name,
      aspectRatio: 63,
      cover: true,
      background: "grayLighter",
      border: "default"
    }, imageViewOverrides, {
      $_css: onClick ? "pointer" : null
    })), themeName === SpaceThemeNames.classic && /*#__PURE__*/React__default.createElement(SelectionBorder, {
      borderRadius: "default",
      isSelected: isSelected
    })), /*#__PURE__*/React__default.createElement(Box$1, contentContainerOverrides, /*#__PURE__*/React__default.createElement(Flex$1, {
      justifyContent: "space-between"
    }, /*#__PURE__*/React__default.createElement(Text, {
      as: "h1",
      id: "kit-title",
      font: "ui.regularBold",
      truncate: true,
      onClick: handleClick
    }, kit.name), /*#__PURE__*/React__default.createElement(Flex$1, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      id: "privacy-".concat(kit.privacy),
      iconId: iconMap$1[kit.privacy],
      size: "24"
    }), canFavorite && renderFavoriteButton(), menuItems && renderOverflowButton(), menu)), canViewMembers && renderMemberCount(), kit.description && renderDescription()), themeName === SpaceThemeNames.wyman && /*#__PURE__*/React__default.createElement(SelectionBorder, {
      borderRadius: "large",
      isSelected: isSelected
    }));
  }
  function renderOverlayTypeKitCard() {
    return /*#__PURE__*/React__default.createElement(KitCardWrapper, _extends({
      ref: dragRef,
      "data-testid": id,
      "data-kitid": id,
      width: "100%",
      showOverlay: menuVisible,
      onClick: handleClick,
      onDoubleClick: onDoubleClick
    }, _dragProps, selectionProps), /*#__PURE__*/React__default.createElement(_StyledImageView2, {
      src: kit.images.cover,
      icon: "content.kit",
      alt: kit.name,
      aspectRatio: 63,
      cover: true,
      background: "grayLighter",
      border: "default",
      $_css2: onClick ? "pointer" : null
    }), /*#__PURE__*/React__default.createElement(Flex$1, {
      className: "hover",
      width: "100%",
      pt: "l",
      px: "m",
      pb: "s",
      flexDirection: "column",
      position: "absolute",
      bottom: "0",
      textAlign: "left"
    }, /*#__PURE__*/React__default.createElement(Flex$1, {
      width: "100%",
      justifyContent: "space-between"
    }, /*#__PURE__*/React__default.createElement(Text, {
      as: "h1",
      id: "kit-title",
      font: "ui.regularSemiBold",
      color: "white",
      truncate: true,
      onClick: handleClick
    }, kit.name), /*#__PURE__*/React__default.createElement(Flex$1, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      id: "privacy-".concat(kit.privacy),
      iconId: iconMap$1[kit.privacy],
      size: "24",
      fill: "white"
    }), canFavorite && renderFavoriteButton(), menuItems && renderOverflowButton(), menu)), canViewMembers && renderMemberCount(), kit.description && renderDescription()), /*#__PURE__*/React__default.createElement(SelectionBorder, {
      isSelected: isSelected
    }));
  }
  function renderFullWidthKitCard() {
    const {
      imageViewOverrides
    } = normalKitCardThemeVals[themeName];
    return /*#__PURE__*/React__default.createElement(ResponsiveKitCardWrapper, _extends({
      ref: dragRef,
      "data-testid": id,
      "data-kitid": id,
      width: "100%",
      showOverlay: menuVisible,
      shadowOnHover: true,
      onClick: handleClick,
      onDoubleClick: onDoubleClick,
      border: "default",
      p: "m",
      borderRadius: "medium"
    }, _dragProps, selectionProps), /*#__PURE__*/React__default.createElement(ResponsiveGrid, {
      width: "100%",
      templateColumns: "minmax(auto, 144px) minmax(200px, 4fr)",
      gap: "12px"
    }, /*#__PURE__*/React__default.createElement(ResponsiveImageWrapper, {
      alignItems: "flex-start"
    }, /*#__PURE__*/React__default.createElement(_StyledImageView3, _extends({
      src: kit.images.cover,
      icon: "content.kit",
      alt: kit.name,
      aspectRatio: 63,
      cover: true,
      width: "100%",
      background: "grayLighter"
    }, imageViewOverrides, {
      $_css3: onClick ? "pointer" : null
    })), themeName === SpaceThemeNames.classic && /*#__PURE__*/React__default.createElement(SelectionBorder, {
      borderRadius: "default",
      isSelected: isSelected
    })), /*#__PURE__*/React__default.createElement(ResponsiveContentWrapper, {
      width: "100%",
      flexDirection: "column",
      overflow: "hidden",
      gap: "16px"
    }, /*#__PURE__*/React__default.createElement(Flex$1, {
      justifyContent: "space-between",
      gap: "16px"
    }, /*#__PURE__*/React__default.createElement(Flex$1, {
      flexDirection: "column",
      gap: "16px"
    }, /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(Text, {
      as: "h1",
      id: "kit-title",
      font: "ui.regularBold",
      truncate: true,
      onClick: handleClick
    }, kit.name), /*#__PURE__*/React__default.createElement(Flex$1, {
      gap: "4px"
    }, canViewMembers && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderMemberCount(), /*#__PURE__*/React__default.createElement(Text, {
      my: "none",
      p: "none",
      font: "ui.small",
      color: "grayLight"
    }, "/")), /*#__PURE__*/React__default.createElement(Text, {
      my: "none",
      p: "none",
      font: "ui.small",
      color: "grayDarker",
      truncate: true,
      flex: "0 2 auto"
    }, "Updated ", formatDistanceToNow(new Date(kit.dateUpdated), {
      addSuffix: true
    }))))), /*#__PURE__*/React__default.createElement(Flex$1, {
      gap: "16px"
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      id: "privacy-".concat(kit.privacy),
      iconId: iconMap$1[kit.privacy],
      size: "24"
    }), canFavorite && renderFavoriteButton(), menuItems && renderOverflowButton(), menu)), kit.description && /*#__PURE__*/React__default.createElement(Box$1, {
      maxWidth: "480px"
    }, /*#__PURE__*/React__default.createElement(KitDescription, {
      id: "kit-description",
      mt: "xs",
      font: "ui.regular"
    }, kit.description)), renderPortalPills())));
  }
  const _dragProps = kitCollectionId && reorderKitCollectionItems ? _objectSpread$c(_objectSpread$c({}, dragProps), {}, {
    dragStyle: dragDirection === null || dragDirection === void 0 ? void 0 : dragDirection.horizontal
  }) : {};
  if (fullWidth) {
    return renderFullWidthKitCard();
  }
  switch (themeName) {
    case SpaceThemeNames.classic:
    case SpaceThemeNames.wyman:
      {
        return renderNormalKitCard();
      }
    case SpaceThemeNames.scher:
      {
        return renderOverlayTypeKitCard();
      }
  }
};
var KitCard$1 = KitCard;
var _StyledImageView$2 = styled(ImageView$1).withConfig({
  displayName: "KitCard___StyledImageView"
})(p => ({
  cursor: p.$_css
}));
var _StyledImageView2 = styled(ImageView$1).withConfig({
  displayName: "KitCard___StyledImageView2"
})(p => ({
  cursor: p.$_css2
}));
var _StyledImageView3 = styled(ImageView$1).withConfig({
  displayName: "KitCard___StyledImageView3"
})(p => ({
  cursor: p.$_css3
}));

const EmptyKitCard = _ref => {
  let {
    onClick
  } = _ref;
  return /*#__PURE__*/React__default.createElement(KitCardWrapper, {
    onClick: onClick,
    width: "100%",
    shadowOnHover: true,
    border: "default",
    p: "16px",
    borderRadius: "medium"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    width: "100%",
    templateColumns: "minmax(auto, 144px) minmax(200px, 4fr)",
    gap: "12px"
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    alignItems: "flex-start"
  }, /*#__PURE__*/React__default.createElement(ImageView$1, {
    src: null,
    icon: "action.add",
    alt: "Create a kit",
    aspectRatio: 63,
    cover: true,
    width: "100%",
    background: "grayLightest",
    borderRadius: "small"
  })), /*#__PURE__*/React__default.createElement(Flex$1, {
    width: "100%",
    flexDirection: "column",
    overflow: "hidden",
    gap: "4px"
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    justifyContent: "space-between",
    gap: "16px",
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    flexDirection: "column",
    gap: "16px"
  }, /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(Text, {
    as: "h1",
    font: "ui.regularBold",
    truncate: true,
    onClick: onClick
  }, "Create a new kit")))), /*#__PURE__*/React__default.createElement(KitDescription, {
    maxWidth: "480px",
    font: "ui.small",
    color: "grayDarker"
  }, "Kits are where your assets and brand guidelines are housed. Start here if you\u2019re setting up a new Lingo space."))));
};
var EmptyKitCard$1 = EmptyKitCard;

const PortalCardWrapper = styled(Box$1).withConfig({
  displayName: "PortalCard__PortalCardWrapper"
})(["flex:1 0 calc((1200px - 32px) / 3);max-width:", ";;width:", ";height:100%;cursor:pointer;background-color:", ";transition:box-shadow 0.3s ease;border:1px solid ", ";border-radius:8px;padding:16px;&:hover{box-shadow:0px 4px 16px 0px rgba(0,0,0,0.07),0px 1.541px 5.096px 0px rgba(0,0,0,0.04),0px 0.326px 1.304px 0px rgba(0,0,0,0.03);}@media screen and (max-width:768px){flex 1 0 calc((1088px - 32px) / 3);width:", ";}@media screen and (max-width:560px){flex 1 0 calc((992px - 32px) / 3);width:", ";}"], props => props.fixedWidth ? "389px" : "100%", props => props.fixedWidth ? "389px" : "100%", getColor("white"), getColor("grayLight"), props => props.fixedWidth ? "352px" : "100%", props => props.fixedWidth ? "320px" : "100%");
const PortalText = styled(Text).attrs({}).withConfig({
  displayName: "PortalCard__PortalText"
})(["overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;line-clamp:3;-webkit-box-orient:vertical;"]);
const iconMap = {
  [PrivacyLevel.public]: "globe",
  [PrivacyLevel.private]: "users",
  [PrivacyLevel.password]: "globe-lock"
};

/**
 *
 * Renders a portal card including an image, name, and description.
 *
 * The button on the card are shown based on the provided props:
 * Overflow button: menuItems
 * @param {Object} props
 */
const PortalCard = _ref => {
  let {
    id,
    portal,
    space,
    onClick,
    menuItems,
    identifier,
    fixedWidth
  } = _ref;
  const dragRef = useRef(null);
  const spacePermissions = ((space || {}).access || {}).permissions || [],
    canViewMembers = spacePermissions.includes("view_members");
  const [menuVisible, setMenuVisible] = useState(false);
  const menuId = identifier ? "".concat(portal.id, "-").concat(identifier, "-overflow-menu") : "".concat(portal.id, "-overflow-menu");
  const menu = menuVisible && menuItems ? /*#__PURE__*/React__default.createElement(PopupMenu, {
    source: menuId,
    "data-testid": "portal-card-menu",
    verticalPosition: "below",
    close: () => setMenuVisible(!menuVisible)
  }, menuItems) : null;
  const handleClick = () => {
    onClick(portal);
  };
  function renderOverflowButton() {
    return /*#__PURE__*/React__default.createElement(Button$1, {
      id: "portal-overflow-button",
      "data-popup-source": menuId,
      buttonStyle: "tertiary",
      icon: "overflow",
      width: "24",
      height: "24",
      onClick: e => {
        e.stopPropagation();
        setMenuVisible(!menuVisible);
      },
      themeOverrides: {
        primaryColor: "black"
      }
    });
  }
  function renderKitCounts() {
    return /*#__PURE__*/React__default.createElement(Flex$1, {
      justifyContent: "center",
      alignItems: "center",
      gap: "2px"
    }, /*#__PURE__*/React__default.createElement(Text, {
      id: "kit-count",
      my: "none",
      p: "none",
      font: "ui.small",
      color: "grayDarker"
    }, portal.counts.kits, pluralize(" kit", portal.counts.kits)));
  }
  function renderMemberCount() {
    return /*#__PURE__*/React__default.createElement(Flex$1, {
      justifyContent: "center",
      alignItems: "center",
      gap: "2px"
    }, /*#__PURE__*/React__default.createElement(Text, {
      id: "member-count",
      my: "none",
      p: "none",
      font: "ui.small",
      color: "grayDarker"
    }, portal.counts.members, pluralize(" user", portal.counts.members)));
  }
  function renderDescription() {
    return /*#__PURE__*/React__default.createElement(PortalText, {
      id: "portal-description",
      mt: "xs"
    }, portal.description);
  }
  return /*#__PURE__*/React__default.createElement(PortalCardWrapper, {
    ref: dragRef,
    "data-testid": id,
    "data-portalid": id,
    fixedWidth: fixedWidth,
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(_StyledImageView$1, {
    src: portal.images.cover,
    icon: "content.portal",
    alt: portal.name,
    aspectRatio: 34,
    cover: true,
    background: "grayLighter",
    borderRadius: "small",
    $_css: onClick ? "pointer" : null
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    mt: "s"
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default.createElement(Text, {
    as: "h1",
    id: "portal-title",
    font: "ui.regularSemiBold",
    truncate: true,
    onClick: handleClick
  }, portal.name), /*#__PURE__*/React__default.createElement(Flex$1, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    id: "privacy-".concat(portal.privacy),
    iconId: iconMap[portal.privacy],
    size: "24"
  }), menuItems && renderOverflowButton(), menu)), /*#__PURE__*/React__default.createElement(Flex$1, {
    gap: "4px"
  }, renderKitCounts(), canViewMembers && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Text, {
    my: "none",
    p: "none",
    font: "ui.small",
    color: "grayLight"
  }, "/"), renderMemberCount())), portal.description && renderDescription()));
};
var PortalCard$1 = PortalCard;
var _StyledImageView$1 = styled(ImageView$1).withConfig({
  displayName: "PortalCard___StyledImageView"
})(p => ({
  cursor: p.$_css
}));

const _excluded$p = ["onClick"];
const EmptyPortalCard = _ref => {
  let {
      onClick
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$p);
  return /*#__PURE__*/React__default.createElement(PortalCardWrapper, _extends({
    onClick: onClick,
    width: "100%"
  }, rest), /*#__PURE__*/React__default.createElement(Box$1, {
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(_StyledImageView, {
    src: null,
    icon: "action.add",
    alt: "Create a portal",
    aspectRatio: 34,
    cover: true,
    background: "grayLightest",
    borderRadius: "small"
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    mt: "s"
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default.createElement(Text, {
    as: "h1",
    font: "ui.regularSemiBold",
    truncate: true,
    onClick: onClick
  }, "Create a new portal")), /*#__PURE__*/React__default.createElement(PortalText, {
    font: "ui.small",
    color: "grayDarker",
    mt: "xs"
  }, "Portals are containers for your kits.")));
};
var EmptyPortalCard$1 = EmptyPortalCard;
var _StyledImageView = styled(ImageView$1).withConfig({
  displayName: "EmptyPortalCard___StyledImageView"
})({
  cursor: "pointer"
});

var _templateObject;
const ModalWrapper = styled(ReactModal).withConfig({
  displayName: "Modal__ModalWrapper"
})(["max-height:calc(100% - 100px);width:750px;margin:auto;top:40px;border:", ";background-color:rgb(255,255,255);border-radius:", ";outline:none;padding:0;display:flex;flex-direction:column;transition:height 0.3s ease;position:fixed;left:50%;transform:translateX(-50%);box-shadow:", ";overflow:hidden;max-width:100%;", ""], getBorder("default"), getBorderRadius("default"), getShadow("panel"), mq.xs(_templateObject || (_templateObject = _taggedTemplateLiteral([" \n    maxHeight: 100%;\n    top: 0;\n    bottom: 0;\n  "]))));
const Modal = _ref => {
  let {
    children,
    isOpen,
    onRequestClose,
    hideCloseButton = false
  } = _ref;
  const modalProps = {
    isOpen,
    onRequestClose,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    style: {
      overlay: {
        zIndex: 70
      }
    }
  };
  return /*#__PURE__*/React__default.createElement(ModalWrapper, _extends({
    ariaHideApp: _lingoConfig.environment !== "test-runner"
  }, modalProps), !hideCloseButton && /*#__PURE__*/React__default.createElement(Button$1, {
    buttonStyle: "tertiary",
    "aria-label": "Close",
    icon: "close",
    onClick: onRequestClose,
    width: "36px",
    height: "36px",
    position: "absolute",
    top: "0",
    right: "0",
    zIndex: "50"
  }), children);
};
var Modal$1 = Modal;

const _excluded$o = ["title", "message", "children"];
const ModalHeader = _ref => {
  let {
      title,
      message,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$o);
  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    zIndex: 20,
    background: "white",
    borderBottom: "default",
    as: "header",
    pt: "l",
    width: "100%",
    display: "block"
  }, rest), /*#__PURE__*/React__default.createElement(Box$1, {
    mx: "xxl",
    textAlign: "center",
    mb: "m"
  }, /*#__PURE__*/React__default.createElement(Text, {
    as: "h1",
    font: "ui.title"
  }, title), message ? /*#__PURE__*/React__default.createElement(Text, {
    mt: "s"
  }, message) : null), children);
};
var Header = ModalHeader;

const ModalBody = styled(Flex$1).attrs(props => {
  return {
    flexDirection: "column",
    px: props.px || "xxl",
    py: props.py || "xl",
    textAlign: "left",
    overflow: "auto"
  };
}).withConfig({
  displayName: "Body__ModalBody"
})([""]);
var Body = ModalBody;

const _excluded$n = ["primary", "secondary"];
const ModalFooter = _ref => {
  let {
      primary,
      secondary
    } = _ref,
    styles = _objectWithoutProperties(_ref, _excluded$n);
  return /*#__PURE__*/React__default.createElement(Flex$1, _extends({
    px: "xxl",
    py: "m",
    borderTop: "default",
    background: "grayLightest",
    alignItems: "center",
    justifyContent: "flex-end",
    flexShrink: "0"
  }, styles), secondary ? /*#__PURE__*/React__default.createElement(Button$1, _extends({
    id: "modal-footer-secondary-button",
    buttonStyle: "secondary",
    mr: "s"
  }, secondary)) : null, /*#__PURE__*/React__default.createElement(Button$1, _extends({
    fullWidth: !secondary,
    id: "modal-footer-primary-button"
  }, primary)));
};
var Footer = ModalFooter;

const Component$9 = Modal$1;
Component$9.Header = Header;
Component$9.Body = Body;
Component$9.Footer = Footer;
Component$9.setAppElement = ReactModal.setAppElement;
var Component$a = Component$9;

const markdownStyle = css(["", " color:", ";> :first-child > :first-child{margin-top:0;}> *:last-child > :last-child{margin-bottom:0;}p{margin-top:0;margin-bottom:16px;code{background:", ";", ";border:1px solid ", ";border-radius:", ";", "}}hr{border:none;border-top:1px solid ", ";margin-top:16px;margin-bottom:16px;}ol,ul{", " margin-bottom:16px;padding-left:28px;li{list-style:inherit;}li p{", ";}ol,ul{", ";}}ol{list-style:decimal outside;li{padding-left:7px;}}ul{list-style:disc outside;}h1{", " ", "}h2,h3,h4,h5,h6{", " ", "}blockquote{", " border-left:3px solid ", ";color:", ";font-size:16px;line-height:1.7;margin-bottom:16px;p{", "}}a{color:", ";&:hover{color:", ";text-decoration:underline;}}"], props => getFont(props.font, "gallery.regular", props), props => getColor(props.color, "black"), getColor("grayLightest"), getFont("gallery.code", null), getColor("border"), getBorderRadius("small"), positioningCSS({
  px: "xs",
  py: "none"
}), getColor("gray"), props => getFont(props.font, "gallery.regular", props), positioningCSS({
  mb: "none"
}), positioningCSS({
  mb: "none"
}), props => getFont(props.font, "gallery.h1", props), positioningCSS({
  my: "xs"
}), props => getFont(props.font, "gallery.h2", props), positioningCSS({
  my: "xs"
}), positioningCSS({
  pl: "l"
}), props => props.theme.primaryColor, getColor("grayDarkest"), positioningCSS({
  mb: "s"
}), props => props.theme.primaryColor || getColor("primary"), props => props.theme.primaryColorDark || getColor("primaryDark"));

const sets = {
  basic: ["blockQuote", "characterReference", "codeFenced", "codeIndented", "codeText", "definition", "del", "footnoteDefinition", "headingAtx", "html", "htmlFlow", "htmlText", "input", "labelStartImage", "list", "setextUnderline", "table", "thematicBreak"
  // Leaving these here for reference
  // "lineEnding",
  // "attention",
  // "autolink",
  // "characterEscape",
  // "hardBreakEscape",
  // "labelEnd",
  // "labelStartLink",
  ],
  gallery: ["codeFenced", "codeIndented", "definition", "del", "footnote", "footnoteDefinition", "html", "htmlFlow", "input", "labelStartImage", "setextHeading", "table"]
};
function remarkDisableElements() {
  let elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  const disable = sets[elements] || [];
  if (!elements) {
    return () => {
      /* noop */
    };
  }
  function disableElements() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const data = this.data();
    const list = data.micromarkExtensions || (data.micromarkExtensions = []);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    list.push({
      disable: {
        null: disable
      }
    });
  }
  return disableElements;
}

function remarkStrikethrough() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const data = this.data();
  add("micromarkExtensions", gfmStrikethrough());
  add("fromMarkdownExtensions", gfmFromMarkdown());
  add("toMarkdownExtensions", gfmToMarkdown());
  function add(field, value) {
    const list /** @type {unknown[]} */ =
    // Other extensions
    /* c8 ignore next 2 */
    data[field] ? data[field] : data[field] = [];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    list.push(value);
  }
}

const _excluded$m = ["children", "buttonComponent", "elements"];
const StyledReactMarkdown$1 = styled(ReactMarkdown).withConfig({
  displayName: "MarkdownText__StyledReactMarkdown"
})(["word-break:break-word;flex:1 1 100%;", " ", ""], positioningCSS, markdownStyle);

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const MarkdownText = _ref => {
  let {
      children,
      buttonComponent,
      elements
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$m);
  const LinkRenderer = useCallback(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _ref2 => {
    let {
      href,
      node
    } = _ref2;
    const props = {
      fontStyle: rest.font,
      link: href,
      text: node.children[0].value,
      icon: null
    };
    const ButtonComp = buttonComponent;
    if (buttonComponent) {
      return /*#__PURE__*/React__default.createElement(ButtonComp, props);
    } else {
      return /*#__PURE__*/React__default.createElement(Button$1, _extends({
        buttonStyle: "tertiary"
      }, props));
    }
  }, [rest.font, buttonComponent]);
  if (typeof children !== "string") return null;
  return /*#__PURE__*/React__default.createElement(StyledReactMarkdown$1
  // Set defaults
  , _extends({
    font: "gallery.regular",
    color: "black"
  }, rest, {
    components: {
      a: LinkRenderer
    },
    remarkPlugins: [remarkDisableElements(elements), remarkStrikethrough, remarkBreaks]
  }), children);
};
var MarkdownText$1 = MarkdownText;

function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Pill = styled(Flex$1).attrs(props => {
  const theme = props.theme.themeName;
  const themeStyleObj = {
    [SpaceThemeNames.classic]: {
      background: props.selected ? "grayLighter" : null,
      variations: {
        "&:hover": {
          background: "grayLighter"
        }
      }
    },
    [SpaceThemeNames.scher]: {},
    [SpaceThemeNames.wyman]: {}
  };
  return _objectSpread$b({
    px: "s",
    py: "xs",
    width: "100%",
    textAlign: "left",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "default"
  }, themeStyleObj[theme]);
}).withConfig({
  displayName: "Pill"
})(["&.disabled{pointer-events:none !important;}"]);
var Pill$1 = Pill;

const _excluded$l = ["placeholder", "defaultText", "onSubmit", "iconId", "submitOnBlur", "autoFocus"];
const NavInputField = styled(Input$2).attrs({
  styleOverrides: {
    mb: "none",
    mt: "none"
  },
  type: "text"
}).withConfig({
  displayName: "Input__NavInputField"
})(["padding:4px;border:none;border-radius:none;box-shadow:none;background:transparent;margin-top:0;margin-bottom:0;height:30px;&::placeholder{color:", ";}&::-webkit-input-placeholder{color:", ";}&:focus{outline:0;border:none;background:", ";}"], getColor("grayDarkest"), getColor("grayDarkest"), getColor("grayLighter"));
const NavInput = _ref => {
  let {
      placeholder,
      defaultText,
      onSubmit,
      iconId = "plus",
      submitOnBlur,
      autoFocus
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$l);
  const [inputText, setInputText] = useState(""),
    [focused, setFocused] = useState(false);
  useEffect(() => {
    if (focused) {
      document.querySelector("#input-nav-pill").select();
    }
  }, [focused]);
  return /*#__PURE__*/React__default.createElement(Flex$1, _extends({
    pl: "xs",
    alignItems: "center",
    borderRadius: "default",
    background: focused ? "grayLighter" : "none"
  }, rest), iconId && /*#__PURE__*/React__default.createElement(Icon$1, {
    iconId: iconId,
    size: "16",
    fill: "grayDarkest"
  }), /*#__PURE__*/React__default.createElement(NavInputField, {
    "data-testid": "navpill-input",
    id: "input-nav-pill",
    placeholder: placeholder,
    autoFocus: autoFocus,
    value: inputText,
    onSubmit: () => {
      if (inputText && inputText.length > 0) {
        onSubmit(inputText);
        setInputText("");
      }
    },
    onChange: e => setInputText(e.target.value),
    onFocus: () => {
      setInputText(defaultText || "");
      setFocused(true);
    },
    onBlur: () => {
      if (submitOnBlur) {
        onSubmit(inputText);
      } else {
        setInputText("");
        setFocused(false);
      }
    }
  }));
};
var Input = NavInput;

/**
 * Hook for using context menus related to individual items
 * @param {Object} itemRef Ref for the item
 * @param {Function} onOpenMenu Function that runs when the menu is opened.
 */
function useContextMenu(_ref) {
  let {
    itemRef,
    onOpenMenu,
    autoOpen = true
  } = _ref;
  const [contextMenuXPos, setXPos] = useState("0px");
  const [contextMenuYPos, setYPos] = useState("0px");
  const [menuOpen, setMenuOpen, setMenuClosed] = useBoolean(false);
  const handleContextMenu = useCallback(e => {
    /**
     * In development, its a hinderance to inspecting elements.
     * Hold the shift key while right clicking to inspect.
     */
    if (e.shiftKey && process.env.NODE_ENV === "development") return;
    e.preventDefault();
    setXPos("".concat(e.pageX, "px"));
    setYPos("".concat(e.pageY, "px"));
    if (onOpenMenu) onOpenMenu(e);
    if (autoOpen) setMenuOpen();
  }, [autoOpen, onOpenMenu, setMenuOpen]);
  const handleContextMenuClose = useCallback(() => {
    if (menuOpen) setMenuClosed();
  }, [menuOpen, setMenuClosed]);
  useEffect(() => {
    const element = itemRef.current;
    element === null || element === void 0 || element.addEventListener("contextmenu", handleContextMenu);
    return () => {
      element === null || element === void 0 || element.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [itemRef, handleContextMenu]);
  return {
    contextMenuXPos,
    contextMenuYPos,
    contextMenuOpen: menuOpen,
    handleContextMenuClose,
    setMenuOpen,
    setMenuClosed
  };
}

// Usage:
// <ContextMenu id={item.id} parentRef={contextMenuRef}>
//   <PopupMenu.Item title="Edit Description" onClick={startEditing} />
// </ContextMenu>

const ContextMenu = _ref => {
  let {
    id,
    parentRef,
    onOpenMenu,
    children
  } = _ref;
  const {
    contextMenuXPos,
    contextMenuYPos,
    contextMenuOpen,
    handleContextMenuClose
  } = useContextMenu({
    itemRef: parentRef,
    onOpenMenu
  });
  const contextMenuSource = "".concat(id, "-context-menu");
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(PopupMenu.ContextMenuAnchor, {
    xPos: contextMenuXPos,
    yPos: contextMenuYPos,
    "data-popup-source": contextMenuSource
  }), contextMenuOpen && /*#__PURE__*/React__default.createElement(PopupMenu, {
    "data-testid": "context-menu-popup",
    source: contextMenuSource,
    close: handleContextMenuClose,
    vPos: "floatBelow",
    hPos: "alignLeft"
  }, children));
};
var ContextMenu$1 = ContextMenu;

function copy(value) {
  return _copy(value, {
    format: "text/plain"
  });
}

function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ParentWrapper = styled(Box$1).attrs(props => {
  const theme = props.theme.themeName;
  const themeStyleObj = {
    [SpaceThemeNames.classic]: {},
    [SpaceThemeNames.scher]: {
      mb: "m"
    },
    [SpaceThemeNames.wyman]: {}
  };
  return _objectSpread$a({
    width: "100%",
    my: "3",
    position: "relative"
  }, themeStyleObj[theme]);
}).withConfig({
  displayName: "NavPill__ParentWrapper"
})(["position:relative;&:after{content:\"\";height:2px;width:calc(100% - 4px);top:-2.5px;left:4px;background:", ";z-index:10;position:absolute;opacity:0;}&:before{content:\"\";height:2px;width:calc(100% - 4px);bottom:-2.5px;left:4px;background:", ";z-index:10;position:absolute;opacity:0;}", ";", ";"], props => getPrimaryColor(props), props => getPrimaryColor(props), props => props.dragDirection === "top" && "\n    &:after {\n      opacity: 1;\n    }\n  ", props => props.dragDirection === "bottom" && "\n    &:before {\n      opacity: 1;\n    }\n  ");
const ChildWrapper = styled(Box$1).attrs(props => {
  const theme = props.theme.themeName;
  const themeStyleObj = {
    [SpaceThemeNames.classic]: {},
    [SpaceThemeNames.scher]: {},
    [SpaceThemeNames.wyman]: {}
  };
  return _objectSpread$a({
    maxHeight: props.selected ? React__default.Children.count(props.children) * 60 : 0,
    overflow: "hidden",
    as: "ul",
    pl: "s"
  }, themeStyleObj[theme]);
}).withConfig({
  displayName: "NavPill__ChildWrapper"
})(["transition:max-height 0.4s cubic-bezier(0.51,0.01,0.29,1.2);"]);

// MARK : Base
// -------------------------------------------------------------------------------

const NavPill = _ref => {
  let {
    id,
    text,
    selected = false,
    disabled,
    onClick,
    link,
    icon,
    canEdit,
    onFinishEditing,
    onDelete,
    shareLink,
    entity = "Item",
    children,
    draggable = false,
    onDropHandler
  } = _ref;
  const [editing, setEditing] = useState(false);
  const [dragDirection, setDragDirection] = useState(null);
  const contextMenuRef = useRef(null);
  const dragRef = useRef(null);
  const theme = useTheme();
  /**
   * Drag context data is only available in the onDrop event,
   * so we need this isDragging state to let each instance know
   * if it's the one being dragged.
   */
  const [isDragging, setIsDragging] = useState(false);
  const finishEditing = useCallback(inputText => {
    setEditing(false);
    if (inputText.trim() === text.trim()) return;
    onFinishEditing(id, inputText.trim() || "Untitled ".concat(entity));
  }, [setEditing, onFinishEditing, text, entity, id]);
  const toggleEditing = useCallback(() => {
    setEditing(!editing);
  }, [editing]);
  const pillProps = {
    selected,
    onClick,
    onDoubleClick: canEdit ? toggleEditing : undefined,
    disabled,
    children,
    canEdit
  };
  const pillTextThemeProps = {
    [SpaceThemeNames.classic]: {
      font: "ui.regularSemiBold"
    },
    [SpaceThemeNames.scher]: {
      font: selected ? "ui.regularSemiBold" : "ui.regular",
      color: selected ? "black" : "grayDarkest",
      variations: {
        "&:hover": {
          font: "ui.regularSemiBold"
        }
      }
    },
    [SpaceThemeNames.wyman]: {}
  }[theme.themeName];
  const pillTextProps = _objectSpread$a({
    truncate: true
  }, pillTextThemeProps);
  const contextMenuItems = [];
  if (!editing) {
    if (shareLink) {
      contextMenuItems.push(/*#__PURE__*/React__default.createElement(PopupMenu.Section, {
        key: "share-link"
      }, /*#__PURE__*/React__default.createElement(PopupMenu.Item, {
        onClick: () => copy(shareLink),
        title: "Copy share link"
      })));
    }
    if (canEdit) {
      contextMenuItems.push(/*#__PURE__*/React__default.createElement(PopupMenu.Section, {
        key: "update-items"
      }, /*#__PURE__*/React__default.createElement(PopupMenu.Item, {
        key: "edit-item",
        onClick: toggleEditing,
        title: "Rename ".concat(entity)
      })));
      if (onDelete) {
        contextMenuItems.push(/*#__PURE__*/React__default.createElement(PopupMenu.Section, {
          key: "edit-items"
        }, /*#__PURE__*/React__default.createElement(PopupMenu.Item, {
          key: "delete-item",
          onClick: () => onDelete(id),
          title: "Delete ".concat(entity)
        })));
      }
    }
  }
  const onDragStart = useCallback(e => {
    if (draggable && !id) {
      console.warn("NavPill components need ID values in order to drag & drop");
    }
    /** Normalize browser UI during drag */
    e.dataTransfer.effectAllowed = "all";
    /** Let this component know its the one being dragged */
    setIsDragging(true);
    /** Create or reuse the previous drag image clone */
    const elem = document.createElement("div");
    elem.setAttribute("style", "position: absolute; top: -1000px; font-size: 14px; padding: 4px 8px; background: white; border-radius: 4px;");
    elem.innerHTML = text;
    document.body.appendChild(elem);

    /** Set the drag element style */
    e.dataTransfer.setDragImage(elem, 0, 0);

    /** Set the ID of the item being dragged */
    e.dataTransfer.setData("navItemId", id);
    setTimeout(() => {
      document.body.removeChild(elem);
    }, 0);
  }, [draggable, id, text]);
  const onDragOver = useCallback(e => {
    if (e) e.preventDefault();
    const activeDragDirection = getVerticalDragDirection(e, dragRef);
    if (dragDirection !== activeDragDirection) setDragDirection(activeDragDirection);
  }, [dragRef, dragDirection, setDragDirection]);
  const onDragLeave = useCallback(e => {
    if (e) e.preventDefault();
    setDragDirection(null);
  }, []);
  const onDragEnd = useCallback(e => {
    if (e) e.preventDefault();
    setIsDragging(false);
  }, []);
  const onDrop = useCallback(e => {
    if (e) e.preventDefault();
    const dragId = e.dataTransfer.getData("navItemId"),
      dropId = id;

    /** If it's a valid drop, fire the handler passed down through props */
    if (dragId && dragId !== dropId) {
      onDropHandler({
        dragId,
        dropId,
        dragDirection
      });
    }
    setDragDirection(null);
  }, [dragDirection, id, onDropHandler]);
  const dragProps = draggable ? {
    draggable: true,
    ref: dragRef,
    dragDirection: isDragging ? null : dragDirection,
    onDragStart,
    onDragOver,
    onDragLeave,
    onDragEnd,
    onDrop
  } : {};
  return /*#__PURE__*/React__default.createElement(ParentWrapper, _extends({
    "data-testid": id
  }, dragProps), contextMenuItems.length ? /*#__PURE__*/React__default.createElement(ContextMenu$1, {
    "data-testid": "navpill-context-menu",
    id: id,
    parentRef: contextMenuRef
  }, contextMenuItems) : null, !editing ? /*#__PURE__*/React__default.createElement(LinkWrapper$1, {
    link: link,
    disabled: disabled,
    title: text
  }, /*#__PURE__*/React__default.createElement(Pill$1, _extends({
    ref: contextMenuRef,
    "data-testid": "nav-pill-title",
    className: disabled ? "disabled" : ""
  }, pillProps), /*#__PURE__*/React__default.createElement(Text, _extends({}, pillTextProps, {
    as: "span"
  }), text), icon ? /*#__PURE__*/React__default.createElement(Icon$1, {
    size: "12",
    iconId: icon
  }) : null)) : /*#__PURE__*/React__default.createElement(Input, {
    autoFocus: true,
    submitOnBlur: true,
    iconId: null,
    placeholder: "Untitled ".concat(entity),
    defaultText: text,
    onSubmit: finishEditing
  }), children && /*#__PURE__*/React__default.createElement(ChildWrapper, {
    selected: selected
  }, children));
};
var NavPill$1 = NavPill;

function elementInViewport(el) {
  if (!el) return;
  const rect = el.getBoundingClientRect(),
    vWidth = window.innerWidth || document.documentElement.clientWidth,
    vHeight = window.innerHeight || document.documentElement.clientHeight,
    efp = function (x, y) {
      return document.elementFromPoint(x, y);
    };

  // Return false if it's not in the viewport
  if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) return false;

  // Return true if any of its four corners are visible
  return el.contains(efp(rect.left, rect.top)) || el.contains(efp(rect.right, rect.top)) || el.contains(efp(rect.right, rect.bottom)) || el.contains(efp(rect.left, rect.bottom));
}

const elementIds = {
  SCROLL_CONTAINER: "scrollContainer"
};

function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ChildPill = styled(Flex$1).attrs(props => {
  const primary = getPrimaryColor(props);
  const themeName = getThemeName(props);
  const themeVals = {
    [SpaceThemeNames.classic]: {
      ml: "s",
      pl: props.relativeInView ? "s" : "xs",
      borderLeft: props.relativeInView ? "2px solid ".concat(primary) : "2px solid transparent",
      variations: {
        "&:hover": {
          borderLeft: "2px solid ".concat(primary)
        }
      }
    },
    [SpaceThemeNames.scher]: {
      ml: "s",
      mt: "m",
      variations: {
        "&:last-child": {
          mb: "s"
        }
      }
    }
  };
  return _merge({
    as: "li",
    mt: "s"
  }, themeVals[themeName]);
}).withConfig({
  displayName: "Child__ChildPill"
})(["transition:all 0.3s ease;width:100%;a{width:100%;}"]);
const ChildPillText = styled(Text).withConfig({
  displayName: "Child__ChildPillText"
})(["transition:all 0.3s ease;"]);
const Child = _ref => {
  let {
    id,
    text,
    disabled,
    onClick,
    relativeIdentifier,
    link
  } = _ref;
  const [relativeInView, setRelativeInViewTrue, setRelativeInViewFalse] = useBoolean(false);
  const theme = useTheme();
  const pillProps = {
    onClick,
    disabled,
    relativeInView
  };
  const themedPillTextProps = {
    [SpaceThemeNames.classic]: {
      color: relativeInView ? "black" : "grayDarkest"
    },
    [SpaceThemeNames.scher]: {
      color: relativeInView ? theme.primaryColor : "black"
    },
    [SpaceThemeNames.wyman]: {
      color: relativeInView ? theme.primaryColor : "grayDarkest"
    }
  };
  const pillTextProps = _objectSpread$9({
    truncate: true
  }, themedPillTextProps[theme.themeName]);
  const classes = ["secondary", disabled ? " disabled" : ""].join(" ");
  const relativeEffect = React__default.useCallback(() => {
    const relativeElementInView = elementInViewport(document.querySelector(relativeIdentifier));
    if (relativeElementInView) setRelativeInViewTrue();else setRelativeInViewFalse();
  }, [relativeIdentifier, setRelativeInViewFalse, setRelativeInViewTrue]);
  React__default.useEffect(() => {
    if (!relativeIdentifier) return;
    relativeEffect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React__default.useEffect(() => {
    if (!relativeIdentifier) return;
    const element = document.getElementById(elementIds.SCROLL_CONTAINER);
    element.addEventListener("scroll", relativeEffect);
    return () => {
      element.removeEventListener("scroll", relativeEffect);
    };
  }, [relativeEffect, relativeIdentifier, relativeInView, setRelativeInViewFalse, setRelativeInViewTrue]);
  return /*#__PURE__*/React__default.createElement(ChildPill, _extends({
    "data-testid": id,
    className: classes
  }, pillProps), /*#__PURE__*/React__default.createElement(LinkWrapper$1, {
    link: link,
    disabled: disabled,
    title: text
  }, /*#__PURE__*/React__default.createElement(ChildPillText, pillTextProps, text)));
};
var Child$1 = Child;

const Component$7 = NavPill$1;
Component$7.Child = Child$1;
Component$7.Input = Input;
var Component$8 = Component$7;

const _excluded$k = ["id", "noticeStyle", "message", "button", "secondaryButton"];
const Notice = _ref => {
  let {
      id = null,
      noticeStyle = "info",
      message,
      button = null,
      secondaryButton = null
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$k);
  const style = {
    border: "1px solid ".concat(noticeStyle),
    background: "".concat(noticeStyle, "Light")
  };
  function renderIcon() {
    const iconName = () => {
      switch (noticeStyle) {
        case "warning":
          return "info.warning";
        case "error":
          return "info.error";
        case "info":
        case "neutral":
        default:
          return "info.info";
      }
    };
    return /*#__PURE__*/React__default.createElement(Icon$1, {
      "data-testid": "notice-icon",
      size: 16,
      fill: "black",
      iconId: iconName(),
      flexShrink: 0,
      mr: "s"
    });
  }
  function renderButton() {
    if (!button) return null;
    const theme = {
      primaryColor: noticeStyle,
      primaryColorDark: "".concat(noticeStyle, "Dark"),
      primaryColorLight: "".concat(noticeStyle, "Light"),
      primaryColorTint: ["warning"].includes(noticeStyle) ? "black" : "white"
    };
    return /*#__PURE__*/React__default.createElement(Button$1, _extends({
      buttonStyle: "primary",
      themeOverrides: theme
    }, button, {
      justifySelf: "flex-end",
      size: "small"
    }));
  }
  function renderSecondaryButton() {
    if (!secondaryButton) return null;
    const theme = {
      primaryColor: noticeStyle,
      primaryColorDark: "".concat(noticeStyle, "Dark"),
      primaryColorLight: "".concat(noticeStyle, "Light"),
      primaryColorTint: ["warning", "neutral"].includes(noticeStyle) ? "black" : "white"
    };
    return /*#__PURE__*/React__default.createElement(Button$1, _extends({
      mr: button ? "m" : "none",
      buttonStyle: "tertiary",
      themeOverrides: theme
    }, secondaryButton, {
      justifySelf: "flex-end",
      size: "small"
    }));
  }
  return /*#__PURE__*/React__default.createElement(Flex$1, _extends({
    "data-testid": id,
    alignItems: "center",
    p: "s",
    mt: "xs",
    borderRadius: "default",
    textAlign: "left"
  }, style, rest), renderIcon(), /*#__PURE__*/React__default.createElement(Text, {
    flex: "1",
    "data-testid": "notice-message",
    font: "ui.small",
    mr: button || secondaryButton ? "m" : "none"
  }, message), renderSecondaryButton(), renderButton());
};
var Notice$1 = Notice;

const _excluded$j = ["data", "hasMore", "error", "isLoading", "fetchNextPage"];
const StyledButton = styled(Button$1).attrs({
  buttonStyle: "secondary",
  px: "xl",
  variations: {
    "mq.xs": {
      width: "100%"
    }
  }
}).withConfig({
  displayName: "PagingIndicator__StyledButton"
})([""]);
const ButtonWrapper = styled(Box$1).attrs({
  width: "100%",
  textAlign: "center"
}).withConfig({
  displayName: "PagingIndicator__ButtonWrapper"
})([""]);
/**
 * Rendered at the bottom of an infinite scroll list to show a loading state or error for pagination status.
 *
 * This is meant to be used with queryActions. It will show a loading state, an error state, or a button to load more data.
 *
 * Note: The component will not render anything no data has been provided. You should render the initial loading state in the parent component, typically a full page loader.
 *
 * Example:
 * ```
 * const totalCount = kit.counts.items // example
 * const {data, error, isLoading, fetchNextPage} = useData({});
 * const hasMore = data.length < totalCount;
 *
 *   if (totalCount === 0) {
 *     return (
 *       <EmptyState
 *         title="Nothing to see here"
 *         subtitle="There are no items to display."
 *       />
 *     );
 *   } else if (isLoading && !data?.length) {
 *     return <ActivityIndicator mt="xxl" center />;
 *   } else if (loadingError && !items?.length) {
 *     return (
 *       <EmptyState
 *         title="Unable to load data"
 *         subtitle={loadingError.message}
 *         iconProps={{ iconId: "error", fill: "error" }}
 *         button={{ text: "Retry", onClick: fetchNextPage }}
 *       />
 *     );
 *   }
 *   return (
 *     <>
 *       <ListComponent data={data} />
 *       {hasMore && (
 *         <PagingIndicator
 *           hasMore={hasMore}
 *           data={items}
 *           error={loadingError}
 *           fetchNextPage={fetchNextPage}
 *           isLoading={isLoading}
 *         />
 *       )}
 *     </>
 *   );
 * ```
 *
 * @param props
 * @returns
 */
const PagingIndicator = _ref => {
  let {
      data,
      hasMore,
      error,
      isLoading,
      fetchNextPage
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$j);
  const [ref, inView] = useInView();

  // Fetching if inView and hasMoreAssets
  useEffect(() => {
    if (inView && !isLoading && !error && hasMore) {
      fetchNextPage();
    }
  }, [error, fetchNextPage, hasMore, inView, isLoading]);
  if (!data) return null;
  if (!hasMore) return null;
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(ActivityIndicator$1, _extends({
      mt: "xxl"
    }, rest, {
      center: true
    }));
  }
  if (error) {
    return /*#__PURE__*/React__default.createElement(ButtonWrapper, _extends({
      ref: ref,
      mt: "xxl"
    }, rest), /*#__PURE__*/React__default.createElement(Flex$1, {
      width: "100%",
      justifyContent: "center"
    }, /*#__PURE__*/React__default.createElement(Notice$1, {
      width: "",
      message: error.message,
      noticeStyle: "error",
      button: {
        text: "Try again",
        onClick: fetchNextPage
      }
    })));
  }
  return /*#__PURE__*/React__default.createElement(ButtonWrapper, _extends({
    mt: "xxl",
    ref: ref
  }, rest), /*#__PURE__*/React__default.createElement(StyledButton, {
    id: "load-more-button",
    text: "Load more",
    onClick: fetchNextPage
  }));
};
var PagingIndicator$1 = PagingIndicator;

function parseUrl(url) {
  if (url.startsWith("/")) {
    return {
      isDifferentHost: false,
      url
    };
  }
  try {
    const {
      hostname: target,
      pathname,
      search,
      hash
    } = new URL(url);
    const {
      hostname: current
    } = window.location;
    if (target !== current) {
      return {
        isDifferentHost: true,
        url
      };
    } else {
      return {
        isDifferentHost: false,
        url: [pathname, search, hash].join("")
      };
    }
  } catch (_unused) {
    return {
      isDifferentHost: false,
      url
    };
  }
}
function useNavigation() {
  const navigate = useNavigate();
  const replace = useCallback(_url => {
    const {
      isDifferentHost,
      url
    } = parseUrl(_url);
    if (isDifferentHost) {
      window.location.replace(url);
    } else {
      navigate(url, {
        replace: true
      });
    }
  }, [navigate]);
  const push = useCallback(_url => {
    const {
      isDifferentHost,
      url
    } = parseUrl(_url);
    if (isDifferentHost) {
      window.location.assign(url);
    } else {
      navigate(url);
    }
  }, [navigate]);
  return {
    replace,
    push
  };
}

const Redirect = _ref => {
  let {
    to,
    replace
  } = _ref;
  const navigation = useNavigation();
  useEffect(() => {
    if (replace) {
      navigation.replace(to);
    } else {
      navigation.push(to);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [to, replace]);
  return null;
};
var Redirect$1 = Redirect;

const _excluded$i = ["id", "text", "size", "onClick", "styleOverrides"];
const buttonHeights = {
  regular: "36px",
  small: "28px"
};
const Wrapper$5 = styled(Flex$1).attrs(props => {
  var _props$theme;
  return {
    as: "button",
    role: "",
    pl: "s",
    justifyContent: "space-between",
    alignItems: "center",
    height: buttonHeights[props.size] || buttonHeights.regular,
    overflow: "hidden",
    border: "default",
    borderRadius: getBorderRadius(props === null || props === void 0 || (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.themeName, "default"),
    flexShrink: 0,
    background: getColor(props.disabled ? "grayLighter" : "white")
  };
}).withConfig({
  displayName: "DropdownButton__Wrapper"
})(["cursor:pointer;transition:background 0.2s ease-in;opacity:", ";&:hover{background:", ";}"], props => props.disabled ? "50%" : null, getColor("grayLighter"));
const IconWrapper = styled(Flex$1).attrs(props => {
  return {
    height: buttonHeights[props.size] || buttonHeights.regular,
    width: buttonHeights[props.size] || buttonHeights.regular,
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    padding: "4px 0"
  };
}).withConfig({
  displayName: "DropdownButton__IconWrapper"
})([""]);
const DropdownButton = props => {
  // ...rest is used for data-attrs here - try to avoid using this pattern
  const {
      id,
      text,
      size = "small",
      onClick,
      styleOverrides
    } = props,
    rest = _objectWithoutProperties(props, _excluded$i);
  return /*#__PURE__*/React__default.createElement(Wrapper$5, _extends({
    "data-testid": id,
    size: size,
    onClick: onClick
  }, styleOverrides, rest), /*#__PURE__*/React__default.createElement(Text, {
    color: "black",
    font: "ui.".concat(size),
    truncate: true
  }, text || ""), /*#__PURE__*/React__default.createElement(IconWrapper, {
    size: size
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    iconId: "navigation.chevron-down",
    size: size === "small" ? "16" : "24",
    fill: "grayDarker"
  })));
};
var DropdownButton$1 = DropdownButton;

const _excluded$h = ["label", "value", "buttonStyle", "size", "options", "onChange", "width", "disabled", "menuId", "tooltip", "placeholder"];
/**
 * A custom select component that wraps a Button and PopupMenu
 * Just provide options and an onChange handle similar to a native select
 */
function Select(_ref) {
  var _find, _containerRef$current, _containerRef$current2;
  let {
      label,
      value,
      buttonStyle = "dropdown",
      size = "regular",
      options,
      onChange,
      width,
      disabled,
      menuId: _menuId,
      tooltip,
      placeholder
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$h);
  const [isMenuActive, showMenu, hideMenu] = useBoolean(false),
    menuId = useMemo(() => _menuId !== null && _menuId !== void 0 ? _menuId : factory.genUUID(), [_menuId]);
  const containerRef = React__default.useRef(null);
  const displayValue = (_find = options.filter(f => f !== "-").find(f => f.value === value)) === null || _find === void 0 ? void 0 : _find.label;
  function renderButton() {
    const sharedProps = {
      "data-popup-source": menuId,
      onClick: showMenu,
      text: displayValue !== null && displayValue !== void 0 ? displayValue : placeholder,
      size,
      disabled
    };
    return buttonStyle === "dropdown" ? /*#__PURE__*/React__default.createElement(DropdownButton$1, _extends({
      styleOverrides: {
        width
      }
    }, sharedProps)) : /*#__PURE__*/React__default.createElement(Button$1, _extends({
      buttonStyle: "tertiary",
      icon: "action.expand"
    }, sharedProps));
  }
  const menuItems = useMemo(() => {
    return options.map(opt => {
      if (opt === "-") {
        return /*#__PURE__*/React__default.createElement(Box$1, {
          borderBottom: "default",
          height: "1px",
          key: factory.genUUID()
        });
      }
      return /*#__PURE__*/React__default.createElement(PopupMenu.Item, {
        key: opt.value.toString(),
        title: opt.labelNode || opt.label,
        checked: value === opt.value,
        onClick: () => onChange(opt.value)
      });
    });
  }, [onChange, options, value]);
  return /*#__PURE__*/React__default.createElement(Box$1, _extends({}, rest, {
    ref: containerRef
  }), label && /*#__PURE__*/React__default.createElement(Box$1, {
    mb: "xs"
  }, /*#__PURE__*/React__default.createElement(Text, {
    as: "label",
    lineHeight: 1
  }, label)), tooltip && /*#__PURE__*/React__default.createElement(Tooltip, {
    source: menuId,
    direction: Tooltip.Direction.Top
  }, tooltip), /*#__PURE__*/React__default.createElement(Box$1, {
    "data-tooltip-source": menuId
  }, renderButton()), /*#__PURE__*/React__default.createElement(PopupMenu, {
    source: menuId,
    open: isMenuActive,
    value: value,
    close: hideMenu,
    width: (containerRef === null || containerRef === void 0 || (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.clientWidth) > 236 ? containerRef === null || containerRef === void 0 || (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.clientWidth : 236
  }, menuItems));
}

const _excluded$g = ["id", "isOn", "size", "onToggle", "label", "disabled"];
const sizes = {
  small: {
    w: 30,
    h: 18,
    m: 3
  },
  regular: {
    w: 40,
    h: 24,
    m: 3
  }
};
function handleSize(size) {
  const m = sizes[size].m;
  return sizes[size].h - m * 2;
}
const ControlWrapper = styled.button.withConfig({
  displayName: "Switch__ControlWrapper"
})(["position:relative;display:inline-block;width:", "px;height:", "px;opacity:", ";"], props => sizes[props.size].w, props => sizes[props.size].h, props => props.disabled ? 0.5 : 1);
const Checkbox = styled.input.withConfig({
  displayName: "Switch__Checkbox"
})(["opacity:0;width:0;height:0;&:focus + span{box-shadow:0 0 1px ", ";}"], props => props.color);
const Handle = styled.span.withConfig({
  displayName: "Switch__Handle"
})(["position:absolute;cursor:", ";top:0;left:0;right:0;bottom:0;background-color:", ";-webkit-transition:0.4s;transition:0.4s;border-radius:34px;flex-shrink:0;&:before{position:absolute;content:\"\";cursor:", ";width:", "px;height:", "px;left:", "px;bottom:", "px;background-color:white;-webkit-transition:0.4s;transition:0.4s;border-radius:50%;}"], props => props.disabled ? "not-allowed" : "pointer", props => {
  var _props$theme;
  return props.isOn ? getColor((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.primaryColor, "primary") : getColor("grayDark");
}, props => props.disabled ? "not-allowed" : "pointer", props => handleSize(props.size), props => handleSize(props.size), props => props.isOn ? sizes[props.size].w - handleSize(props.size) - sizes[props.size].m : sizes[props.size].m, props => sizes[props.size].m);
const Label = styled.label.withConfig({
  displayName: "Switch__Label"
})(["margin-right:", "px;margin-left:", "px;", ";color:", ";"], props => props.position === "left" ? 6 : 0, props => props.position === "right" ? 6 : 0, props => getFont(props.font, "ui.regular"), getColor("black"));
const Switch = _ref => {
  let {
      id,
      isOn = false,
      size = "regular",
      onToggle,
      label = null,
      disabled = false
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$g);
  const handler = useCallback(() => {
    onToggle(!isOn);
  }, [isOn, onToggle]);
  function renderLabel(render) {
    if (render && label && label.text) return /*#__PURE__*/React__default.createElement(Label, {
      "data-testid": "switch-label",
      htmlFor: id,
      font: label.font,
      position: label.position || "left"
    }, label.text);
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Flex$1, _extends({
    alignItems: "center",
    "data-testid": id
  }, rest), renderLabel(label && (!label.position || label.position === "left")), /*#__PURE__*/React__default.createElement(ControlWrapper, {
    size: size,
    className: "".concat(disabled ? "disabled" : ""),
    "data-testid": "switch-content",
    onClick: disabled ? null : handler,
    role: "switch",
    "aria-checked": isOn,
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(Handle, {
    "data-testid": "switch-handle",
    disabled: disabled,
    isOn: isOn,
    size: size
  }), /*#__PURE__*/React__default.createElement(Checkbox, {
    id: id
  })), renderLabel((label === null || label === void 0 ? void 0 : label.position) === "right"));
};
var Switch$1 = Switch;

function useEventListener(eventName, handler) {
  React__default.useEffect(() => {
    window.addEventListener(eventName, handler);
    return () => window.removeEventListener(eventName, handler);
  }, [eventName, handler]);
}

const BarWrapper = styled(Flex$1).attrs(props => {
  return {
    width: "100%",
    height: props.size === "small" ? "28px" : "36px",
    px: props.innerOverflows ? "40px" : "0"
  };
}).withConfig({
  displayName: "TabBar__BarWrapper"
})(["position:relative;overflow:hidden;scroll-behavior:smooth;button{", ";}a{button{height:100%;}}"], props => getFont(props.size === "small" ? "ui.small" : "ui.regular", null, props));
const OverflowOverlay = styled(Flex$1).attrs(props => {
  return {
    width: "49px",
    height: props.size === "small" ? "28px" : "36px"
  };
}).withConfig({
  displayName: "TabBar__OverflowOverlay"
})(["z-index:100;background:", ";flex-flow:", ";"], props => props.side === "right" ? "linear-gradient(270deg, #FFFFFF 45.48%, rgba(255, 255, 255, 0) 100%)" : "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ffffff 40.1%)", props => props.side === "right" ? "row-reverse" : "row");
const ScrollButton = styled.button.withConfig({
  displayName: "TabBar__ScrollButton"
})(["display:flex;align-items:center;"]);
const TabBar = _ref => {
  let {
    center = true,
    size = "regular",
    separator = false,
    children,
    styleOverrides
  } = _ref;
  const outerRef = useRef();
  const innerRef = useRef();
  const [innerOverflows, setTrue, setFalse] = useBoolean(false);
  const handleResize = useCallback(() => {
    if (outerRef.current.clientWidth < innerRef.current.clientWidth && !innerOverflows) {
      setTrue();
    } else if (outerRef.current.clientWidth > innerRef.current.clientWidth && innerOverflows) {
      setFalse();
    }
  }, [innerOverflows, setTrue, setFalse]);
  useEffect(() => {
    handleResize();
  }, [handleResize]);
  useEventListener("resize", handleResize);
  const scroll = direction => {
    const numberOfItems = Children.count(children);
    if (direction === "left") {
      outerRef.current.scrollLeft -= innerRef.current.clientWidth / numberOfItems;
    } else if (direction === "right") {
      outerRef.current.scrollLeft += innerRef.current.clientWidth / numberOfItems;
    }
  };
  function renderOverlay(direction) {
    return /*#__PURE__*/React__default.createElement(OverflowOverlay, {
      size: size,
      side: direction
    }, /*#__PURE__*/React__default.createElement(ScrollButton, {
      onClick: () => scroll(direction)
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      iconId: "navigation.chevron-".concat(direction),
      size: "24"
    })));
  }
  return /*#__PURE__*/React__default.createElement(Box$1, null, innerOverflows && /*#__PURE__*/React__default.createElement(Flex$1, {
    width: "100%",
    justifyContent: "space-between",
    position: "absolute"
  }, renderOverlay("left"), renderOverlay("right")), separator && /*#__PURE__*/React__default.createElement(Box$1, {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    height: "1",
    background: "border"
  }), /*#__PURE__*/React__default.createElement(BarWrapper, _extends({
    ref: outerRef,
    size: size,
    innerOverflows: innerOverflows
  }, styleOverrides), /*#__PURE__*/React__default.createElement(Box$1, {
    ref: innerRef,
    mx: center ? "auto" : null
  }, children)));
};
var TabBar$1 = TabBar;

const _excluded$f = ["text", "subtext", "disabled", "link"];
function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ItemWrapper$1 = styled.button.withConfig({
  displayName: "Item__ItemWrapper"
})(["background:none;padding:0;opacity:", ";user-select:none;box-shadow:none;flex-shrink:0;border:none;height:100%;flex:1;pointer-events:", ";", ";", " ", " ", " color:", ";span.subtext{color:", ";", ";}&:hover{color:", ";text-decoration:underline;}border-bottom:2px solid ", ";", " &:hover,&:focus{border-bottom:2px solid ", ";text-decoration:none;outline:none;}", ""], props => props.disabled ? ".5" : "1", props => props.disabled ? "none" : null, ellipsis, positioningCSS, flexCSS, transitionCSS({
  transitionProperty: "background, opacity, color, text-decoration, box-shadow",
  transitionDuration: "0.5s",
  transitionTimingFunction: "ease"
}), props => props.selected ? getColor(props.theme.primaryColor, "primary") : getColor("black"), getColor("grayDarker"), positioningCSS({
  ml: "xs"
}), props => props.selected ? getColor(props.theme.primaryColor, "primary") : "black", props => props.selected ? getColor("grayLight") : "transparent", transitionCSS({
  transitionProperty: "color, border-bottom"
}), props => props.selected ? getColor(props.theme.primaryColor, "primary") : getColor("grayDark"), props => props.selected && "\n  border-bottom: 2px solid ".concat(getColor(props.theme.primaryColor, "primary"), ";\n"));
const Item$1 = _ref => {
  let {
      text,
      subtext = null,
      disabled = false,
      link = null
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$f);
  const linkProps = {
    disabled,
    link,
    height: "100%",
    style: null
  };
  const buttonProps = _objectSpread$8(_objectSpread$8({
    disabled
  }, rest), {}, {
    px: "m"
  });
  function renderContent() {
    return /*#__PURE__*/React__default.createElement(Flex$1, {
      justifyContent: "center",
      alignItems: "center"
    }, text && /*#__PURE__*/React__default.createElement("span", null, text), subtext && /*#__PURE__*/React__default.createElement("span", {
      className: "subtext"
    }, subtext));
  }
  return /*#__PURE__*/React__default.createElement(LinkWrapper$1, linkProps, /*#__PURE__*/React__default.createElement(ItemWrapper$1, buttonProps, renderContent()));
};
var Item$2 = Item$1;

const Component$5 = TabBar$1;
Component$5.Item = Item$2;
var Component$6 = Component$5;

function memo(getDeps, fn, opts) {
  let deps = opts.initialDeps ?? [];
  let result;
  return () => {
    var _a, _b, _c, _d;
    let depTime;
    if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
    const newDeps = getDeps();
    const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index) => deps[index] !== dep);
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    let resultTime;
    if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
    result = fn(...newDeps);
    if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
      const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
      const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
      const resultFpsPercentage = resultEndTime / 16;
      const pad = (str, num) => {
        str = String(str);
        while (str.length < num) {
          str = " " + str;
        }
        return str;
      };
      console.info(
        `%c⏱ ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * resultFpsPercentage, 120)
        )}deg 100% 31%);`,
        opts == null ? void 0 : opts.key
      );
    }
    (_d = opts == null ? void 0 : opts.onChange) == null ? void 0 : _d.call(opts, result);
    return result;
  };
}
function notUndefined(value, msg) {
  if (value === void 0) {
    throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
  } else {
    return value;
  }
}
const approxEqual = (a, b) => Math.abs(a - b) < 1;
const debounce = (targetWindow, fn, ms) => {
  let timeoutId;
  return function(...args) {
    targetWindow.clearTimeout(timeoutId);
    timeoutId = targetWindow.setTimeout(() => fn.apply(this, args), ms);
  };
};

const defaultKeyExtractor = (index) => index;
const defaultRangeExtractor = (range) => {
  const start = Math.max(range.startIndex - range.overscan, 0);
  const end = Math.min(range.endIndex + range.overscan, range.count - 1);
  const arr = [];
  for (let i = start; i <= end; i++) {
    arr.push(i);
  }
  return arr;
};
const observeElementRect = (instance, cb) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  const handler = (rect) => {
    const { width, height } = rect;
    cb({ width: Math.round(width), height: Math.round(height) });
  };
  handler(element.getBoundingClientRect());
  if (!targetWindow.ResizeObserver) {
    return () => {
    };
  }
  const observer = new targetWindow.ResizeObserver((entries) => {
    const entry = entries[0];
    if (entry == null ? void 0 : entry.borderBoxSize) {
      const box = entry.borderBoxSize[0];
      if (box) {
        handler({ width: box.inlineSize, height: box.blockSize });
        return;
      }
    }
    handler(element.getBoundingClientRect());
  });
  observer.observe(element, { box: "border-box" });
  return () => {
    observer.unobserve(element);
  };
};
const addEventListenerOptions = {
  passive: true
};
const supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const observeElementOffset = (instance, cb) => {
  const element = instance.scrollElement;
  if (!element) {
    return;
  }
  const targetWindow = instance.targetWindow;
  if (!targetWindow) {
    return;
  }
  let offset = 0;
  const fallback = supportsScrollend ? () => void 0 : debounce(
    targetWindow,
    () => {
      cb(offset, false);
    },
    instance.options.isScrollingResetDelay
  );
  const createHandler = (isScrolling) => () => {
    const { horizontal, isRtl } = instance.options;
    offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
    fallback();
    cb(offset, isScrolling);
  };
  const handler = createHandler(true);
  const endHandler = createHandler(false);
  endHandler();
  element.addEventListener("scroll", handler, addEventListenerOptions);
  element.addEventListener("scrollend", endHandler, addEventListenerOptions);
  return () => {
    element.removeEventListener("scroll", handler);
    element.removeEventListener("scrollend", endHandler);
  };
};
const measureElement = (element, entry, instance) => {
  if (entry == null ? void 0 : entry.borderBoxSize) {
    const box = entry.borderBoxSize[0];
    if (box) {
      const size = Math.round(
        box[instance.options.horizontal ? "inlineSize" : "blockSize"]
      );
      return size;
    }
  }
  return Math.round(
    element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]
  );
};
const elementScroll = (offset, {
  adjustments = 0,
  behavior
}, instance) => {
  var _a, _b;
  const toOffset = offset + adjustments;
  (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null ? void 0 : _b.call(_a, {
    [instance.options.horizontal ? "left" : "top"]: toOffset,
    behavior
  });
};
class Virtualizer {
  constructor(opts) {
    this.unsubs = [];
    this.scrollElement = null;
    this.targetWindow = null;
    this.isScrolling = false;
    this.scrollToIndexTimeoutId = null;
    this.measurementsCache = [];
    this.itemSizeCache =  new Map();
    this.pendingMeasuredCacheIndexes = [];
    this.scrollRect = null;
    this.scrollOffset = null;
    this.scrollDirection = null;
    this.scrollAdjustments = 0;
    this.elementsCache =  new Map();
    this.observer =  (() => {
      let _ro = null;
      const get = () => {
        if (_ro) {
          return _ro;
        }
        if (!this.targetWindow || !this.targetWindow.ResizeObserver) {
          return null;
        }
        return _ro = new this.targetWindow.ResizeObserver((entries) => {
          entries.forEach((entry) => {
            this._measureElement(entry.target, entry);
          });
        });
      };
      return {
        disconnect: () => {
          var _a;
          (_a = get()) == null ? void 0 : _a.disconnect();
          _ro = null;
        },
        observe: (target) => {
          var _a;
          return (_a = get()) == null ? void 0 : _a.observe(target, { box: "border-box" });
        },
        unobserve: (target) => {
          var _a;
          return (_a = get()) == null ? void 0 : _a.unobserve(target);
        }
      };
    })();
    this.range = null;
    this.setOptions = (opts2) => {
      Object.entries(opts2).forEach(([key, value]) => {
        if (typeof value === "undefined") delete opts2[key];
      });
      this.options = {
        debug: false,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: false,
        getItemKey: defaultKeyExtractor,
        rangeExtractor: defaultRangeExtractor,
        onChange: () => {
        },
        measureElement,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: true,
        isRtl: false,
        ...opts2
      };
    };
    this.notify = (sync) => {
      var _a, _b;
      (_b = (_a = this.options).onChange) == null ? void 0 : _b.call(_a, this, sync);
    };
    this.maybeNotify = memo(
      () => {
        this.calculateRange();
        return [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ];
      },
      (isScrolling) => {
        this.notify(isScrolling);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    );
    this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((d) => d());
      this.unsubs = [];
      this.observer.disconnect();
      this.scrollElement = null;
      this.targetWindow = null;
    };
    this._didMount = () => {
      return () => {
        this.cleanup();
      };
    };
    this._willUpdate = () => {
      var _a;
      const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== scrollElement) {
        this.cleanup();
        if (!scrollElement) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = scrollElement;
        if (this.scrollElement && "ownerDocument" in this.scrollElement) {
          this.targetWindow = this.scrollElement.ownerDocument.defaultView;
        } else {
          this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
        }
        this.elementsCache.forEach((cached) => {
          this.observer.observe(cached);
        });
        this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
        this.unsubs.push(
          this.options.observeElementRect(this, (rect) => {
            this.scrollRect = rect;
            this.maybeNotify();
          })
        );
        this.unsubs.push(
          this.options.observeElementOffset(this, (offset, isScrolling) => {
            this.scrollAdjustments = 0;
            this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
            this.scrollOffset = offset;
            this.isScrolling = isScrolling;
            this.maybeNotify();
          })
        );
      }
    };
    this.getSize = () => {
      if (!this.options.enabled) {
        this.scrollRect = null;
        return 0;
      }
      this.scrollRect = this.scrollRect ?? this.options.initialRect;
      return this.scrollRect[this.options.horizontal ? "width" : "height"];
    };
    this.getScrollOffset = () => {
      if (!this.options.enabled) {
        this.scrollOffset = null;
        return 0;
      }
      this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
      return this.scrollOffset;
    };
    this.getFurthestMeasurement = (measurements, index) => {
      const furthestMeasurementsFound =  new Map();
      const furthestMeasurements =  new Map();
      for (let m = index - 1; m >= 0; m--) {
        const measurement = measurements[m];
        if (furthestMeasurementsFound.has(measurement.lane)) {
          continue;
        }
        const previousFurthestMeasurement = furthestMeasurements.get(
          measurement.lane
        );
        if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) {
          furthestMeasurements.set(measurement.lane, measurement);
        } else if (measurement.end < previousFurthestMeasurement.end) {
          furthestMeasurementsFound.set(measurement.lane, true);
        }
        if (furthestMeasurementsFound.size === this.options.lanes) {
          break;
        }
      }
      return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b) => {
        if (a.end === b.end) {
          return a.index - b.index;
        }
        return a.end - b.end;
      })[0] : void 0;
    };
    this.getMeasurementOptions = memo(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (count, paddingStart, scrollMargin, getItemKey, enabled) => {
        this.pendingMeasuredCacheIndexes = [];
        return {
          count,
          paddingStart,
          scrollMargin,
          getItemKey,
          enabled
        };
      },
      {
        key: false
      }
    );
    this.getMeasurements = memo(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count, paddingStart, scrollMargin, getItemKey, enabled }, itemSizeCache) => {
        if (!enabled) {
          this.measurementsCache = [];
          this.itemSizeCache.clear();
          return [];
        }
        if (this.measurementsCache.length === 0) {
          this.measurementsCache = this.options.initialMeasurementsCache;
          this.measurementsCache.forEach((item) => {
            this.itemSizeCache.set(item.key, item.size);
          });
        }
        const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const measurements = this.measurementsCache.slice(0, min);
        for (let i = min; i < count; i++) {
          const key = getItemKey(i);
          const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
          const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
          const measuredSize = itemSizeCache.get(key);
          const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
          const end = start + size;
          const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
          measurements[i] = {
            index: i,
            start,
            size,
            end,
            key,
            lane
          };
        }
        this.measurementsCache = measurements;
        return measurements;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    );
    this.calculateRange = memo(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (measurements, outerSize, scrollOffset) => {
        return this.range = measurements.length > 0 && outerSize > 0 ? calculateRange({
          measurements,
          outerSize,
          scrollOffset
        }) : null;
      },
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    );
    this.getIndexes = memo(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (rangeExtractor, range, overscan, count) => {
        return range === null ? [] : rangeExtractor({
          startIndex: range.startIndex,
          endIndex: range.endIndex,
          overscan,
          count
        });
      },
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    );
    this.indexFromElement = (node) => {
      const attributeName = this.options.indexAttribute;
      const indexStr = node.getAttribute(attributeName);
      if (!indexStr) {
        console.warn(
          `Missing attribute name '${attributeName}={index}' on measured element.`
        );
        return -1;
      }
      return parseInt(indexStr, 10);
    };
    this._measureElement = (node, entry) => {
      const index = this.indexFromElement(node);
      const item = this.measurementsCache[index];
      if (!item) {
        return;
      }
      const key = item.key;
      const prevNode = this.elementsCache.get(key);
      if (prevNode !== node) {
        if (prevNode) {
          this.observer.unobserve(prevNode);
        }
        this.observer.observe(node);
        this.elementsCache.set(key, node);
      }
      if (node.isConnected) {
        this.resizeItem(index, this.options.measureElement(node, entry, this));
      }
    };
    this.resizeItem = (index, size) => {
      const item = this.measurementsCache[index];
      if (!item) {
        return;
      }
      const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
      const delta = size - itemSize;
      if (delta !== 0) {
        if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) {
          if (process.env.NODE_ENV !== "production" && this.options.debug) {
            console.info("correction", delta);
          }
          this._scrollToOffset(this.getScrollOffset(), {
            adjustments: this.scrollAdjustments += delta,
            behavior: void 0
          });
        }
        this.pendingMeasuredCacheIndexes.push(item.index);
        this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
        this.notify(false);
      }
    };
    this.measureElement = (node) => {
      if (!node) {
        this.elementsCache.forEach((cached, key) => {
          if (!cached.isConnected) {
            this.observer.unobserve(cached);
            this.elementsCache.delete(key);
          }
        });
        return;
      }
      this._measureElement(node, void 0);
    };
    this.getVirtualItems = memo(
      () => [this.getIndexes(), this.getMeasurements()],
      (indexes, measurements) => {
        const virtualItems = [];
        for (let k = 0, len = indexes.length; k < len; k++) {
          const i = indexes[k];
          const measurement = measurements[i];
          virtualItems.push(measurement);
        }
        return virtualItems;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    );
    this.getVirtualItemForOffset = (offset) => {
      const measurements = this.getMeasurements();
      if (measurements.length === 0) {
        return void 0;
      }
      return notUndefined(
        measurements[findNearestBinarySearch(
          0,
          measurements.length - 1,
          (index) => notUndefined(measurements[index]).start,
          offset
        )]
      );
    };
    this.getOffsetForAlignment = (toOffset, align) => {
      const size = this.getSize();
      const scrollOffset = this.getScrollOffset();
      if (align === "auto") {
        if (toOffset <= scrollOffset) {
          align = "start";
        } else if (toOffset >= scrollOffset + size) {
          align = "end";
        } else {
          align = "start";
        }
      }
      if (align === "start") {
        toOffset = toOffset;
      } else if (align === "end") {
        toOffset = toOffset - size;
      } else if (align === "center") {
        toOffset = toOffset - size / 2;
      }
      const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
      const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
      const maxOffset = scrollSize - size;
      return Math.max(Math.min(maxOffset, toOffset), 0);
    };
    this.getOffsetForIndex = (index, align = "auto") => {
      index = Math.max(0, Math.min(index, this.options.count - 1));
      const item = this.measurementsCache[index];
      if (!item) {
        return void 0;
      }
      const size = this.getSize();
      const scrollOffset = this.getScrollOffset();
      if (align === "auto") {
        if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) {
          align = "end";
        } else if (item.start <= scrollOffset + this.options.scrollPaddingStart) {
          align = "start";
        } else {
          return [scrollOffset, align];
        }
      }
      const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(toOffset, align), align];
    };
    this.isDynamicMode = () => this.elementsCache.size > 0;
    this.cancelScrollToIndex = () => {
      if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
        this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
        this.scrollToIndexTimeoutId = null;
      }
    };
    this.scrollToOffset = (toOffset, { align = "start", behavior } = {}) => {
      this.cancelScrollToIndex();
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn(
          "The `smooth` scroll behavior is not fully supported with dynamic size."
        );
      }
      this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
        adjustments: void 0,
        behavior
      });
    };
    this.scrollToIndex = (index, { align: initialAlign = "auto", behavior } = {}) => {
      index = Math.max(0, Math.min(index, this.options.count - 1));
      this.cancelScrollToIndex();
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn(
          "The `smooth` scroll behavior is not fully supported with dynamic size."
        );
      }
      const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
      if (!offsetAndAlign) return;
      const [offset, align] = offsetAndAlign;
      this._scrollToOffset(offset, { adjustments: void 0, behavior });
      if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) {
        this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
          this.scrollToIndexTimeoutId = null;
          const elementInDOM = this.elementsCache.has(
            this.options.getItemKey(index)
          );
          if (elementInDOM) {
            const [latestOffset] = notUndefined(
              this.getOffsetForIndex(index, align)
            );
            if (!approxEqual(latestOffset, this.getScrollOffset())) {
              this.scrollToIndex(index, { align, behavior });
            }
          } else {
            this.scrollToIndex(index, { align, behavior });
          }
        });
      }
    };
    this.scrollBy = (delta, { behavior } = {}) => {
      this.cancelScrollToIndex();
      if (behavior === "smooth" && this.isDynamicMode()) {
        console.warn(
          "The `smooth` scroll behavior is not fully supported with dynamic size."
        );
      }
      this._scrollToOffset(this.getScrollOffset() + delta, {
        adjustments: void 0,
        behavior
      });
    };
    this.getTotalSize = () => {
      var _a;
      const measurements = this.getMeasurements();
      let end;
      if (measurements.length === 0) {
        end = this.options.paddingStart;
      } else {
        end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(
          ...measurements.slice(-this.options.lanes).map((m) => m.end)
        );
      }
      return end - this.options.scrollMargin + this.options.paddingEnd;
    };
    this._scrollToOffset = (offset, {
      adjustments,
      behavior
    }) => {
      this.options.scrollToFn(offset, { behavior, adjustments }, this);
    };
    this.measure = () => {
      this.itemSizeCache =  new Map();
      this.notify(false);
    };
    this.setOptions(opts);
  }
}
const findNearestBinarySearch = (low, high, getCurrentValue, value) => {
  while (low <= high) {
    const middle = (low + high) / 2 | 0;
    const currentValue = getCurrentValue(middle);
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
function calculateRange({
  measurements,
  outerSize,
  scrollOffset
}) {
  const count = measurements.length - 1;
  const getOffset = (index) => measurements[index].start;
  const startIndex = findNearestBinarySearch(0, count, getOffset, scrollOffset);
  let endIndex = startIndex;
  while (endIndex < count && measurements[endIndex].end < scrollOffset + outerSize) {
    endIndex++;
  }
  return { startIndex, endIndex };
}

const useIsomorphicLayoutEffect = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
function useVirtualizerBase(options) {
  const rerender = React.useReducer(() => ({}), {})[1];
  const resolvedOptions = {
    ...options,
    onChange: (instance2, sync) => {
      var _a;
      if (sync) {
        flushSync(rerender);
      } else {
        rerender();
      }
      (_a = options.onChange) == null ? void 0 : _a.call(options, instance2, sync);
    }
  };
  const [instance] = React.useState(
    () => new Virtualizer(resolvedOptions)
  );
  instance.setOptions(resolvedOptions);
  React.useEffect(() => {
    return instance._didMount();
  }, []);
  useIsomorphicLayoutEffect(() => {
    return instance._willUpdate();
  });
  return instance;
}
function useVirtualizer(options) {
  return useVirtualizerBase({
    observeElementRect,
    observeElementOffset,
    scrollToFn: elementScroll,
    ...options
  });
}

const _excluded$e = ["row", "columns", "dynamicHeight", "data", "hideFinalBottomBorder", "getHeight", "onRowClick", "checkboxProps", "renderContextMenuItems"];
const TableRowWrapper = styled(Flex$1).attrs(props => {
  return {
    height: props.height,
    gap: "16px",
    alignItems: props.alignItems || "center",
    variations: {
      "&:hover": {
        background: "grayLighter"
      }
    }
  };
}).withConfig({
  displayName: "TableRow__TableRowWrapper"
})(["padding:", ";.asset_row_hover{opacity:0;transition:opacity 0.2s ease-in-out;}p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;user-select:text;cursor:text;}&:hover{.asset_row_hover{opacity:1;}cursor:", ";}"], props => props.padding || "0px", _ref => {
  let {
    onMouseDown
  } = _ref;
  return onMouseDown ? "pointer" : "default";
});
const TableCellWrapper = styled(Flex$1).attrs({
  display: "inline-flex",
  overflow: "hidden"
}).withConfig({
  displayName: "TableRow__TableCellWrapper"
})(["user-select:none;", ":hover &{background-color:", ";}", ""], TableRowWrapper, getColor("grayLighter"), props => props.innerShadow && "\n  box-shadow: 3px 0px 24px 16px rgba(0,0,0,0.075);\n  clip-path: inset(0px -100px 0px 0px);\n  ");
const TableRow = _ref2 => {
  var _checkboxProps$disabl, _checkboxProps$disabl2;
  let {
      row,
      columns,
      dynamicHeight,
      data,
      hideFinalBottomBorder,
      getHeight,
      onRowClick,
      checkboxProps,
      renderContextMenuItems
    } = _ref2,
    styles = _objectWithoutProperties(_ref2, _excluded$e);
  const totalWidth = columns.reduce((acc, column) => acc + column.minWidth, 0);
  const rowData = data[row.index];
  const shouldHandleClick = onRowClick && !(checkboxProps !== null && checkboxProps !== void 0 && (_checkboxProps$disabl = checkboxProps.disabled) !== null && _checkboxProps$disabl !== void 0 && _checkboxProps$disabl.call(checkboxProps, rowData));
  const ref = React__default.useRef(null);
  const hasContextMenu = renderContextMenuItems && renderContextMenuItems(rowData) !== null;
  const onClickTableRow = (rowData, e) => {
    if (e.target.tagName === "P") return;
    onRowClick(rowData, e);
  };
  const onOpenContextMenu = e => {
    if (checkboxProps && !checkboxProps.isSelected(rowData)) {
      onRowClick(rowData, e);
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, {
    key: row.key
  }, hasContextMenu && /*#__PURE__*/React__default.createElement(ContextMenu$1, {
    onOpenMenu: onOpenContextMenu,
    id: row.index.toString(),
    parentRef: ref
  }, renderContextMenuItems(rowData)), /*#__PURE__*/React__default.createElement(TableRowWrapper, _extends({
    "data-index": row.index,
    ref: ref,
    minWidth: "".concat(totalWidth, "px"),
    height: !dynamicHeight && "".concat(getHeight(), "px"),
    borderBottom: row.index === data.length - 1 && hideFinalBottomBorder ? "none" : "default",
    onClick: shouldHandleClick ? e => onClickTableRow(rowData, e) : undefined
  }, styles), checkboxProps && /*#__PURE__*/React__default.createElement(TableCellWrapper, {
    borderRight: "default",
    position: "sticky",
    left: 0,
    zIndex: 10,
    justifyContent: "center",
    overflow: "visible",
    backgroundColor: "white",
    height: "100%",
    px: "16px",
    onClick: () => checkboxProps.onClick(rowData)
  }, /*#__PURE__*/React__default.createElement(Checkbox$2, {
    disabled: (checkboxProps === null || checkboxProps === void 0 || (_checkboxProps$disabl2 = checkboxProps.disabled) === null || _checkboxProps$disabl2 === void 0 ? void 0 : _checkboxProps$disabl2.call(checkboxProps, rowData)) === true,
    isSelected: checkboxProps.isSelected(rowData),
    onClick: () => checkboxProps.onClick(rowData)
  })), columns.map((k, kIdx) => /*#__PURE__*/React__default.createElement(TableCellWrapper, {
    "data-testid": "table-row-".concat(kIdx),
    flex: "".concat(k.flexGrow || 1, " ").concat(k.flexShrink || 1, " ").concat(k.minWidth, "px"),
    justifyContent: k.justify || undefined,
    key: kIdx
  }, k.renderer(rowData)))));
};
var TableRow$1 = TableRow;

const TableHeadWrapper = styled(Flex$1).attrs(_ref => {
  let {
    top
  } = _ref;
  return {
    height: "44px",
    borderBottom: "default",
    alignItems: "center",
    gap: "16px",
    justifyContent: "space-between",
    zIndex: "60",
    background: "grayLightest",
    position: "sticky",
    top: top || 0
  };
}).withConfig({
  displayName: "TableHeader__TableHeadWrapper"
})([""]);
const Cell = styled(Flex$1).attrs({
  display: "inline-flex",
  overflowY: "hidden"
}).withConfig({
  displayName: "TableHeader__Cell"
})([""]);
const headerButtonProps = {
  buttonStyle: "tertiary",
  size: "small",
  fontStyle: "ui.smallBold",
  themeOverrides: {
    primaryColor: "grayDarker",
    primaryColorDark: "grayDarkest"
  }
};
const headerTextProps = {
  font: "ui.smallBold",
  color: "grayDarker"
};
const TableHeader = _ref2 => {
  let {
    columns,
    sort,
    onSort,
    headerSpacer
  } = _ref2;
  const totalWidth = columns.reduce((acc, column) => acc + column.minWidth, 0);
  const handleSortClick = value => {
    const baseKey = value.replace(/-/g, "");
    if (sort !== null && sort !== void 0 && sort.includes(baseKey)) {
      onSort(sort !== null && sort !== void 0 && sort.includes("-") ? baseKey : "-".concat(baseKey));
    } else {
      onSort("-".concat(baseKey));
    }
  };
  const getSortIcon = type => {
    if (sort !== null && sort !== void 0 && sort.includes(type)) {
      return sort !== null && sort !== void 0 && sort.includes("-") ? "action.table-sort-descending" : "action.table-sort-ascending";
    }
    return "action.expand";
  };
  return /*#__PURE__*/React__default.createElement(TableHeadWrapper, {
    minWidth: "".concat(totalWidth + headerSpacer, "px")
  }, headerSpacer > 0 && /*#__PURE__*/React__default.createElement(Flex$1, {
    width: "".concat(headerSpacer, "px")
  }), columns.map((column, idx) => {
    return /*#__PURE__*/React__default.createElement(Cell, {
      key: idx,
      pl: column.leftPadding,
      justifyContent: column.justify || undefined,
      flex: "".concat(column.flexGrow || 1, " ").concat(column.flexShrink || 1, " ").concat(column.minWidth, "px")
    }, column.sortKey ? /*#__PURE__*/React__default.createElement(Button$1, _extends({
      text: column.name,
      onClick: () => handleSortClick(column.sortKey),
      icon: getSortIcon(column.sortKey)
    }, headerButtonProps)) : /*#__PURE__*/React__default.createElement(Text, headerTextProps, column.name));
  }));
};
var TableHeader$1 = TableHeader;

const _excluded$d = ["header", "rowSize", "hasMorePages", "tableData", "onRowClick", "columns", "checkboxProps", "hideFinalBottomBorder", "dynamicHeight", "renderContextMenuItems", "sort", "onSort", "emptyState", "errorState"],
  _excluded2$1 = ["title", "subtitle", "subtitleButton", "actions", "tooltip"];
function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Table = _ref => {
  let {
      header = null,
      rowSize = "medium",
      hasMorePages,
      tableData,
      onRowClick,
      columns,
      checkboxProps,
      hideFinalBottomBorder = false,
      dynamicHeight,
      renderContextMenuItems,
      sort,
      onSort,
      emptyState,
      errorState
    } = _ref,
    styles = _objectWithoutProperties(_ref, _excluded$d);
  const parentScrollRef = React__default.useRef(null);
  const {
    data,
    isLoading,
    error,
    fetchNextPage
  } = tableData;
  const isEmpty = useMemo(() => !isLoading && !error && (data === null || data === void 0 ? void 0 : data.length) === 0, [data === null || data === void 0 ? void 0 : data.length, isLoading, error]);
  let count = data === null || data === void 0 ? void 0 : data.length;
  if (count && hasMorePages) count += 1;
  const getHeight = useCallback(() => {
    const tableRowHeights = {
      small: 40,
      medium: 80,
      large: 136
    };
    return tableRowHeights[rowSize];
  }, [rowSize]);
  const rowVirtualizer = useVirtualizer({
    count,
    getScrollElement: () => parentScrollRef.current,
    estimateSize: getHeight,
    overscan: 3
  });
  const headerSpacer = checkboxProps ? 56 : 0;
  function renderHeader() {
    if (!(header !== null && header !== void 0 && header.title)) return;
    const {
        title,
        subtitle,
        subtitleButton,
        actions,
        tooltip
      } = header,
      styling = _objectWithoutProperties(header, _excluded2$1);
    return /*#__PURE__*/React__default.createElement(Flex$1, _extends({
      alignItems: "center",
      borderBottom: "default",
      borderRadius: "4px 4px 0 0",
      background: "grayLightest",
      px: "24px",
      py: "16px"
    }, styling), /*#__PURE__*/React__default.createElement(Box$1, {
      flex: "1"
    }, title && /*#__PURE__*/React__default.createElement(Text, {
      mb: "xxs",
      font: "ui.regularBold"
    }, title), subtitle && /*#__PURE__*/React__default.createElement(Flex$1, {
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Text, {
      as: "div",
      color: "grayDarkest"
    }, subtitle), subtitleButton && /*#__PURE__*/React__default.createElement(Button$1, _extends({
      buttonStyle: "tertiary",
      ml: "xs"
    }, subtitleButton)), tooltip && /*#__PURE__*/React__default.createElement(Tooltip.InfoTip, {
      direction: "bottom",
      fill: "grayDarkest"
    }, tooltip))), actions && /*#__PURE__*/React__default.createElement(Box$1, null, actions));
  }
  function renderContent() {
    if (isEmpty) {
      if (/*#__PURE__*/isValidElement(emptyState)) return emptyState;
      return /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(EmptyState$1, _extends({
        styleOverrides: {
          py: "xxl"
        },
        title: "No data",
        subtitle: "There is nothing to show here."
      }, emptyState)));
    } else if (isLoading && !(data !== null && data !== void 0 && data.length)) {
      return /*#__PURE__*/React__default.createElement(ActivityIndicator$1, {
        mt: "xxl",
        center: true
      });
    } else if (error && !(data !== null && data !== void 0 && data.length)) {
      return /*#__PURE__*/isValidElement(errorState) ? errorState : /*#__PURE__*/React__default.createElement(EmptyState$1, _extends({
        title: "Unable to load data",
        subtitle: error === null || error === void 0 ? void 0 : error.message,
        iconProps: {
          iconId: "error",
          fill: "error"
        },
        button: {
          text: "Retry",
          onClick: fetchNextPage
        }
      }, errorState));
    } else {
      return renderTable();
    }
  }
  function renderTable() {
    return /*#__PURE__*/React__default.createElement("div", {
      ref: parentScrollRef,
      style: {
        overflowX: "auto"
      }
    }, /*#__PURE__*/React__default.createElement(TableHeader$1, {
      columns: columns.map((col, i) => _objectSpread$7(_objectSpread$7({}, col), {}, {
        leftPadding: i === 0 && !headerSpacer ? "40px" : "0"
      })),
      sort: sort,
      onSort: onSort,
      headerSpacer: headerSpacer
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        height: "".concat(rowVirtualizer.getTotalSize(), "px"),
        width: "100%",
        position: "relative"
      }
    }, rowVirtualizer.getVirtualItems().map(virtualRow => {
      const isLoaderRow = virtualRow.index > data.length - 1;
      return /*#__PURE__*/React__default.createElement(Fragment, {
        key: virtualRow.key
      }, isLoaderRow ? /*#__PURE__*/React__default.createElement(PagingIndicator$1, {
        mt: "".concat(virtualRow.size / 2, "px"),
        transform: "translateY(-50%)",
        hasMore: hasMorePages,
        data: data,
        error: error,
        fetchNextPage: fetchNextPage,
        isLoading: isLoading
      }) : /*#__PURE__*/React__default.createElement(TableRow$1, {
        row: virtualRow,
        columns: columns,
        dynamicHeight: dynamicHeight,
        data: data,
        hideFinalBottomBorder: hideFinalBottomBorder,
        getHeight: getHeight,
        onRowClick: onRowClick,
        checkboxProps: checkboxProps,
        renderContextMenuItems: renderContextMenuItems
      }));
    })));
  }
  return /*#__PURE__*/React__default.createElement(Flex$1, _extends({
    position: "relative",
    flexDirection: "Column",
    width: "100%"
  }, styles), renderHeader(), renderContent());
};
var Table$1 = Table;

const Component$3 = Table$1;
var Component$4 = Component$3;

/**
 * Helper for pulling a space-identifying domain from the URL.
 */

function getCustomDomainComponents() {
  return parseHostname(window.location.hostname);
}

const apiDomains = {
  "test-runner": "http://local.lingoapp.com",
  development: "http://local.lingoapp.com:9000",
  test: "https://api-test.lingoapp.com",
  staging: "https://api-staging.lingoapp.com",
  production: "https://api.lingoapp.com"
};
const wwwDomains = {
  "test-runner": {
    protocol: "http",
    subdomain: "local",
    port: "8080"
  },
  development: {
    protocol: "http",
    subdomain: "local",
    port: "8080"
  },
  test: {
    protocol: "https",
    subdomain: "www-test",
    port: ""
  },
  staging: {
    protocol: "https",
    subdomain: "www-staging",
    port: ""
  },
  production: {
    protocol: "https",
    subdomain: "www",
    port: ""
  }
};
const getWWWDomainComponents = () => {
  const env = _lingoConfig.environment;
  const domain = wwwDomains[env];
  if (domain) return domain;
  throw new Error("Environment not found in config.");
};

// By default, spaces with custom domains access the api through
// lingo-api.<custom-domain>.com. This object allows us to override
// that behavior for specific spaces with special DNS needs.
const hostOverrides = {
  "brandportal.mwg.aaa.com": "mwg.aaa.com",
  "brandhub.rmit.edu.au": "brandhub.rmit.edu.au"
};
const getApiDomain = () => {
  const {
    host,
    identifier
  } = getCustomDomainComponents();
  if (host) {
    var _hostOverrides$identi;
    // Local with custom domain
    if (_lingoConfig.environment === Environment.development) {
      return "http://local.".concat(host, ":9000");
    }
    return "https://lingo-api.".concat((_hostOverrides$identi = hostOverrides[identifier]) !== null && _hostOverrides$identi !== void 0 ? _hostOverrides$identi : host);
  }
  const env = _lingoConfig.environment;
  const domain = apiDomains[env];
  if (domain) return "".concat(domain);
  throw new Error("Environment not found in config.");
};
const getApiServiceURL = endpoint => {
  let path = endpoint || "";
  if (path[0] === "/") path = path.substring(1);
  return "".concat(getApiDomain(), "/v4/").concat(path);
};

function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Builds an appropriate URL based on the path and context passed in
 *
 * @param {String} path The desired path, minus any consideration of space id or store
 * @param {Object} context An optional object to describe the space the url is for.
 *   If null, a base url is returned (i.e. a url outside the context of the store or a space)
 *
 * Example context
 * ```
 * {
 *   space: { id, subdomain }
 * }
 * ```
 */
function buildURL() {
  let path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  let {
    space,
    portal,
    isPublic
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let hash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  const pathComponents = [];

  // Extract query parameters from the path, if present.
  const queryStringIndex = path.indexOf("?");
  let queryParams = {};
  if (queryStringIndex !== -1) {
    const pathWithoutQuery = path.substring(0, queryStringIndex);
    const queryString = path.substring(queryStringIndex + 1);
    queryParams = Object.fromEntries(new URLSearchParams(queryString));
    path = pathWithoutQuery;
  }
  query = _objectSpread$6(_objectSpread$6({}, queryParams), query);
  if (portal !== null && portal !== void 0 && portal.subdomain || portal !== null && portal !== void 0 && portal.domain) {
    var _space$access, _portal$access;
    const portalOrigin = new URL(getOrigin(portal === null || portal === void 0 ? void 0 : portal.domain, portal === null || portal === void 0 ? void 0 : portal.subdomain));
    const isPrivateAccess = (space === null || space === void 0 || (_space$access = space.access) === null || _space$access === void 0 ? void 0 : _space$access.isPublic) === false || ((_portal$access = portal.access) === null || _portal$access === void 0 ? void 0 : _portal$access.isPublic) === false;
    if (isPublic || !isPrivateAccess) {
      const fullPath = constructPath(path, 0, true, query, hash);
      return joinPath(portalOrigin.toString(), fullPath);
    }
  }
  if (portal) {
    pathComponents.push("p", portal.urlId);
  }
  const {
      id: spaceId,
      subdomain,
      domain
    } = space || {},
    origin = getOrigin(domain, subdomain);
  const fullPath = constructPath(joinPath(...pathComponents, path), spaceId, Boolean(subdomain || domain), query, hash);
  return "".concat(origin).concat(fullPath);
}

/**
 * Builds an appropriate path based on the context passed in and hopeful that
 * the current subdomain matches the required one
 *
 * @param {String} path The desired path, minus any consideration of space id
 * @param {Object} context An optional object to describe the space context the url is for.
 *   If null, a base url is returned (i.e. a url outside the context of a space)
 *
 * Example context
 * ```
 * {
 *   space: { id, subdomain }
 * }
 * ```
 */
function buildPath() {
  let path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  let {
    space
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let hash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  const {
      id: spaceId,
      subdomain
    } = space || {},
    {
      subdomain: currentSubdomain,
      identifier
    } = getCustomDomainComponents();
  if (_lingoConfig.environment !== "production" && currentSubdomain && subdomain !== undefined &&
  // Undefined subdomain will mean it was not convenient to supply it but can be assumed unimportant
  currentSubdomain !== subdomain) {
    console.error("Cannot reach this space with only a path change!");
  }
  return constructPath(path, spaceId, Boolean(identifier), query, hash);
}
function joinPath() {
  for (var _len = arguments.length, components = new Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }
  return components.reduce((acc, path) => {
    return "".concat(acc.replace(/\/$/, ""), "/").concat(path.replace(/^\//, ""));
  }, "")
  // Remove the leading slash
  .replace(/^\//, "");
}

/**
 * Attaches the appropriate prefix to the passed in path, based on the other context variables passed
 *
 * @param {String} path The desired path, minus any consideration of space id or store
 * @param {Number} spaceId The target space's id, if any
 * @param {Boolean} hasSubdomain Whether we are targeting a URL with a subdomain
 * @param {Object} query Search parameters in object notation
 * @param {String} hash URL hash
 *
 */
function constructPath(path, spaceId, hasSubdomain, query, hash) {
  // eslint-disable-next-line no-nested-ternary
  const spacePrefix = hasSubdomain || !spaceId ? "" : "/".concat(spaceId),
    normalizedPath = "/".concat(path || "").replace("//", "/"),
    qs = QueryString.stringify(query),
    h = hash ? "#".concat(hash) : "";
  return ["".concat(spacePrefix).concat(normalizedPath), qs].filter(Boolean).join("?").concat(h);
}

/**
 * Get the base url from the current window location and the subdomain passed in
 *
 * @param {String} [subdomain] A subdomain to use when building the host. Defaults to the standard lingo subdomain for the current environment.
 *
 */
function getOrigin(domain, subdomain) {
  const subdomainOrBase = subdomain || getBaseSubdomain(),
    host = domain || "lingoapp.com",
    {
      port,
      protocol
    } = window.location,
    subdomainPlusPeriod = subdomainOrBase ? "".concat(subdomainOrBase, ".") : "",
    portPlusColon = port ? ":".concat(port) : "";
  return "".concat(protocol, "//").concat(subdomainPlusPeriod).concat(host).concat(portPlusColon);
}
function getBaseSubdomain() {
  return getWWWDomainComponents().subdomain;
}

const ExpandButton = styled.button.withConfig({
  displayName: "TableCell__ExpandButton"
})(["position:absolute;z-index:5;background:white;display:flex;align-items:center;justify-content:center;padding:0;border-radius:4px;.asset_row_hover{opacity:0;transition:opacity 0.2s ease-in-out;}", ""], props => props.rowSize === "small" ? "height: 100%; width: 100%; bottom: 0; right: 0;" : props.rowSize === "medium" ? "bottom: 4px; right: 4px; height: 28px; width: 28px;" : "bottom: 8px; right: 8px; height: 28px; width: 28px;");
const CellWrapper = styled(Flex$1).withConfig({
  displayName: "TableCell__CellWrapper"
})(["align-items:center;overflow:hidden;&:hover{.asset_row_hover{opacity:1;}}"]);
const TableCellText = styled(Text).withConfig({
  displayName: "TableCell__TableCellText"
})(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;user-select:none;min-width:0;*{user-select:none;}"]);
function TableCell(_ref) {
  var _data$meta5, _data$colors, _data$meta6, _data$colors2;
  let {
    data,
    space,
    icon,
    background,
    rowSize = "medium",
    insights = true
  } = _ref;
  const dataType = useMemo(() => {
    var _data$counts;
    if ("kitId" in data) return "kit";
    if ("avatar" in data) return "user";
    if ("counts" in data && (_data$counts = data.counts) !== null && _data$counts !== void 0 && _data$counts.kits) return "portal";
    return "asset";
  }, [data]);
  const isUser = dataType === "user";
  const isAsset = dataType === "asset";
  const isKit = dataType === "kit";
  const isActive = !["deleted", "trashed"].includes(data.status);
  const getUrl = () => {
    switch (dataType) {
      case "asset":
        return buildURL("/library/a/".concat(data.id), {
          space
        });
      case "kit":
        return buildURL("/k/".concat(data.kitId), {
          space
        });
      case "portal":
        return buildURL("/p/".concat(data.id), {
          space
        });
      default:
        return undefined;
    }
  };
  const getImageSource = () => {
    var _data$thumbnails, _data$meta, _data$images;
    return isAsset ? "".concat(data === null || data === void 0 || (_data$thumbnails = data.thumbnails) === null || _data$thumbnails === void 0 ? void 0 : _data$thumbnails[292], "&p=").concat(data === null || data === void 0 || (_data$meta = data.meta) === null || _data$meta === void 0 ? void 0 : _data$meta.assetProcessing) : dataType === "portal" || isKit ? (data === null || data === void 0 || (_data$images = data.images) === null || _data$images === void 0 ? void 0 : _data$images.cover) || null : isUser ? data === null || data === void 0 ? void 0 : data.avatar : null;
  };
  const imageSizes = {
    small: 30,
    medium: 64,
    large: 120
  };
  const imageSize = imageSizes[rowSize];
  const renderThumbnail = () => {
    var _data$meta2, _data$meta3, _data$meta4;
    const imageView = /*#__PURE__*/React__default.createElement(ImageView$1, {
      width: isUser ? "40" : imageSize,
      height: isUser ? "40" : imageSize,
      borderRadius: isUser ? "50%" : "default",
      iconSize: 24,
      icon: icon ? icon : getImageSource() === null ? "content.".concat(dataType) : undefined,
      iconFill: "grayDarker",
      src: getImageSource(),
      background: background || "grayLighter",
      cover: !isAsset
    });
    if (!isAsset || (data === null || data === void 0 || (_data$meta2 = data.meta) === null || _data$meta2 === void 0 ? void 0 : _data$meta2.assetProcessing) === "complete") {
      return imageView;
    }
    if (((_data$meta3 = data.meta) === null || _data$meta3 === void 0 ? void 0 : _data$meta3.assetProcessing) === "error") {
      return /*#__PURE__*/React__default.createElement(ImageView$1, {
        width: imageSize,
        height: imageSize,
        icon: "info.error",
        iconSize: 32,
        iconFill: "error"
      });
    }
    if (((_data$meta4 = data.meta) === null || _data$meta4 === void 0 ? void 0 : _data$meta4.assetProcessing) === "processing") {
      return /*#__PURE__*/React__default.createElement(Flex$1, {
        alignItems: "center",
        justifyContent: "center",
        width: imageSize,
        height: imageSize,
        background: "grayLighter"
      }, /*#__PURE__*/React__default.createElement(ActivityIndicator$1, {
        size: "small"
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(CellWrapper, {
    pl: insights && "40px",
    "data-assetid": isAsset && "".concat(data.id)
  }, /*#__PURE__*/React__default.createElement(LinkWrapper$1, {
    link: isActive ? getUrl() : undefined,
    target: !isAsset && "_blank"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative"
    }
  }, isActive && !isUser && /*#__PURE__*/React__default.createElement(ExpandButton, {
    rowSize: rowSize,
    className: "asset_row_hover"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    iconId: isAsset ? "action.maximize" : "action.external-link",
    size: 16,
    fill: space === null || space === void 0 ? void 0 : space.theme.primaryColor
  })), renderThumbnail())), isAsset && isActive ? /*#__PURE__*/React__default.createElement(Button$1, {
    buttonStyle: "tertiary",
    link: getUrl(),
    text: data.name || ((_data$meta5 = data.meta) === null || _data$meta5 === void 0 || (_data$meta5 = _data$meta5.font) === null || _data$meta5 === void 0 ? void 0 : _data$meta5.displayName) || ((_data$colors = data.colors) === null || _data$colors === void 0 || (_data$colors = _data$colors[0]) === null || _data$colors === void 0 ? void 0 : _data$colors.name) || "Unnamed Asset",
    truncate: true,
    ml: "m"
  }) : /*#__PURE__*/React__default.createElement(TableCellText, {
    ml: "m"
  }, data.name || ((_data$meta6 = data.meta) === null || _data$meta6 === void 0 || (_data$meta6 = _data$meta6.font) === null || _data$meta6 === void 0 ? void 0 : _data$meta6.displayName) || ((_data$colors2 = data.colors) === null || _data$colors2 === void 0 || (_data$colors2 = _data$colors2[0]) === null || _data$colors2 === void 0 ? void 0 : _data$colors2.name) || data.kitName || "Unnamed"));
}
var TableCell$1 = /*#__PURE__*/React__default.memo(TableCell);

const Component$1 = TableCell$1;
var Component$2 = Component$1;

const _excluded$c = ["value", "onChange", "placeholder", "id", "label", "message", "textareaStyle", "maxLength", "rows", "resize", "disabled", "readOnly", "autoFocus", "onFocus", "onBlur"];
const StyledTextArea = styled.textarea.withConfig({
  displayName: "Textarea__StyledTextArea"
})(["width:100%;border:", ";border-radius:", ";background:white;box-sizing:border-box;", ";", " resize:", ";&::placeholder{color:", ";}&.active,&:focus{border:", ";outline:none;}&.error{border:", ";}&.disabled{border:", ";background:", ";}"], getBorder("1px solid border"), getBorderRadius("default"), props => getFont("ui.regular", null, props), positioningCSS({
  px: "s",
  py: "s"
}), props => props.resize || "vertical", getColor("grayDark"), getBorder("1px solid focus"), getBorder("1px solid error"), getBorder("1px solid border"), getColor("grayLighter"));
const Textarea$2 = _ref => {
  let {
      value,
      onChange,
      placeholder,
      id,
      label,
      message,
      textareaStyle,
      maxLength,
      rows,
      resize = "vertical",
      disabled,
      readOnly,
      autoFocus,
      onFocus,
      onBlur
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$c);
  const elementProps = {
    id,
    value,
    placeholder,
    maxLength,
    rows,
    resize,
    autoFocus,
    disabled,
    readOnly,
    onChange,
    onFocus,
    onBlur
  };
  const ref = useRef();
  useEffect(() => {
    if (autoFocus) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getIcon() {
    switch (textareaStyle) {
      case "error":
        return /*#__PURE__*/React__default.createElement(Icon$1, {
          size: "16",
          fill: "error",
          iconId: "error",
          pr: "xs"
        });
      case "success":
        return /*#__PURE__*/React__default.createElement(Icon$1, {
          size: "16",
          fill: "success",
          iconId: "checkmark",
          pr: "xs"
        });
      case "warning":
        return /*#__PURE__*/React__default.createElement(Icon$1, {
          size: "16",
          fill: "warning",
          iconId: "warning",
          pr: "xs"
        });
      default:
        return null;
    }
  }
  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    "data-testid": id,
    width: "100%"
  }, rest), label ? /*#__PURE__*/React__default.createElement(Text, {
    as: "label",
    "data-testid": "textarea-label",
    display: "block",
    color: "black",
    mb: "xs",
    htmlFor: id
  }, label) : null, /*#__PURE__*/React__default.createElement(Flex$1, {
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(StyledTextArea, _extends({
    ref: ref,
    role: "textbox",
    className: disabled || readOnly ? "disabled" : textareaStyle
  }, elementProps))), message ? /*#__PURE__*/React__default.createElement(Flex$1, {
    "data-testid": "textarea-message",
    ml: "s",
    flexDirection: "row",
    alignItems: "center"
  }, getIcon(), /*#__PURE__*/React__default.createElement(Text, {
    my: "xs",
    font: "ui.small",
    color: textareaStyle === "error" ? "error" : "black"
  }, message)) : null);
};
var Textarea$3 = Textarea$2;

const ContentBox = styled(Box$1).withConfig({
  displayName: "ToggleBox__ContentBox"
})(["transition:opacity 500ms,padding-top 500ms,padding-bottom 500ms,max-height 500ms;opacity:", ";max-height:", ";"], props => props.isOpen ? 1 : 0, props => props.isOpen ? cssVal(props.estimatedHeight || "200px") : 0);
const ToggleBox = _ref => {
  let {
    id,
    icon,
    title,
    description,
    isOpen,
    isOn,
    disabled,
    onToggle,
    children,
    estimatedHeight,
    control = "switch",
    styleOverrides,
    descriptionButton,
    buttonProps,
    titleBadge,
    action,
    customControl
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    "data-testid": id,
    borderRadius: "default",
    border: "default",
    background: "grayLightest"
  }, styleOverrides), /*#__PURE__*/React__default.createElement(Flex$1, {
    p: "m",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "40px"
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    flex: 5,
    flexDirection: "column",
    pr: "8px"
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    alignItems: "center"
  }, icon && /*#__PURE__*/React__default.createElement(Icon$1, {
    pr: "s",
    iconId: icon
  }), /*#__PURE__*/React__default.createElement(Text, {
    id: "toggle-box-title",
    font: "ui.regularBold",
    mr: "s"
  }, title), typeof titleBadge === "string" && /*#__PURE__*/React__default.createElement(Badge, {
    id: "".concat(title, "-upgrade"),
    text: titleBadge
  }), typeof titleBadge === "object" && (titleBadge === null || titleBadge === void 0 ? void 0 : titleBadge.text) && /*#__PURE__*/React__default.createElement(Badge, _extends({
    id: "".concat(title, "-upgrade")
  }, titleBadge))), description && /*#__PURE__*/React__default.createElement(Text, {
    id: "toggle-box-description",
    mt: "xs",
    m: 0
  }, description, descriptionButton && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: descriptionButton.onClick,
    text: descriptionButton.text,
    buttonStyle: "tertiary"
  })))), action, control === "switch" && !customControl && /*#__PURE__*/React__default.createElement("div", {
    className: "toggle"
  }, /*#__PURE__*/React__default.createElement(Switch$1, {
    id: "toggle-box-switch",
    isOn: typeof isOn === "boolean" ? isOn : isOpen,
    disabled: disabled,
    size: "small",
    onToggle: toggledOn => {
      onToggle(toggledOn);
    }
  })), control === "button" && !customControl && /*#__PURE__*/React__default.createElement(Button$1, _extends({
    disabled: disabled
  }, buttonProps)), customControl && /*#__PURE__*/React__default.createElement(Fragment, null, customControl)), children && /*#__PURE__*/React__default.createElement(ContentBox, {
    "data-testid": "toggle-box-content",
    isOpen: isOpen,
    estimatedHeight: estimatedHeight,
    py: isOpen ? "m" : "0",
    px: "m",
    borderTop: "default",
    overflow: "hidden"
  }, children));
};
var ToggleBox$1 = ToggleBox;

var keyNames = {
  backspace: "Backspace",
  tab: "Tab",
  enter: "Enter",
  escape: "Escape",
  delete: "Delete",
  shift: "Shift",
  meta: "Meta",
  alt: "Alt",
  control: "Control",
  comma: ",",
  space: " ",
  forwardSlash: "/",
  leftArrow: "ArrowLeft",
  rightArrow: "ArrowRight",
  upArrow: "ArrowUp",
  downArrow: "ArrowDown"
};

const _excluded$b = ["title", "isHighlighted"],
  _excluded2 = ["inputValue", "onChange", "autoFocus", "tokens", "onAddToken", "onRemoveToken", "suggestions", "renderEmptySuggestions", "TokenComponent", "SuggestionComponent", "children"];
const InputValueWrapper = styled(Flex$1).attrs(props => {
  var _props$theme;
  return {
    background: "white",
    px: "xs",
    py: "xxs",
    flex: "1 1 auto",
    border: "1px ".concat(props.isFocused ? "focus" : "border", " solid"),
    borderRadius: getBorderRadius(props === null || props === void 0 || (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.themeName, "default"),
    alignItems: "center"
  };
}).withConfig({
  displayName: "TokenInput__InputValueWrapper"
})(["outline:none;cursor:text;"]);
const ItemWrapper = styled(Flex$1).attrs({
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  flex: "1 1 auto"
}).withConfig({
  displayName: "TokenInput__ItemWrapper"
})([""]);
const inputClassName = "input-style";
const StyledAutosizeInput = styled(AutosizeInput).attrs({
  inputClassName
}).withConfig({
  displayName: "TokenInput__StyledAutosizeInput"
})(["flex:1;.", "{width:100% !important;min-width:75px;padding:0;margin:4px;border:none;outline:none;cursor:inherit;background-color:transparent;}"], inputClassName);
const DefaultTokenComponent = styled(Flex$1).attrs(props => {
  return {
    m: "xs",
    pl: "s",
    pr: "xs",
    borderRadius: "default",
    backgroundColor: props.isValid ? "primaryColor" : "error",
    alignItems: "center"
  };
}).withConfig({
  displayName: "TokenInput__DefaultTokenComponent"
})([""]);
const DefaultSuggestionComponent = _ref => {
  let {
      title,
      isHighlighted
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$b);
  return /*#__PURE__*/React__default.createElement(PopupMenu.Item, _extends({
    isActive: isHighlighted,
    title: title
  }, rest));
};
const TokenInput = _ref2 => {
  let {
      inputValue: providedValue = null,
      onChange,
      autoFocus,
      tokens,
      onAddToken,
      onRemoveToken: onRemoveToken,
      suggestions,
      renderEmptySuggestions,
      TokenComponent = DefaultTokenComponent,
      SuggestionComponent = DefaultSuggestionComponent,
      children
    } = _ref2,
    styleProps = _objectWithoutProperties(_ref2, _excluded2);
  const [cachedValue, setCachedValue] = useState("");
  const [isFocused, setFocused] = useState(false);
  const currentValue = providedValue === null ? cachedValue : providedValue;
  const popupSource = useMemo(() => factory.genUUID(), []);
  const inputWrapperRef = useRef(null);
  const addToken = useCallback(text => {
      if (!text || !onAddToken) return;
      onAddToken(text);
      setCachedValue("");
    }, [onAddToken]),
    removeToken = useCallback(index => {
      onRemoveToken(index);
    }, [onRemoveToken]),
    popToken = useCallback(() => {
      if (tokens.length === 0) return;
      return removeToken(tokens.length - 1);
    }, [tokens, removeToken]);
  const {
    getInputProps,
    getMenuProps,
    getItemProps,
    isOpen,
    highlightedIndex
  } = useCombobox({
    inputValue: currentValue,
    items: suggestions !== null && suggestions !== void 0 ? suggestions : [],
    defaultIsOpen: false,
    itemToString: () => "",
    onStateChange(_ref3) {
      var _ref4;
      let {
        inputValue: newInputValue,
        type,
        selectedItem: newSelectedItem
      } = _ref3;
      switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          addToken((_ref4 = newSelectedItem !== null && newSelectedItem !== void 0 ? newSelectedItem : newInputValue) !== null && _ref4 !== void 0 ? _ref4 : currentValue);
          setCachedValue("");
          break;
        case useCombobox.stateChangeTypes.InputKeyDownEnd:
          addToken(newInputValue);
          break;
        case useCombobox.stateChangeTypes.InputBlur:
          addToken(newInputValue !== null && newInputValue !== void 0 ? newInputValue : currentValue);
          setFocused(false);
          break;
        case useCombobox.stateChangeTypes.InputChange:
          onChange === null || onChange === void 0 || onChange(newInputValue);
          setCachedValue(newInputValue);
          break;
      }
    }
  });
  const inputProps = getInputProps();
  const onKeyDown = useCallback(e => {
      switch (e.key) {
        case keyNames.backspace:
        case keyNames.delete:
          {
            if (currentValue === "") {
              e.preventDefault();
              popToken();
              return;
            }
            break;
          }
      }
      inputProps.onKeyDown(e);
    }, [currentValue, inputProps, popToken]),
    onFocus = useCallback(() => {
      setFocused(true);
    }, []);
  function renderSuggestions() {
    var _suggestions$length, _inputWrapperRef$curr;
    const suggestionCount = (_suggestions$length = suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) !== null && _suggestions$length !== void 0 ? _suggestions$length : 0;
    const emptyComponent = suggestionCount === 0 ? renderEmptySuggestions === null || renderEmptySuggestions === void 0 ? void 0 : renderEmptySuggestions() : null;
    const hasContent = Boolean(suggestionCount > 0 || emptyComponent);
    const width = (_inputWrapperRef$curr = inputWrapperRef.current) === null || _inputWrapperRef$curr === void 0 ? void 0 : _inputWrapperRef$curr.getBoundingClientRect().width;
    return /*#__PURE__*/React__default.createElement(PopupMenu, _extends({
      source: popupSource,
      open: isOpen && hasContent,
      width: width
    }, getMenuProps(), {
      close: noop
    }), emptyComponent && /*#__PURE__*/React__default.createElement(PopupMenu.Section, null, emptyComponent), suggestionCount > 0 && /*#__PURE__*/React__default.createElement(PopupMenu.Section, null, suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((sugg, index) => /*#__PURE__*/React__default.createElement("span", _extends({
      key: "item-".concat(index)
    }, getItemProps({
      item: sugg,
      index
    })), /*#__PURE__*/React__default.createElement(SuggestionComponent, {
      suggestion: sugg,
      isHighlighted: highlightedIndex === index,
      title: sugg.value
    })))));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputValueWrapper, _extends({
    "data-popup-source": popupSource,
    ref: inputWrapperRef,
    isFocused: isFocused,
    tabIndex: -1
  }, styleProps), /*#__PURE__*/React__default.createElement(ItemWrapper, null, (tokens === null || tokens === void 0 ? void 0 : tokens.map((token, idx) => /*#__PURE__*/React__default.createElement(TokenComponent, {
    "data-tooltip-source": token.id,
    isValid: token.isValid,
    key: "item-".concat(token.id),
    title: token.isValid ? "Valid email" : "Invalid: ".concat(token.invalidReason)
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: token.isValid ? "primaryColorTint" : "white",
    pr: "xs"
  }, token.value), /*#__PURE__*/React__default.createElement(Icon$1, {
    size: "16",
    iconId: "action.close",
    fill: "primaryColorTint",
    onClick: () => removeToken(idx)
  }), token.invalidReason && /*#__PURE__*/React__default.createElement(Tooltip, {
    direction: Tooltip.Direction.Top,
    source: token.id
  }, token.invalidReason)))) || null, /*#__PURE__*/React__default.createElement(StyledAutosizeInput, _extends({}, inputProps, {
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    autoFocus: autoFocus
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      whiteSpace: "nowrap"
    }
  }, children)), renderSuggestions());
};
var TokenInput$1 = TokenInput;

const _excluded$a = ["id", "title", "detail", "image", "cardStyle", "disabled", "selected", "onClick", "size"];
const Container$1 = styled(Flex$1).attrs({
  borderRadius: "default"
}).withConfig({
  displayName: "OptionCard__Container"
})(["cursor:", ";transition:background-color 0.4s;opacity:", ";&:hover{background:", ";}"], props => props.disabled && "not-allowed" || props.selectable && "pointer", props => props.disabled && "50%", props => props.selectable && getColor("grayLightest"));
const OptionCard = _ref => {
  let {
      id = null,
      title,
      detail = null,
      image = null,
      cardStyle = "default",
      disabled = false,
      selected = false,
      onClick = null,
      size = "regular"
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$a);
  function renderImage() {
    if (!image) return null;
    if (image.style === "iconOnly") {
      return /*#__PURE__*/React__default.createElement(Box$1, {
        mr: "m"
      }, /*#__PURE__*/React__default.createElement(Icon$1, {
        id: "optioncard-icon",
        size: "40",
        fill: "grayDarkest",
        iconId: image.icon
      }));
    }
    let radius;
    if (image.style === "rounded") radius = "default";
    if (image.style === "circle") radius = "50%";
    return /*#__PURE__*/React__default.createElement(Box$1, {
      borderRadius: radius,
      mr: "m",
      background: "grayLightest",
      overflow: "hidden"
    }, /*#__PURE__*/React__default.createElement(ImageView$1, {
      id: "optioncard-image",
      width: "40px",
      height: "40px",
      icon: image.icon,
      iconFill: "grayDarkest",
      src: image.src
    }));
  }
  const theme = useContext(ThemeContext);
  const accentColor = theme && theme.primaryColor || "primary";
  function renderAccessory() {
    switch (cardStyle) {
      case "radio":
        return /*#__PURE__*/React__default.createElement(Icon$1, {
          ml: "s",
          id: "optioncard-accessory",
          fill: accentColor,
          iconId: selected ? "radio-checked" : "radio-unchecked"
        });
      case "checkbox":
        return /*#__PURE__*/React__default.createElement(Icon$1, {
          ml: "s",
          id: "optioncard-accessory",
          fill: accentColor,
          iconId: selected ? "checkbox-checked" : "checkbox-unchecked"
        });
      case "disclosure":
        return /*#__PURE__*/React__default.createElement(Icon$1, {
          ml: "s",
          id: "optioncard-accessory",
          fill: "grayDarker",
          iconId: "arrow-right"
        });
      default:
        return null;
    }
  }
  const ariaAttributes = useMemo(() => {
    switch (cardStyle) {
      case "radio":
        return {
          role: "radio",
          "aria-checked": selected,
          "aria-disabled": disabled
        };
      case "checkbox":
        return {
          role: "checkbox",
          "aria-checked": selected,
          "aria-disabled": disabled
        };
      case "disclosure":
        return {
          role: "button"
        };
    }
  }, [cardStyle, disabled, selected]);
  const role = useMemo(() => {
    switch (cardStyle) {
      case "radio":
        return "radio";
      case "checkbox":
        return "checkbox";
      case "disclosure":
        return "button";
    }
  }, [cardStyle]);
  return /*#__PURE__*/React__default.createElement(Container$1, _extends({
    "data-testid": id !== null && id !== void 0 ? id : "option-card",
    mb: "8px",
    px: "16px",
    role: role,
    minHeight: size === "small" ? null : "80px",
    borderRadius: "default",
    py: size === "small" ? "12px" : "16px",
    alignItems: "center",
    border: selected && cardStyle !== "checkbox" ? "1px solid ".concat(accentColor) : "default",
    disabled: disabled,
    selectable: !disabled && cardStyle !== "default",
    onClick: disabled ? null : onClick
  }, ariaAttributes, rest), renderImage(), /*#__PURE__*/React__default.createElement(Flex$1, {
    flex: "10",
    flexDirection: "column"
  }, /*#__PURE__*/React__default.createElement(Text, {
    id: "optioncard-title",
    font: "ui.regularBold"
  }, title), detail && /*#__PURE__*/React__default.createElement(Text, {
    id: "optioncard-detail",
    font: size === "small" ? "ui.small" : "ui.regular"
  }, detail)), renderAccessory());
};
var OptionCard$1 = OptionCard;

var useRect = ref => {
  const [rect, setRect] = useState(getRect(ref ? ref.current : null));
  const handleResize = useCallback(() => {
    if (!ref.current) {
      return;
    }

    // Update client rect
    setRect(getRect(ref.current));
  }, [ref]);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    handleResize();
    if (typeof ResizeObserver === "function") {
      let resizeObserver = new ResizeObserver(() => handleResize());
      resizeObserver.observe(element);
      return () => {
        if (!resizeObserver) {
          return;
        }
        resizeObserver.disconnect();
        resizeObserver = null;
      };
    } else {
      // Browser support, remove freely
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [handleResize, ref]);
  return rect;
};
function getRect(element) {
  if (!element) {
    return {
      bottom: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      width: 0
    };
  }
  return element.getBoundingClientRect();
}

const ErrorCode = {
  unknown: 1,
  invalidParams: 103,
  unauthorized: 401,
  permissionDenied: 403,
  objectNotFound: 404,
  rateLimited: 429,
  serverError: 500,
  serviceUnavailable: 503,
  needsAdditionalConfirmation: 444,
  deprecatedAction: 900,
  deprecatedApi: 901,
  // Kits
  kitNotFound: 1100,
  kitAleadyExists: 1101,
  kitNotAccepted: 1102,
  versionNotFound: 1200,
  // Kit Collections
  kitCollectionAlreadyExists: 6101,
  kitCollectionNotFound: 6404,
  kitCollectionItemNotFound: 61404,
  // Sections
  sectionNotFound: 2100,
  sectionAlreadyExists: 2101,
  sectionNotAccepted: 2102,
  // Assets
  assetNotFound: 3100,
  assetAlreadyExists: 3101,
  assetNotAccepted: 3102,
  assetReferenceDenied: 3106,
  // Files
  fileTooLarge: 413,
  fileNotValid: 3300,
  fileNotAccepted: 3302,
  fileCutUnavailable: 3304,
  // Items
  itemNotFound: 3200,
  itemAlreadyExists: 3201,
  itemNotAccepted: 3202,
  // Users
  userNotFound: 5100,
  userAlreadyExists: 5101,
  userNotActive: 5102,
  // Space
  spaceNotAccepted: 7102,
  spaceNotFound: 7101,
  spaceMemberLimitReached: 7103,
  featureUnavailable: 7104,
  // Invitations & Joining
  invitationAlreadyAccepted: 7201,
  invitationNotFound: 7204,
  joinLinkNotValid: 7304,
  // SSO
  organizationNotFound: 8101,
  organizationNotConfigured: 8304,
  invalidSsoToken: 8305,
  organizationInviteNeeded: 8403,
  // Figma Auth
  figmaAuthNotFound: 10404,
  figmaAuthInvalid: 10403,
  // Figma import
  figmaInvalidType: 11103,
  figmaNotFound: 11404,
  figmaRateLimited: 11503,
  // Fields
  fieldNotFound: 12404,
  fieldLimitReached: 12103,
  // Field options
  optionNotFound: 13404,
  // MFA
  totpRequired: 14403,
  totpInvalid: 14401,
  totpAlreadyUsed: 14101,
  // Google Auth
  googleAuthConfirmationRequired: 15101,
  // Download requests
  downloadRequiresIdentity: 16401,
  downloadRequiresVerifiedIdentity: 16403,
  downloadRequestPending: 16800,
  downloadRequestDenied: 16801,
  // Portal
  portalNotFound: 17404
};
const validCodes = new Set(Object.values(ErrorCode));
function isError(obj) {
  return obj && obj instanceof Error === false && validCodes.has(obj.code) && obj.message;
}

/**
 * Returns the cookieName value based on the _lingoConfig environment
 */

const apiCSRFCookieNames = {
  development: "api_dev_csrftoken",
  staging: "api_staging_csrftoken",
  test: "api_test_csrftoken",
  production: "api_csrftoken"
};
const getCSRFCookieName = () => {
  const env = _lingoConfig.environment;
  if (!env) throw new Error("Environment missing from config");
  return apiCSRFCookieNames[env] || apiCSRFCookieNames.production;
};

function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Entity = {
  user: "user",
  space: "space",
  spacePreview: "spacePreview",
  spaceMember: "spaceMember",
  apiToken: "apiToken",
  charge: "charge",
  kitCollection: "kitCollection",
  kitCollectionItem: "kitCollectionItem",
  portalItem: "portalItem",
  portal: "portal",
  portalPreview: "portalPreview",
  portalMember: "portalMember",
  kit: "kit",
  kitVersion: "kitVersion",
  kitMember: "kitMember",
  invitation: "invitation",
  section: "section",
  item: "item",
  asset: "asset",
  assetSearch: "assetSearch",
  assetFilters: "assetFilters",
  search: "search",
  spaceSearch: "spaceSearch",
  customField: "customField",
  assetView: "assetView",
  analytics: "analytics",
  downloadRequest: "downloadRequest",
  contextIdentification: "contextIdentification",
  contextIdentificationPreview: "contextIdentificationPreview",
  directLink: "directLink"
};
const callApi$1 = _ref => {
  let {
    endpoint,
    entity,
    method = "GET",
    data,
    formData,
    query,
    onUploadProgress
  } = _ref;
  if (data && formData) {
    throw new Error("Cannot dispatch CALL_API action with both data and formData.");
  }
  return new Promise((resolve, reject) => {
    let fullUrl = getApiServiceURL(endpoint);
    if (query) {
      fullUrl += "?".concat(QueryString.stringify(query));
    }
    const xhr = new XMLHttpRequest();
    xhr.open(method, fullUrl, true);
    xhr.withCredentials = true;
    setRequestHeaders(xhr, data, method);

    // Note: if we ever refactor this to use fetch,
    // we will lose the ability to track upload progress
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#monitoring_progress
    if (onUploadProgress && formData) {
      xhr.upload.onprogress = event => {
        if (event.lengthComputable) {
          const percentComplete = event.loaded / event.total * 100;
          onUploadProgress === null || onUploadProgress === void 0 || onUploadProgress(percentComplete);
        }
      };
    }
    // eslint-disable-next-line func-names
    xhr.onload = function () {
      try {
        if (!this.responseText) {
          return reject({
            error: true,
            code: this.status,
            message: "An error occured"
          });
        }
        const response = JSON.parse(this.responseText);
        if (this.status === 400) {
          reportError(fullUrl, data, this.status, response.error);
        }
        if (response.success) {
          if (entity) {
            const normalizer = normalizers[entity];
            if (!normalizer) {
              // This should never happen
              throw new Error("No normalizer found for entity: ".concat(entity));
            }
            return resolve(normalizer(response.result));
          }
          return resolve({
            result: response.result
          });
        }
        let error = response.error;

        // Some www endpoints just return strings still
        if (typeof error === "string") {
          error = {
            message: error,
            code: 0
          };
        }
        return reject(_objectSpread$5({
          error: true
        }, error));
      } catch (e) {
        var _e$message;
        // If any response handling code fails, report error, then resolve as a failure
        if (_lingoConfig.environment !== "production") {
          console.error(e, e.stack);
        }
        return reject({
          code: ErrorCode.unknown,
          message: (_e$message = e.message) !== null && _e$message !== void 0 ? _e$message : "An unknown error occurred"
        });
      }
    };
    xhr.onerror = e => {
      console.error(e);
      reject({
        code: ErrorCode.unknown,
        message: "Unable to complete request"
      });
    };
    xhr.send(getRequestBody(data, formData));
  });
};
const getRequestBody = function (data, formData) {
  if (formData) return formData;
  if (data) return JSON.stringify(data);
  return null;
};
const setRequestHeaders = function (xhr, data, method) {
  const accessToken = localStorage.getItem("token");
  if (accessToken) {
    xhr.setRequestHeader("Authorization", "Bearer ".concat(accessToken));
  }
  xhr.setRequestHeader("X-lingo-fingerprint", getFingerprint());
  const csrfCookieName = getCSRFCookieName(),
    csrfCookieValue = Cookie.get(csrfCookieName);
  if (csrfCookieValue && !csrfSafeMethod(method)) {
    xhr.setRequestHeader("X-CSRFToken", csrfCookieValue);
  }
  if (data) {
    xhr.setRequestHeader("Content-Type", "application/json");
  }
  return xhr;
};
const getFingerprint = function () {
  let fingerprint = Cookie.get("user_fingerprint");
  if (!fingerprint) {
    var _getCustomDomainCompo;
    fingerprint = v4();
    const domain = (_getCustomDomainCompo = getCustomDomainComponents().host) !== null && _getCustomDomainCompo !== void 0 ? _getCustomDomainCompo : "lingoapp.com";
    Cookie.set("user_fingerprint", fingerprint, {
      expires: 365,
      domain
    });
  }
  return fingerprint;
};
const csrfSafeMethod = function (method) {
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
};
const reportError = function (url, data, statusCode, errorObj) {
  const message = getResponseErrorMessage(errorObj);
  if (message && _lingoConfig.environment !== "production") {
    console.error("Error from ".concat(url, ": ").concat(message));
  }
};
const getResponseErrorMessage = function (error) {
  // Take an error object, and return a string to display in error tracking service
  if (typeof error === "string") return error;
  if (error.message) return error.message;
};

function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const callApi = function (endpoint, schema) {
  let method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "GET";
  let data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let formData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  if (data && formData) {
    throw new Error("Cannot dispatch CALL_API action with both data and formData.");
  }
  return new Promise(resolve => {
    const fullUrl = getApiServiceURL(endpoint),
      xhr = new XMLHttpRequest();
    xhr.open(method, fullUrl, true);
    xhr.withCredentials = true;
    setRequestHeaders(xhr, data, method);

    // eslint-disable-next-line func-names
    xhr.onload = function () {
      try {
        if (!this.responseText) {
          resolve({
            error: true,
            code: this.status,
            message: "An error occured"
          });
          return;
        }
        const response = JSON.parse(this.responseText);

        // Most of the meaningful error responses from api/www come with code 400
        if (this.status === 400) {
          reportError(fullUrl, data, this.status, response.error);
        }
        if (response.success) {
          return schema ? resolve(normalizeResponse(response, schema)) : resolve(response.result);
        }
        let error = response.error;

        // Some www endpoints just return strings still
        if (typeof error === "string") {
          error = {
            message: error,
            code: 0
          };
        }
        return resolve(_objectSpread$4({
          error: true
        }, error));
      } catch (e) {
        // If any response handling code fails, report error, then resolve as a failure
        if (_lingoConfig.environment !== "production") {
          console.error(e);
        }
        return resolve({
          error: true,
          code: 0,
          message: "An error occured"
        });
      }
    };
    xhr.onerror = () => {
      resolve({
        code: ErrorCode.unknown,
        error: true,
        message: "Unable to complete request"
        // status: xhr.statusText,
      });
    };
    xhr.send(getRequestBody(data, formData));
  });
};
const callApiWithRawResponse = function (endpoint) {
  let method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GET";
  let data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let formData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (data && formData) {
    throw new Error("Cannot dispatch CALL_API action with both data and formData.");
  }
  return new Promise(resolve => {
    const fullUrl = getApiServiceURL(endpoint),
      xhr = new XMLHttpRequest();
    xhr.open(method, fullUrl, true);
    xhr.withCredentials = true;
    setRequestHeaders(xhr, data, method);

    // eslint-disable-next-line func-names
    xhr.onload = function () {
      try {
        if (!this.responseText) {
          resolve({
            error: true,
            code: this.status,
            message: "An error occured"
          });
          return;
        }
        const response = JSON.parse(this.responseText);

        // Most of the meaningful error responses from api come with code 400
        if (this.status === 400) {
          reportError(fullUrl, data, this.status, response.error);
        }
        return resolve(response);
      } catch (e) {
        // If any response handling code fails, report error, then resolve as a failure
        if (_lingoConfig.environment === "development") {
          console.error(e);
        }
        return resolve({
          error: true,
          code: 0
        });
      }
    };
    xhr.onerror = () => {
      resolve({
        code: ErrorCode.unknown,
        error: true,
        message: "Unable to complete request",
        status: xhr.statusText
      });
    };
    xhr.send(getRequestBody(data, formData));
  });
};
const normalizeResponse = function (response, normalizer) {
  return normalizer(response.result);
};

// Action key that carries API call info interpreted by this Redux middleware.
const CALL_API = Symbol("Call API");

/**
 *
 * @param {object} props properties of the requests to make
 *
 * types: an array of 3 action types [initial, ]
 */
function makeAction(props) {
  return {
    [CALL_API]: props
  };
}

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.

var apiMiddleware = store => next => action => {
  const callAPI = action[CALL_API];
  if (typeof callAPI === "undefined") {
    return next(action);
  }
  let {
    endpoint
  } = callAPI;
  const {
    schema,
    types,
    data,
    method,
    formData
  } = callAPI;
  if (typeof endpoint === "function") {
    endpoint = endpoint(store.getState());
  }
  if (typeof endpoint !== "string") {
    throw new Error("Specify a string endpoint URL.");
  }
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error("Expected an array of three action types.");
  }
  if (!types.every(type => typeof type === "string")) {
    throw new Error("Expected action types to be strings.");
  }
  function actionWith(props) {
    const finalAction = _objectSpread$4(_objectSpread$4({}, action), props);
    delete finalAction[CALL_API];
    return finalAction;
  }
  const [requestType, successType, failureType] = types;

  // Initial action to trigger loading state or optimistic update
  next(actionWith({
    type: requestType,
    apiRequest: true
  }));
  return callApi(endpoint, schema, method, data, formData).then(response => {
    if (response.error) {
      return next(actionWith({
        type: failureType,
        apiResponse: true,
        // statusCode: response.code,
        error: response
      }));
    }
    return next(actionWith({
      type: successType,
      response,
      apiResponse: true,
      page: callAPI.page
    }));
  });
};

const LottieContainer = styled(Box$1).withConfig({
  displayName: "LottieAnimation__LottieContainer"
})(["position:absolute;top:0;left:0;height:100%;width:100%;opacity:0;transition:opacity 0.3s ease;", ""], props => props.loaded && "\n    opacity: 1;\n  ");
const AbsoluteContainer = styled(Box$1).withConfig({
  displayName: "LottieAnimation__AbsoluteContainer"
})(["position:absolute;top:0;left:0;height:100%;width:100%;display:flex;justify-content:center;align-items:center;"]);
const LottieAnimation = _ref => {
  let {
    permalink
  } = _ref;
  const lottieContainerRef = useRef();
  const [animationData, setAnimationData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  if (!permalink.includes("/v4/")) console.warn("Lottie permalink must be a valid API url");
  let endpoint = permalink.split("/v4/")[1];
  if (endpoint.includes("?")) endpoint += "&response=data";else endpoint += "?response=data";

  /**
   * Need to fetch the raw json from our asset permalink
   */
  useEffect(() => {
    setLoaded(false);
    setFailed(false);
    callApiWithRawResponse(endpoint).then(data => {
      if (data.error) return setFailed(true);
      setAnimationData(data);
      setLoaded(true);
    }).catch(err => {
      console.log({
        err
      });
      setFailed(true);
    });
  }, [endpoint, permalink]);

  /**
   * Once asset json has been fetched, initialize the animation
   */
  useEffect(() => {
    if (!animationData) return;
    try {
      const lottieInstance = lottie.loadAnimation({
        container: lottieContainerRef.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData
      });

      /**
       * If the JSON can be fetched, but it's invalid upon loading
       */
      lottieInstance.addEventListener("data_failed", () => setFailed(true));
      return () => {
        lottieInstance.destroy();
      };
    } catch (err) {
      console.error("Failed to initialize Lottie animation:", err);
      setFailed(true);
    }
  }, [animationData, permalink]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, !loaded && !failed && /*#__PURE__*/React__default.createElement(AbsoluteContainer, null, /*#__PURE__*/React__default.createElement(ActivityIndicator$1, {
    size: "small",
    color: getColor("grayDark"),
    center: true
  })), failed && /*#__PURE__*/React__default.createElement(AbsoluteContainer, null, /*#__PURE__*/React__default.createElement(Notice$1, {
    noticeStyle: "error",
    message: "Oops! Failed to load Lottie JSON."
  })), /*#__PURE__*/React__default.createElement(LottieContainer, {
    loaded: loaded,
    ref: lottieContainerRef
  }));
};
var LottieAnimation$1 = LottieAnimation;

const VideoInner = Box$1;
const VideoContainer = styled(Box$1).attrs({
  position: "relative"
}).withConfig({
  displayName: "Video__VideoContainer"
})(["margin:0 auto;video,.mask{height:100%;width:100%;position:absolute;top:0;left:0;}.mask{&:after{content:\"\";position:absolute;top:0;left:0;height:100%;width:100%;background:rgba(0,0,0,0.2);z-index:2;}img{position:relative;z-index:0;width:100%;}svg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer;z-index:5;filter:drop-shadow(0px 4px 14px rgba(42,42,42,0.12)) drop-shadow(0px 1px 4px rgba(42,42,42,0.2));}}"]);
const Video = _ref => {
  let {
    src,
    placeholder,
    type,
    dimensions,
    muted = true
  } = _ref;
  const [playing, setPlaying] = useState(false),
    videoRef = useRef(),
    playVideo = useCallback(() => {
      videoRef.current.play().catch(() => {
        videoRef.current.muted = muted;
        return videoRef.current.play();
      });
    }, [muted]);
  const [width, height] = dimensions.split("x").map(d => Number(d)),
    videoContainerProps = {
      width: "100%",
      maxWidth: width
    },
    videoInnerProps = {
      width: "100%",
      pb: "".concat(height / width * 100, "%")
    };
  if (!src) return null;
  return /*#__PURE__*/React__default.createElement(VideoContainer, videoContainerProps, /*#__PURE__*/React__default.createElement(VideoInner, videoInnerProps, playing ? /*#__PURE__*/React__default.createElement("video", {
    ref: videoRef,
    poster: placeholder,
    controls: true,
    autoPlay: true,
    onCanPlay: playVideo
  }, /*#__PURE__*/React__default.createElement("source", {
    src: src,
    type: "video/".concat(type.toLowerCase().replace("mov", "mp4"))
  }), /*#__PURE__*/React__default.createElement("p", null, "Sorry, this video can't be played in this browser.")) : /*#__PURE__*/React__default.createElement("div", {
    className: "mask"
  }, placeholder && /*#__PURE__*/React__default.createElement("img", {
    src: placeholder
  }), /*#__PURE__*/React__default.createElement(Icon$1, {
    onClick: () => setPlaying(true),
    fill: "white",
    iconId: "play-video",
    size: "60"
  }))));
};
var Video$1 = Video;

const _excluded$9 = ["asset", "className", "background", "maxHeight", "imageSize", "pointerEvents"];
const stretchingVideoTestId = "stretching-asset-video";
const stretchingImageTestId = "stretching-asset-image";
const stretchingLottieTestId = "stretching-asset-lottie";
const spinning = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(960deg);}"]);
const StretchingAssetContainer = styled(Box$1).attrs(props => {
  return {
    width: "100%",
    borderRadius: "default",
    p: props.p || "m",
    pointerEvents: props.pointerEvents || "auto"
  };
}).withConfig({
  displayName: "StretchingAsset__StretchingAssetContainer"
})(["", ""], props => props.isImage && css(["& svg{animation:", " 1s ease-in-out infinite alternate;transform-origin:50% 50%;}& svg::selection{background:transparent;}"], spinning));
const MotionContainer = styled(Box$1).withConfig({
  displayName: "StretchingAsset__MotionContainer"
})(["position:relative;"]);
const LoadingContainer = styled(Box$1).withConfig({
  displayName: "StretchingAsset__LoadingContainer"
})(["width:100%;"]);
const StretchingAsset = _ref => {
  let {
      asset,
      className,
      background,
      maxHeight,
      imageSize,
      pointerEvents
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$9);
  const measuredRef = useRef(null);
  const {
    width
  } = useRect(measuredRef);
  const paddingInt = getContainerPadding(measuredRef.current);
  const height = getStretchingAssetHeight(asset.dimensions, width - paddingInt, maxHeight);
  const isImage = [AssetType.jpg, AssetType.png, AssetType.gif].includes(asset.type),
    isGif = [AssetType.gif].includes(asset.type),
    isLottie = [AssetType.lottie].includes(asset.type),
    isVideo = [AssetType.mp4, AssetType.mov].includes(asset.type);
  const thumbnailMap = {
    large: asset.thumbnails ? asset.thumbnails["1232"] : asset.permalink,
    medium: asset.thumbnails ? asset.thumbnails["480"] : asset.permalink,
    small: asset.thumbnails ? asset.thumbnails["292"] : asset.permalink,
    full: asset.permalink
  };
  const isProcessing = asset.meta && asset.meta.assetProcessing === "processing";
  function responsiveImageUrl() {
    // If it's a GIF, return the original file, as the generated thumbs are static
    if (isGif) return thumbnailMap.full;

    // If an image size has been specified, return that one
    if (imageSize && thumbnailMap[imageSize]) {
      return thumbnailMap[imageSize];
    }

    // If no explicit image size is set, load the proper thumnail size given the ref width
    const [assetWidth, assetHeight] = asset.dimensions.split("x").map(d => parseInt(d, 10));
    const containerSize = Math.max(width, height),
      assetSize = Math.max(assetWidth, assetHeight),
      desiredSize = Math.min(assetSize, containerSize);
    if (desiredSize === 0) return null;
    if (desiredSize <= 292) return thumbnailMap.small;
    if (desiredSize <= 480) return thumbnailMap.medium;
    if (desiredSize <= 1232) return thumbnailMap.large;
    return thumbnailMap.full;
  }
  function renderAssetComponent() {
    // Loading container has an arbitrary fallback height of 120px for when user
    // uploads content and it's still processing without dimension data.

    if (isProcessing) return /*#__PURE__*/React__default.createElement(LoadingContainer, {
      height: height || "120px"
    }, /*#__PURE__*/React__default.createElement(ActivityIndicator$1, {
      size: "small",
      center: true,
      color: getColor("grayDark")
    }));
    if (isVideo) return /*#__PURE__*/React__default.createElement(MotionContainer, {
      "data-testid": stretchingVideoTestId,
      height
    }, /*#__PURE__*/React__default.createElement(Video$1, {
      src: asset.permalink,
      placeholder: responsiveImageUrl(),
      dimensions: asset.dimensions,
      type: asset.type,
      muted: false
    }));
    if (isLottie) return /*#__PURE__*/React__default.createElement(MotionContainer, {
      "data-testid": stretchingLottieTestId,
      height
    }, /*#__PURE__*/React__default.createElement(LottieAnimation$1, {
      permalink: asset.permalink
    }));
    return /*#__PURE__*/React__default.createElement(ImageView$1, {
      id: stretchingImageTestId,
      src: responsiveImageUrl(),
      icon: "spinner",
      background: background,
      height: height
    });
  }
  return /*#__PURE__*/React__default.createElement(StretchingAssetContainer, _extends({
    ref: measuredRef,
    className: className,
    background: background,
    isImage: isImage,
    pointerEvents: pointerEvents
  }, rest), renderAssetComponent());
};
const getContainerPadding = el => {
  if (!el) return 0;
  const extractPixelInt = (computedStyle, propertyName) => {
    const propVal = computedStyle.getPropertyValue(propertyName);
    const propValNum = propVal.match(/[0-9]+/);
    if (propValNum !== null) return parseInt(propValNum[0], 10);
    return 0;
  };
  const compStyle = getComputedStyle(el);
  return extractPixelInt(compStyle, "padding-left") + extractPixelInt(compStyle, "padding-right");
};
const getStretchingAssetHeight = function (dimensions, maxWidth) {
  let maxHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
  let result = 0;
  const [width, height] = dimensions.split("x").map(d => parseInt(d, 10));
  if (width <= maxWidth) {
    result = height;
  } else {
    const scaleBy = maxWidth / width;
    result = height * scaleBy;
  }
  return Math.min(result, maxHeight);
};
var StretchingAsset$1 = StretchingAsset;

const Wrapper$4 = styled.div.withConfig({
  displayName: "LinkPopupMenu__Wrapper"
})(["padding:16px;gap:8px;display:flex;flex-direction:column;"]);
const LinkPopupMenu = _ref => {
  var _editor$getAttributes;
  let {
    editor,
    setEditingLabel,
    source,
    labelRef,
    isFocused
  } = _ref;
  const selectedText = editor.state.selection.content().size ? editor.state.doc.textBetween(editor.state.selection.from, editor.state.selection.to) : "";
  const [url, setUrl] = useState((editor === null || editor === void 0 || (_editor$getAttributes = editor.getAttributes("link")) === null || _editor$getAttributes === void 0 ? void 0 : _editor$getAttributes.href) || "");
  const [label, setLabel] = useState(selectedText);
  const setLink = useCallback(() => {
    if (!url || url.trim() === "") {
      editor.chain().focus().extendMarkRange("link").unsetLink().run();
      setEditingLabel(false);
      return;
    }
    const formattedUrl = url.startsWith("http") ? url : "https://".concat(url);
    const {
      from,
      to
    } = editor.state.selection;
    const hasLabel = label.trim().length > 0;
    editor.chain().focus();
    if (hasLabel) {
      editor.chain().deleteRange({
        from,
        to
      }).insertContentAt(from, {
        type: "text",
        text: label.trim(),
        marks: [{
          type: "link",
          attrs: {
            href: formattedUrl
          }
        }]
      }).run();
    } else {
      editor.chain().extendMarkRange("link").setLink({
        href: formattedUrl
      }).run();
    }
    setEditingLabel(false);
  }, [editor, url, label, setEditingLabel]);
  if (!isFocused) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PopupMenu, {
    source: source,
    vPos: "floatBelow",
    hPos: "alignLeft",
    stayOpenOnClick: true,
    style: {
      width: "300px"
    },
    close: () => setEditingLabel(false)
  }, /*#__PURE__*/React__default.createElement(Wrapper$4, {
    ref: labelRef
  }, /*#__PURE__*/React__default.createElement(Input$2, {
    label: "Label",
    placeholder: "example text",
    value: label,
    onChange: e => setLabel(e.target.value)
  }), /*#__PURE__*/React__default.createElement(Input$2, {
    label: "URL",
    value: url,
    onChange: e => setUrl(e.target.value)
  }), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: setLink,
    text: "Insert Link"
  }))));
};
var LinkPopupMenu$1 = /*#__PURE__*/React__default.memo(LinkPopupMenu);

const MID_WIDTH = 580;
const NARROW_WIDTH = 500;
function useEditorToolbarLayout(_ref) {
  let {
    rootRef,
    toolbarGroups,
    setMainButtons,
    setOverflowButtons
  } = _ref;
  const resizeObserverRef = useRef(null);
  useLayoutEffect(() => {
    const node = rootRef.current;
    if (!node) return;
    const handleResize = entry => {
      const width = entry.contentRect.width;
      if (width < NARROW_WIDTH) {
        setMainButtons(toolbarGroups.slice(0, 1));
        setOverflowButtons(toolbarGroups.slice(1));
      } else if (width < MID_WIDTH) {
        setMainButtons(toolbarGroups.slice(0, 2));
        setOverflowButtons(toolbarGroups.slice(2));
      } else {
        setMainButtons(toolbarGroups);
        setOverflowButtons([]);
      }
    };
    const observer = new ResizeObserver(_ref2 => {
      let [entry] = _ref2;
      if (entry) handleResize(entry);
    });
    observer.observe(node);
    resizeObserverRef.current = observer;
    return () => {
      observer.disconnect();
    };
  }, [rootRef, toolbarGroups, setMainButtons, setOverflowButtons]);
}

const getToolbarGroups = (editor, setEditingLabel, source) => [{
  id: "section1",
  buttons: [{
    action: () => editor.chain().focus().toggleBold().run(),
    iconId: "editor.bold",
    activeCondition: "bold"
  }, {
    action: () => editor.chain().focus().toggleItalic().run(),
    iconId: "editor.italic",
    activeCondition: "italic"
  }, {
    action: () => editor.chain().focus().toggleUnderline().run(),
    iconId: "editor.underline",
    activeCondition: "underline"
  }, {
    action: () => editor.chain().focus().toggleStrike().run(),
    iconId: "editor.strike",
    activeCondition: "strike"
  }]
}, {
  id: "section2",
  buttons: [{
    action: () => editor.chain().focus().toggleBulletList().run(),
    iconId: "editor.unordered-list",
    activeCondition: "bulletList"
  }, {
    action: () => editor.chain().focus().toggleOrderedList().run(),
    iconId: "editor.ordered-list",
    activeCondition: "orderedList"
  }, {
    action: () => setEditingLabel(true),
    iconId: "editor.link",
    activeCondition: "link",
    popupSource: source
  }]
}, {
  id: "section3",
  buttons: [{
    action: () => editor.chain().focus().toggleCode().run(),
    iconId: "editor.code",
    activeCondition: "code"
  }, {
    action: () => editor.chain().focus().setHorizontalRule().run(),
    iconId: "editor.line",
    activeCondition: "line"
  }, {
    action: () => editor.chain().focus().toggleBlockquote().run(),
    iconId: "editor.quote",
    activeCondition: "blockquote"
  }]
}];

const ToolbarButton = styled.button.withConfig({
  displayName: "Toolbar__ToolbarButton"
})(["position:relative;display:flex;justify-content:center;align-items:center;width:", ";height:32px;padding:8px;border-radius:4px;&.is-active{background-color:", ";}&:hover{background-color:", ";}"], props => props.textButton ? "95px" : "32px", getColor("grayLighter"), getColor("grayLighter"));
const ToolbarContainer = styled(Box$1).withConfig({
  displayName: "Toolbar__ToolbarContainer"
})(["position:", ";top:", ";display:flex;width:fit-content;gap:8px;box-shadow:0px 0.33px 1.3px rgba(0,0,0,0.03),0px 1.54px 5.1px rgba(0,0,0,0.04),0px 4px 16px rgba(0,0,0,0.07);background:white;border-radius:4px;justify-content:space-between;align-items:center;padding:8px;height:48px;font-size:16px;z-index:9;"], props => props.sticky ? "sticky" : "absolute", props => props.sticky ? "var(--editor-toolbar-offset, 0px)" : "-55px");
const Separator = styled(Box$1).attrs({
  background: "grayLighter",
  width: "1px",
  radius: "32px",
  height: "24px"
}).withConfig({
  displayName: "Toolbar__Separator"
})([""]);
const Toolbar$1 = _ref => {
  let {
    editor,
    source,
    setEditingLabel,
    refs,
    backgroundColorMenu,
    colorProps
  } = _ref;
  const {
    textOptionRef,
    rootRef,
    sentinelRef,
    toolbarRef,
    colorOptionRef
  } = refs;
  const {
    colorOptionsShown,
    showColorOptions,
    hideColorOptions,
    buttonBgColor
  } = colorProps;
  const [menuShown, showMenu, hideMenu] = useBoolean(false),
    [overflowMenuShown, showOverflowMenu, hideOverflowMenu] = useBoolean(false),
    textDropdownSource = useMemo(() => source + "-dropdown", [source]),
    overflowDropdownSource = useMemo(() => source + "-overflow", [source]),
    toolbarGroups = useMemo(() => getToolbarGroups(editor, setEditingLabel, source), [editor, setEditingLabel, source]),
    getBlockLabel = useCallback(() => {
      if (editor.isActive("heading", {
        level: 1
      })) return "Heading 1";
      if (editor.isActive("heading", {
        level: 2
      })) return "Heading 2";
      if (editor.isActive("paragraph")) return "Paragraph";
      return "Paragraph";
    }, [editor]);
  const [visibleGroups, setVisibleGroups] = useState(toolbarGroups);
  const [overflowGroups, setOverflowGroups] = useState([]);
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const sentinelEl = sentinelRef.current;
    if (!sentinelEl) return;
    const observer = new IntersectionObserver(_ref2 => {
      let [entry] = _ref2;
      setIsSticky(!entry.isIntersecting);
    }, {
      root: null,
      threshold: 0
    });
    observer.observe(sentinelEl);
    return () => {
      observer.disconnect();
    };
  }, [sentinelRef]);
  const SeparatorWrap = () => /*#__PURE__*/React__default.createElement(Flex$1, {
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Separator, null));
  const renderColorSelection = useCallback(() => {
    if (!backgroundColorMenu) return null;
    const fill = getIconFill(buttonBgColor);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ToolbarButton, {
      onClick: showColorOptions,
      "data-popup-source": source + "-color-selection",
      style: {
        backgroundColor: buttonBgColor
      }
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      fill: fill,
      size: "16px",
      iconId: "content.color"
    })), /*#__PURE__*/React__default.createElement(PopupMenu$2, {
      open: colorOptionsShown,
      close: hideColorOptions,
      source: source + "-color-selection",
      ref: colorOptionRef
    }, backgroundColorMenu), /*#__PURE__*/React__default.createElement(SeparatorWrap, null));
  }, [source, colorOptionsShown, showColorOptions, hideColorOptions, colorOptionRef, backgroundColorMenu, buttonBgColor]);
  const renderTextDropdown = useCallback(() => {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ToolbarButton, {
      "data-popup-source": textDropdownSource,
      onClick: showMenu,
      textButton: true
    }, /*#__PURE__*/React__default.createElement(Flex$1, {
      alignItems: "center",
      gap: "4px",
      width: "95px"
    }, /*#__PURE__*/React__default.createElement(Text, {
      font: "ui.smallBold"
    }, getBlockLabel()), /*#__PURE__*/React__default.createElement(Icon$1, {
      fill: "black",
      size: "12px",
      iconId: "navigation.chevron-down"
    }))), /*#__PURE__*/React__default.createElement(PopupMenu$2, {
      open: menuShown,
      close: hideMenu,
      source: textDropdownSource,
      ref: textOptionRef
    }, /*#__PURE__*/React__default.createElement(PopupItem, {
      onClick: () => editor.chain().focus().setParagraph().run(),
      title: "Paragraph",
      checked: editor.isActive("paragraph"),
      "aria-label": "Paragraph"
    }), /*#__PURE__*/React__default.createElement(PopupItem, {
      onClick: () => editor.chain().focus().setHeading({
        level: 1
      }).run(),
      title: "Heading 1",
      checked: editor.isActive("heading", {
        level: 1
      }),
      "aria-label": "Heading 1"
    }), /*#__PURE__*/React__default.createElement(PopupItem, {
      onClick: () => editor.chain().focus().setHeading({
        level: 2
      }).run(),
      title: "Heading 2",
      checked: editor.isActive("heading", {
        level: 2
      }),
      "aria-label": "Heading 2"
    })), /*#__PURE__*/React__default.createElement(SeparatorWrap, null));
  }, [menuShown, editor, showMenu, hideMenu, textDropdownSource, textOptionRef, getBlockLabel]);
  const renderMainButtons = useCallback(() => {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, visibleGroups.map((group, groupIndex) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: group.id
    }, /*#__PURE__*/React__default.createElement(Flex$1, {
      gap: "8px"
    }, group.buttons.map(button => /*#__PURE__*/React__default.createElement(ToolbarButton, {
      "aria-label": button.activeCondition,
      key: button.iconId,
      onClick: button.action,
      disabled: button.disabledCondition,
      className: editor.isActive(button.activeCondition) ? "is-active" : "",
      "data-popup-source": button === null || button === void 0 ? void 0 : button.popupSource
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      fill: "black",
      size: "16px",
      iconId: button.iconId
    })))), groupIndex < visibleGroups.length - 1 && /*#__PURE__*/React__default.createElement(SeparatorWrap, null))));
  }, [visibleGroups, editor]);
  const renderOverflowButtons = useCallback(() => {
    if (!overflowGroups.length) return null;
    const flatButtons = overflowGroups.flatMap(group => group.buttons);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SeparatorWrap, null), /*#__PURE__*/React__default.createElement(ToolbarButton, {
      onClick: showOverflowMenu,
      "data-popup-source": overflowDropdownSource
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      fill: "black",
      size: "16px",
      iconId: "navigation.overflow"
    })), /*#__PURE__*/React__default.createElement(PopupMenu$2, {
      open: overflowMenuShown,
      close: hideOverflowMenu,
      source: overflowDropdownSource,
      ref: textOptionRef,
      style: {
        width: "fit-content"
      },
      hPos: "alignRight"
    }, /*#__PURE__*/React__default.createElement(Flex$1, {
      gap: "8px",
      p: "s"
    }, flatButtons.map(button => /*#__PURE__*/React__default.createElement(ToolbarButton, {
      "aria-label": button.activeCondition,
      key: button.iconId,
      onClick: button.action,
      disabled: button.disabledCondition,
      className: editor.isActive(button.activeCondition) ? "is-active" : "",
      "data-popup-source": button === null || button === void 0 ? void 0 : button.popupSource
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      fill: "black",
      size: "16px",
      iconId: button.iconId
    }))))));
  }, [overflowGroups, overflowDropdownSource, overflowMenuShown, hideOverflowMenu, textOptionRef, editor, showOverflowMenu]);
  useEditorToolbarLayout({
    rootRef,
    toolbarGroups,
    setMainButtons: setVisibleGroups,
    setOverflowButtons: setOverflowGroups
  });
  return /*#__PURE__*/React__default.createElement(ToolbarContainer, {
    id: "toolbar",
    "data-testid": "editor-toolbar",
    sticky: isSticky,
    ref: toolbarRef
  }, renderColorSelection(), renderTextDropdown(), renderMainButtons(), renderOverflowButtons());
};
var Toolbar$2 = Toolbar$1;

const useTurndownService = () => {
  const turndownService = useMemo(() => {
    const service = new TurndownService({
      headingStyle: "atx"
    });
    service.addRule("emptyParagraphToNewline", {
      filter: "br",
      replacement: () => "<br>" // keep line breaks
    });
    service.keep(["u", "s"]); // Keep <u> and <s> tag in Markdown
    return service;
  }, []);
  return {
    turndownService
  };
};

const useMarkdownIt = _ref => {
  var _item$data;
  let {
    item
  } = _ref;
  const md = markdownIt({
    html: true
  });
  const initialHtml = md.render(((_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.content) || "");
  const content = DOMPurify.sanitize(initialHtml);
  return {
    content
  };
};

// Tiptap changed how they handle select all in December 2024 to use ProseMirror's AllSelection
// rather than their internal TextSelection. They previous said they intentionally avoid ProseMirror's
// AllSelection because of how it doesn't work with some of their features.
// This custom extension fixes that by using the old behavior from their package.
// related change: https://github.com/ueberdosis/tiptap/pull/5900/files
const SelectAllExtension = Extension.create({
  name: "selectAllFix",
  addCommands() {
    return {
      selectAll: () => _ref => {
        let {
          tr,
          commands
        } = _ref;
        return commands.setTextSelection({
          from: 0,
          to: tr.doc.content.size
        });
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-a": () => this.editor.commands.selectAll()
    };
  }
});
var SelectAllExtension$1 = SelectAllExtension;

function useEditorColors(bgColorKey, theme) {
  const getBackgroundColor = useCallback(bgColor => {
    if (theme !== null && theme !== void 0 && theme[bgColor]) return theme[bgColor];
    if (bgColor.includes("Color")) {
      return getColor(bgColor.replace("Color", "")) || "";
    }
    if (bgColor === "default") return getColor("white");
    return bgColor;
  }, [theme]);
  return useMemo(() => {
    const bg = getBackgroundColor(bgColorKey);
    return {
      backgroundColor: bg,
      color: getTextColor(bg),
      blockquoteColor: getBlockquoteTextColor(bg)
    };
  }, [bgColorKey, getBackgroundColor]);
}

/*
 * catches links that haven't been converted to links by the editor
 * and converts them to links
 * @param {string} html - the HTML content to process
 * @returns {string} - the processed HTML content with links converted
 */
function updateLinksOnRender(html) {
  if (!html) return "";
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  const urlRegex = /(\bhttps?:\/\/[^\s<]+[^\s<.,:;"')\]\s])/g;
  let node;
  while (node = walker.nextNode()) {
    const parent = node.parentElement;
    if ((parent === null || parent === void 0 ? void 0 : parent.tagName) === "A") continue;
    const text = node.textContent;
    if (!text) continue;
    const newHTML = text.replace(urlRegex, url => {
      return "<a href=\"".concat(url, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(url, "</a>");
    });
    if (newHTML !== text) {
      const span = document.createElement("span");
      span.innerHTML = newHTML;
      parent === null || parent === void 0 || parent.replaceChild(span, node);
    }
  }
  return doc.body.innerHTML;
}

const StyledEditor = styled(EditorContent).withConfig({
  displayName: "TextEditor__StyledEditor"
})(["background-color:", ";word-break:break-word;border-radius:4px;padding:", ";flex:1 1 100%;", ";blockquote{color:", ";}code{color:black;}& .tiptap{outline:none;:focus-visible{outline:none;}}"], props => props.backgroundcolor, props => {
  var _props$backgroundcolo;
  return ((_props$backgroundcolo = props.backgroundcolor) === null || _props$backgroundcolo === void 0 ? void 0 : _props$backgroundcolo.toLowerCase()) === "#ffffff" ? "4px" : "16px";
}, markdownStyle, props => props.blockquotecolor);
const extensions = [StarterKit, Underline, Link$1.configure({
  openOnClick: true,
  autolink: true,
  defaultProtocol: "https",
  protocols: ["http", "https"],
  shouldAutoLink: url => url.startsWith("https://"),
  isAllowedUri: (url, ctx) => {
    return ctx.defaultValidate(url);
  }
}), SelectAllExtension$1];
const TextEditor = _ref => {
  let {
    item,
    selected,
    canEdit,
    isEditing,
    hasDefaultValue,
    onBeginEditing,
    onFinishEditing,
    onClick,
    backgroundColorMenu
  } = _ref;
  const [isFocused, setIsFocused] = useState(false);
  const [editingLabel, setEditingLabel] = useState(false);
  const [colorOptionsShown, showColorOptions, hideColorOptions] = useBoolean(false);
  const rootRef = useRef(null);
  const labelRef = useRef(null);
  const textOptionRef = useRef(null);
  const colorOptionRef = useRef(null);
  const sentinelRef = useRef(null);
  const toolbarRef = useRef(null);
  const theme = useTheme();
  const id = useMemo(() => factory.genID(), []);
  const source = id.toString().concat("-label-editor");
  const {
    turndownService
  } = useTurndownService();
  const {
    content
  } = useMarkdownIt({
    item
  });
  const contentWithAutolink = updateLinksOnRender(content);
  const {
    backgroundColor,
    color,
    blockquoteColor
  } = useEditorColors(item.data.backgroundColor, theme);
  const editor = useEditor({
    extensions,
    content: contentWithAutolink,
    autofocus: false,
    editable: false,
    editorProps: {
      handleKeyDown: (_, event) => {
        if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
          event.preventDefault();
          handleFinishEditing();
          return true;
        }
        return false;
      }
    }
  });
  useEffect(() => {
    if (!editor) return;
    if (isEditing) {
      setIsFocused(true);
      editor.setOptions({
        editable: true
      });
      if (hasDefaultValue) {
        editor.commands.focus("all");
      } else {
        editor.commands.focus("end");
      }
    } else {
      setIsFocused(false);
      editor.setOptions({
        editable: false
      });
    }
  }, [editor, isEditing, hasDefaultValue]);
  useEffect(() => {
    if (!isFocused && editingLabel === true) {
      setEditingLabel(false);
    }
  }, [isFocused, editingLabel]);
  useEffect(() => {
    if (!selected) {
      setIsFocused(false);
      editor === null || editor === void 0 || editor.setOptions({
        editable: false
      });
    }
  }, [selected, editor]);
  const handleFinishEditing = useCallback(() => {
    var _item$data;
    setIsFocused(false);
    const html = editor === null || editor === void 0 ? void 0 : editor.getHTML();
    // Replace truly empty <p> tags with <p><br> to maintain visual layout
    const modifiedHTML = html.replace(/<p><\/p>/g, "<p><br></p>");
    const isEmpty = modifiedHTML.replace(/<p><br\s*\/?><\/p>/g, "") // remove all <p><br></p> or <p><br/></p>
    .replace(/\s+/g, "").length === 0; // remove whitespace
    const markdown = isEmpty ? "" : turndownService.turndown(modifiedHTML);
    // don't submit if no changes were made
    if (markdown.trim() === ((_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.content.trim())) {
      onFinishEditing(item, null);
      return;
    }
    const data = {
      data: {
        content: markdown
      }
    };
    onFinishEditing(item, data);
  }, [editor, item, onFinishEditing, turndownService, setIsFocused]);
  const handleClickOutside = useCallback(event => {
    var _toolbarRef$current, _rootRef$current, _labelRef$current, _textOptionRef$curren, _colorOptionRef$curre;
    if (!isFocused) return;
    if ((_toolbarRef$current = toolbarRef.current) !== null && _toolbarRef$current !== void 0 && _toolbarRef$current.contains(event.target) || (_rootRef$current = rootRef.current) !== null && _rootRef$current !== void 0 && _rootRef$current.contains(event.target) || (_labelRef$current = labelRef.current) !== null && _labelRef$current !== void 0 && _labelRef$current.contains(event.target) || (_textOptionRef$curren = textOptionRef.current) !== null && _textOptionRef$curren !== void 0 && _textOptionRef$curren.contains(event.target) || (_colorOptionRef$curre = colorOptionRef.current) !== null && _colorOptionRef$curre !== void 0 && _colorOptionRef$curre.contains(event.target)) {
      return;
    }
    handleFinishEditing();
  }, [handleFinishEditing, isFocused]);
  const beginEditing = useCallback(() => {
    if (onBeginEditing) onBeginEditing(item.id);
  }, [item, onBeginEditing]);
  useEffect(() => {
    if (!selected) return;
    if (colorOptionsShown) return;
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleFinishEditing, selected, isFocused, handleClickOutside, colorOptionsShown]);
  if (!editor) return null;
  const editorProps = {
    id: "editor",
    editor,
    onDoubleClick: canEdit ? beginEditing : null,
    onClick,
    color
  };
  return /*#__PURE__*/React__default.createElement(Flex$1, {
    flexDirection: "column",
    width: "100%",
    ref: rootRef
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: sentinelRef,
    style: {
      position: "absolute",
      top: 0
    }
  }), isFocused && /*#__PURE__*/React__default.createElement(Toolbar$2, {
    editor: editor,
    setEditingLabel: setEditingLabel,
    source: source,
    backgroundColorMenu: backgroundColorMenu,
    refs: {
      textOptionRef,
      rootRef,
      sentinelRef,
      toolbarRef,
      colorOptionRef
    },
    colorProps: {
      buttonBgColor: backgroundColor,
      colorOptionsShown,
      showColorOptions,
      hideColorOptions
    }
  }), editingLabel && /*#__PURE__*/React__default.createElement(LinkPopupMenu$1, {
    editor: editor,
    setEditingLabel: setEditingLabel,
    source: source,
    labelRef: labelRef,
    isFocused: isFocused
  }), /*#__PURE__*/React__default.createElement(StyledEditor, _extends({
    "data-testid": "tiptap-editor",
    blockquotecolor: blockquoteColor,
    backgroundcolor: backgroundColor
  }, editorProps)));
};
var TextEditor$1 = TextEditor;

const _excluded$8 = ["item", "selected", "canEdit", "isEditing", "hasDefaultValue", "onBeginEditing", "onFinishEditing", "onInitiateUpload", "align", "children", "onClick"];
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const RowClear = styled(Box$1).attrs({
  height: 0,
  flex: "1 1 100%"
}).withConfig({
  displayName: "GalleryGuide__RowClear"
})([""]);
const StyledStretchingImage = styled(StretchingAsset$1).attrs({
  background: "grayLightest"
}).withConfig({
  displayName: "GalleryGuide__StyledStretchingImage"
})(["pointer-events:none;"]);
const UploadImageButton = styled(Button$1).attrs(props => {
  return {
    p: "m",
    buttonStyle: "tertiary",
    text: "＋ Add Image",
    fontStyle: "ui.regularBold",
    theme: _objectSpread$3(_objectSpread$3({}, props.theme), {}, {
      primaryColor: "grayDark",
      primaryColorDark: "grayDarker"
    }),
    width: "100%"
  };
}).withConfig({
  displayName: "GalleryGuide__UploadImageButton"
})(["&:hover{text-decoration:none;}"]);
const Rule = styled.hr.withConfig({
  displayName: "GalleryGuide__Rule"
})(["border:none;border-top:3px solid ", ";", " transition:border-color 0.2s ease;"], props => getColor(props.color, "grayDarker"), positioningCSS({
  m: "none",
  mb: "s"
}));
const TextWrapper = styled(Flex$1).attrs({
  pb: 1
}).withConfig({
  displayName: "GalleryGuide__TextWrapper"
})(["", ""], props => props.canEdit && !props.isEditing && "\n    cursor: pointer;\n  ");
const DropDownButton = styled(Flex$1).attrs({
  justifyContent: "space-between",
  alignItems: "center",
  height: 28
}).withConfig({
  displayName: "GalleryGuide__DropDownButton"
})(["cursor:pointer;"]);
const DropDownText = styled(Text).attrs({
  pr: "xs"
}).withConfig({
  displayName: "GalleryGuide__DropDownText"
})(["color:", ";transition:color 0.2s ease;", ":hover &{color:", ";}"], props => getColor(props.color, "grayDarker"), DropDownButton, props => getColor(props.color, "grayDarkest"));
const DropDownIcon = styled(Icon$1).attrs({
  iconId: "triangle-double"
}).withConfig({
  displayName: "GalleryGuide__DropDownIcon"
})(["fill:", ";transition:fill 0.2s ease;", ":hover &{fill:", ";}"], props => getColor(props.fill, "grayDarker"), DropDownButton, getColor("grayDarkest"));
const SelectionWrapper$2 = styled(Box$1).attrs(props => {
  return {
    borderRadius: "default",
    m: "-2px",
    border: "2px solid ".concat(props.selected && props.canEdit ? getColor(props.theme.primaryColor, "primary") : "transparent")
  };
}).withConfig({
  displayName: "GalleryGuide__SelectionWrapper"
})([""]);
const GalleryGuide = _ref => {
  let {
      item,
      selected,
      canEdit,
      isEditing,
      hasDefaultValue,
      onBeginEditing,
      onFinishEditing,
      onInitiateUpload,
      align,
      children,
      onClick
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$8);
  const {
    asset,
    data: {
      displayStyle,
      color: accentColor,
      title
    }
  } = item;
  const [hovering, setHovering] = useState(false),
    [titleDropdownOpen, setTitleDropdownOpen] = useState(false),
    [styleDropdownOpen, setStyleDropdownOpen] = useState(false);
  const onMouseEnter = useCallback(() => setHovering(true), []),
    onMouseLeave = useCallback(() => setHovering(false), []);
  const onClickTitle = useCallback(() => setTitleDropdownOpen(true), []),
    onCloseTitleDropdown = useCallback(() => setTitleDropdownOpen(false), []),
    onChangeTitle = (newTitle, newColor) => {
      if (!onFinishEditing || newTitle === title) return;
      onFinishEditing(item, {
        data: {
          title: newTitle,
          color: newColor
        }
      });
    };
  const onClickStyle = useCallback(() => setStyleDropdownOpen(true), []),
    onCloseStyleDropdown = useCallback(() => setStyleDropdownOpen(false), []),
    onChangeStyle = newStyle => {
      if (!onFinishEditing || newStyle === displayStyle) return;
      onFinishEditing(item, {
        data: {
          display_style: newStyle
        },
        asset_uuid: null
      });
    };
  const onClickUpload = useCallback(() => onInitiateUpload(item), [onInitiateUpload, item]);
  const displayColor = !accentColor || ["green", "red"].includes(accentColor) ? getColor(accentColor || "green") : accentColor;
  const alignment = {
    pl: align === "right" ? "m" : "s",
    pr: align === "left" ? "m" : "s",
    flex: align === "left" || align === "right" ? "0 0 50%" : "1 1 100%",
    position: "relative"
  };
  function renderImage() {
    if (displayStyle !== "image") return null;
    if (asset) {
      return /*#__PURE__*/React__default.createElement(StyledStretchingImage, {
        asset: asset,
        maxHeight: 600
      });
    }
    if (canEdit && onInitiateUpload) {
      return /*#__PURE__*/React__default.createElement(Box$1, {
        background: "grayLightest",
        textAlign: "center"
      }, /*#__PURE__*/React__default.createElement(UploadImageButton, {
        onClick: onClickUpload
      }));
    }
  }
  function renderTitleDropdown() {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(DropDownButton, {
      "data-testid": "guide-title",
      mx: "xs",
      onClick: onClickTitle,
      "data-popup-source": "guide-title-select-".concat(item.id)
    }, /*#__PURE__*/React__default.createElement(DropDownText, {
      color: displayColor,
      font: "ui.regularBold"
    }, title), /*#__PURE__*/React__default.createElement(DropDownIcon, {
      fill: hovering ? displayColor : "transparent"
    })), titleDropdownOpen && /*#__PURE__*/React__default.createElement(PopupMenu, {
      source: "guide-title-select-".concat(item.id),
      close: onCloseTitleDropdown,
      vPos: "alignTop",
      hPos: "alignLeft"
    }, [["DO", "green"], ["DON'T", "red"]].map(_ref2 => {
      let [command, commandColor] = _ref2;
      return /*#__PURE__*/React__default.createElement(PopupMenu.Item, {
        key: command,
        "data-testid": "guide-title-".concat(command),
        checked: title === command,
        title: command,
        onClick: () => onChangeTitle(command, commandColor)
      });
    })));
  }
  function renderStyleDropdown() {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(DropDownButton, {
      "data-testid": "guide-style",
      mx: "xs",
      onClick: onClickStyle,
      "data-popup-source": "guide-style-select-".concat(item.id)
    }, /*#__PURE__*/React__default.createElement(DropDownText, {
      color: hovering ? undefined : "transparent",
      font: "ui.regularSemiBold"
    }, displayStyle === "image" ? "Image & Text" : "Text Only"), /*#__PURE__*/React__default.createElement(DropDownIcon, {
      fill: hovering ? undefined : "transparent"
    })), styleDropdownOpen && /*#__PURE__*/React__default.createElement(PopupMenu, {
      source: "guide-style-select-".concat(item.id),
      close: onCloseStyleDropdown,
      vPos: "alignTop",
      hPos: "alignLeft"
    }, [["Image & Text", "image"], ["Text Only", "text_only"]].map(_ref3 => {
      let [text, style] = _ref3;
      return /*#__PURE__*/React__default.createElement(PopupMenu.Item, {
        key: style,
        "data-testid": "guide-style-".concat(style),
        checked: displayStyle === style,
        title: text,
        onClick: () => onChangeStyle(style)
      });
    })));
  }
  function renderStatic() {
    return /*#__PURE__*/React__default.createElement(Box$1, _extends({}, alignment, {
      "data-testid": "guide-static-wrapper",
      mb: "l"
    }, rest), /*#__PURE__*/React__default.createElement(SelectionWrapper$2, {
      selected: selected
    }, renderImage(), /*#__PURE__*/React__default.createElement(Rule, {
      color: displayColor
    }), /*#__PURE__*/React__default.createElement(Text, {
      "data-testid": "guide-title",
      color: displayColor,
      font: "ui.regularBold",
      mb: "s",
      mx: "xs"
    }, title), /*#__PURE__*/React__default.createElement(Box$1, {
      "data-testid": "guide-text"
    }, /*#__PURE__*/React__default.createElement(TextEditor$1, {
      item: item,
      hasDefaultValue: hasDefaultValue,
      canEdit: canEdit,
      "aria-label": "Update guide text"
    }))));
  }
  function renderEditable() {
    return /*#__PURE__*/React__default.createElement(Box$1, _extends({}, alignment, {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      "data-testid": "guide-editable-wrapper",
      mb: "l"
    }, rest), /*#__PURE__*/React__default.createElement(SelectionWrapper$2, {
      selected: selected,
      canEdit: canEdit,
      onClick: canEdit ? onClick : null
    }, children, renderImage(), /*#__PURE__*/React__default.createElement(Rule, {
      color: displayColor,
      "data-testid": "guide-hr"
    }), /*#__PURE__*/React__default.createElement(Flex$1, {
      justifyContent: "space-between",
      mb: "s"
    }, renderTitleDropdown(), renderStyleDropdown()), /*#__PURE__*/React__default.createElement(TextWrapper, {
      canEdit: canEdit,
      isEditing: isEditing
    }, /*#__PURE__*/React__default.createElement(TextEditor$1, {
      item: item,
      hasDefaultValue: hasDefaultValue,
      onFinishEditing: onFinishEditing,
      canEdit: canEdit,
      selected: selected,
      isEditing: isEditing,
      onBeginEditing: onBeginEditing,
      "aria-label": "Update guide text"
    }))));
  }
  return /*#__PURE__*/React__default.createElement(Fragment, null, align === "left" ? /*#__PURE__*/React__default.createElement(RowClear, null) : null, canEdit ? renderEditable() : renderStatic());
};
var GalleryGuide$1 = GalleryGuide;

function getElement(idOrNode) {
  if (typeof idOrNode === "string") {
    return document.getElementById(idOrNode);
  } else {
    return idOrNode;
  }
}

/**
 * Helper function to focus an input element, and place the users cursor at the end of the predefined content
 * @param {String|Node} idOrNode Dom input node OR its ID value
 */
function focusEndOfInput(idOrNode) {
  const inputEl = getElement(idOrNode);
  if (inputEl) {
    inputEl.focus();
    inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length);
  } else console.warn("No input element detected - make sure you've applied it on the target node.");
}

/**
 * Helper function to focus an input element, and highlight all text inside of it
 * @param {String|Node} idOrNode Dom input node OR its ID value
 */
function focusAllOfInput(idOrNode) {
  const inputEl = getElement(idOrNode);
  if (inputEl) {
    inputEl.focus();
    inputEl.select();
  } else console.warn("No input element detected - make sure you've applied it on the target node.");
}

const keyCodes = {
  backspace: 8,
  tab: 9,
  enter: 13,
  esc: 27,
  space: 32,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  delete: 46,
  comma: 188,
  shift: 16,
  meta: 91
};
var keyCodes$1 = keyCodes;

function shouldSubmit(e, multiline) {
  const enterKey = e.which === keyCodes$1.enter || [e.key, e.code].includes(keyNames.enter);
  return multiline ? enterKey && e.metaKey : enterKey;
}
function useSubmitTextKeys(multiline) {
  return useCallback(e => {
    if (shouldSubmit(e, multiline)) {
      e.preventDefault();
      e.currentTarget.blur();
    }
  }, [multiline]);
}

const _excluded$7 = ["item", "selected", "canEdit", "isEditing", "hasDefaultValue", "onBeginEditing", "onFinishEditing", "data-itemid", "onClick"];
const headingTestId = "gallery-heading-text";
const wrapperTestId$3 = "gallery-heading-wrapper";
const editorTestId$1 = "gallery-heading-editor";
const Wrapper$3 = styled(Box$1).attrs(props => ({
  mx: "s",
  flex: "1 1 100%",
  border: props.selected && props.canEdit ? "2px solid ".concat(getColor(props.theme.primaryColor, "primary")) : "2px solid transparent",
  borderRadius: "default"
})).withConfig({
  displayName: "GalleryHeading__Wrapper"
})(["position:\"relative\";", ""], props => !props.canEdit && "\n    pointer-events: none;\n  ");
const HeadingText = styled(Text).attrs({
  as: "h2",
  font: "gallery.heading",
  color: "black",
  borderRadius: "default",
  px: "xs"
}).withConfig({
  displayName: "GalleryHeading__HeadingText"
})(["word-break:break-word;", " &:first-child{margin-top:0;}"], props => !props.canEdit ? "\n    pointer-events: none;\n  " : "\n    cursor: pointer;\n  ");
const Textarea$1 = styled(AutosizeTextarea).withConfig({
  displayName: "GalleryHeading__Textarea"
})(["min-height:42px;padding:0;border-radius:", ";border:none;resize:none;width:100%;", " margin:0;font-feature-settings:inherit;&:focus{outline:none;}"], getBorderRadius("default"), props => getFont(null, "gallery.heading", props));
const GalleryHeading = _ref => {
  let {
      item,
      selected,
      canEdit,
      isEditing,
      hasDefaultValue,
      onBeginEditing,
      onFinishEditing,
      "data-itemid": itemId,
      onClick
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  const [editValue, setEditValue] = useState(item.data.content);

  // Refs
  const editorRef = useRef(null);
  const beginEditing = useCallback(() => {
      if (onBeginEditing) onBeginEditing(item.id);
    }, [item, onBeginEditing]),
    finishEditing = useCallback(() => {
      if (!isEditing || !canEdit || !onFinishEditing) return;

      // Do not submit if the original content hasn't changed
      const val = editValue.trim();
      if (item.data.content === val) return onFinishEditing(item, null);
      const data = {
        data: {
          content: val
        }
      };
      onFinishEditing(item, data);
    }, [isEditing, canEdit, onFinishEditing, item, editValue]);

  /**
   * Every time the edit mode changes, make sure the latest version
   * of the content prop is hydrated in the editValue state variable.
   *
   * If opening edit mode, select the text within the textarea for manipulation.
   */
  useEffect(() => {
    setEditValue(item.data.content);
    if (isEditing && editorRef.current) {
      (hasDefaultValue ? focusAllOfInput : focusEndOfInput)(editorRef.current);
    }
  }, [hasDefaultValue, isEditing, item.data.content]);
  const onKeyDown = useSubmitTextKeys(false);
  const headingTextProps = {
    canEdit,
    selected,
    onDoubleClick: canEdit ? beginEditing : undefined
  };
  return /*#__PURE__*/React__default.createElement(Wrapper$3, _extends({
    id: item.shortId,
    "data-testid": wrapperTestId$3,
    "data-itemid": itemId,
    canEdit: canEdit,
    selected: selected,
    onClick: onClick
  }, rest), isEditing ? /*#__PURE__*/React__default.createElement(Textarea$1, {
    "aria-label": "Update heading text",
    "data-testid": editorTestId$1,
    ref: editorRef,
    value: editValue,
    onBlur: finishEditing,
    onChange: e => setEditValue(e.target.value),
    onKeyDown: onKeyDown
  }) : /*#__PURE__*/React__default.createElement(HeadingText, _extends({}, headingTextProps, {
    "data-testid": headingTestId
  }), item.data.content));
};
var GalleryHeading$1 = GalleryHeading;

const _excluded$6 = ["item", "routeToGallery", "replaceFile"];
const Wrapper$2 = styled(Flex$1).attrs(props => {
  return {
    mx: props.mx || "s",
    border: props.selected ? "2px solid ".concat(getColor(props.theme.primaryColor, "primary")) : "2px solid transparent",
    borderRadius: "default",
    width: "100%",
    flexDirection: "row",
    background: props.backgroundColor,
    p: "l",
    alignItems: "center",
    variations: {
      "mq.s": {
        flexDirection: "column"
      }
    }
  };
}).withConfig({
  displayName: "GalleryItem__Wrapper"
})([""]);
const ButtonContainer = styled(Flex$1).attrs({
  width: "100%",
  justifyContent: "center",
  alignItems: "center"
}).withConfig({
  displayName: "GalleryItem__ButtonContainer"
})(["aspect-ratio:3/2;"]);
const GalleryItem = _ref => {
  var _item$asset3, _item$asset4, _item$data, _item$data2, _item$data3, _item$data4;
  let {
      item,
      routeToGallery,
      replaceFile
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$6);
  const [hovered, setHovered, setNotHovered] = useBoolean(false);
  const backgroundColor = item.data.backgroundColor === "default" ? getColor("grayLightest") : item.data.backgroundColor;
  const hsl = new TinyColor(backgroundColor).toHsl();
  const isLightBackground = hsl.l > 0.6 || hsl.l === 0;
  const backgroundImage = useMemo(() => {
    var _item$asset;
    if (((_item$asset = item.asset) === null || _item$asset === void 0 || (_item$asset = _item$asset.meta) === null || _item$asset === void 0 ? void 0 : _item$asset.assetProcessing) === "complete") {
      var _item$asset2;
      return (_item$asset2 = item.asset) === null || _item$asset2 === void 0 ? void 0 : _item$asset2.thumbnails["1232"];
    }
    return null;
  }, [(_item$asset3 = item.asset) === null || _item$asset3 === void 0 ? void 0 : _item$asset3.thumbnails, (_item$asset4 = item.asset) === null || _item$asset4 === void 0 || (_item$asset4 = _item$asset4.meta) === null || _item$asset4 === void 0 ? void 0 : _item$asset4.assetProcessing]);
  const renderImageSection = useCallback(() => {
    var _item$asset5;
    if (((_item$asset5 = item.asset) === null || _item$asset5 === void 0 || (_item$asset5 = _item$asset5.meta) === null || _item$asset5 === void 0 ? void 0 : _item$asset5.assetProcessing) === "processing") {
      return /*#__PURE__*/React__default.createElement(ButtonContainer, null, /*#__PURE__*/React__default.createElement(ActivityIndicator$1, {
        size: "default",
        center: true,
        color: "neutralLoader"
      }));
    }
    if (!item.asset && replaceFile && hovered) {
      return /*#__PURE__*/React__default.createElement(ButtonContainer, null, /*#__PURE__*/React__default.createElement(Button$1, {
        buttonStyle: "tertiary",
        text: "Add image",
        icon: "action.add",
        size: "small",
        onClick: e => {
          e.stopPropagation();
          replaceFile(item);
        }
      }));
    }
    return /*#__PURE__*/React__default.createElement(ImageView$1, {
      src: backgroundImage,
      icon: "content.grid",
      iconSize: "56",
      iconFill: "grayDark",
      aspectRatio: 66.6666,
      cover: true,
      background: "grayLighter"
    });
  }, [item, replaceFile, hovered, backgroundImage]);
  return /*#__PURE__*/React__default.createElement(Wrapper$2, _extends({
    onDoubleClick: routeToGallery,
    "data-shortid": item.shortId,
    backgroundColor: backgroundColor
  }, rest), /*#__PURE__*/React__default.createElement(Box$1, {
    flex: "1",
    borderRadius: "2px",
    overflow: "hidden",
    variations: {
      "mq.s": {
        width: "100%"
      }
    },
    background: "grayLighter",
    onMouseEnter: setHovered,
    onMouseLeave: setNotHovered
  }, renderImageSection()), /*#__PURE__*/React__default.createElement(Flex$1, {
    width: "100%",
    variations: {
      "mq.s_up": {
        flex: "1"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    mx: "l",
    variations: {
      "mq.s": {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        m: "m"
      }
    }
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default.createElement(Text, {
    font: "gallery.h1",
    color: getTextColor(backgroundColor)
  }, ((_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.viewName) || ((_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.name)), item.data.itemProcessing === "pending" ? /*#__PURE__*/React__default.createElement(Flex$1, {
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(ActivityIndicator$1, {
    size: "extraSmall",
    color: "grayDark",
    mr: "4"
  }), /*#__PURE__*/React__default.createElement(Text, {
    font: "ui.small",
    color: isLightBackground ? "grayDarkest" : "gray"
  }, "Loading...")) : /*#__PURE__*/React__default.createElement(Text, {
    font: "ui.small",
    color: isLightBackground ? "grayDarkest" : "gray"
  }, (_item$data3 = item.data) === null || _item$data3 === void 0 ? void 0 : _item$data3.assets, " ", pluralize("asset", (_item$data4 = item.data) === null || _item$data4 === void 0 ? void 0 : _item$data4.assets))), /*#__PURE__*/React__default.createElement(Button$1, {
    mt: "m",
    buttonStyle: "secondary",
    size: "small",
    onClick: routeToGallery,
    icon: "navigation.chevron-right",
    text: "View"
  }))));
};
var GalleryItem$1 = GalleryItem;

const _excluded$5 = ["item", "selected", "canEdit", "isEditing", "hasDefaultValue", "onBeginEditing", "onFinishEditing", "onClick", "backgroundColorMenu"];
const noteTestId = "gallery-note-text";
const wrapperTestId$2 = "gallery-note-wrapper";
const Wrapper$1 = styled(Box$1).attrs(() => {
  return {
    px: "s",
    flex: "1 1 100%"
  };
}).withConfig({
  displayName: "GalleryNote__Wrapper"
})(["transition:min-height 0.4s ease;", ""], props => props.canEdit && !props.isEditing && "\n    cursor: pointer;\n  ");
const GalleryNote = _ref => {
  let {
      item,
      selected,
      canEdit,
      isEditing,
      hasDefaultValue,
      onBeginEditing,
      onFinishEditing,
      onClick,
      backgroundColorMenu
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$5);
  const theme = useTheme();
  const noteRef = useRef();
  const noteProps = {
    canEdit,
    borderRadius: "default",
    border: selected && canEdit ? "2px solid ".concat(getColor(theme.primaryColor, "primary")) : "2px solid transparent"
  };
  return /*#__PURE__*/React__default.createElement(Wrapper$1, _extends({
    "data-testid": wrapperTestId$2,
    canEdit: canEdit,
    isEditing: isEditing
  }, rest), /*#__PURE__*/React__default.createElement(Box$1, _extends({}, noteProps, {
    ref: noteRef,
    "data-testid": noteTestId
  }), /*#__PURE__*/React__default.createElement(TextEditor$1, {
    item: item,
    selected: selected,
    canEdit: canEdit,
    isEditing: isEditing,
    hasDefaultValue: hasDefaultValue,
    onBeginEditing: onBeginEditing,
    onFinishEditing: onFinishEditing,
    backgroundColorMenu: backgroundColorMenu,
    onClick: canEdit ? onClick : null
  })));
};
var GalleryNote$1 = GalleryNote;

const _excluded$4 = ["children"];
const StyledReactMarkdown = styled(ReactMarkdown).withConfig({
  displayName: "GalleryMarkdown__StyledReactMarkdown"
})(["word-break:break-word;flex:1 1 100%;padding:16px;", " ", " padding:", ";"], positioningCSS({
  mx: "s"
}), markdownStyle, props => props.hasBgColor ? "16px" : "0px");
const LinkRenderer = _ref => {
  let {
    children,
    href
  } = _ref;
  return /*#__PURE__*/React__default.createElement(LinkWrapper$1, {
    link: href,
    style: {
      textDecoration: "underline"
    },
    "data-testid": "link-wrapper"
  }, children);
};
const GalleryMarkdown = _ref2 => {
  let {
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded$4);
  if (typeof children !== "string") return null;
  return /*#__PURE__*/React__default.createElement(StyledReactMarkdown, _extends({}, rest, {
    components: {
      a: LinkRenderer
    },
    remarkPlugins: [remarkDisableElements("gallery"), remarkStrikethrough, remarkBreaks]
  }), children);
};
var GalleryMarkdown$1 = GalleryMarkdown;

function useClipboard(value) {
  let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;
  const [hasCopied, setHasCopied] = useState(false);
  const onCopy = useCallback(() => {
    try {
      if (typeof value === "string") {
        const didCopy = copy(value);
        setHasCopied(didCopy);
      }
    } catch (err) {
      console.error("Clipboard error:", err);
      setHasCopied(false);
    }
  }, [value]);
  const onClickInputToCopy = useCallback(e => {
    e === null || e === void 0 || e.currentTarget.select();
    onCopy();
  }, [onCopy]);
  useEffect(() => {
    if (hasCopied) {
      const id = setTimeout(() => setHasCopied(false), timeout);
      return () => clearTimeout(id);
    }
  }, [hasCopied, timeout]);
  return {
    value,
    onCopy,
    hasCopied,
    onClickInputToCopy
  };
}

const codeLangs = ["Auto", "Plaintext", "Markdown", "JSON", "Javascript", "Typescript", "HTML", "XML", "YAML", "CSS", "Less", "Swift", "ObjectiveC", "Python", "PHP", "Perl", "Java"];

hljs.registerLanguage("plaintext", plaintext);
hljs.registerLanguage("markdown", markdown);
hljs.registerLanguage("json", json);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("css", cssLang);
hljs.registerLanguage("less", less);
hljs.registerLanguage("swift", swift);
hljs.registerLanguage("objectivec", objectivec);
hljs.registerLanguage("python", python);
hljs.registerLanguage("php", php);
hljs.registerLanguage("perl", perl);
hljs.registerLanguage("java", java);

/**
 *
 * @param {String} textContent The text string to be highlighted, even if it already exists in the target div
 * @param {String} language The language to use to highlight with
 * @returns {Object} A ref that should be assigned to the HTML node that should contain the highlighted code
 *
 * Fills a div with the given code formatted according to the given language
 *
 * const codeRef = useCodeHighlighting('var stuff = { thing: "blargh" };', "javascript");
 *
 * <pre>
 *   <code ref={codeRef} />
 * </pre>
 */

function useCodeHighlighting(textContent, language) {
  const codeSnippetRef = useRef(null);
  useLayoutEffect(() => {
    const currentNode = codeSnippetRef.current;
    if (currentNode && textContent) {
      if (!language || language === "Auto") {
        currentNode.innerHTML = hljs.highlightAuto(textContent).value;
      } else currentNode.innerHTML = hljs.highlight(textContent, {
        language: language.toLowerCase()
      }).value;
    }
  }, [language, textContent]);
  return codeSnippetRef;
}

const _excluded$3 = ["item", "selected", "canEdit", "isEditing", "hasDefaultValue", "onBeginEditing", "onFinishEditing", "onClick"];
const editorTestId = "gallery-code-snippet-editor";
const wrapperTestId$1 = "gallery-code-snippet-wrapper";
const parentTestId = "gallery-code-snippet-parent";
const selectTestId = "gallery-code-snippet-select";
const Wrapper = styled(Box$1).attrs(props => {
  return {
    mx: props.mx || "s",
    border: "1px solid ".concat(props.selected && props.canEdit ? "transparent" : "border"),
    background: "grayLightest",
    borderRadius: "default",
    width: "100%"
  };
}).withConfig({
  displayName: "GalleryCodeSnippet__Wrapper"
})([""]);
const SelectionWrapper$1 = styled(Box$1).attrs(props => {
  return {
    borderRadius: "default",
    m: "-2px",
    border: "2px solid ".concat(props.selected ? getColor(props.theme.primaryColor, "primary") : "transparent")
  };
}).withConfig({
  displayName: "GalleryCodeSnippet__SelectionWrapper"
})([""]);
const Pre = styled(Text).attrs({
  as: "pre",
  p: "none",
  background: "transparent"
}).withConfig({
  displayName: "GalleryCodeSnippet__Pre"
})([""]);
const Code = styled(Text).attrs({
  as: "code",
  font: "gallery.code",
  p: "none"
}).withConfig({
  displayName: "GalleryCodeSnippet__Code"
})(["word-break:break-word;"]);
const Toolbar = styled(Flex$1).attrs({
  p: "s",
  borderTop: "default",
  justifyContent: "flex-end",
  alignItems: "center"
}).withConfig({
  displayName: "GalleryCodeSnippet__Toolbar"
})([""]);
const EditorWrapper = styled(Box$1).attrs(props => {
  return {
    p: "s",
    background: "transparent",
    minHeight: props.minHeight
  };
}).withConfig({
  displayName: "GalleryCodeSnippet__EditorWrapper"
})(["", ""], props => props.canEdit && "\n    cursor: pointer;\n  ");
const LangSelect = styled.select.withConfig({
  displayName: "GalleryCodeSnippet__LangSelect"
})(["color:", ";", " ", " background:transparent;opacity:0.5;width:auto;border:none;appearance:none;", ""], props => props.theme.primaryColor || getColor("primary"), props => getFont(null, "ui.small", props), positioningCSS({
  mr: "s",
  pr: "s",
  py: "none"
}), props => !props.canEdit && "\n    user-select: none;\n    pointer-events: none;\n  ");
const SelectIcon = styled(Icon$1).withConfig({
  displayName: "GalleryCodeSnippet__SelectIcon"
})(["fill:", ";pointer-events:none;position:absolute;right:0;top:calc(50% - 6px);"], props => props.theme.primaryColor || getColor("primary"));
const Textarea = styled(AutosizeTextarea).withConfig({
  displayName: "GalleryCodeSnippet__Textarea"
})(["min-height:18px;padding:0;background:transparent;border:none;width:100%;", ";color:", ";resize:none;vertical-align:top;margin:0;&:focus{outline:none;}"], getFont(null, "gallery.code"), getColor("grayDarkest"));
const GalleryCodeSnippet = _ref => {
  let {
      item,
      selected,
      canEdit,
      isEditing = false,
      hasDefaultValue,
      onBeginEditing,
      onFinishEditing,
      onClick
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  const {
    data: {
      content,
      codeLanguage
    }
  } = item;
  const [editValue, setEditValue] = useState(content);
  const [minHeight, setMinHeight] = useState(null);

  // Refs
  const codeRef = useCodeHighlighting(content, codeLanguage);
  const editorRef = useRef(null);
  const {
    onCopy,
    hasCopied
  } = useClipboard(content);
  const wrapperId = item.id.concat("-code-snippet");
  const langOpts = codeLangs.map(c => /*#__PURE__*/React__default.createElement("option", {
    key: c,
    value: c
  }, c));
  const beginEditing = useCallback(() => {
      if (onBeginEditing) onBeginEditing(item.id);
    }, [item, onBeginEditing]),
    finishEditing = useCallback(() => {
      if (!isEditing || !canEdit || !onFinishEditing) return;

      // Do not submit if the original content hasn't changed
      const val = editValue.trim();
      if (content.trim() === val) {
        return onFinishEditing(item, null);
      }
      const data = {
        data: {
          content: val,
          // original code lang
          codeLanguage
        }
      };
      onFinishEditing(item, data);
    }, [isEditing, canEdit, onFinishEditing, editValue, content, codeLanguage, item]);
  const updateLanguage = useCallback(value => {
    if (!canEdit || !onFinishEditing) return;
    // Do not submit if the lang hasn't changed
    if (codeLanguage === value) return;
    const data = {
      data: {
        // current item text content
        content: content,
        codeLanguage: value
      }
    };
    onFinishEditing(item, data);
  }, [canEdit, onFinishEditing, codeLanguage, content, item]);
  const onKeyDown = useSubmitTextKeys(true);

  /**
   * Rehydrate the editor state vars each time the item in state updates
   * or the editor mode is toggled
   *
   * Focus and place cursor at the end of the textara content when entering edit mode
   */
  useEffect(() => {
    setEditValue(content);
    if (isEditing && editorRef.current) {
      (hasDefaultValue ? focusAllOfInput : focusEndOfInput)(editorRef.current);
    }
  }, [content, isEditing, hasDefaultValue]);

  /**
   * Set the min-height of the editor container to the initial
   * height to prevent flashes of surrounding content when toggling modes
   */
  useLayoutEffect(() => {
    const heightTimeout = setTimeout(() => {
      const wrapperEl = document.getElementById(wrapperId);
      if (!wrapperEl) return;
      if (isEditing) return setMinHeight(null);
      setMinHeight("".concat(wrapperEl.clientHeight, "px"));
    }, 100);
    return () => clearTimeout(heightTimeout);
  }, [wrapperId, editValue, item, isEditing]);
  const renderPre = () => {
    return /*#__PURE__*/React__default.createElement(Pre, null, /*#__PURE__*/React__default.createElement(Code, {
      ref: codeRef
    }, content));
  };

  /**
   * Watch for shift+enter or meta+enter key tp update snippet
   */

  const wrapperProps = {
    canEdit,
    onDoubleClick: canEdit ? beginEditing : undefined
  };
  return /*#__PURE__*/React__default.createElement(Wrapper, _extends({
    selected: selected
  }, rest, {
    "data-testid": parentTestId
  }), /*#__PURE__*/React__default.createElement(SelectionWrapper$1, {
    selected: selected,
    onClick: canEdit ? onClick : null
  }, /*#__PURE__*/React__default.createElement(EditorWrapper, _extends({
    id: wrapperId,
    "data-testid": wrapperTestId$1,
    minHeight: minHeight
  }, wrapperProps), isEditing ? /*#__PURE__*/React__default.createElement(Textarea, {
    ref: editorRef,
    "data-testid": editorTestId,
    "aria-label": "Update code snippet",
    onBlur: finishEditing,
    onKeyDown: onKeyDown,
    onChange: e => setEditValue(e.target.value),
    value: editValue,
    maxRows: 1000
  }) : renderPre()), /*#__PURE__*/React__default.createElement(Toolbar, null, /*#__PURE__*/React__default.createElement(Box$1, {
    position: "relative",
    pr: canEdit ? "s" : "none"
  }, /*#__PURE__*/React__default.createElement(LangSelect, {
    "data-testid": selectTestId,
    canEdit: canEdit,
    dir: "rtl",
    value: codeLanguage,
    onChange: e => updateLanguage(e.target.value)
  }, langOpts), canEdit && /*#__PURE__*/React__default.createElement(SelectIcon, {
    size: 14,
    iconId: "triangle-double"
  })), /*#__PURE__*/React__default.createElement(Button$1, {
    mx: "s",
    onClick: onCopy,
    size: "small",
    text: hasCopied ? "Copied" : "Copy"
  }))));
};
var GalleryCodeSnippet$1 = GalleryCodeSnippet;

const _excluded$2 = ["item", "selected", "canEdit", "onClick"];
const wrapperTestId = "support-image-wrapper";
const SelectionWrapper = styled(Box$1).attrs(props => {
  return {
    overflow: "hidden",
    borderRadius: "default",
    background: "white",
    border: props.selected && props.canEdit ? "2px solid ".concat(getColor(props.theme.primaryColor, "primary")) : "2px solid transparent"
  };
}).withConfig({
  displayName: "GallerySupportingAsset__SelectionWrapper"
})([""]);
const GallerySupportingAsset = _ref => {
  let {
      item,
      selected,
      canEdit,
      onClick
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  if (!item) return null;
  if (!item.asset) {
    console.error("Expected item ".concat(item.id, " to have asset"));
    return null;
  }
  const isImage = [AssetType.jpg, AssetType.png, AssetType.gif].includes(item.asset.type);
  const imageStyles = isImage ? {
    pointerEvents: "none"
  } : {}; // Don't interfere with drag & drop

  return /*#__PURE__*/React__default.createElement(Box$1, _extends({
    "data-testid": wrapperTestId,
    width: "100%",
    mx: "8px"
  }, rest), /*#__PURE__*/React__default.createElement(SelectionWrapper, {
    onClick: canEdit ? onClick : null,
    selected: selected,
    canEdit: canEdit
  }, /*#__PURE__*/React__default.createElement(StretchingAsset$1, {
    asset: item.asset,
    style: imageStyles,
    px: "none"
  })));
};
var GallerySupportingAsset$1 = GallerySupportingAsset;

const AutocompleteMenu = styled(Box$1).attrs({
  borderRadius: "default",
  position: "absolute",
  top: "100%",
  zIndex: 1,
  width: "100%",
  background: "white",
  border: "default",
  borderTop: "none",
  boxShadow: "panel"
}).withConfig({
  displayName: "AutocompleteMenu"
})([""]);
const Item = styled(Box$1).attrs(props => {
  return {
    p: "xs",
    mx: "xs",
    borderRadius: "default",
    background: props.isActive ? "grayLightest" : "none"
  };
}).withConfig({
  displayName: "AutocompleteMenu__Item"
})([""]);
const Divider = styled(Box$1).attrs({
  height: "4px",
  background: "grayLightest"
}).withConfig({
  displayName: "AutocompleteMenu__Divider"
})([""]);
const Component = AutocompleteMenu;
Component.Item = Item;
Component.Divider = Divider;
var AutocompleteMenu$1 = Component;

const _excluded$1 = ["query", "suggestions", "autoFocus", "placeholder", "clearSearch", "submitSearch", "fetchSuggestions", "background", "disabled"];
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const StyledInput = styled(Element).withConfig({
  displayName: "SearchField__StyledInput"
})(["background:", ";"], props => getColor(props.background, "grayLightest"));
const SearchField = _ref => {
  let {
      query: queryProp = "",
      suggestions = [],
      autoFocus = false,
      placeholder = "Search",
      clearSearch,
      submitSearch,
      fetchSuggestions,
      background,
      disabled
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  const [query, setQuery] = useState(queryProp || ""),
    onQueryChanged = q => {
      setQuery(q);
      if (fetchSuggestions && q) {
        fetchSuggestions(q);
      }
      if (!q) clearSearch();
    },
    clearSearchQuery = () => {
      setQuery("");
      clearSearch();
    },
    submitSearchQuery = q => {
      if (q && q !== query) {
        setQuery(q);
      }
      const qry = q || query;
      if (qry) {
        submitSearch(qry);
      } else {
        // User hit enter with empty query; go back to full kit
        clearSearch();
      }
    };

  /**
   *  If the query prop changes from an outside source (ex. Tags),
   *  update the internal query state variable to match the change
   * */
  useEffect(() => {
    if (queryProp !== query) setQuery(queryProp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryProp]);

  // Normalize the suggestion list into a flat array of objects
  // The normalized list can contain Suggestions or `0` to indicate a divider
  const displayItems = useMemo(() => {
    function validateSuggestionFormat(suggs) {
      if (!suggs) return null;
      if (Array.isArray(suggs[0])) return suggs;
      if (!suggs.length) return [];
      return [suggs];
    }
    let _count = 0;
    const _items = validateSuggestionFormat(suggestions).filter(s => s.length).reduce((res, items) => {
      if (res.length) res.push(0);
      const indexedItems = items.map((i, idx) => _objectSpread$2(_objectSpread$2({}, i), {}, {
        idx: _count + idx
      }));
      _count += items.length;
      return [...res, ...indexedItems];
    }, []);
    return _items;
  }, [suggestions]);
  const items = displayItems.filter(i => i !== 0);
  const {
    isOpen,
    closeMenu,
    getMenuProps,
    getInputProps,
    selectedItem,
    highlightedIndex,
    getItemProps
  } = useCombobox({
    items,
    inputValue: query,
    onInputValueChange: _ref2 => {
      let {
        inputValue
      } = _ref2;
      return onQueryChanged(inputValue);
    },
    onHighlightedIndexChange: event => {
      const isArrowEvent = event.type === useCombobox.stateChangeTypes.InputKeyDownArrowUp || event.type === useCombobox.stateChangeTypes.InputKeyDownArrowDown;
      if (isArrowEvent) {
        const item = items[event.highlightedIndex];
        if (item) {
          setQuery(item.display);
        }
      }
    },
    onSelectedItemChange: _ref3 => {
      let {
        selectedItem
      } = _ref3;
      if (selectedItem) {
        submitSearchQuery(selectedItem.token);
      }
    },
    itemToString: i => i ? i.token : ""
  });
  function renderResetButton() {
    return query ? /*#__PURE__*/React__default.createElement(Button$1, {
      id: "search-field-clear-button",
      buttonStyle: "tertiary",
      size: "regular",
      position: "absolute",
      top: "calc(50% - 12px)",
      right: "6px",
      onClick: clearSearchQuery,
      icon: "close"
    }) : /*#__PURE__*/React__default.createElement(Icon$1, {
      "data-testid": "search-field-icon",
      iconId: "search",
      fill: "grayDark",
      position: "absolute",
      right: "6px",
      top: "calc(50% - 12px)"
    });
  }
  const showMenu = isOpen && query && items.length;
  return /*#__PURE__*/React__default.createElement(Flex$1, _extends({
    width: "100%"
  }, rest), /*#__PURE__*/React__default.createElement(StyledInput, _extends({
    styleOverrides: {
      pr: "28px"
    },
    background: background,
    "data-testid": "search-field-input",
    disabled: disabled
  }, getInputProps({
    id: "search-input",
    autoFocus: autoFocus,
    type: "search",
    placeholder,
    onKeyDown: e => {
      if (e.key === "Enter" && highlightedIndex < 0) {
        closeMenu();
        submitSearchQuery();
      }
    }
  }))), renderResetButton(), /*#__PURE__*/React__default.createElement(AutocompleteMenu$1, _extends({
    "data-testid": "search-field-autocomplete",
    display: showMenu ? "visible" : "none"
  }, getMenuProps()), displayItems.map((item, idx) => item === 0 ? /*#__PURE__*/React__default.createElement(AutocompleteMenu$1.Divider, {
    key: "divider-".concat(idx),
    "data-testid": "search-field-divider"
  }) : /*#__PURE__*/React__default.createElement(AutocompleteMenu$1.Item, _extends({
    "data-testid": "search-field-suggestion",
    key: "item-".concat(item.idx),
    isActive: highlightedIndex === item.idx
  }, getItemProps({
    item,
    index: item.idx,
    isSelected: selectedItem === item.idx
  })), /*#__PURE__*/React__default.createElement(Text, {
    truncate: true
  }, item.display)))));
};
var SearchField$1 = SearchField;

// Styled container for the progress bar
const Container = styled(Box$1).attrs(() => {
  return {
    display: "flex",
    width: "100%",
    backgroundColor: "grayLight",
    borderRadius: "4px",
    overflow: "hidden"
  };
}).withConfig({
  displayName: "ProgressBar__Container"
})([""]);

// Styled bar for the filled portion
const Filled = styled(Box$1).attrs(props => ({
  width: "".concat(props.percentage, "%"),
  backgroundColor: props.barColor,
  borderRadius: "4px",
  height: "100%",
  transition: "width 0.3s ease"
})).withConfig({
  displayName: "ProgressBar__Filled"
})([""]);
const ProgressBar = _ref => {
  let {
    current,
    max,
    filledColor = "primary",
    emptyColor = "grayLight",
    fullColor = "primary",
    height = "8px"
  } = _ref;
  const percentage = Math.min(current / max * 100, 100); // Cap at 100%
  const barColor = percentage === 100 ? fullColor : filledColor;
  return /*#__PURE__*/React__default.createElement(Container, {
    height: height,
    emptyColor: emptyColor
  }, /*#__PURE__*/React__default.createElement(Filled, {
    percentage: percentage,
    barColor: barColor
  }));
};
var ProgressBar$1 = ProgressBar;

const _excluded = ["title", "current", "max", "unit", "tooltip", "action"];
const UsageBar = _ref => {
  let {
      title,
      current,
      max,
      unit = "",
      tooltip = null,
      action = null
    } = _ref,
    positioning = _objectWithoutProperties(_ref, _excluded);
  const currentNum = Number(current);
  const maxNum = Number(max);
  return /*#__PURE__*/React__default.createElement(Flex$1, _extends({
    flexDirection: "column",
    gap: "4px"
  }, positioning), /*#__PURE__*/React__default.createElement(Flex$1, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default.createElement(Flex$1, {
    gap: "4px",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Text, {
    font: "ui.regularBold"
  }, current), /*#__PURE__*/React__default.createElement(Text, null, "/ ", max, " ", unit), tooltip && /*#__PURE__*/React__default.createElement(InfoTip$1, {
    direction: TooltipDirection.Right,
    interactive: false
  }, tooltip)), action && /*#__PURE__*/React__default.createElement(Button$1, _extends({
    buttonStyle: "tertiary",
    size: "small",
    text: "Increase Usage"
  }, action))), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(ProgressBar$1, {
    current: currentNum,
    max: maxNum,
    fullColor: currentNum > maxNum ? "warning" : "info",
    "aria-label": "".concat(title, " usage: ").concat(current, " of ").concat(max)
  })));
};
var UsageBar$1 = UsageBar;

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * Options for generating a custom Reboot/Reset css file
 * https://getbootstrap.com/docs/4.0/content/reboot/
 */
const theme = _objectSpread$1(_objectSpread$1({}, defaultRebootTheme), {}, {
  black: getColor("black"),
  fontFamilyBase: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  fontFamilyMonospace: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  fontSizeBase: "14px",
  fontWeightBase: 400,
  lineHeightBase: 1.5,
  bodyColor: getColor("black"),
  bodyBg: getColor("white"),
  linkColor: getColor("primary"),
  linkDecoration: "none",
  linkHoverColor: getColor("primaryDark"),
  linkHoverDecoration: "underline",
  primaryColor: "",
  // Add the missing properties
  primaryColorDark: "",
  primaryColorLight: "",
  primaryColorTint: "",
  active: false
});

// const rebootCss = reboot({theme});

/**
 * Global style component for consistent base styles across web projects
 *
 * Usage:
 * import { GlobalStyle } from '@nounproject/lingo-core';
 *
 * const App = () => {
 * <Wrapper>
 *    <GlobalStyle />
 * </Wrapper>
 * }
 */
const StyleWrapper = createGlobalStyle(["", " html{font-feature-settings:\"dlig\",\"zero\",\"ss01\",\"cv05\",\"cv10\";}img{max-width:100%;}"], reboot);
const GlobalStyle = () => {
  return /*#__PURE__*/React__default.createElement(StyleWrapper, {
    theme: theme
  });
};
var GlobalStyle$1 = GlobalStyle;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getShortIdsFromEntities = entities => {
  const objectMap = {
    sections: {
      key: "id",
      type: "sections"
    },
    items: {
      key: "id",
      type: "items"
    },
    kits: {
      key: "kitId",
      type: "kits"
    },
    portals: {
      key: "id",
      type: "portals"
    },
    kitCollections: {
      key: "uuid",
      type: "kitCollections"
    }
  };
  return Object.keys(entities).reduce((res, entitityType) => {
    var _entities$entitityTyp;
    // We only care object types with an id mapping defined above
    const mapping = objectMap[entitityType];
    if (!mapping) return res;
    const {
      key,
      type
    } = mapping;
    const objects = Object.values((_entities$entitityTyp = entities[entitityType].objects) !== null && _entities$entitityTyp !== void 0 ? _entities$entitityTyp : entities[entitityType]);
    res[type] = objects.reduce((objAcc, obj) => {
      // This check ensures values because inserting null or undefined values would produce strange bugs
      if (!obj[key] || !obj.shortId) throw new Error("".concat(type, " object missing expected shortID or ").concat(key));
      objAcc[obj.shortId] = obj[key];
      return objAcc;
    }, res[type] || {});
    return res;
  }, {});
};
class Repo {
  constructor(state) {
    this.entities = state.entities || {};
    this.shortIds = this.entities.shortIds || getShortIdsFromEntities(this.entities);
  }

  /**
   * Clean ids formatted as uuid-version, returning only the uuid.
   *
   * @param {String} idString a string object identifier
   */
  parseIdentifier(id) {
    let version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    const uuidPattern = "^(X{8}-X{4}-4X{3}-[89abAB]X{3}-X{12})(?:-(\\d+))?".replace(/X/g, "[0-9a-fA-F]");
    const match = id.match(uuidPattern) || [];
    return {
      id: match[1] || id,
      version: [version, match[2]].map(v => Number(v)).find(v => !Number.isNaN(v))
    };
  }
  getUser(id) {
    if (!id) return null;
    return this._users[id] || null;
  }
  getSpace(id) {
    if (!id) return null;
    const spaces = this._spaces;
    if (spaces[id]) return spaces[id];
    return Object.values(spaces).find(s => s.subdomain === id) || null;
  }
  getJoinLink(token) {
    if (!token) return null;
    return this._joinLinks[token] || null;
  }
  getSpaceMember(spaceId, userId) {
    const members = this._spaceMembers,
      member = members[spaceId] || members[[spaceId, userId].join("-")];
    return member ? _objectSpread(_objectSpread({}, member), {}, {
      user: this.getUser(member.userId)
    }) : null;
  }
  getSpaceMembers(spaceId) {
    var _this$getSpace;
    const normalizedId = ((_this$getSpace = this.getSpace(spaceId)) === null || _this$getSpace === void 0 ? void 0 : _this$getSpace.id) || spaceId;
    const members = Object.values(this._spaceMembers);
    return members.filter(m => m.spaceId === normalizedId).map(m => _objectSpread(_objectSpread({}, m), {}, {
      user: this.getUser(m.userId)
    }));
  }
  getInvitation(id) {
    if (!id) return null;
    return this._invitations[id] || null;
  }
  getKit(identifier) {
    if (!identifier) return null;
    const uuid = this._kitShortIds[identifier] || identifier;
    return this._kits[uuid] || null;
  }
  getKitMember(userId, kitIdentifier, spaceId) {
    const uuid = this._kitShortIds[kitIdentifier] || kitIdentifier;
    const id = [spaceId, userId, uuid].join("-");
    const member = this._kitMembers[id];
    return member ? _objectSpread(_objectSpread({}, member), {}, {
      user: this.getUser(userId)
    }) : null;
  }
  getKitMembers(kitIdentifier, spaceId) {
    const uuid = this._kitShortIds[kitIdentifier] || kitIdentifier;
    return Object.values(this._kitMembers).filter(m => m.kitId === uuid && m.spaceId === spaceId).map(m => {
      return _objectSpread(_objectSpread({}, m), {}, {
        user: this.getUser(m.userId)
      });
    });
  }
  getKitVersions(identifier) {
    const kit = this.getKit(identifier);
    if (!kit) return [];
    return this.fetchVersions(kit.versions || []);
  }
  fetchVersions(versionIdentifiers) {
    const versions = this._versions;
    return versionIdentifiers.map(versionId => versions[versionId]).sort((a, b) => {
      return a.version - b.version;
    });
  }
  getVersion(identifier, versionNumber) {
    if (!identifier) return null;
    const {
      id,
      version
    } = this.parseIdentifier(identifier, versionNumber);
    if (version == null) return null;
    const uuid = this._kitShortIds[id] || id;
    const idVersion = "".concat(uuid, "-").concat(version);
    return this._versions[idVersion] || null;
  }
  getSection(identifier) {
    let versionNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    if (!identifier) return null;
    const {
      id,
      version
    } = this.parseIdentifier(identifier, versionNumber);
    if (version == null) return null;
    const uuid = this._sectionShortIds[id] || id;
    const idVersion = "".concat(uuid, "-").concat(version);
    return this._sections[idVersion] || null;
  }
  getItem(identifier) {
    let versionNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    if (!identifier) return null;
    const {
      id,
      version
    } = this.parseIdentifier(identifier, versionNumber);
    if (version == null) return null;
    const uuid = this._itemShortIds[id] || id;
    const idVersion = "".concat(uuid, "-").concat(version);
    const item = this._items[idVersion];
    if (!item) return null;
    const asset = this._assets[item.assetId];
    if (asset) {
      const itemWithAsset = _objectSpread(_objectSpread({}, item), {}, {
        asset
      });
      return itemWithAsset;
    }
    return item;
  }
  getAsset(identifier) {
    if (!identifier) return null;
    const asset = this._assets[identifier];
    if (asset) {
      return asset;
    }
    return null;
  }
  getKitCollection(identifier) {
    const uuid = this._kitCollectionShortIds[identifier] || identifier;
    return this._kitCollections[uuid] || null;
  }

  // MARK : Private getters
  /*-------------------------------------------------------------------------------*/
  _getObjects(type) {
    var _ref, _objs$objects;
    const objs = this.entities[type];
    return (_ref = (_objs$objects = objs === null || objs === void 0 ? void 0 : objs.objects) !== null && _objs$objects !== void 0 ? _objs$objects : objs) !== null && _ref !== void 0 ? _ref : {};
  }
  get _assets() {
    return this._getObjects("assets");
  }
  get _users() {
    return this._getObjects("users");
  }
  get _spaces() {
    return this._getObjects("spaces");
  }
  get _spaceMembers() {
    return this._getObjects("spaceMembers");
  }
  get _invitations() {
    return this._getObjects("invitations");
  }
  get _joinLinks() {
    return this._getObjects("joinLinks");
  }
  get _kits() {
    return this._getObjects("kits");
  }
  get _kitMembers() {
    return this._getObjects("kitMembers");
  }
  get _versions() {
    return this._getObjects("kitVersions");
  }
  get _items() {
    return this._getObjects("items");
  }
  get _sections() {
    return this._getObjects("sections");
  }
  get _kitCollections() {
    return this._getObjects("kitCollections");
  }

  // MARK : Get short Ids
  /*-------------------------------------------------------------------------------*/
  _getShortIds(type) {
    return this.shortIds[type] || {};
  }
  get _itemShortIds() {
    return this._getShortIds("items");
  }
  get _sectionShortIds() {
    return this._getShortIds("sections");
  }
  get _kitShortIds() {
    return this._getShortIds("kits");
  }
  get _kitCollectionShortIds() {
    return this._getShortIds("kitCollections");
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RepoClass = Repo;
RepoClass.getShortIdsFromEntities = getShortIdsFromEntities;
var RepoClass$1 = RepoClass;

const legacySchemas = {
  USER: normalizers.user,
  SPACE: normalizers.space,
  SPACE_PREVIEW: normalizers.spacePreview,
  SPACE_MEMBER: normalizers.spaceMember,
  API_TOKEN: normalizers.apiToken,
  CHARGE: normalizers.charge,
  SPACE_SEARCH: normalizers.spaceSearch,
  KIT_COLLECTION_ITEM: normalizers.kitCollectionItem,
  KIT_COLLECTION: normalizers.kitCollection,
  KIT: normalizers.kit,
  KIT_VERSION: normalizers.kitVersion,
  KIT_MEMBER: normalizers.kitMember,
  INVITATION: normalizers.invitation,
  SECTION: normalizers.section,
  ITEM: normalizers.item,
  SEARCH: normalizers.search,
  ASSET: normalizers.asset,
  ASSET_SEARCH: normalizers.assetSearch,
  CUSTOM_FIELD: normalizers.customField,
  ASSET_VIEW: normalizers.assetView
};
var legacySchemas$1 = legacySchemas;

const API = {
  call: callApi$1,
  Entity,
  // Legacy support
  middleware: apiMiddleware,
  makeAction,
  CALL_API
};

/**
 * Hook for determining the browser viewport X and Y scroll position
 * https://github.com/n8tb1t/use-scroll-position
 *
 * Props:
 * effect => Effect callback.
 * deps => For effects to fire on selected dependencies change.
 * element => Get scroll position for a specified element by reference.
 * useWindow => Use window.scroll instead of document.body.getBoundingClientRect() to detect scroll position.
 * wait => 	The timeout in ms. Good for performance.
 */

function getScrollPosition(_ref) {
  let {
    element,
    useWindow
  } = _ref;
  if (!isBrowser()) return {
    x: 0,
    y: 0
  };
  const target = element !== null && element !== void 0 ? element : document.body;
  const position = target.getBoundingClientRect();
  return useWindow ? {
    x: window.scrollX,
    y: window.scrollY
  } : {
    x: position.left,
    y: position.top
  };
}
function useScrollPosition(effect, deps, element, useWindow, wait) {
  const position = useRef(getScrollPosition({
    useWindow
  }));
  const throttleTimeout = useRef();
  const callBack = () => {
    const currPos = getScrollPosition({
      element,
      useWindow
    });
    effect({
      prevPos: position.current,
      currPos
    });
    position.current = currPos;
    throttleTimeout.current = null;
  };
  useLayoutEffect(() => {
    const handleScroll = () => {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout.current = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

/**
 * A light wrapper around date-fns dateFormat to automate parsing date strings
 * from model objects
 * @param {String} dateString
 * @param {String} format the template to format the date
 * @returns A formatted string date representation
 */
function _dateFormat(dateString, dateFormat) {
  if (!dateString || dateString === "") {
    return "";
  }
  return format(parseISO(dateString), dateFormat);
}

function formatBytes(bytes) {
  if (bytes === 0) return "0 Bytes";
  if (bytes === 1) return "1 Byte";
  const k = 1000;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const decimals = 0;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // eslint-disable-next-line no-restricted-properties
  const val = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)),
    unit = sizes[i];
  return "".concat(val, " ").concat(unit);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */

const openIntercom = function () {
  var _window;
  let {
    launchChat = true,
    message
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (_window = window) === null || _window === void 0 || _window.Intercom("update", {
    hide_default_launcher: false
  });

  /**
   * launchChat indicates that the bubble was hidden previously.
   * Add a listener to shut down again when then dialog is closed.
   */
  if (launchChat || message) {
    var _window2, _window4;
    (_window2 = window) === null || _window2 === void 0 || _window2.Intercom("show");
    if (message) {
      var _window3;
      (_window3 = window) === null || _window3 === void 0 || _window3.Intercom("showNewMessage", message);
    }
    (_window4 = window) === null || _window4 === void 0 || _window4.Intercom("onHide", () => {
      var _window5;
      return (_window5 = window) === null || _window5 === void 0 ? void 0 : _window5.Intercom("update", {
        hide_default_launcher: true
      });
    });
  }
};

/**
 * Encode unicode values to base64
 * https://attacomsian.com/blog/javascript-base64-encode-decode
 * https://developer.mozilla.org/en-US/docs/Web/API/btoa
 */

/**
 * Base 64 encode a value to a string accounting for unicode
 * @param value Any json value
 * @returns
 */
const encode = value => {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  let str = value;
  if (typeof value !== "string") str = JSON.stringify(str);
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(_match, p1) {
    return String.fromCharCode("0x".concat(p1));
  }));
};
const decode = value => {
  return decodeURIComponent(atob(value).split("").map(function (c) {
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
};
var base64 = {
  encode,
  decode
};

const consumerTiers = [{
  max: 1000,
  costPerUnit: 15
}, {
  max: 5000,
  costPerUnit: 10
}, {
  max: Number.MAX_SAFE_INTEGER,
  costPerUnit: 5
}];
const storageTiers = [{
  max: 1000,
  costPerUnit: 20
}, {
  max: 5000,
  costPerUnit: 15
}, {
  max: Number.MAX_SAFE_INTEGER,
  costPerUnit: 10
}];
const dlBandwidthTiers = [{
  max: Number.MAX_SAFE_INTEGER,
  costPerUnit: 30
}];
const dlRequestTiers = [{
  max: Number.MAX_SAFE_INTEGER,
  costPerUnit: 1 / 1000
}];
const pricingTiers = {
  consumers: consumerTiers,
  storage: storageTiers,
  dlBandwidth: dlBandwidthTiers,
  dlRequests: dlRequestTiers
};

function calculateTieredPrice(tiers, included, amount) {
  let chargeable = Math.max(0, amount - included);
  return tiers.reduce((acc, tier) => {
    const units = Math.min(chargeable, tier.max);
    chargeable = Math.max(0, chargeable - units);
    return acc + units * tier.costPerUnit;
  }, 0);
}
function estimatePlanCosts(space, newPlan) {
  var _ref, _newUsage$editors$quo, _ref2, _newUsage$storage$quo, _ref3, _newUsage$consumers$q, _ref4, _newUsage$dlRequests$, _ref5, _newUsage$dlBandwidth, _newUsage$consumers$i, _newUsage$storage$inc, _newUsage$dlRequests$2, _newUsage$dlBandwidth2;
  const currentPlan = space === null || space === void 0 ? void 0 : space.plan;
  const currentUsage = currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.usage;
  const newUsage = newPlan.usage;
  const interval = newPlan.interval;
  const editorsCount = (_ref = (_newUsage$editors$quo = newUsage === null || newUsage === void 0 ? void 0 : newUsage.editors.quota) !== null && _newUsage$editors$quo !== void 0 ? _newUsage$editors$quo : currentUsage === null || currentUsage === void 0 ? void 0 : currentUsage.editors.quota) !== null && _ref !== void 0 ? _ref : space.counts.editors;
  const storageCount = Math.max((_ref2 = (_newUsage$storage$quo = newUsage === null || newUsage === void 0 ? void 0 : newUsage.storage.quota) !== null && _newUsage$storage$quo !== void 0 ? _newUsage$storage$quo : currentUsage === null || currentUsage === void 0 ? void 0 : currentUsage.storage.quota) !== null && _ref2 !== void 0 ? _ref2 : 0, newUsage === null || newUsage === void 0 ? void 0 : newUsage.storage.included, 0);
  const consumerCount = Math.max((_ref3 = (_newUsage$consumers$q = newUsage === null || newUsage === void 0 ? void 0 : newUsage.consumers.quota) !== null && _newUsage$consumers$q !== void 0 ? _newUsage$consumers$q : currentUsage === null || currentUsage === void 0 ? void 0 : currentUsage.consumers.quota) !== null && _ref3 !== void 0 ? _ref3 : 0, newUsage === null || newUsage === void 0 ? void 0 : newUsage.consumers.included, 0);
  const dlRequestCount = Math.max((_ref4 = (_newUsage$dlRequests$ = newUsage === null || newUsage === void 0 ? void 0 : newUsage.dlRequests.quota) !== null && _newUsage$dlRequests$ !== void 0 ? _newUsage$dlRequests$ : currentUsage === null || currentUsage === void 0 ? void 0 : currentUsage.dlRequests.quota) !== null && _ref4 !== void 0 ? _ref4 : 0, newUsage === null || newUsage === void 0 ? void 0 : newUsage.dlRequests.included, 0);
  const dlBandwidthCount = Math.max((_ref5 = (_newUsage$dlBandwidth = newUsage === null || newUsage === void 0 ? void 0 : newUsage.dlBandwidth.quota) !== null && _newUsage$dlBandwidth !== void 0 ? _newUsage$dlBandwidth : currentUsage === null || currentUsage === void 0 ? void 0 : currentUsage.dlBandwidth.quota) !== null && _ref5 !== void 0 ? _ref5 : 0, newUsage === null || newUsage === void 0 ? void 0 : newUsage.dlBandwidth.included, 0);
  const consumerCost = calculateTieredPrice(pricingTiers.consumers, (_newUsage$consumers$i = newUsage === null || newUsage === void 0 ? void 0 : newUsage.consumers.included) !== null && _newUsage$consumers$i !== void 0 ? _newUsage$consumers$i : 0, consumerCount);
  const storageCost = calculateTieredPrice(pricingTiers.storage, (_newUsage$storage$inc = newUsage === null || newUsage === void 0 ? void 0 : newUsage.storage.included) !== null && _newUsage$storage$inc !== void 0 ? _newUsage$storage$inc : 0, storageCount);
  const dlRequestCost = calculateTieredPrice(pricingTiers.dlRequests, (_newUsage$dlRequests$2 = newUsage === null || newUsage === void 0 ? void 0 : newUsage.dlRequests.included) !== null && _newUsage$dlRequests$2 !== void 0 ? _newUsage$dlRequests$2 : 0, dlRequestCount);
  const dlBandwidthCost = calculateTieredPrice(pricingTiers.dlBandwidth, (_newUsage$dlBandwidth2 = newUsage === null || newUsage === void 0 ? void 0 : newUsage.dlBandwidth.included) !== null && _newUsage$dlBandwidth2 !== void 0 ? _newUsage$dlBandwidth2 : 0, dlBandwidthCount);
  const monthlyDivisor = interval === "year" ? 12 : 1;
  const monthlyPlatformFee = newPlan.platformFee / monthlyDivisor;
  const monthlyPricePerEditor = newPlan.costPerEditor / monthlyDivisor;
  const editorCost = newPlan.costPerEditor * editorsCount / monthlyDivisor;
  const totalMonthly = monthlyPlatformFee + editorCost + consumerCost + storageCost + dlRequestCost + dlBandwidthCost;
  return {
    total: totalMonthly,
    platformFee: {
      total: monthlyPlatformFee
    },
    editors: {
      count: editorsCount,
      perEditor: monthlyPricePerEditor,
      total: editorCost
    },
    consumers: {
      count: consumerCount,
      total: consumerCost
    },
    storage: {
      count: storageCount,
      total: storageCost
    },
    dlRequests: {
      count: dlRequestCount,
      total: dlRequestCost
    },
    dlBandwidth: {
      count: dlBandwidthCount,
      total: dlBandwidthCost
    }
  };
}

function formatPrice(cents) {
  let {
    round,
    include
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (include && cents === 0) return "Included";
  const price = cents / 100;
  const shouldRound = round && cents % 100 === 0;
  const str = price.toLocaleString(undefined, {
    minimumFractionDigits: shouldRound ? 0 : 2,
    maximumFractionDigits: 2
  });
  return "$".concat(str);
}

function analyzeChargePreview(chargePreview) {
  const newCredit = Math.abs(Math.min(chargePreview.newCharges, 0)),
    newCharges = Math.max(chargePreview.newCharges, 0),
    existingCredit = Math.abs(Math.min(chargePreview.existingCredit, 0)),
    creditApplied = newCharges > 0 && existingCredit > 0 ? Math.min(chargePreview.newCharges, existingCredit) : 0,
    remainingCredit = Math.max(existingCredit - creditApplied + newCredit, 0),
    totalDueToday = Math.max(chargePreview.total - creditApplied, 0);
  return {
    newCredit,
    newCharges,
    creditApplied,
    remainingCredit,
    totalDueToday: totalDueToday
  };
}

export { API, ActivityIndicator$1 as ActivityIndicator, AssetType, Badge, BigNumber$1 as BigNumber, Box$1 as Box, Button$1 as Button, ButtonStyle, Checkbox$2 as Checkbox, ContextMenu$1 as ContextMenu, CustomFieldOperation, CustomFieldTypes, DropdownButton$1 as DropdownButton, EmptyKitCard$1 as EmptyKitCard, EmptyPortalCard$1 as EmptyPortalCard, EmptyState$1 as EmptyState, ErrorCode, Flex$1 as Flex, GalleryCodeSnippet$1 as GalleryCodeSnippet, GalleryGuide$1 as GalleryGuide, GalleryHeading$1 as GalleryHeading, GalleryItem$1 as GalleryItem, GalleryMarkdown$1 as GalleryMarkdown, GalleryNote$1 as GalleryNote, GallerySupportingAsset$1 as GallerySupportingAsset, GlobalStyle$1 as GlobalStyle, Grid$1 as Grid, Icon$1 as Icon, ImageView$1 as ImageView, Input$2 as Input, ItemType, KitCard$1 as KitCard, KitPermission, LinkWrapper$1 as LinkWrapper, LottieAnimation$1 as LottieAnimation, MarkdownText$1 as MarkdownText, Component$a as Modal, Component$8 as NavPill, normalizers as Normalizers, Notice$1 as Notice, OptionCard$1 as OptionCard, PagingIndicator$1 as PagingIndicator, PopupMenu, PortalCard$1 as PortalCard, PortalItemType, PortalPermission, PrivacyLevel, ProgressBar$1 as ProgressBar, Redirect$1 as Redirect, RepoClass$1 as Repo, legacySchemas$1 as Schemas, SearchField$1 as SearchField, SearchFilterTypes, SearchOperators, Select, SpacePermission, SpaceThemeNames, Switch$1 as Switch, Component$6 as TabBar, Component$4 as Table, Component$2 as TableCell, TableCellText, Text, TextEditor$1 as TextEditor, Textarea$3 as Textarea, ThemeHeaderTitleOptions, ToggleBox$1 as ToggleBox, TokenInput$1 as TokenInput, Tooltip, UsageBar$1 as UsageBar, analyzeChargePreview, base64, buildPath, buildURL, formatBytes as bytesToSize, callApi, callApiWithRawResponse, camelize, copy, elementIds, elementInViewport, estimatePlanCosts, factory, formatAsset, _dateFormat as formatDate, formatItem, formatPrice, getApiServiceURL, getCustomDomainComponents, isError, markdownStyle, openIntercom, pluralize, slugifyName, slugifySubdomain, styles, trimSubdomain, useBoolean, useClipboard, useCodeHighlighting, useContextMenu, useDrag, useEventListener, useNavigation, usePrevious, useScrollPosition, useSpaceThemeName, useWindowSize, utils };
